import * as ft from "react";
import S, { useEffect as bo, useState as Pr, isValidElement as bt, Children as _r, PureComponent as tt, forwardRef as ux, useRef as ha, useImperativeHandle as V_, useCallback as Y_, useMemo as sx, cloneElement as Ce, createElement as cx, useContext as zt, createContext as Mr, Component as lx } from "react";
import { X as fx, ChevronDown as X_, User as Wp, LogOut as Up, Menu as Z_, Calendar as J_, HelpCircle as Q_, Lock as e1, Sparkles as t1 } from "lucide-react";
import { Link as ze, useLocation as r1 } from "react-router-dom";
var Yi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ye(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Xi = { exports: {} }, Dn = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Kp;
function n1() {
  if (Kp) return Dn;
  Kp = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function r(n, i, a) {
    var o = null;
    if (a !== void 0 && (o = "" + a), i.key !== void 0 && (o = "" + i.key), "key" in i) {
      a = {};
      for (var u in i)
        u !== "key" && (a[u] = i[u]);
    } else a = i;
    return i = a.ref, {
      $$typeof: e,
      type: n,
      key: o,
      ref: i !== void 0 ? i : null,
      props: a
    };
  }
  return Dn.Fragment = t, Dn.jsx = r, Dn.jsxs = r, Dn;
}
var Ln = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hp;
function i1() {
  return Hp || (Hp = 1, process.env.NODE_ENV !== "production" && function() {
    function e(E) {
      if (E == null) return null;
      if (typeof E == "function")
        return E.$$typeof === M ? null : E.displayName || E.name || null;
      if (typeof E == "string") return E;
      switch (E) {
        case v:
          return "Fragment";
        case x:
          return "Profiler";
        case h:
          return "StrictMode";
        case m:
          return "Suspense";
        case w:
          return "SuspenseList";
        case T:
          return "Activity";
      }
      if (typeof E == "object")
        switch (typeof E.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), E.$$typeof) {
          case y:
            return "Portal";
          case b:
            return (E.displayName || "Context") + ".Provider";
          case g:
            return (E._context.displayName || "Context") + ".Consumer";
          case O:
            var N = E.render;
            return E = E.displayName, E || (E = N.displayName || N.name || "", E = E !== "" ? "ForwardRef(" + E + ")" : "ForwardRef"), E;
          case _:
            return N = E.displayName || null, N !== null ? N : e(E.type) || "Memo";
          case P:
            N = E._payload, E = E._init;
            try {
              return e(E(N));
            } catch {
            }
        }
      return null;
    }
    function t(E) {
      return "" + E;
    }
    function r(E) {
      try {
        t(E);
        var N = !1;
      } catch {
        N = !0;
      }
      if (N) {
        N = console;
        var L = N.error, z = typeof Symbol == "function" && Symbol.toStringTag && E[Symbol.toStringTag] || E.constructor.name || "Object";
        return L.call(
          N,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          z
        ), t(E);
      }
    }
    function n(E) {
      if (E === v) return "<>";
      if (typeof E == "object" && E !== null && E.$$typeof === P)
        return "<...>";
      try {
        var N = e(E);
        return N ? "<" + N + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function i() {
      var E = j.A;
      return E === null ? null : E.getOwner();
    }
    function a() {
      return Error("react-stack-top-frame");
    }
    function o(E) {
      if ($.call(E, "key")) {
        var N = Object.getOwnPropertyDescriptor(E, "key").get;
        if (N && N.isReactWarning) return !1;
      }
      return E.key !== void 0;
    }
    function u(E, N) {
      function L() {
        R || (R = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          N
        ));
      }
      L.isReactWarning = !0, Object.defineProperty(E, "key", {
        get: L,
        configurable: !0
      });
    }
    function s() {
      var E = e(this.type);
      return D[E] || (D[E] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), E = this.props.ref, E !== void 0 ? E : null;
    }
    function c(E, N, L, z, V, Y, ee, ne) {
      return L = Y.ref, E = {
        $$typeof: p,
        type: E,
        key: N,
        props: Y,
        _owner: V
      }, (L !== void 0 ? L : null) !== null ? Object.defineProperty(E, "ref", {
        enumerable: !1,
        get: s
      }) : Object.defineProperty(E, "ref", { enumerable: !1, value: null }), E._store = {}, Object.defineProperty(E._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(E, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(E, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ee
      }), Object.defineProperty(E, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ne
      }), Object.freeze && (Object.freeze(E.props), Object.freeze(E)), E;
    }
    function l(E, N, L, z, V, Y, ee, ne) {
      var X = N.children;
      if (X !== void 0)
        if (z)
          if (I(X)) {
            for (z = 0; z < X.length; z++)
              f(X[z]);
            Object.freeze && Object.freeze(X);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else f(X);
      if ($.call(N, "key")) {
        X = e(E);
        var F = Object.keys(N).filter(function(Q) {
          return Q !== "key";
        });
        z = 0 < F.length ? "{key: someKey, " + F.join(": ..., ") + ": ...}" : "{key: someKey}", K[X + z] || (F = 0 < F.length ? "{" + F.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          z,
          X,
          F,
          X
        ), K[X + z] = !0);
      }
      if (X = null, L !== void 0 && (r(L), X = "" + L), o(N) && (r(N.key), X = "" + N.key), "key" in N) {
        L = {};
        for (var G in N)
          G !== "key" && (L[G] = N[G]);
      } else L = N;
      return X && u(
        L,
        typeof E == "function" ? E.displayName || E.name || "Unknown" : E
      ), c(
        E,
        X,
        Y,
        V,
        i(),
        L,
        ee,
        ne
      );
    }
    function f(E) {
      typeof E == "object" && E !== null && E.$$typeof === p && E._store && (E._store.validated = 1);
    }
    var d = S, p = Symbol.for("react.transitional.element"), y = Symbol.for("react.portal"), v = Symbol.for("react.fragment"), h = Symbol.for("react.strict_mode"), x = Symbol.for("react.profiler"), g = Symbol.for("react.consumer"), b = Symbol.for("react.context"), O = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), _ = Symbol.for("react.memo"), P = Symbol.for("react.lazy"), T = Symbol.for("react.activity"), M = Symbol.for("react.client.reference"), j = d.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $ = Object.prototype.hasOwnProperty, I = Array.isArray, k = console.createTask ? console.createTask : function() {
      return null;
    };
    d = {
      "react-stack-bottom-frame": function(E) {
        return E();
      }
    };
    var R, D = {}, B = d["react-stack-bottom-frame"].bind(
      d,
      a
    )(), W = k(n(a)), K = {};
    Ln.Fragment = v, Ln.jsx = function(E, N, L, z, V) {
      var Y = 1e4 > j.recentlyCreatedOwnerStacks++;
      return l(
        E,
        N,
        L,
        !1,
        z,
        V,
        Y ? Error("react-stack-top-frame") : B,
        Y ? k(n(E)) : W
      );
    }, Ln.jsxs = function(E, N, L, z, V) {
      var Y = 1e4 > j.recentlyCreatedOwnerStacks++;
      return l(
        E,
        N,
        L,
        !0,
        z,
        V,
        Y ? Error("react-stack-top-frame") : B,
        Y ? k(n(E)) : W
      );
    };
  }()), Ln;
}
var Gp;
function a1() {
  return Gp || (Gp = 1, process.env.NODE_ENV === "production" ? Xi.exports = n1() : Xi.exports = i1()), Xi.exports;
}
var A = a1();
function dx(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (r = dx(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function ae() {
  for (var e, t, r = 0, n = "", i = arguments.length; r < i; r++) (e = arguments[r]) && (t = dx(e)) && (n && (n += " "), n += t);
  return n;
}
const Vp = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Yp = ae, o1 = (e, t) => (r) => {
  var n;
  if ((t == null ? void 0 : t.variants) == null) return Yp(e, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
  const { variants: i, defaultVariants: a } = t, o = Object.keys(i).map((c) => {
    const l = r == null ? void 0 : r[c], f = a == null ? void 0 : a[c];
    if (l === null) return null;
    const d = Vp(l) || Vp(f);
    return i[c][d];
  }), u = r && Object.entries(r).reduce((c, l) => {
    let [f, d] = l;
    return d === void 0 || (c[f] = d), c;
  }, {}), s = t == null || (n = t.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((c, l) => {
    let { class: f, className: d, ...p } = l;
    return Object.entries(p).every((y) => {
      let [v, h] = y;
      return Array.isArray(h) ? h.includes({
        ...a,
        ...u
      }[v]) : {
        ...a,
        ...u
      }[v] === h;
    }) ? [
      ...c,
      f,
      d
    ] : c;
  }, []);
  return Yp(e, o, s, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
};
function se(...e) {
  return ae(e);
}
const u1 = o1(
  // Base styles
  "inline-flex items-center justify-center font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed border",
  {
    variants: {
      variant: {
        primary: "bg-brand-primary text-white border-brand-primary hover:bg-brand-primaryHover focus:ring-brand-accent",
        secondary: "bg-white text-neutral-900 border-neutral-200 hover:bg-neutral-50 focus:ring-brand-accent",
        success: "bg-success text-white border-success hover:bg-success-hover focus:ring-success",
        danger: "bg-error text-white border-error hover:bg-error-hover focus:ring-error",
        ghost: "bg-transparent text-brand-primary border-transparent hover:bg-neutral-100 focus:ring-brand-accent",
        outline: "bg-transparent text-brand-primary border-brand-primary hover:bg-brand-primaryLight focus:ring-brand-accent"
      },
      size: {
        sm: "px-3 py-1.5 text-sm rounded-md",
        md: "px-4 py-2 text-sm rounded-md",
        lg: "px-6 py-3 text-base rounded-lg",
        xl: "px-8 py-4 text-lg rounded-lg"
      },
      fullWidth: {
        true: "w-full",
        false: "w-auto"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
      fullWidth: !1
    }
  }
);
function s1({
  variant: e,
  size: t,
  fullWidth: r,
  icon: n,
  iconPosition: i = "left",
  loading: a = !1,
  disabled: o,
  className: u,
  children: s,
  ...c
}) {
  const l = o || a;
  return /* @__PURE__ */ A.jsxs(
    "button",
    {
      className: se(u1({ variant: e, size: t, fullWidth: r }), u),
      disabled: l,
      ...c,
      children: [
        a && /* @__PURE__ */ A.jsx("div", { className: "w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin mr-2" }),
        n && i === "left" && !a && /* @__PURE__ */ A.jsx(n, { className: se("w-4 h-4", s ? "mr-2" : "") }),
        s,
        n && i === "right" && !a && /* @__PURE__ */ A.jsx(n, { className: se("w-4 h-4", s ? "ml-2" : "") })
      ]
    }
  );
}
function px({ children: e, className: t, hover: r = !0, header: n }) {
  return /* @__PURE__ */ A.jsxs("div", { className: se("card", r && "hover:shadow-lg", t), children: [
    n && /* @__PURE__ */ A.jsxs("div", { className: "flex items-center gap-3 mb-6", children: [
      n.icon && /* @__PURE__ */ A.jsx(
        "div",
        {
          className: se(
            "w-10 h-10 rounded-lg flex items-center justify-center",
            n.iconBgColor || "bg-blue-100"
          ),
          children: /* @__PURE__ */ A.jsx(
            n.icon,
            {
              className: se("w-6 h-6", n.iconColor || "text-blue-600")
            }
          )
        }
      ),
      /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("h3", { className: "text-lg font-semibold text-gray-900", children: n.title }),
        n.subtitle && /* @__PURE__ */ A.jsx("p", { className: "text-sm text-gray-600", children: n.subtitle })
      ] })
    ] }),
    e
  ] });
}
function BB({
  icon: e,
  title: t,
  description: r,
  className: n
}) {
  return /* @__PURE__ */ A.jsxs(px, { className: se("text-center group cursor-pointer", n), children: [
    /* @__PURE__ */ A.jsx("div", { className: "w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-200 transition-colors", children: /* @__PURE__ */ A.jsx(e, { className: "w-6 h-6 text-blue-600" }) }),
    /* @__PURE__ */ A.jsx("h3", { className: "text-lg font-semibold text-gray-900 mb-2", children: t }),
    /* @__PURE__ */ A.jsx("p", { className: "text-gray-600", children: r })
  ] });
}
function FB({
  title: e,
  value: t,
  change: r,
  changeType: n = "neutral",
  icon: i,
  className: a
}) {
  const o = {
    positive: "text-green-600",
    negative: "text-red-600",
    neutral: "text-gray-600"
  }[n];
  return /* @__PURE__ */ A.jsx(px, { className: a, children: /* @__PURE__ */ A.jsxs("div", { className: "flex items-center justify-between", children: [
    /* @__PURE__ */ A.jsxs("div", { children: [
      /* @__PURE__ */ A.jsx("p", { className: "text-sm font-medium text-gray-600", children: e }),
      /* @__PURE__ */ A.jsx("p", { className: "text-2xl font-bold text-gray-900", children: t }),
      r && /* @__PURE__ */ A.jsx("p", { className: se("text-sm", o), children: r })
    ] }),
    i && /* @__PURE__ */ A.jsx("div", { className: "w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center", children: /* @__PURE__ */ A.jsx(i, { className: "w-6 h-6 text-gray-600" }) })
  ] }) });
}
function zB({
  className: e,
  orientation: t = "horizontal",
  size: r = "md"
}) {
  const n = t === "horizontal" ? "border-t border-gray-200" : "border-l border-gray-200 h-full", i = {
    sm: t === "horizontal" ? "pt-2" : "pl-2",
    md: t === "horizontal" ? "pt-3" : "pl-3",
    lg: t === "horizontal" ? "pt-4" : "pl-4"
  };
  return /* @__PURE__ */ A.jsx("div", { className: se(n, i[r], e) });
}
function WB({
  label: e,
  error: t,
  helperText: r,
  leftIcon: n,
  rightIcon: i,
  onRightIconClick: a,
  inputSize: o = "md",
  className: u,
  id: s,
  ...c
}) {
  const l = s || (e == null ? void 0 : e.toLowerCase().replace(/\s+/g, "-")), f = !!t, d = () => {
    switch (o) {
      case "sm":
        return "px-3 py-1.5 text-sm";
      case "md":
        return "px-4 py-2 text-base";
      case "lg":
        return "px-4 py-3 text-lg";
      default:
        return "px-4 py-2 text-base";
    }
  };
  return /* @__PURE__ */ A.jsxs("div", { className: "w-full", children: [
    e && /* @__PURE__ */ A.jsx("label", { htmlFor: l, className: "label", children: e }),
    /* @__PURE__ */ A.jsxs("div", { className: "relative", children: [
      n && /* @__PURE__ */ A.jsx("div", { className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none", children: /* @__PURE__ */ A.jsx(n, { className: "h-5 w-5 text-secondary" }) }),
      /* @__PURE__ */ A.jsx(
        "input",
        {
          id: l,
          className: se(
            // Base styles using our utility classes
            "input",
            f && "error",
            // Size classes
            d(),
            // Icon padding
            n && "pl-10",
            i && "pr-10",
            // Custom className
            u
          ),
          ...c
        }
      ),
      i && /* @__PURE__ */ A.jsx("div", { className: "absolute inset-y-0 right-0 pr-3 flex items-center", children: /* @__PURE__ */ A.jsx(
        "button",
        {
          type: "button",
          onClick: a,
          className: se(
            "text-secondary transition-colors hover:text-primary",
            !a && "cursor-default pointer-events-none"
          ),
          children: /* @__PURE__ */ A.jsx(i, { className: "h-5 w-5" })
        }
      ) })
    ] }),
    (t || r) && /* @__PURE__ */ A.jsx("p", { className: f ? "error-text" : "helper-text", children: t || r })
  ] });
}
function UB({
  size: e = 48,
  color: t = "text-blue-600",
  className: r = ""
}) {
  return /* @__PURE__ */ A.jsx(
    "div",
    {
      className: `inline-block ${r}`,
      style: { width: e, height: e },
      role: "status",
      "aria-label": "Carregando",
      children: /* @__PURE__ */ A.jsxs(
        "svg",
        {
          className: `w-full h-full animate-spin ${t}`,
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [
            /* @__PURE__ */ A.jsx(
              "circle",
              {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
              }
            ),
            /* @__PURE__ */ A.jsx(
              "path",
              {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              }
            )
          ]
        }
      )
    }
  );
}
const c1 = {
  sm: "max-w-md",
  md: "max-w-lg",
  lg: "max-w-2xl",
  xl: "max-w-4xl",
  full: "max-w-[95vw]"
};
function KB({
  isOpen: e,
  onClose: t,
  title: r,
  size: n = "md",
  closeOnBackdropClick: i = !0,
  showCloseButton: a = !0,
  children: o,
  footer: u
}) {
  if (bo(() => {
    const c = (l) => {
      l.key === "Escape" && e && t();
    };
    return e && (document.addEventListener("keydown", c), document.body.style.overflow = "hidden"), () => {
      document.removeEventListener("keydown", c), document.body.style.overflow = "unset";
    };
  }, [e, t]), !e) return null;
  const s = (c) => {
    c.target === c.currentTarget && i && t();
  };
  return /* @__PURE__ */ A.jsxs("div", { className: "fixed inset-0 z-50 overflow-y-auto", children: [
    /* @__PURE__ */ A.jsx(
      "div",
      {
        className: "fixed inset-0 bg-black bg-opacity-25 transition-opacity",
        onClick: s
      }
    ),
    /* @__PURE__ */ A.jsx("div", { className: "flex min-h-full items-center justify-center p-4", children: /* @__PURE__ */ A.jsxs(
      "div",
      {
        className: se(
          "relative bg-white rounded-lg shadow-xl w-full transition-all",
          "max-h-[90vh] overflow-y-auto",
          c1[n]
        ),
        children: [
          (r || a) && /* @__PURE__ */ A.jsxs("div", { className: "flex items-center justify-between p-6 border-b border-gray-200", children: [
            r && /* @__PURE__ */ A.jsx("h3", { className: "text-lg font-semibold text-gray-900", children: r }),
            a && /* @__PURE__ */ A.jsx(
              "button",
              {
                onClick: t,
                className: "text-gray-400 hover:text-gray-600 p-2 rounded-lg hover:bg-gray-100 transition-colors",
                children: /* @__PURE__ */ A.jsx(fx, { className: "w-6 h-6" })
              }
            )
          ] }),
          /* @__PURE__ */ A.jsx("div", { className: "p-6", children: o }),
          u && /* @__PURE__ */ A.jsx("div", { className: "flex items-center justify-end gap-3 p-6 border-t border-gray-200", children: u })
        ]
      }
    ) })
  ] });
}
const l1 = {
  default: "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
  error: "border-red-500 focus:border-red-500 focus:ring-red-500"
};
function HB({
  label: e,
  error: t,
  helperText: r,
  variant: n = "default",
  options: i = [],
  placeholder: a,
  className: o,
  children: u,
  id: s,
  ...c
}) {
  const l = s || (e == null ? void 0 : e.toLowerCase().replace(/\s+/g, "-")), f = !!t, d = f ? "error" : n;
  return /* @__PURE__ */ A.jsxs("div", { className: "w-full", children: [
    e && /* @__PURE__ */ A.jsx(
      "label",
      {
        htmlFor: l,
        className: "block text-sm font-medium text-gray-700 mb-2",
        children: e
      }
    ),
    /* @__PURE__ */ A.jsxs("div", { className: "relative", children: [
      /* @__PURE__ */ A.jsxs(
        "select",
        {
          id: l,
          className: se(
            // Base styles
            "w-full px-4 py-3 border rounded-lg transition-all duration-200",
            "focus:outline-none focus:ring-2 focus:ring-offset-0",
            "disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed",
            "appearance-none pr-10 bg-white",
            // Variant styles
            l1[d],
            // Custom className
            o
          ),
          ...c,
          children: [
            a && /* @__PURE__ */ A.jsx("option", { value: "", disabled: !0, children: a }),
            i.map((p) => /* @__PURE__ */ A.jsx(
              "option",
              {
                value: p.value,
                disabled: p.disabled,
                children: p.label
              },
              p.value
            )),
            u
          ]
        }
      ),
      /* @__PURE__ */ A.jsx("div", { className: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none", children: /* @__PURE__ */ A.jsx(X_, { className: "h-5 w-5 text-gray-400" }) })
    ] }),
    (t || r) && /* @__PURE__ */ A.jsx(
      "p",
      {
        className: se(
          "mt-1 text-sm",
          f ? "text-red-600" : "text-gray-500"
        ),
        children: t || r
      }
    )
  ] });
}
const f1 = {
  default: "border-gray-300 focus:border-blue-500 focus:ring-blue-500",
  error: "border-red-500 focus:border-red-500 focus:ring-red-500"
};
function GB({
  label: e,
  error: t,
  helperText: r,
  variant: n = "default",
  minRows: i = 3,
  className: a,
  id: o,
  ...u
}) {
  const s = o || (e == null ? void 0 : e.toLowerCase().replace(/\s+/g, "-")), c = !!t, l = c ? "error" : n;
  return /* @__PURE__ */ A.jsxs("div", { className: "w-full", children: [
    e && /* @__PURE__ */ A.jsx(
      "label",
      {
        htmlFor: s,
        className: "block text-sm font-medium text-gray-700 mb-2",
        children: e
      }
    ),
    /* @__PURE__ */ A.jsx(
      "textarea",
      {
        id: s,
        rows: i,
        className: se(
          // Base styles
          "w-full px-4 py-3 border rounded-lg transition-all duration-200",
          "focus:outline-none focus:ring-2 focus:ring-offset-0",
          "disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed",
          "resize-y",
          // Variant styles
          f1[l],
          // Custom className
          a
        ),
        ...u
      }
    ),
    (t || r) && /* @__PURE__ */ A.jsx(
      "p",
      {
        className: se(
          "mt-1 text-sm",
          c ? "text-red-600" : "text-gray-500"
        ),
        children: t || r
      }
    )
  ] });
}
function VB({
  isAuthenticated: e = !1,
  userName: t,
  onLogout: r,
  className: n,
  isEnterprise: i = !1
}) {
  const [a, o] = Pr(!1), u = () => {
    r ? r() : console.warn("No onLogout handler provided to Navbar");
  };
  return /* @__PURE__ */ A.jsx(
    "nav",
    {
      className: se(
        "bg-white border-b border-gray-100 sticky top-0 z-50",
        n
      ),
      children: /* @__PURE__ */ A.jsxs("div", { className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8", children: [
        /* @__PURE__ */ A.jsxs("div", { className: "flex justify-between items-center h-16", children: [
          /* @__PURE__ */ A.jsxs(ze, { to: "/", className: "flex items-center space-x-2", children: [
            /* @__PURE__ */ A.jsx(
              "img",
              {
                src: "/finansafe.png",
                alt: "FinanSafe Logo",
                className: "w-8 h-8 object-contain brightness-0"
              }
            ),
            /* @__PURE__ */ A.jsx("span", { className: "text-xl font-bold text-gray-900", children: "FinanSafe" })
          ] }),
          /* @__PURE__ */ A.jsx("div", { className: "navbar-desktop-menu", children: e ? /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
            /* @__PURE__ */ A.jsx(ze, { to: "/", className: "navbar-link", children: "Home" }),
            /* @__PURE__ */ A.jsx(ze, { to: "/finance-management/dashboard", className: "navbar-link", children: "Gestão Financeira" }),
            /* @__PURE__ */ A.jsx(ze, { to: "/extra-income/introduction", className: "navbar-link", children: i ? "Plano Estratégico" : "Renda Extra" }),
            /* @__PURE__ */ A.jsx(ze, { to: "/my-plans", className: "navbar-link", children: "Meus Planos" }),
            /* @__PURE__ */ A.jsxs("div", { className: "navbar-user-section", children: [
              /* @__PURE__ */ A.jsxs("div", { className: "navbar-user-info", children: [
                /* @__PURE__ */ A.jsx(Wp, { className: "navbar-user-icon" }),
                /* @__PURE__ */ A.jsx("span", { className: "navbar-user-name", children: t })
              ] }),
              /* @__PURE__ */ A.jsx(
                "button",
                {
                  onClick: u,
                  className: "navbar-logout-btn",
                  title: "Sair",
                  children: /* @__PURE__ */ A.jsx(Up, { className: "navbar-logout-icon" })
                }
              )
            ] })
          ] }) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
            /* @__PURE__ */ A.jsx(
              ze,
              {
                to: "/login",
                className: "px-4 py-2 text-blue-600 hover:text-blue-700 font-medium transition-colors duration-200",
                children: "Entrar"
              }
            ),
            /* @__PURE__ */ A.jsx(
              ze,
              {
                to: "/register",
                className: "px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-all duration-200 shadow-sm hover:shadow-md",
                children: "Começar Agora"
              }
            )
          ] }) }),
          /* @__PURE__ */ A.jsx(
            "button",
            {
              onClick: () => o(!a),
              className: "navbar-mobile-toggle",
              children: a ? /* @__PURE__ */ A.jsx(fx, { className: "w-6 h-6" }) : /* @__PURE__ */ A.jsx(Z_, { className: "w-6 h-6" })
            }
          )
        ] }),
        a && /* @__PURE__ */ A.jsx("div", { className: "navbar-mobile-menu", children: /* @__PURE__ */ A.jsx("div", { className: "navbar-mobile-links", children: e ? /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
          /* @__PURE__ */ A.jsx(
            ze,
            {
              to: "/",
              className: "navbar-link",
              onClick: () => o(!1),
              children: "Home"
            }
          ),
          /* @__PURE__ */ A.jsx(
            ze,
            {
              to: "/finance-management/dashboard",
              className: "navbar-link",
              onClick: () => o(!1),
              children: "Gestão Financeira"
            }
          ),
          /* @__PURE__ */ A.jsx(
            ze,
            {
              to: "/extra-income/introduction",
              className: "navbar-link",
              onClick: () => o(!1),
              children: i ? "Plano Estratégico" : "Renda Extra"
            }
          ),
          /* @__PURE__ */ A.jsx(
            ze,
            {
              to: "/my-plans",
              className: "navbar-link",
              onClick: () => o(!1),
              children: "Meus Planos"
            }
          ),
          /* @__PURE__ */ A.jsxs("div", { className: "navbar-mobile-user", children: [
            /* @__PURE__ */ A.jsxs("div", { className: "navbar-user-info", children: [
              /* @__PURE__ */ A.jsx(Wp, { className: "navbar-user-icon" }),
              /* @__PURE__ */ A.jsx("span", { className: "navbar-user-name", children: t })
            ] }),
            /* @__PURE__ */ A.jsx(
              "button",
              {
                onClick: () => {
                  u(), o(!1);
                },
                className: "navbar-logout-btn",
                children: /* @__PURE__ */ A.jsx(Up, { className: "navbar-logout-icon" })
              }
            )
          ] })
        ] }) : /* @__PURE__ */ A.jsxs(A.Fragment, { children: [
          /* @__PURE__ */ A.jsx(
            ze,
            {
              to: "/login",
              className: "block px-4 py-3 text-blue-600 hover:text-blue-700 font-medium text-center border border-blue-200 rounded-lg hover:bg-blue-50 transition-all duration-200",
              onClick: () => o(!1),
              children: "Entrar"
            }
          ),
          /* @__PURE__ */ A.jsx(
            ze,
            {
              to: "/register",
              className: "block px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium text-center transition-all duration-200 shadow-sm",
              onClick: () => o(!1),
              children: "Começar Agora"
            }
          )
        ] }) }) })
      ] })
    }
  );
}
function YB({
  items: e,
  title: t,
  className: r,
  orientation: n = "vertical",
  showTitle: i = !0
}) {
  const a = r1();
  return n === "horizontal" ? /* @__PURE__ */ A.jsx(
    "div",
    {
      className: se(
        "w-full bg-white border-b border-gray-200 flex-shrink-0",
        r
      ),
      children: /* @__PURE__ */ A.jsxs("div", { className: "px-4 py-3", children: [
        i && t && /* @__PURE__ */ A.jsx("h2", { className: "text-sm font-semibold text-gray-900 mb-3 px-2", children: t }),
        /* @__PURE__ */ A.jsx("nav", { className: "flex gap-1 overflow-x-auto scrollbar-hide", children: e.map((o) => {
          const u = a.pathname === o.href || o.isActive, s = o.icon;
          return o.disabled ? /* @__PURE__ */ A.jsxs(
            "div",
            {
              className: se(
                "flex items-center gap-2 px-3 py-2 rounded-lg text-gray-400 cursor-not-allowed whitespace-nowrap flex-shrink-0"
              ),
              children: [
                /* @__PURE__ */ A.jsx(s, { className: "w-4 h-4" }),
                /* @__PURE__ */ A.jsx("span", { className: "text-sm font-medium", children: o.label }),
                o.badge && /* @__PURE__ */ A.jsx("span", { className: "text-xs bg-gray-200 text-gray-600 px-2 py-1 rounded-full", children: o.badge })
              ]
            },
            o.href
          ) : /* @__PURE__ */ A.jsxs(
            ze,
            {
              to: o.href,
              className: se(
                "flex items-center gap-2 px-3 py-2 rounded-lg font-medium transition-all duration-200 whitespace-nowrap flex-shrink-0",
                "hover:bg-gray-50 hover:text-blue-600",
                u ? "bg-blue-50 text-blue-600 border-b-2 border-blue-600" : "text-gray-700"
              ),
              children: [
                /* @__PURE__ */ A.jsx(s, { className: "w-4 h-4" }),
                /* @__PURE__ */ A.jsx("span", { className: "text-sm", children: o.label }),
                o.badge && /* @__PURE__ */ A.jsx(
                  "span",
                  {
                    className: se(
                      "text-xs px-2 py-1 rounded-full",
                      u ? "bg-blue-100 text-blue-700" : "bg-gray-100 text-gray-600"
                    ),
                    children: o.badge
                  }
                )
              ]
            },
            o.href
          );
        }) })
      ] })
    }
  ) : /* @__PURE__ */ A.jsx(
    "div",
    {
      className: se(
        "w-64 bg-white border-r border-gray-200 h-full flex-shrink-0",
        r
      ),
      children: /* @__PURE__ */ A.jsxs("div", { className: "p-6", children: [
        i && t && /* @__PURE__ */ A.jsx("h2", { className: "text-lg font-semibold text-gray-900 mb-6", children: t }),
        /* @__PURE__ */ A.jsx("nav", { className: "space-y-1", children: e.map((o) => {
          const u = a.pathname === o.href || o.isActive, s = o.icon;
          return o.disabled ? /* @__PURE__ */ A.jsxs(
            "div",
            {
              className: se(
                "flex items-center gap-3 px-3 py-2 rounded-lg text-gray-400 cursor-not-allowed"
              ),
              children: [
                /* @__PURE__ */ A.jsx(s, { className: "w-5 h-5" }),
                /* @__PURE__ */ A.jsx("span", { className: "font-medium", children: o.label }),
                o.badge && /* @__PURE__ */ A.jsx("span", { className: "ml-auto text-xs bg-gray-200 text-gray-600 px-2 py-1 rounded-full", children: o.badge })
              ]
            },
            o.href
          ) : /* @__PURE__ */ A.jsxs(
            ze,
            {
              to: o.href,
              className: se(
                "flex items-center gap-3 px-3 py-2 rounded-lg font-medium transition-all duration-200",
                "hover:bg-gray-50 hover:text-blue-600",
                u ? "bg-blue-50 text-blue-600 border-r-2 border-blue-600" : "text-gray-700"
              ),
              children: [
                /* @__PURE__ */ A.jsx(s, { className: "w-5 h-5" }),
                /* @__PURE__ */ A.jsx("span", { children: o.label }),
                o.badge && /* @__PURE__ */ A.jsx(
                  "span",
                  {
                    className: se(
                      "ml-auto text-xs px-2 py-1 rounded-full",
                      u ? "bg-blue-100 text-blue-700" : "bg-gray-100 text-gray-600"
                    ),
                    children: o.badge
                  }
                )
              ]
            },
            o.href
          );
        }) })
      ] })
    }
  );
}
const d1 = {
  low: "Crítico",
  medium: "Atenção",
  high: "Saudável"
};
function XB({
  value: e,
  min: t = 0,
  max: r = 100,
  labels: n = d1,
  animatedPointer: i = !0,
  width: a = 280,
  onClick: o,
  emptyStateMessage: u = "Dados não disponíveis"
}) {
  const s = e != null, c = s ? Math.max(t, Math.min(r, e)) : 0, l = s ? (c - t) / (r - t) * 100 : 0, f = -90 + l / 100 * 180, p = s ? ((b) => b <= 30 ? "#DC2626" : b <= 70 ? "#EAB308" : "#16A34A")(l) : "#9CA3AF", y = a / 2, v = a * 0.35, h = 16;
  function x(b, O, m, w) {
    const _ = (w - 90) * Math.PI / 180;
    return {
      x: b + m * Math.cos(_),
      y: O + m * Math.sin(_)
    };
  }
  const g = (b, O) => {
    const m = x(y, y, v, O), w = x(y, y, v, b), _ = O - b <= 180 ? "0" : "1";
    return `M ${m.x} ${m.y} A ${v} ${v} 0 ${_} 0 ${w.x} ${w.y}`;
  };
  return /* @__PURE__ */ A.jsx(
    "div",
    {
      className: `transition-all duration-300 ${o ? "cursor-pointer" : ""}`,
      onClick: o,
      role: o ? "button" : void 0,
      tabIndex: o ? 0 : void 0,
      onKeyDown: o ? (b) => {
        (b.key === "Enter" || b.key === " ") && (b.preventDefault(), o());
      } : void 0,
      children: /* @__PURE__ */ A.jsxs("div", { className: "flex flex-col items-center w-full", children: [
        /* @__PURE__ */ A.jsx("div", { className: "relative w-full", children: /* @__PURE__ */ A.jsxs(
          "svg",
          {
            width: "100%",
            height: a * 0.6,
            viewBox: `0 0 ${a} ${a * 0.6}`,
            className: "mb-4 w-full",
            role: "meter",
            "aria-label": `Financial health: ${c}%`,
            "aria-valuenow": c,
            "aria-valuemin": t,
            "aria-valuemax": r,
            preserveAspectRatio: "xMidYMid meet",
            children: [
              /* @__PURE__ */ A.jsx(
                "path",
                {
                  d: g(-90, 90),
                  fill: "none",
                  stroke: "#E5E7EB",
                  strokeWidth: h,
                  strokeLinecap: "round"
                }
              ),
              /* @__PURE__ */ A.jsx(
                "path",
                {
                  d: g(-90, -36),
                  fill: "none",
                  stroke: "#DC2626",
                  strokeWidth: h,
                  strokeLinecap: "round",
                  opacity: 0.6
                }
              ),
              /* @__PURE__ */ A.jsx(
                "path",
                {
                  d: g(36, 90),
                  fill: "none",
                  stroke: "#16A34A",
                  strokeWidth: h,
                  strokeLinecap: "round",
                  opacity: 0.6
                }
              ),
              /* @__PURE__ */ A.jsx(
                "path",
                {
                  d: g(-36, 36),
                  fill: "none",
                  stroke: "#EAB308",
                  strokeWidth: h,
                  strokeLinecap: "round",
                  opacity: 0.6
                }
              ),
              /* @__PURE__ */ A.jsx(
                "g",
                {
                  className: i ? "transition-transform duration-1000 ease-out" : "",
                  style: {
                    transform: `rotate(${f}deg)`,
                    transformOrigin: `${y}px ${y}px`
                  },
                  children: /* @__PURE__ */ A.jsx(
                    "line",
                    {
                      x1: y,
                      y1: y,
                      x2: y,
                      y2: y - v + h / 2,
                      stroke: "#374151",
                      strokeWidth: "4",
                      strokeLinecap: "round"
                    }
                  )
                }
              ),
              /* @__PURE__ */ A.jsx(
                "circle",
                {
                  cx: y,
                  cy: y,
                  r: "6",
                  fill: "#374151",
                  stroke: "white",
                  strokeWidth: "2"
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ A.jsxs("div", { className: "text-center mb-4", children: [
          /* @__PURE__ */ A.jsx("div", { className: "text-3xl font-bold", style: { color: p }, children: s ? `${Math.round(c)}%` : "--" }),
          /* @__PURE__ */ A.jsx("div", { className: "text-sm text-gray-600 mt-1", children: "Score Finansafe" })
        ] }),
        /* @__PURE__ */ A.jsx(
          "div",
          {
            className: "px-4 py-3 rounded-lg text-center w-full mb-4",
            style: {
              backgroundColor: s ? l <= 30 ? "#FEE2E2" : l <= 70 ? "#FEFCE8" : "#F0FDF4" : "#F5F5F5",
              color: s ? p : "#6B7280"
            },
            children: /* @__PURE__ */ A.jsx("p", { className: "text-sm font-medium", children: s ? l <= 30 ? "Saúde financeira crítica" : l <= 70 ? "Atenção: espaço para melhorar" : "Saúde financeira saudável" : u })
          }
        ),
        /* @__PURE__ */ A.jsxs("div", { className: "flex justify-between w-full text-sm text-gray-500", children: [
          /* @__PURE__ */ A.jsxs("div", { className: "text-center", children: [
            /* @__PURE__ */ A.jsx(
              "div",
              {
                className: "w-3 h-3 rounded-full mx-auto mb-1",
                style: { backgroundColor: "#DC2626" }
              }
            ),
            /* @__PURE__ */ A.jsx("div", { className: "text-xs", children: n.low }),
            /* @__PURE__ */ A.jsx("div", { className: "text-xs", children: "0-30%" })
          ] }),
          /* @__PURE__ */ A.jsxs("div", { className: "text-center", children: [
            /* @__PURE__ */ A.jsx(
              "div",
              {
                className: "w-3 h-3 rounded-full mx-auto mb-1",
                style: { backgroundColor: "#EAB308" }
              }
            ),
            /* @__PURE__ */ A.jsx("div", { className: "text-xs", children: n.medium }),
            /* @__PURE__ */ A.jsx("div", { className: "text-xs", children: "30-70%" })
          ] }),
          /* @__PURE__ */ A.jsxs("div", { className: "text-center", children: [
            /* @__PURE__ */ A.jsx(
              "div",
              {
                className: "w-3 h-3 rounded-full mx-auto mb-1",
                style: { backgroundColor: "#16A34A" }
              }
            ),
            /* @__PURE__ */ A.jsx("div", { className: "text-xs", children: n.high }),
            /* @__PURE__ */ A.jsx("div", { className: "text-xs", children: "70-100%" })
          ] })
        ] })
      ] })
    }
  );
}
var su, Xp;
function Ye() {
  if (Xp) return su;
  Xp = 1;
  var e = Array.isArray;
  return su = e, su;
}
var cu, Zp;
function hx() {
  if (Zp) return cu;
  Zp = 1;
  var e = typeof Yi == "object" && Yi && Yi.Object === Object && Yi;
  return cu = e, cu;
}
var lu, Jp;
function jt() {
  if (Jp) return lu;
  Jp = 1;
  var e = hx(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
  return lu = r, lu;
}
var fu, Qp;
function Bi() {
  if (Qp) return fu;
  Qp = 1;
  var e = jt(), t = e.Symbol;
  return fu = t, fu;
}
var du, eh;
function p1() {
  if (eh) return du;
  eh = 1;
  var e = Bi(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, i = e ? e.toStringTag : void 0;
  function a(o) {
    var u = r.call(o, i), s = o[i];
    try {
      o[i] = void 0;
      var c = !0;
    } catch {
    }
    var l = n.call(o);
    return c && (u ? o[i] = s : delete o[i]), l;
  }
  return du = a, du;
}
var pu, th;
function h1() {
  if (th) return pu;
  th = 1;
  var e = Object.prototype, t = e.toString;
  function r(n) {
    return t.call(n);
  }
  return pu = r, pu;
}
var hu, rh;
function Wt() {
  if (rh) return hu;
  rh = 1;
  var e = Bi(), t = p1(), r = h1(), n = "[object Null]", i = "[object Undefined]", a = e ? e.toStringTag : void 0;
  function o(u) {
    return u == null ? u === void 0 ? i : n : a && a in Object(u) ? t(u) : r(u);
  }
  return hu = o, hu;
}
var vu, nh;
function Ut() {
  if (nh) return vu;
  nh = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return vu = e, vu;
}
var yu, ih;
function En() {
  if (ih) return yu;
  ih = 1;
  var e = Wt(), t = Ut(), r = "[object Symbol]";
  function n(i) {
    return typeof i == "symbol" || t(i) && e(i) == r;
  }
  return yu = n, yu;
}
var mu, ah;
function Dd() {
  if (ah) return mu;
  ah = 1;
  var e = Ye(), t = En(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
  function i(a, o) {
    if (e(a))
      return !1;
    var u = typeof a;
    return u == "number" || u == "symbol" || u == "boolean" || a == null || t(a) ? !0 : n.test(a) || !r.test(a) || o != null && a in Object(o);
  }
  return mu = i, mu;
}
var gu, oh;
function or() {
  if (oh) return gu;
  oh = 1;
  function e(t) {
    var r = typeof t;
    return t != null && (r == "object" || r == "function");
  }
  return gu = e, gu;
}
var bu, uh;
function Ld() {
  if (uh) return bu;
  uh = 1;
  var e = Wt(), t = or(), r = "[object AsyncFunction]", n = "[object Function]", i = "[object GeneratorFunction]", a = "[object Proxy]";
  function o(u) {
    if (!t(u))
      return !1;
    var s = e(u);
    return s == n || s == i || s == r || s == a;
  }
  return bu = o, bu;
}
var xu, sh;
function v1() {
  if (sh) return xu;
  sh = 1;
  var e = jt(), t = e["__core-js_shared__"];
  return xu = t, xu;
}
var wu, ch;
function y1() {
  if (ch) return wu;
  ch = 1;
  var e = v1(), t = function() {
    var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return n ? "Symbol(src)_1." + n : "";
  }();
  function r(n) {
    return !!t && t in n;
  }
  return wu = r, wu;
}
var Ou, lh;
function vx() {
  if (lh) return Ou;
  lh = 1;
  var e = Function.prototype, t = e.toString;
  function r(n) {
    if (n != null) {
      try {
        return t.call(n);
      } catch {
      }
      try {
        return n + "";
      } catch {
      }
    }
    return "";
  }
  return Ou = r, Ou;
}
var _u, fh;
function m1() {
  if (fh) return _u;
  fh = 1;
  var e = Ld(), t = y1(), r = or(), n = vx(), i = /[\\^$.*+?()[\]{}|]/g, a = /^\[object .+?Constructor\]$/, o = Function.prototype, u = Object.prototype, s = o.toString, c = u.hasOwnProperty, l = RegExp(
    "^" + s.call(c).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(d) {
    if (!r(d) || t(d))
      return !1;
    var p = e(d) ? l : a;
    return p.test(n(d));
  }
  return _u = f, _u;
}
var Au, dh;
function g1() {
  if (dh) return Au;
  dh = 1;
  function e(t, r) {
    return t == null ? void 0 : t[r];
  }
  return Au = e, Au;
}
var Su, ph;
function Cr() {
  if (ph) return Su;
  ph = 1;
  var e = m1(), t = g1();
  function r(n, i) {
    var a = t(n, i);
    return e(a) ? a : void 0;
  }
  return Su = r, Su;
}
var Pu, hh;
function xo() {
  if (hh) return Pu;
  hh = 1;
  var e = Cr(), t = e(Object, "create");
  return Pu = t, Pu;
}
var Eu, vh;
function b1() {
  if (vh) return Eu;
  vh = 1;
  var e = xo();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Eu = t, Eu;
}
var ju, yh;
function x1() {
  if (yh) return ju;
  yh = 1;
  function e(t) {
    var r = this.has(t) && delete this.__data__[t];
    return this.size -= r ? 1 : 0, r;
  }
  return ju = e, ju;
}
var Tu, mh;
function w1() {
  if (mh) return Tu;
  mh = 1;
  var e = xo(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    if (e) {
      var u = o[a];
      return u === t ? void 0 : u;
    }
    return n.call(o, a) ? o[a] : void 0;
  }
  return Tu = i, Tu;
}
var $u, gh;
function O1() {
  if (gh) return $u;
  gh = 1;
  var e = xo(), t = Object.prototype, r = t.hasOwnProperty;
  function n(i) {
    var a = this.__data__;
    return e ? a[i] !== void 0 : r.call(a, i);
  }
  return $u = n, $u;
}
var Mu, bh;
function _1() {
  if (bh) return Mu;
  bh = 1;
  var e = xo(), t = "__lodash_hash_undefined__";
  function r(n, i) {
    var a = this.__data__;
    return this.size += this.has(n) ? 0 : 1, a[n] = e && i === void 0 ? t : i, this;
  }
  return Mu = r, Mu;
}
var Cu, xh;
function A1() {
  if (xh) return Cu;
  xh = 1;
  var e = b1(), t = x1(), r = w1(), n = O1(), i = _1();
  function a(o) {
    var u = -1, s = o == null ? 0 : o.length;
    for (this.clear(); ++u < s; ) {
      var c = o[u];
      this.set(c[0], c[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = i, Cu = a, Cu;
}
var Iu, wh;
function S1() {
  if (wh) return Iu;
  wh = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Iu = e, Iu;
}
var Nu, Oh;
function qd() {
  if (Oh) return Nu;
  Oh = 1;
  function e(t, r) {
    return t === r || t !== t && r !== r;
  }
  return Nu = e, Nu;
}
var ku, _h;
function wo() {
  if (_h) return ku;
  _h = 1;
  var e = qd();
  function t(r, n) {
    for (var i = r.length; i--; )
      if (e(r[i][0], n))
        return i;
    return -1;
  }
  return ku = t, ku;
}
var Ru, Ah;
function P1() {
  if (Ah) return Ru;
  Ah = 1;
  var e = wo(), t = Array.prototype, r = t.splice;
  function n(i) {
    var a = this.__data__, o = e(a, i);
    if (o < 0)
      return !1;
    var u = a.length - 1;
    return o == u ? a.pop() : r.call(a, o, 1), --this.size, !0;
  }
  return Ru = n, Ru;
}
var Du, Sh;
function E1() {
  if (Sh) return Du;
  Sh = 1;
  var e = wo();
  function t(r) {
    var n = this.__data__, i = e(n, r);
    return i < 0 ? void 0 : n[i][1];
  }
  return Du = t, Du;
}
var Lu, Ph;
function j1() {
  if (Ph) return Lu;
  Ph = 1;
  var e = wo();
  function t(r) {
    return e(this.__data__, r) > -1;
  }
  return Lu = t, Lu;
}
var qu, Eh;
function T1() {
  if (Eh) return qu;
  Eh = 1;
  var e = wo();
  function t(r, n) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? (++this.size, i.push([r, n])) : i[a][1] = n, this;
  }
  return qu = t, qu;
}
var Bu, jh;
function Oo() {
  if (jh) return Bu;
  jh = 1;
  var e = S1(), t = P1(), r = E1(), n = j1(), i = T1();
  function a(o) {
    var u = -1, s = o == null ? 0 : o.length;
    for (this.clear(); ++u < s; ) {
      var c = o[u];
      this.set(c[0], c[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = i, Bu = a, Bu;
}
var Fu, Th;
function Bd() {
  if (Th) return Fu;
  Th = 1;
  var e = Cr(), t = jt(), r = e(t, "Map");
  return Fu = r, Fu;
}
var zu, $h;
function $1() {
  if ($h) return zu;
  $h = 1;
  var e = A1(), t = Oo(), r = Bd();
  function n() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || t)(),
      string: new e()
    };
  }
  return zu = n, zu;
}
var Wu, Mh;
function M1() {
  if (Mh) return Wu;
  Mh = 1;
  function e(t) {
    var r = typeof t;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
  }
  return Wu = e, Wu;
}
var Uu, Ch;
function _o() {
  if (Ch) return Uu;
  Ch = 1;
  var e = M1();
  function t(r, n) {
    var i = r.__data__;
    return e(n) ? i[typeof n == "string" ? "string" : "hash"] : i.map;
  }
  return Uu = t, Uu;
}
var Ku, Ih;
function C1() {
  if (Ih) return Ku;
  Ih = 1;
  var e = _o();
  function t(r) {
    var n = e(this, r).delete(r);
    return this.size -= n ? 1 : 0, n;
  }
  return Ku = t, Ku;
}
var Hu, Nh;
function I1() {
  if (Nh) return Hu;
  Nh = 1;
  var e = _o();
  function t(r) {
    return e(this, r).get(r);
  }
  return Hu = t, Hu;
}
var Gu, kh;
function N1() {
  if (kh) return Gu;
  kh = 1;
  var e = _o();
  function t(r) {
    return e(this, r).has(r);
  }
  return Gu = t, Gu;
}
var Vu, Rh;
function k1() {
  if (Rh) return Vu;
  Rh = 1;
  var e = _o();
  function t(r, n) {
    var i = e(this, r), a = i.size;
    return i.set(r, n), this.size += i.size == a ? 0 : 1, this;
  }
  return Vu = t, Vu;
}
var Yu, Dh;
function Fd() {
  if (Dh) return Yu;
  Dh = 1;
  var e = $1(), t = C1(), r = I1(), n = N1(), i = k1();
  function a(o) {
    var u = -1, s = o == null ? 0 : o.length;
    for (this.clear(); ++u < s; ) {
      var c = o[u];
      this.set(c[0], c[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = r, a.prototype.has = n, a.prototype.set = i, Yu = a, Yu;
}
var Xu, Lh;
function yx() {
  if (Lh) return Xu;
  Lh = 1;
  var e = Fd(), t = "Expected a function";
  function r(n, i) {
    if (typeof n != "function" || i != null && typeof i != "function")
      throw new TypeError(t);
    var a = function() {
      var o = arguments, u = i ? i.apply(this, o) : o[0], s = a.cache;
      if (s.has(u))
        return s.get(u);
      var c = n.apply(this, o);
      return a.cache = s.set(u, c) || s, c;
    };
    return a.cache = new (r.Cache || e)(), a;
  }
  return r.Cache = e, Xu = r, Xu;
}
var Zu, qh;
function R1() {
  if (qh) return Zu;
  qh = 1;
  var e = yx(), t = 500;
  function r(n) {
    var i = e(n, function(o) {
      return a.size === t && a.clear(), o;
    }), a = i.cache;
    return i;
  }
  return Zu = r, Zu;
}
var Ju, Bh;
function D1() {
  if (Bh) return Ju;
  Bh = 1;
  var e = R1(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, n = e(function(i) {
    var a = [];
    return i.charCodeAt(0) === 46 && a.push(""), i.replace(t, function(o, u, s, c) {
      a.push(s ? c.replace(r, "$1") : u || o);
    }), a;
  });
  return Ju = n, Ju;
}
var Qu, Fh;
function zd() {
  if (Fh) return Qu;
  Fh = 1;
  function e(t, r) {
    for (var n = -1, i = t == null ? 0 : t.length, a = Array(i); ++n < i; )
      a[n] = r(t[n], n, t);
    return a;
  }
  return Qu = e, Qu;
}
var es, zh;
function L1() {
  if (zh) return es;
  zh = 1;
  var e = Bi(), t = zd(), r = Ye(), n = En(), i = e ? e.prototype : void 0, a = i ? i.toString : void 0;
  function o(u) {
    if (typeof u == "string")
      return u;
    if (r(u))
      return t(u, o) + "";
    if (n(u))
      return a ? a.call(u) : "";
    var s = u + "";
    return s == "0" && 1 / u == -1 / 0 ? "-0" : s;
  }
  return es = o, es;
}
var ts, Wh;
function mx() {
  if (Wh) return ts;
  Wh = 1;
  var e = L1();
  function t(r) {
    return r == null ? "" : e(r);
  }
  return ts = t, ts;
}
var rs, Uh;
function gx() {
  if (Uh) return rs;
  Uh = 1;
  var e = Ye(), t = Dd(), r = D1(), n = mx();
  function i(a, o) {
    return e(a) ? a : t(a, o) ? [a] : r(n(a));
  }
  return rs = i, rs;
}
var ns, Kh;
function Ao() {
  if (Kh) return ns;
  Kh = 1;
  var e = En();
  function t(r) {
    if (typeof r == "string" || e(r))
      return r;
    var n = r + "";
    return n == "0" && 1 / r == -1 / 0 ? "-0" : n;
  }
  return ns = t, ns;
}
var is, Hh;
function Wd() {
  if (Hh) return is;
  Hh = 1;
  var e = gx(), t = Ao();
  function r(n, i) {
    i = e(i, n);
    for (var a = 0, o = i.length; n != null && a < o; )
      n = n[t(i[a++])];
    return a && a == o ? n : void 0;
  }
  return is = r, is;
}
var as, Gh;
function bx() {
  if (Gh) return as;
  Gh = 1;
  var e = Wd();
  function t(r, n, i) {
    var a = r == null ? void 0 : e(r, n);
    return a === void 0 ? i : a;
  }
  return as = t, as;
}
var q1 = bx();
const et = /* @__PURE__ */ ye(q1);
var os, Vh;
function B1() {
  if (Vh) return os;
  Vh = 1;
  function e(t) {
    return t == null;
  }
  return os = e, os;
}
var F1 = B1();
const te = /* @__PURE__ */ ye(F1);
var us, Yh;
function z1() {
  if (Yh) return us;
  Yh = 1;
  var e = Wt(), t = Ye(), r = Ut(), n = "[object String]";
  function i(a) {
    return typeof a == "string" || !t(a) && r(a) && e(a) == n;
  }
  return us = i, us;
}
var W1 = z1();
const Er = /* @__PURE__ */ ye(W1);
var U1 = Ld();
const re = /* @__PURE__ */ ye(U1);
var K1 = or();
const jn = /* @__PURE__ */ ye(K1);
var Zi = { exports: {} }, le = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xh;
function H1() {
  if (Xh) return le;
  Xh = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), u = Symbol.for("react.server_context"), s = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), y;
  y = Symbol.for("react.module.reference");
  function v(h) {
    if (typeof h == "object" && h !== null) {
      var x = h.$$typeof;
      switch (x) {
        case e:
          switch (h = h.type, h) {
            case r:
            case i:
            case n:
            case c:
            case l:
              return h;
            default:
              switch (h = h && h.$$typeof, h) {
                case u:
                case o:
                case s:
                case d:
                case f:
                case a:
                  return h;
                default:
                  return x;
              }
          }
        case t:
          return x;
      }
    }
  }
  return le.ContextConsumer = o, le.ContextProvider = a, le.Element = e, le.ForwardRef = s, le.Fragment = r, le.Lazy = d, le.Memo = f, le.Portal = t, le.Profiler = i, le.StrictMode = n, le.Suspense = c, le.SuspenseList = l, le.isAsyncMode = function() {
    return !1;
  }, le.isConcurrentMode = function() {
    return !1;
  }, le.isContextConsumer = function(h) {
    return v(h) === o;
  }, le.isContextProvider = function(h) {
    return v(h) === a;
  }, le.isElement = function(h) {
    return typeof h == "object" && h !== null && h.$$typeof === e;
  }, le.isForwardRef = function(h) {
    return v(h) === s;
  }, le.isFragment = function(h) {
    return v(h) === r;
  }, le.isLazy = function(h) {
    return v(h) === d;
  }, le.isMemo = function(h) {
    return v(h) === f;
  }, le.isPortal = function(h) {
    return v(h) === t;
  }, le.isProfiler = function(h) {
    return v(h) === i;
  }, le.isStrictMode = function(h) {
    return v(h) === n;
  }, le.isSuspense = function(h) {
    return v(h) === c;
  }, le.isSuspenseList = function(h) {
    return v(h) === l;
  }, le.isValidElementType = function(h) {
    return typeof h == "string" || typeof h == "function" || h === r || h === i || h === n || h === c || h === l || h === p || typeof h == "object" && h !== null && (h.$$typeof === d || h.$$typeof === f || h.$$typeof === a || h.$$typeof === o || h.$$typeof === s || h.$$typeof === y || h.getModuleId !== void 0);
  }, le.typeOf = v, le;
}
var fe = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Zh;
function G1() {
  return Zh || (Zh = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), o = Symbol.for("react.context"), u = Symbol.for("react.server_context"), s = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), y = !1, v = !1, h = !1, x = !1, g = !1, b;
    b = Symbol.for("react.module.reference");
    function O(H) {
      return !!(typeof H == "string" || typeof H == "function" || H === r || H === i || g || H === n || H === c || H === l || x || H === p || y || v || h || typeof H == "object" && H !== null && (H.$$typeof === d || H.$$typeof === f || H.$$typeof === a || H.$$typeof === o || H.$$typeof === s || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      H.$$typeof === b || H.getModuleId !== void 0));
    }
    function m(H) {
      if (typeof H == "object" && H !== null) {
        var ge = H.$$typeof;
        switch (ge) {
          case e:
            var Ae = H.type;
            switch (Ae) {
              case r:
              case i:
              case n:
              case c:
              case l:
                return Ae;
              default:
                var Le = Ae && Ae.$$typeof;
                switch (Le) {
                  case u:
                  case o:
                  case s:
                  case d:
                  case f:
                  case a:
                    return Le;
                  default:
                    return ge;
                }
            }
          case t:
            return ge;
        }
      }
    }
    var w = o, _ = a, P = e, T = s, M = r, j = d, $ = f, I = t, k = i, R = n, D = c, B = l, W = !1, K = !1;
    function E(H) {
      return W || (W = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function N(H) {
      return K || (K = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function L(H) {
      return m(H) === o;
    }
    function z(H) {
      return m(H) === a;
    }
    function V(H) {
      return typeof H == "object" && H !== null && H.$$typeof === e;
    }
    function Y(H) {
      return m(H) === s;
    }
    function ee(H) {
      return m(H) === r;
    }
    function ne(H) {
      return m(H) === d;
    }
    function X(H) {
      return m(H) === f;
    }
    function F(H) {
      return m(H) === t;
    }
    function G(H) {
      return m(H) === i;
    }
    function Q(H) {
      return m(H) === n;
    }
    function C(H) {
      return m(H) === c;
    }
    function ue(H) {
      return m(H) === l;
    }
    fe.ContextConsumer = w, fe.ContextProvider = _, fe.Element = P, fe.ForwardRef = T, fe.Fragment = M, fe.Lazy = j, fe.Memo = $, fe.Portal = I, fe.Profiler = k, fe.StrictMode = R, fe.Suspense = D, fe.SuspenseList = B, fe.isAsyncMode = E, fe.isConcurrentMode = N, fe.isContextConsumer = L, fe.isContextProvider = z, fe.isElement = V, fe.isForwardRef = Y, fe.isFragment = ee, fe.isLazy = ne, fe.isMemo = X, fe.isPortal = F, fe.isProfiler = G, fe.isStrictMode = Q, fe.isSuspense = C, fe.isSuspenseList = ue, fe.isValidElementType = O, fe.typeOf = m;
  }()), fe;
}
var Jh;
function V1() {
  return Jh || (Jh = 1, process.env.NODE_ENV === "production" ? Zi.exports = H1() : Zi.exports = G1()), Zi.exports;
}
var Y1 = V1(), ss, Qh;
function xx() {
  if (Qh) return ss;
  Qh = 1;
  var e = Wt(), t = Ut(), r = "[object Number]";
  function n(i) {
    return typeof i == "number" || t(i) && e(i) == r;
  }
  return ss = n, ss;
}
var cs, ev;
function X1() {
  if (ev) return cs;
  ev = 1;
  var e = xx();
  function t(r) {
    return e(r) && r != +r;
  }
  return cs = t, cs;
}
var Z1 = X1();
const Tn = /* @__PURE__ */ ye(Z1);
var J1 = xx();
const Q1 = /* @__PURE__ */ ye(J1);
var We = function(t) {
  return t === 0 ? 0 : t > 0 ? 1 : -1;
}, gr = function(t) {
  return Er(t) && t.indexOf("%") === t.length - 1;
}, U = function(t) {
  return Q1(t) && !Tn(t);
}, eA = function(t) {
  return te(t);
}, Ie = function(t) {
  return U(t) || Er(t);
}, tA = 0, ur = function(t) {
  var r = ++tA;
  return "".concat(t || "").concat(r);
}, Ue = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!U(t) && !Er(t))
    return n;
  var a;
  if (gr(t)) {
    var o = t.indexOf("%");
    a = r * parseFloat(t.slice(0, o)) / 100;
  } else
    a = +t;
  return Tn(a) && (a = n), i && a > r && (a = r), a;
}, Xt = function(t) {
  if (!t)
    return null;
  var r = Object.keys(t);
  return r && r.length ? t[r[0]] : null;
}, rA = function(t) {
  if (!Array.isArray(t))
    return !1;
  for (var r = t.length, n = {}, i = 0; i < r; i++)
    if (!n[t[i]])
      n[t[i]] = !0;
    else
      return !0;
  return !1;
}, Pe = function(t, r) {
  return U(t) && U(r) ? function(n) {
    return t + n * (r - t);
  } : function() {
    return r;
  };
};
function va(e, t, r) {
  return !e || !e.length ? null : e.find(function(n) {
    return n && (typeof t == "function" ? t(n) : et(n, t)) === r;
  });
}
var nA = function(t) {
  if (!t || !t.length)
    return null;
  for (var r = t.length, n = 0, i = 0, a = 0, o = 0, u = 1 / 0, s = -1 / 0, c = 0, l = 0, f = 0; f < r; f++)
    c = t[f].cx || 0, l = t[f].cy || 0, n += c, i += l, a += c * l, o += c * c, u = Math.min(u, c), s = Math.max(s, c);
  var d = r * o !== n * n ? (r * a - n * i) / (r * o - n * n) : 0;
  return {
    xmin: u,
    xmax: s,
    a: d,
    b: (i - d * n) / r
  };
}, iA = function(t, r) {
  return U(t) && U(r) ? t - r : Er(t) && Er(r) ? t.localeCompare(r) : t instanceof Date && r instanceof Date ? t.getTime() - r.getTime() : String(t).localeCompare(String(r));
};
function Gr(e, t) {
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r) && (!{}.hasOwnProperty.call(t, r) || e[r] !== t[r]))
      return !1;
  for (var n in t)
    if ({}.hasOwnProperty.call(t, n) && !{}.hasOwnProperty.call(e, n))
      return !1;
  return !0;
}
function pf(e) {
  "@babel/helpers - typeof";
  return pf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, pf(e);
}
var aA = ["viewBox", "children"], oA = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], tv = ["points", "pathLength"], ls = {
  svg: aA,
  polygon: tv,
  polyline: tv
}, Ud = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], ya = function(t, r) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var n = t;
  if (/* @__PURE__ */ bt(t) && (n = t.props), !jn(n))
    return null;
  var i = {};
  return Object.keys(n).forEach(function(a) {
    Ud.includes(a) && (i[a] = r || function(o) {
      return n[a](n, o);
    });
  }), i;
}, uA = function(t, r, n) {
  return function(i) {
    return t(r, n, i), null;
  };
}, nr = function(t, r, n) {
  if (!jn(t) || pf(t) !== "object")
    return null;
  var i = null;
  return Object.keys(t).forEach(function(a) {
    var o = t[a];
    Ud.includes(a) && typeof o == "function" && (i || (i = {}), i[a] = uA(o, r, n));
  }), i;
}, sA = ["children"], cA = ["children"];
function rv(e, t) {
  if (e == null) return {};
  var r = lA(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function lA(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function hf(e) {
  "@babel/helpers - typeof";
  return hf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, hf(e);
}
var nv = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
}, Dt = function(t) {
  return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
}, iv = null, fs = null, Kd = function e(t) {
  if (t === iv && Array.isArray(fs))
    return fs;
  var r = [];
  return _r.forEach(t, function(n) {
    te(n) || (Y1.isFragment(n) ? r = r.concat(e(n.props.children)) : r.push(n));
  }), fs = r, iv = t, r;
};
function He(e, t) {
  var r = [], n = [];
  return Array.isArray(t) ? n = t.map(function(i) {
    return Dt(i);
  }) : n = [Dt(t)], Kd(e).forEach(function(i) {
    var a = et(i, "type.displayName") || et(i, "type.name");
    n.indexOf(a) !== -1 && r.push(i);
  }), r;
}
function Je(e, t) {
  var r = He(e, t);
  return r && r[0];
}
var av = function(t) {
  if (!t || !t.props)
    return !1;
  var r = t.props, n = r.width, i = r.height;
  return !(!U(n) || n <= 0 || !U(i) || i <= 0);
}, fA = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], dA = function(t) {
  return t && t.type && Er(t.type) && fA.indexOf(t.type) >= 0;
}, wx = function(t) {
  return t && hf(t) === "object" && "clipDot" in t;
}, pA = function(t, r, n, i) {
  var a, o = (a = ls == null ? void 0 : ls[i]) !== null && a !== void 0 ? a : [];
  return r.startsWith("data-") || !re(t) && (i && o.includes(r) || oA.includes(r)) || n && Ud.includes(r);
}, J = function(t, r, n) {
  if (!t || typeof t == "function" || typeof t == "boolean")
    return null;
  var i = t;
  if (/* @__PURE__ */ bt(t) && (i = t.props), !jn(i))
    return null;
  var a = {};
  return Object.keys(i).forEach(function(o) {
    var u;
    pA((u = i) === null || u === void 0 ? void 0 : u[o], o, r, n) && (a[o] = i[o]);
  }), a;
}, vf = function e(t, r) {
  if (t === r)
    return !0;
  var n = _r.count(t);
  if (n !== _r.count(r))
    return !1;
  if (n === 0)
    return !0;
  if (n === 1)
    return ov(Array.isArray(t) ? t[0] : t, Array.isArray(r) ? r[0] : r);
  for (var i = 0; i < n; i++) {
    var a = t[i], o = r[i];
    if (Array.isArray(a) || Array.isArray(o)) {
      if (!e(a, o))
        return !1;
    } else if (!ov(a, o))
      return !1;
  }
  return !0;
}, ov = function(t, r) {
  if (te(t) && te(r))
    return !0;
  if (!te(t) && !te(r)) {
    var n = t.props || {}, i = n.children, a = rv(n, sA), o = r.props || {}, u = o.children, s = rv(o, cA);
    return i && u ? Gr(a, s) && vf(i, u) : !i && !u ? Gr(a, s) : !1;
  }
  return !1;
}, uv = function(t, r) {
  var n = [], i = {};
  return Kd(t).forEach(function(a, o) {
    if (dA(a))
      n.push(a);
    else if (a) {
      var u = Dt(a.type), s = r[u] || {}, c = s.handler, l = s.once;
      if (c && (!l || !i[u])) {
        var f = c(a, u, o);
        n.push(f), i[u] = !0;
      }
    }
  }), n;
}, hA = function(t) {
  var r = t && t.type;
  return r && nv[r] ? nv[r] : null;
}, vA = function(t, r) {
  return Kd(r).indexOf(t);
}, yA = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function yf() {
  return yf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, yf.apply(this, arguments);
}
function mA(e, t) {
  if (e == null) return {};
  var r = gA(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function gA(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function mf(e) {
  var t = e.children, r = e.width, n = e.height, i = e.viewBox, a = e.className, o = e.style, u = e.title, s = e.desc, c = mA(e, yA), l = i || {
    width: r,
    height: n,
    x: 0,
    y: 0
  }, f = ae("recharts-surface", a);
  return /* @__PURE__ */ S.createElement("svg", yf({}, J(c, !0, "svg"), {
    className: f,
    width: r,
    height: n,
    style: o,
    viewBox: "".concat(l.x, " ").concat(l.y, " ").concat(l.width, " ").concat(l.height)
  }), /* @__PURE__ */ S.createElement("title", null, u), /* @__PURE__ */ S.createElement("desc", null, s), t);
}
var bA = ["children", "className"];
function gf() {
  return gf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gf.apply(this, arguments);
}
function xA(e, t) {
  if (e == null) return {};
  var r = wA(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function wA(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var oe = /* @__PURE__ */ S.forwardRef(function(e, t) {
  var r = e.children, n = e.className, i = xA(e, bA), a = ae("recharts-layer", n);
  return /* @__PURE__ */ S.createElement("g", gf({
    className: a
  }, J(i, !0), {
    ref: t
  }), r);
}), OA = process.env.NODE_ENV !== "production", xt = function(t, r) {
  for (var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++)
    i[a - 2] = arguments[a];
  if (OA && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var o = 0;
      console.warn(r.replace(/%s/g, function() {
        return i[o++];
      }));
    }
}, ds, sv;
function _A() {
  if (sv) return ds;
  sv = 1;
  function e(t, r, n) {
    var i = -1, a = t.length;
    r < 0 && (r = -r > a ? 0 : a + r), n = n > a ? a : n, n < 0 && (n += a), a = r > n ? 0 : n - r >>> 0, r >>>= 0;
    for (var o = Array(a); ++i < a; )
      o[i] = t[i + r];
    return o;
  }
  return ds = e, ds;
}
var ps, cv;
function AA() {
  if (cv) return ps;
  cv = 1;
  var e = _A();
  function t(r, n, i) {
    var a = r.length;
    return i = i === void 0 ? a : i, !n && i >= a ? r : e(r, n, i);
  }
  return ps = t, ps;
}
var hs, lv;
function Ox() {
  if (lv) return hs;
  lv = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", i = t + r + n, a = "\\ufe0e\\ufe0f", o = "\\u200d", u = RegExp("[" + o + e + i + a + "]");
  function s(c) {
    return u.test(c);
  }
  return hs = s, hs;
}
var vs, fv;
function SA() {
  if (fv) return vs;
  fv = 1;
  function e(t) {
    return t.split("");
  }
  return vs = e, vs;
}
var ys, dv;
function PA() {
  if (dv) return ys;
  dv = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", i = t + r + n, a = "\\ufe0e\\ufe0f", o = "[" + e + "]", u = "[" + i + "]", s = "\\ud83c[\\udffb-\\udfff]", c = "(?:" + u + "|" + s + ")", l = "[^" + e + "]", f = "(?:\\ud83c[\\udde6-\\uddff]){2}", d = "[\\ud800-\\udbff][\\udc00-\\udfff]", p = "\\u200d", y = c + "?", v = "[" + a + "]?", h = "(?:" + p + "(?:" + [l, f, d].join("|") + ")" + v + y + ")*", x = v + y + h, g = "(?:" + [l + u + "?", u, f, d, o].join("|") + ")", b = RegExp(s + "(?=" + s + ")|" + g + x, "g");
  function O(m) {
    return m.match(b) || [];
  }
  return ys = O, ys;
}
var ms, pv;
function EA() {
  if (pv) return ms;
  pv = 1;
  var e = SA(), t = Ox(), r = PA();
  function n(i) {
    return t(i) ? r(i) : e(i);
  }
  return ms = n, ms;
}
var gs, hv;
function jA() {
  if (hv) return gs;
  hv = 1;
  var e = AA(), t = Ox(), r = EA(), n = mx();
  function i(a) {
    return function(o) {
      o = n(o);
      var u = t(o) ? r(o) : void 0, s = u ? u[0] : o.charAt(0), c = u ? e(u, 1).join("") : o.slice(1);
      return s[a]() + c;
    };
  }
  return gs = i, gs;
}
var bs, vv;
function TA() {
  if (vv) return bs;
  vv = 1;
  var e = jA(), t = e("toUpperCase");
  return bs = t, bs;
}
var $A = TA();
const So = /* @__PURE__ */ ye($A);
function xe(e) {
  return function() {
    return e;
  };
}
const _x = Math.cos, ma = Math.sin, Ot = Math.sqrt, ga = Math.PI, Po = 2 * ga, bf = Math.PI, xf = 2 * bf, vr = 1e-6, MA = xf - vr;
function Ax(e) {
  this._ += e[0];
  for (let t = 1, r = e.length; t < r; ++t)
    this._ += arguments[t] + e[t];
}
function CA(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return Ax;
  const r = 10 ** t;
  return function(n) {
    this._ += n[0];
    for (let i = 1, a = n.length; i < a; ++i)
      this._ += Math.round(arguments[i] * r) / r + n[i];
  };
}
class IA {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? Ax : CA(t);
  }
  moveTo(t, r) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, r) {
    this._append`L${this._x1 = +t},${this._y1 = +r}`;
  }
  quadraticCurveTo(t, r, n, i) {
    this._append`Q${+t},${+r},${this._x1 = +n},${this._y1 = +i}`;
  }
  bezierCurveTo(t, r, n, i, a, o) {
    this._append`C${+t},${+r},${+n},${+i},${this._x1 = +a},${this._y1 = +o}`;
  }
  arcTo(t, r, n, i, a) {
    if (t = +t, r = +r, n = +n, i = +i, a = +a, a < 0) throw new Error(`negative radius: ${a}`);
    let o = this._x1, u = this._y1, s = n - t, c = i - r, l = o - t, f = u - r, d = l * l + f * f;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = r}`;
    else if (d > vr) if (!(Math.abs(f * s - c * l) > vr) || !a)
      this._append`L${this._x1 = t},${this._y1 = r}`;
    else {
      let p = n - o, y = i - u, v = s * s + c * c, h = p * p + y * y, x = Math.sqrt(v), g = Math.sqrt(d), b = a * Math.tan((bf - Math.acos((v + d - h) / (2 * x * g))) / 2), O = b / g, m = b / x;
      Math.abs(O - 1) > vr && this._append`L${t + O * l},${r + O * f}`, this._append`A${a},${a},0,0,${+(f * p > l * y)},${this._x1 = t + m * s},${this._y1 = r + m * c}`;
    }
  }
  arc(t, r, n, i, a, o) {
    if (t = +t, r = +r, n = +n, o = !!o, n < 0) throw new Error(`negative radius: ${n}`);
    let u = n * Math.cos(i), s = n * Math.sin(i), c = t + u, l = r + s, f = 1 ^ o, d = o ? i - a : a - i;
    this._x1 === null ? this._append`M${c},${l}` : (Math.abs(this._x1 - c) > vr || Math.abs(this._y1 - l) > vr) && this._append`L${c},${l}`, n && (d < 0 && (d = d % xf + xf), d > MA ? this._append`A${n},${n},0,1,${f},${t - u},${r - s}A${n},${n},0,1,${f},${this._x1 = c},${this._y1 = l}` : d > vr && this._append`A${n},${n},0,${+(d >= bf)},${f},${this._x1 = t + n * Math.cos(a)},${this._y1 = r + n * Math.sin(a)}`);
  }
  rect(t, r, n, i) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}h${n = +n}v${+i}h${-n}Z`;
  }
  toString() {
    return this._;
  }
}
function Hd(e) {
  let t = 3;
  return e.digits = function(r) {
    if (!arguments.length) return t;
    if (r == null)
      t = null;
    else {
      const n = Math.floor(r);
      if (!(n >= 0)) throw new RangeError(`invalid digits: ${r}`);
      t = n;
    }
    return e;
  }, () => new IA(t);
}
function Gd(e) {
  return typeof e == "object" && "length" in e ? e : Array.from(e);
}
function Sx(e) {
  this._context = e;
}
Sx.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(e, t);
        break;
    }
  }
};
function Eo(e) {
  return new Sx(e);
}
function Px(e) {
  return e[0];
}
function Ex(e) {
  return e[1];
}
function jx(e, t) {
  var r = xe(!0), n = null, i = Eo, a = null, o = Hd(u);
  e = typeof e == "function" ? e : e === void 0 ? Px : xe(e), t = typeof t == "function" ? t : t === void 0 ? Ex : xe(t);
  function u(s) {
    var c, l = (s = Gd(s)).length, f, d = !1, p;
    for (n == null && (a = i(p = o())), c = 0; c <= l; ++c)
      !(c < l && r(f = s[c], c, s)) === d && ((d = !d) ? a.lineStart() : a.lineEnd()), d && a.point(+e(f, c, s), +t(f, c, s));
    if (p) return a = null, p + "" || null;
  }
  return u.x = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : xe(+s), u) : e;
  }, u.y = function(s) {
    return arguments.length ? (t = typeof s == "function" ? s : xe(+s), u) : t;
  }, u.defined = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : xe(!!s), u) : r;
  }, u.curve = function(s) {
    return arguments.length ? (i = s, n != null && (a = i(n)), u) : i;
  }, u.context = function(s) {
    return arguments.length ? (s == null ? n = a = null : a = i(n = s), u) : n;
  }, u;
}
function Ji(e, t, r) {
  var n = null, i = xe(!0), a = null, o = Eo, u = null, s = Hd(c);
  e = typeof e == "function" ? e : e === void 0 ? Px : xe(+e), t = typeof t == "function" ? t : xe(t === void 0 ? 0 : +t), r = typeof r == "function" ? r : r === void 0 ? Ex : xe(+r);
  function c(f) {
    var d, p, y, v = (f = Gd(f)).length, h, x = !1, g, b = new Array(v), O = new Array(v);
    for (a == null && (u = o(g = s())), d = 0; d <= v; ++d) {
      if (!(d < v && i(h = f[d], d, f)) === x)
        if (x = !x)
          p = d, u.areaStart(), u.lineStart();
        else {
          for (u.lineEnd(), u.lineStart(), y = d - 1; y >= p; --y)
            u.point(b[y], O[y]);
          u.lineEnd(), u.areaEnd();
        }
      x && (b[d] = +e(h, d, f), O[d] = +t(h, d, f), u.point(n ? +n(h, d, f) : b[d], r ? +r(h, d, f) : O[d]));
    }
    if (g) return u = null, g + "" || null;
  }
  function l() {
    return jx().defined(i).curve(o).context(a);
  }
  return c.x = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : xe(+f), n = null, c) : e;
  }, c.x0 = function(f) {
    return arguments.length ? (e = typeof f == "function" ? f : xe(+f), c) : e;
  }, c.x1 = function(f) {
    return arguments.length ? (n = f == null ? null : typeof f == "function" ? f : xe(+f), c) : n;
  }, c.y = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : xe(+f), r = null, c) : t;
  }, c.y0 = function(f) {
    return arguments.length ? (t = typeof f == "function" ? f : xe(+f), c) : t;
  }, c.y1 = function(f) {
    return arguments.length ? (r = f == null ? null : typeof f == "function" ? f : xe(+f), c) : r;
  }, c.lineX0 = c.lineY0 = function() {
    return l().x(e).y(t);
  }, c.lineY1 = function() {
    return l().x(e).y(r);
  }, c.lineX1 = function() {
    return l().x(n).y(t);
  }, c.defined = function(f) {
    return arguments.length ? (i = typeof f == "function" ? f : xe(!!f), c) : i;
  }, c.curve = function(f) {
    return arguments.length ? (o = f, a != null && (u = o(a)), c) : o;
  }, c.context = function(f) {
    return arguments.length ? (f == null ? a = u = null : u = o(a = f), c) : a;
  }, c;
}
class Tx {
  constructor(t, r) {
    this._context = t, this._x = r;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(t, r) {
    switch (t = +t, r = +r, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(t, r) : this._context.moveTo(t, r);
        break;
      }
      case 1:
        this._point = 2;
      // falls through
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, r, t, r) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + r) / 2, t, this._y0, t, r);
        break;
      }
    }
    this._x0 = t, this._y0 = r;
  }
}
function NA(e) {
  return new Tx(e, !0);
}
function kA(e) {
  return new Tx(e, !1);
}
const Vd = {
  draw(e, t) {
    const r = Ot(t / ga);
    e.moveTo(r, 0), e.arc(0, 0, r, 0, Po);
  }
}, RA = {
  draw(e, t) {
    const r = Ot(t / 5) / 2;
    e.moveTo(-3 * r, -r), e.lineTo(-r, -r), e.lineTo(-r, -3 * r), e.lineTo(r, -3 * r), e.lineTo(r, -r), e.lineTo(3 * r, -r), e.lineTo(3 * r, r), e.lineTo(r, r), e.lineTo(r, 3 * r), e.lineTo(-r, 3 * r), e.lineTo(-r, r), e.lineTo(-3 * r, r), e.closePath();
  }
}, $x = Ot(1 / 3), DA = $x * 2, LA = {
  draw(e, t) {
    const r = Ot(t / DA), n = r * $x;
    e.moveTo(0, -r), e.lineTo(n, 0), e.lineTo(0, r), e.lineTo(-n, 0), e.closePath();
  }
}, qA = {
  draw(e, t) {
    const r = Ot(t), n = -r / 2;
    e.rect(n, n, r, r);
  }
}, BA = 0.8908130915292852, Mx = ma(ga / 10) / ma(7 * ga / 10), FA = ma(Po / 10) * Mx, zA = -_x(Po / 10) * Mx, WA = {
  draw(e, t) {
    const r = Ot(t * BA), n = FA * r, i = zA * r;
    e.moveTo(0, -r), e.lineTo(n, i);
    for (let a = 1; a < 5; ++a) {
      const o = Po * a / 5, u = _x(o), s = ma(o);
      e.lineTo(s * r, -u * r), e.lineTo(u * n - s * i, s * n + u * i);
    }
    e.closePath();
  }
}, xs = Ot(3), UA = {
  draw(e, t) {
    const r = -Ot(t / (xs * 3));
    e.moveTo(0, r * 2), e.lineTo(-xs * r, -r), e.lineTo(xs * r, -r), e.closePath();
  }
}, rt = -0.5, nt = Ot(3) / 2, wf = 1 / Ot(12), KA = (wf / 2 + 1) * 3, HA = {
  draw(e, t) {
    const r = Ot(t / KA), n = r / 2, i = r * wf, a = n, o = r * wf + r, u = -a, s = o;
    e.moveTo(n, i), e.lineTo(a, o), e.lineTo(u, s), e.lineTo(rt * n - nt * i, nt * n + rt * i), e.lineTo(rt * a - nt * o, nt * a + rt * o), e.lineTo(rt * u - nt * s, nt * u + rt * s), e.lineTo(rt * n + nt * i, rt * i - nt * n), e.lineTo(rt * a + nt * o, rt * o - nt * a), e.lineTo(rt * u + nt * s, rt * s - nt * u), e.closePath();
  }
};
function GA(e, t) {
  let r = null, n = Hd(i);
  e = typeof e == "function" ? e : xe(e || Vd), t = typeof t == "function" ? t : xe(t === void 0 ? 64 : +t);
  function i() {
    let a;
    if (r || (r = a = n()), e.apply(this, arguments).draw(r, +t.apply(this, arguments)), a) return r = null, a + "" || null;
  }
  return i.type = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : xe(a), i) : e;
  }, i.size = function(a) {
    return arguments.length ? (t = typeof a == "function" ? a : xe(+a), i) : t;
  }, i.context = function(a) {
    return arguments.length ? (r = a ?? null, i) : r;
  }, i;
}
function ba() {
}
function xa(e, t, r) {
  e._context.bezierCurveTo(
    (2 * e._x0 + e._x1) / 3,
    (2 * e._y0 + e._y1) / 3,
    (e._x0 + 2 * e._x1) / 3,
    (e._y0 + 2 * e._y1) / 3,
    (e._x0 + 4 * e._x1 + t) / 6,
    (e._y0 + 4 * e._y1 + r) / 6
  );
}
function Cx(e) {
  this._context = e;
}
Cx.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        xa(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        xa(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function VA(e) {
  return new Cx(e);
}
function Ix(e) {
  this._context = e;
}
Ix.prototype = {
  areaStart: ba,
  areaEnd: ba,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._x2 = e, this._y2 = t;
        break;
      case 1:
        this._point = 2, this._x3 = e, this._y3 = t;
        break;
      case 2:
        this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
        break;
      default:
        xa(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function YA(e) {
  return new Ix(e);
}
function Nx(e) {
  this._context = e;
}
Nx.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var r = (this._x0 + 4 * this._x1 + e) / 6, n = (this._y0 + 4 * this._y1 + t) / 6;
        this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        xa(this, e, t);
        break;
    }
    this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
  }
};
function XA(e) {
  return new Nx(e);
}
function kx(e) {
  this._context = e;
}
kx.prototype = {
  areaStart: ba,
  areaEnd: ba,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(e, t) {
    e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
  }
};
function ZA(e) {
  return new kx(e);
}
function yv(e) {
  return e < 0 ? -1 : 1;
}
function mv(e, t, r) {
  var n = e._x1 - e._x0, i = t - e._x1, a = (e._y1 - e._y0) / (n || i < 0 && -0), o = (r - e._y1) / (i || n < 0 && -0), u = (a * i + o * n) / (n + i);
  return (yv(a) + yv(o)) * Math.min(Math.abs(a), Math.abs(o), 0.5 * Math.abs(u)) || 0;
}
function gv(e, t) {
  var r = e._x1 - e._x0;
  return r ? (3 * (e._y1 - e._y0) / r - t) / 2 : t;
}
function ws(e, t, r) {
  var n = e._x0, i = e._y0, a = e._x1, o = e._y1, u = (a - n) / 3;
  e._context.bezierCurveTo(n + u, i + u * t, a - u, o - u * r, a, o);
}
function wa(e) {
  this._context = e;
}
wa.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        ws(this, this._t0, gv(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(e, t) {
    var r = NaN;
    if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, ws(this, gv(this, r = mv(this, e, t)), r);
          break;
        default:
          ws(this, this._t0, r = mv(this, e, t));
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = r;
    }
  }
};
function Rx(e) {
  this._context = new Dx(e);
}
(Rx.prototype = Object.create(wa.prototype)).point = function(e, t) {
  wa.prototype.point.call(this, t, e);
};
function Dx(e) {
  this._context = e;
}
Dx.prototype = {
  moveTo: function(e, t) {
    this._context.moveTo(t, e);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(e, t) {
    this._context.lineTo(t, e);
  },
  bezierCurveTo: function(e, t, r, n, i, a) {
    this._context.bezierCurveTo(t, e, n, r, a, i);
  }
};
function JA(e) {
  return new wa(e);
}
function QA(e) {
  return new Rx(e);
}
function Lx(e) {
  this._context = e;
}
Lx.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var e = this._x, t = this._y, r = e.length;
    if (r)
      if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), r === 2)
        this._context.lineTo(e[1], t[1]);
      else
        for (var n = bv(e), i = bv(t), a = 0, o = 1; o < r; ++a, ++o)
          this._context.bezierCurveTo(n[0][a], i[0][a], n[1][a], i[1][a], e[o], t[o]);
    (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(e, t) {
    this._x.push(+e), this._y.push(+t);
  }
};
function bv(e) {
  var t, r = e.length - 1, n, i = new Array(r), a = new Array(r), o = new Array(r);
  for (i[0] = 0, a[0] = 2, o[0] = e[0] + 2 * e[1], t = 1; t < r - 1; ++t) i[t] = 1, a[t] = 4, o[t] = 4 * e[t] + 2 * e[t + 1];
  for (i[r - 1] = 2, a[r - 1] = 7, o[r - 1] = 8 * e[r - 1] + e[r], t = 1; t < r; ++t) n = i[t] / a[t - 1], a[t] -= n, o[t] -= n * o[t - 1];
  for (i[r - 1] = o[r - 1] / a[r - 1], t = r - 2; t >= 0; --t) i[t] = (o[t] - i[t + 1]) / a[t];
  for (a[r - 1] = (e[r] + i[r - 1]) / 2, t = 0; t < r - 1; ++t) a[t] = 2 * e[t + 1] - i[t + 1];
  return [i, a];
}
function eS(e) {
  return new Lx(e);
}
function jo(e, t) {
  this._context = e, this._t = t;
}
jo.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, t), this._context.lineTo(e, t);
        else {
          var r = this._x * (1 - this._t) + e * this._t;
          this._context.lineTo(r, this._y), this._context.lineTo(r, t);
        }
        break;
      }
    }
    this._x = e, this._y = t;
  }
};
function tS(e) {
  return new jo(e, 0.5);
}
function rS(e) {
  return new jo(e, 0);
}
function nS(e) {
  return new jo(e, 1);
}
function Xr(e, t) {
  if ((o = e.length) > 1)
    for (var r = 1, n, i, a = e[t[0]], o, u = a.length; r < o; ++r)
      for (i = a, a = e[t[r]], n = 0; n < u; ++n)
        a[n][1] += a[n][0] = isNaN(i[n][1]) ? i[n][0] : i[n][1];
}
function Of(e) {
  for (var t = e.length, r = new Array(t); --t >= 0; ) r[t] = t;
  return r;
}
function iS(e, t) {
  return e[t];
}
function aS(e) {
  const t = [];
  return t.key = e, t;
}
function oS() {
  var e = xe([]), t = Of, r = Xr, n = iS;
  function i(a) {
    var o = Array.from(e.apply(this, arguments), aS), u, s = o.length, c = -1, l;
    for (const f of a)
      for (u = 0, ++c; u < s; ++u)
        (o[u][c] = [0, +n(f, o[u].key, c, a)]).data = f;
    for (u = 0, l = Gd(t(o)); u < s; ++u)
      o[l[u]].index = u;
    return r(o, l), o;
  }
  return i.keys = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : xe(Array.from(a)), i) : e;
  }, i.value = function(a) {
    return arguments.length ? (n = typeof a == "function" ? a : xe(+a), i) : n;
  }, i.order = function(a) {
    return arguments.length ? (t = a == null ? Of : typeof a == "function" ? a : xe(Array.from(a)), i) : t;
  }, i.offset = function(a) {
    return arguments.length ? (r = a ?? Xr, i) : r;
  }, i;
}
function uS(e, t) {
  if ((n = e.length) > 0) {
    for (var r, n, i = 0, a = e[0].length, o; i < a; ++i) {
      for (o = r = 0; r < n; ++r) o += e[r][i][1] || 0;
      if (o) for (r = 0; r < n; ++r) e[r][i][1] /= o;
    }
    Xr(e, t);
  }
}
function sS(e, t) {
  if ((i = e.length) > 0) {
    for (var r = 0, n = e[t[0]], i, a = n.length; r < a; ++r) {
      for (var o = 0, u = 0; o < i; ++o) u += e[o][r][1] || 0;
      n[r][1] += n[r][0] = -u / 2;
    }
    Xr(e, t);
  }
}
function cS(e, t) {
  if (!(!((o = e.length) > 0) || !((a = (i = e[t[0]]).length) > 0))) {
    for (var r = 0, n = 1, i, a, o; n < a; ++n) {
      for (var u = 0, s = 0, c = 0; u < o; ++u) {
        for (var l = e[t[u]], f = l[n][1] || 0, d = l[n - 1][1] || 0, p = (f - d) / 2, y = 0; y < u; ++y) {
          var v = e[t[y]], h = v[n][1] || 0, x = v[n - 1][1] || 0;
          p += h - x;
        }
        s += f, c += p * f;
      }
      i[n - 1][1] += i[n - 1][0] = r, s && (r -= c / s);
    }
    i[n - 1][1] += i[n - 1][0] = r, Xr(e, t);
  }
}
function oi(e) {
  "@babel/helpers - typeof";
  return oi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, oi(e);
}
var lS = ["type", "size", "sizeType"];
function _f() {
  return _f = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, _f.apply(this, arguments);
}
function xv(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function wv(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? xv(Object(r), !0).forEach(function(n) {
      fS(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xv(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function fS(e, t, r) {
  return t = dS(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function dS(e) {
  var t = pS(e, "string");
  return oi(t) == "symbol" ? t : t + "";
}
function pS(e, t) {
  if (oi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (oi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function hS(e, t) {
  if (e == null) return {};
  var r = vS(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function vS(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var qx = {
  symbolCircle: Vd,
  symbolCross: RA,
  symbolDiamond: LA,
  symbolSquare: qA,
  symbolStar: WA,
  symbolTriangle: UA,
  symbolWye: HA
}, yS = Math.PI / 180, mS = function(t) {
  var r = "symbol".concat(So(t));
  return qx[r] || Vd;
}, gS = function(t, r, n) {
  if (r === "area")
    return t;
  switch (n) {
    case "cross":
      return 5 * t * t / 9;
    case "diamond":
      return 0.5 * t * t / Math.sqrt(3);
    case "square":
      return t * t;
    case "star": {
      var i = 18 * yS;
      return 1.25 * t * t * (Math.tan(i) - Math.tan(i * 2) * Math.pow(Math.tan(i), 2));
    }
    case "triangle":
      return Math.sqrt(3) * t * t / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * t * t / 8;
    default:
      return Math.PI * t * t / 4;
  }
}, bS = function(t, r) {
  qx["symbol".concat(So(t))] = r;
}, To = function(t) {
  var r = t.type, n = r === void 0 ? "circle" : r, i = t.size, a = i === void 0 ? 64 : i, o = t.sizeType, u = o === void 0 ? "area" : o, s = hS(t, lS), c = wv(wv({}, s), {}, {
    type: n,
    size: a,
    sizeType: u
  }), l = function() {
    var h = mS(n), x = GA().type(h).size(gS(a, u, n));
    return x();
  }, f = c.className, d = c.cx, p = c.cy, y = J(c, !0);
  return d === +d && p === +p && a === +a ? /* @__PURE__ */ S.createElement("path", _f({}, y, {
    className: ae("recharts-symbols", f),
    transform: "translate(".concat(d, ", ").concat(p, ")"),
    d: l()
  })) : null;
};
To.registerSymbol = bS;
function Zr(e) {
  "@babel/helpers - typeof";
  return Zr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zr(e);
}
function Af() {
  return Af = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Af.apply(this, arguments);
}
function Ov(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function xS(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ov(Object(r), !0).forEach(function(n) {
      ui(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ov(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function wS(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function OS(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Fx(n.key), n);
  }
}
function _S(e, t, r) {
  return t && OS(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function AS(e, t, r) {
  return t = Oa(t), SS(e, Bx() ? Reflect.construct(t, r || [], Oa(e).constructor) : t.apply(e, r));
}
function SS(e, t) {
  if (t && (Zr(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return PS(e);
}
function PS(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Bx() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Bx = function() {
    return !!e;
  })();
}
function Oa(e) {
  return Oa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Oa(e);
}
function ES(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Sf(e, t);
}
function Sf(e, t) {
  return Sf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Sf(e, t);
}
function ui(e, t, r) {
  return t = Fx(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Fx(e) {
  var t = jS(e, "string");
  return Zr(t) == "symbol" ? t : t + "";
}
function jS(e, t) {
  if (Zr(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Zr(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var it = 32, Yd = /* @__PURE__ */ function(e) {
  function t() {
    return wS(this, t), AS(this, t, arguments);
  }
  return ES(t, e), _S(t, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(n) {
        var i = this.props.inactiveColor, a = it / 2, o = it / 6, u = it / 3, s = n.inactive ? i : n.color;
        if (n.type === "plainline")
          return /* @__PURE__ */ S.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: s,
            strokeDasharray: n.payload.strokeDasharray,
            x1: 0,
            y1: a,
            x2: it,
            y2: a,
            className: "recharts-legend-icon"
          });
        if (n.type === "line")
          return /* @__PURE__ */ S.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: s,
            d: "M0,".concat(a, "h").concat(u, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(2 * u, ",").concat(a, `
            H`).concat(it, "M").concat(2 * u, ",").concat(a, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(u, ",").concat(a),
            className: "recharts-legend-icon"
          });
        if (n.type === "rect")
          return /* @__PURE__ */ S.createElement("path", {
            stroke: "none",
            fill: s,
            d: "M0,".concat(it / 8, "h").concat(it, "v").concat(it * 3 / 4, "h").concat(-it, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ S.isValidElement(n.legendIcon)) {
          var c = xS({}, n);
          return delete c.legendIcon, /* @__PURE__ */ S.cloneElement(n.legendIcon, c);
        }
        return /* @__PURE__ */ S.createElement(To, {
          fill: s,
          cx: a,
          cy: a,
          size: it,
          sizeType: "diameter",
          type: n.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var n = this, i = this.props, a = i.payload, o = i.iconSize, u = i.layout, s = i.formatter, c = i.inactiveColor, l = {
        x: 0,
        y: 0,
        width: it,
        height: it
      }, f = {
        display: u === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, d = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return a.map(function(p, y) {
        var v = p.formatter || s, h = ae(ui(ui({
          "recharts-legend-item": !0
        }, "legend-item-".concat(y), !0), "inactive", p.inactive));
        if (p.type === "none")
          return null;
        var x = re(p.value) ? null : p.value;
        xt(
          !re(p.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var g = p.inactive ? c : p.color;
        return /* @__PURE__ */ S.createElement("li", Af({
          className: h,
          style: f,
          key: "legend-item-".concat(y)
        }, nr(n.props, p, y)), /* @__PURE__ */ S.createElement(mf, {
          width: o,
          height: o,
          viewBox: l,
          style: d
        }, n.renderIcon(p)), /* @__PURE__ */ S.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: g
          }
        }, v ? v(x, p, y) : x));
      });
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, i = n.payload, a = n.layout, o = n.align;
      if (!i || !i.length)
        return null;
      var u = {
        padding: 0,
        margin: 0,
        textAlign: a === "horizontal" ? o : "left"
      };
      return /* @__PURE__ */ S.createElement("ul", {
        className: "recharts-default-legend",
        style: u
      }, this.renderItems());
    }
  }]);
}(tt);
ui(Yd, "displayName", "Legend");
ui(Yd, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var Os, _v;
function TS() {
  if (_v) return Os;
  _v = 1;
  var e = Oo();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Os = t, Os;
}
var _s, Av;
function $S() {
  if (Av) return _s;
  Av = 1;
  function e(t) {
    var r = this.__data__, n = r.delete(t);
    return this.size = r.size, n;
  }
  return _s = e, _s;
}
var As, Sv;
function MS() {
  if (Sv) return As;
  Sv = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return As = e, As;
}
var Ss, Pv;
function CS() {
  if (Pv) return Ss;
  Pv = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Ss = e, Ss;
}
var Ps, Ev;
function IS() {
  if (Ev) return Ps;
  Ev = 1;
  var e = Oo(), t = Bd(), r = Fd(), n = 200;
  function i(a, o) {
    var u = this.__data__;
    if (u instanceof e) {
      var s = u.__data__;
      if (!t || s.length < n - 1)
        return s.push([a, o]), this.size = ++u.size, this;
      u = this.__data__ = new r(s);
    }
    return u.set(a, o), this.size = u.size, this;
  }
  return Ps = i, Ps;
}
var Es, jv;
function zx() {
  if (jv) return Es;
  jv = 1;
  var e = Oo(), t = TS(), r = $S(), n = MS(), i = CS(), a = IS();
  function o(u) {
    var s = this.__data__ = new e(u);
    this.size = s.size;
  }
  return o.prototype.clear = t, o.prototype.delete = r, o.prototype.get = n, o.prototype.has = i, o.prototype.set = a, Es = o, Es;
}
var js, Tv;
function NS() {
  if (Tv) return js;
  Tv = 1;
  var e = "__lodash_hash_undefined__";
  function t(r) {
    return this.__data__.set(r, e), this;
  }
  return js = t, js;
}
var Ts, $v;
function kS() {
  if ($v) return Ts;
  $v = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Ts = e, Ts;
}
var $s, Mv;
function Wx() {
  if (Mv) return $s;
  Mv = 1;
  var e = Fd(), t = NS(), r = kS();
  function n(i) {
    var a = -1, o = i == null ? 0 : i.length;
    for (this.__data__ = new e(); ++a < o; )
      this.add(i[a]);
  }
  return n.prototype.add = n.prototype.push = t, n.prototype.has = r, $s = n, $s;
}
var Ms, Cv;
function Ux() {
  if (Cv) return Ms;
  Cv = 1;
  function e(t, r) {
    for (var n = -1, i = t == null ? 0 : t.length; ++n < i; )
      if (r(t[n], n, t))
        return !0;
    return !1;
  }
  return Ms = e, Ms;
}
var Cs, Iv;
function Kx() {
  if (Iv) return Cs;
  Iv = 1;
  function e(t, r) {
    return t.has(r);
  }
  return Cs = e, Cs;
}
var Is, Nv;
function Hx() {
  if (Nv) return Is;
  Nv = 1;
  var e = Wx(), t = Ux(), r = Kx(), n = 1, i = 2;
  function a(o, u, s, c, l, f) {
    var d = s & n, p = o.length, y = u.length;
    if (p != y && !(d && y > p))
      return !1;
    var v = f.get(o), h = f.get(u);
    if (v && h)
      return v == u && h == o;
    var x = -1, g = !0, b = s & i ? new e() : void 0;
    for (f.set(o, u), f.set(u, o); ++x < p; ) {
      var O = o[x], m = u[x];
      if (c)
        var w = d ? c(m, O, x, u, o, f) : c(O, m, x, o, u, f);
      if (w !== void 0) {
        if (w)
          continue;
        g = !1;
        break;
      }
      if (b) {
        if (!t(u, function(_, P) {
          if (!r(b, P) && (O === _ || l(O, _, s, c, f)))
            return b.push(P);
        })) {
          g = !1;
          break;
        }
      } else if (!(O === m || l(O, m, s, c, f))) {
        g = !1;
        break;
      }
    }
    return f.delete(o), f.delete(u), g;
  }
  return Is = a, Is;
}
var Ns, kv;
function RS() {
  if (kv) return Ns;
  kv = 1;
  var e = jt(), t = e.Uint8Array;
  return Ns = t, Ns;
}
var ks, Rv;
function DS() {
  if (Rv) return ks;
  Rv = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(i, a) {
      n[++r] = [a, i];
    }), n;
  }
  return ks = e, ks;
}
var Rs, Dv;
function Xd() {
  if (Dv) return Rs;
  Dv = 1;
  function e(t) {
    var r = -1, n = Array(t.size);
    return t.forEach(function(i) {
      n[++r] = i;
    }), n;
  }
  return Rs = e, Rs;
}
var Ds, Lv;
function LS() {
  if (Lv) return Ds;
  Lv = 1;
  var e = Bi(), t = RS(), r = qd(), n = Hx(), i = DS(), a = Xd(), o = 1, u = 2, s = "[object Boolean]", c = "[object Date]", l = "[object Error]", f = "[object Map]", d = "[object Number]", p = "[object RegExp]", y = "[object Set]", v = "[object String]", h = "[object Symbol]", x = "[object ArrayBuffer]", g = "[object DataView]", b = e ? e.prototype : void 0, O = b ? b.valueOf : void 0;
  function m(w, _, P, T, M, j, $) {
    switch (P) {
      case g:
        if (w.byteLength != _.byteLength || w.byteOffset != _.byteOffset)
          return !1;
        w = w.buffer, _ = _.buffer;
      case x:
        return !(w.byteLength != _.byteLength || !j(new t(w), new t(_)));
      case s:
      case c:
      case d:
        return r(+w, +_);
      case l:
        return w.name == _.name && w.message == _.message;
      case p:
      case v:
        return w == _ + "";
      case f:
        var I = i;
      case y:
        var k = T & o;
        if (I || (I = a), w.size != _.size && !k)
          return !1;
        var R = $.get(w);
        if (R)
          return R == _;
        T |= u, $.set(w, _);
        var D = n(I(w), I(_), T, M, j, $);
        return $.delete(w), D;
      case h:
        if (O)
          return O.call(w) == O.call(_);
    }
    return !1;
  }
  return Ds = m, Ds;
}
var Ls, qv;
function Gx() {
  if (qv) return Ls;
  qv = 1;
  function e(t, r) {
    for (var n = -1, i = r.length, a = t.length; ++n < i; )
      t[a + n] = r[n];
    return t;
  }
  return Ls = e, Ls;
}
var qs, Bv;
function qS() {
  if (Bv) return qs;
  Bv = 1;
  var e = Gx(), t = Ye();
  function r(n, i, a) {
    var o = i(n);
    return t(n) ? o : e(o, a(n));
  }
  return qs = r, qs;
}
var Bs, Fv;
function BS() {
  if (Fv) return Bs;
  Fv = 1;
  function e(t, r) {
    for (var n = -1, i = t == null ? 0 : t.length, a = 0, o = []; ++n < i; ) {
      var u = t[n];
      r(u, n, t) && (o[a++] = u);
    }
    return o;
  }
  return Bs = e, Bs;
}
var Fs, zv;
function FS() {
  if (zv) return Fs;
  zv = 1;
  function e() {
    return [];
  }
  return Fs = e, Fs;
}
var zs, Wv;
function zS() {
  if (Wv) return zs;
  Wv = 1;
  var e = BS(), t = FS(), r = Object.prototype, n = r.propertyIsEnumerable, i = Object.getOwnPropertySymbols, a = i ? function(o) {
    return o == null ? [] : (o = Object(o), e(i(o), function(u) {
      return n.call(o, u);
    }));
  } : t;
  return zs = a, zs;
}
var Ws, Uv;
function WS() {
  if (Uv) return Ws;
  Uv = 1;
  function e(t, r) {
    for (var n = -1, i = Array(t); ++n < t; )
      i[n] = r(n);
    return i;
  }
  return Ws = e, Ws;
}
var Us, Kv;
function US() {
  if (Kv) return Us;
  Kv = 1;
  var e = Wt(), t = Ut(), r = "[object Arguments]";
  function n(i) {
    return t(i) && e(i) == r;
  }
  return Us = n, Us;
}
var Ks, Hv;
function Zd() {
  if (Hv) return Ks;
  Hv = 1;
  var e = US(), t = Ut(), r = Object.prototype, n = r.hasOwnProperty, i = r.propertyIsEnumerable, a = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(o) {
    return t(o) && n.call(o, "callee") && !i.call(o, "callee");
  };
  return Ks = a, Ks;
}
var Vn = { exports: {} }, Hs, Gv;
function KS() {
  if (Gv) return Hs;
  Gv = 1;
  function e() {
    return !1;
  }
  return Hs = e, Hs;
}
Vn.exports;
var Vv;
function Vx() {
  return Vv || (Vv = 1, function(e, t) {
    var r = jt(), n = KS(), i = t && !t.nodeType && t, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, u = o ? r.Buffer : void 0, s = u ? u.isBuffer : void 0, c = s || n;
    e.exports = c;
  }(Vn, Vn.exports)), Vn.exports;
}
var Gs, Yv;
function Jd() {
  if (Yv) return Gs;
  Yv = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function r(n, i) {
    var a = typeof n;
    return i = i ?? e, !!i && (a == "number" || a != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < i;
  }
  return Gs = r, Gs;
}
var Vs, Xv;
function Qd() {
  if (Xv) return Vs;
  Xv = 1;
  var e = 9007199254740991;
  function t(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Vs = t, Vs;
}
var Ys, Zv;
function HS() {
  if (Zv) return Ys;
  Zv = 1;
  var e = Wt(), t = Qd(), r = Ut(), n = "[object Arguments]", i = "[object Array]", a = "[object Boolean]", o = "[object Date]", u = "[object Error]", s = "[object Function]", c = "[object Map]", l = "[object Number]", f = "[object Object]", d = "[object RegExp]", p = "[object Set]", y = "[object String]", v = "[object WeakMap]", h = "[object ArrayBuffer]", x = "[object DataView]", g = "[object Float32Array]", b = "[object Float64Array]", O = "[object Int8Array]", m = "[object Int16Array]", w = "[object Int32Array]", _ = "[object Uint8Array]", P = "[object Uint8ClampedArray]", T = "[object Uint16Array]", M = "[object Uint32Array]", j = {};
  j[g] = j[b] = j[O] = j[m] = j[w] = j[_] = j[P] = j[T] = j[M] = !0, j[n] = j[i] = j[h] = j[a] = j[x] = j[o] = j[u] = j[s] = j[c] = j[l] = j[f] = j[d] = j[p] = j[y] = j[v] = !1;
  function $(I) {
    return r(I) && t(I.length) && !!j[e(I)];
  }
  return Ys = $, Ys;
}
var Xs, Jv;
function Yx() {
  if (Jv) return Xs;
  Jv = 1;
  function e(t) {
    return function(r) {
      return t(r);
    };
  }
  return Xs = e, Xs;
}
var Yn = { exports: {} };
Yn.exports;
var Qv;
function GS() {
  return Qv || (Qv = 1, function(e, t) {
    var r = hx(), n = t && !t.nodeType && t, i = n && !0 && e && !e.nodeType && e, a = i && i.exports === n, o = a && r.process, u = function() {
      try {
        var s = i && i.require && i.require("util").types;
        return s || o && o.binding && o.binding("util");
      } catch {
      }
    }();
    e.exports = u;
  }(Yn, Yn.exports)), Yn.exports;
}
var Zs, ey;
function Xx() {
  if (ey) return Zs;
  ey = 1;
  var e = HS(), t = Yx(), r = GS(), n = r && r.isTypedArray, i = n ? t(n) : e;
  return Zs = i, Zs;
}
var Js, ty;
function VS() {
  if (ty) return Js;
  ty = 1;
  var e = WS(), t = Zd(), r = Ye(), n = Vx(), i = Jd(), a = Xx(), o = Object.prototype, u = o.hasOwnProperty;
  function s(c, l) {
    var f = r(c), d = !f && t(c), p = !f && !d && n(c), y = !f && !d && !p && a(c), v = f || d || p || y, h = v ? e(c.length, String) : [], x = h.length;
    for (var g in c)
      (l || u.call(c, g)) && !(v && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      p && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      y && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      i(g, x))) && h.push(g);
    return h;
  }
  return Js = s, Js;
}
var Qs, ry;
function YS() {
  if (ry) return Qs;
  ry = 1;
  var e = Object.prototype;
  function t(r) {
    var n = r && r.constructor, i = typeof n == "function" && n.prototype || e;
    return r === i;
  }
  return Qs = t, Qs;
}
var ec, ny;
function Zx() {
  if (ny) return ec;
  ny = 1;
  function e(t, r) {
    return function(n) {
      return t(r(n));
    };
  }
  return ec = e, ec;
}
var tc, iy;
function XS() {
  if (iy) return tc;
  iy = 1;
  var e = Zx(), t = e(Object.keys, Object);
  return tc = t, tc;
}
var rc, ay;
function ZS() {
  if (ay) return rc;
  ay = 1;
  var e = YS(), t = XS(), r = Object.prototype, n = r.hasOwnProperty;
  function i(a) {
    if (!e(a))
      return t(a);
    var o = [];
    for (var u in Object(a))
      n.call(a, u) && u != "constructor" && o.push(u);
    return o;
  }
  return rc = i, rc;
}
var nc, oy;
function Fi() {
  if (oy) return nc;
  oy = 1;
  var e = Ld(), t = Qd();
  function r(n) {
    return n != null && t(n.length) && !e(n);
  }
  return nc = r, nc;
}
var ic, uy;
function $o() {
  if (uy) return ic;
  uy = 1;
  var e = VS(), t = ZS(), r = Fi();
  function n(i) {
    return r(i) ? e(i) : t(i);
  }
  return ic = n, ic;
}
var ac, sy;
function JS() {
  if (sy) return ac;
  sy = 1;
  var e = qS(), t = zS(), r = $o();
  function n(i) {
    return e(i, r, t);
  }
  return ac = n, ac;
}
var oc, cy;
function QS() {
  if (cy) return oc;
  cy = 1;
  var e = JS(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
  function i(a, o, u, s, c, l) {
    var f = u & t, d = e(a), p = d.length, y = e(o), v = y.length;
    if (p != v && !f)
      return !1;
    for (var h = p; h--; ) {
      var x = d[h];
      if (!(f ? x in o : n.call(o, x)))
        return !1;
    }
    var g = l.get(a), b = l.get(o);
    if (g && b)
      return g == o && b == a;
    var O = !0;
    l.set(a, o), l.set(o, a);
    for (var m = f; ++h < p; ) {
      x = d[h];
      var w = a[x], _ = o[x];
      if (s)
        var P = f ? s(_, w, x, o, a, l) : s(w, _, x, a, o, l);
      if (!(P === void 0 ? w === _ || c(w, _, u, s, l) : P)) {
        O = !1;
        break;
      }
      m || (m = x == "constructor");
    }
    if (O && !m) {
      var T = a.constructor, M = o.constructor;
      T != M && "constructor" in a && "constructor" in o && !(typeof T == "function" && T instanceof T && typeof M == "function" && M instanceof M) && (O = !1);
    }
    return l.delete(a), l.delete(o), O;
  }
  return oc = i, oc;
}
var uc, ly;
function eP() {
  if (ly) return uc;
  ly = 1;
  var e = Cr(), t = jt(), r = e(t, "DataView");
  return uc = r, uc;
}
var sc, fy;
function tP() {
  if (fy) return sc;
  fy = 1;
  var e = Cr(), t = jt(), r = e(t, "Promise");
  return sc = r, sc;
}
var cc, dy;
function Jx() {
  if (dy) return cc;
  dy = 1;
  var e = Cr(), t = jt(), r = e(t, "Set");
  return cc = r, cc;
}
var lc, py;
function rP() {
  if (py) return lc;
  py = 1;
  var e = Cr(), t = jt(), r = e(t, "WeakMap");
  return lc = r, lc;
}
var fc, hy;
function nP() {
  if (hy) return fc;
  hy = 1;
  var e = eP(), t = Bd(), r = tP(), n = Jx(), i = rP(), a = Wt(), o = vx(), u = "[object Map]", s = "[object Object]", c = "[object Promise]", l = "[object Set]", f = "[object WeakMap]", d = "[object DataView]", p = o(e), y = o(t), v = o(r), h = o(n), x = o(i), g = a;
  return (e && g(new e(new ArrayBuffer(1))) != d || t && g(new t()) != u || r && g(r.resolve()) != c || n && g(new n()) != l || i && g(new i()) != f) && (g = function(b) {
    var O = a(b), m = O == s ? b.constructor : void 0, w = m ? o(m) : "";
    if (w)
      switch (w) {
        case p:
          return d;
        case y:
          return u;
        case v:
          return c;
        case h:
          return l;
        case x:
          return f;
      }
    return O;
  }), fc = g, fc;
}
var dc, vy;
function iP() {
  if (vy) return dc;
  vy = 1;
  var e = zx(), t = Hx(), r = LS(), n = QS(), i = nP(), a = Ye(), o = Vx(), u = Xx(), s = 1, c = "[object Arguments]", l = "[object Array]", f = "[object Object]", d = Object.prototype, p = d.hasOwnProperty;
  function y(v, h, x, g, b, O) {
    var m = a(v), w = a(h), _ = m ? l : i(v), P = w ? l : i(h);
    _ = _ == c ? f : _, P = P == c ? f : P;
    var T = _ == f, M = P == f, j = _ == P;
    if (j && o(v)) {
      if (!o(h))
        return !1;
      m = !0, T = !1;
    }
    if (j && !T)
      return O || (O = new e()), m || u(v) ? t(v, h, x, g, b, O) : r(v, h, _, x, g, b, O);
    if (!(x & s)) {
      var $ = T && p.call(v, "__wrapped__"), I = M && p.call(h, "__wrapped__");
      if ($ || I) {
        var k = $ ? v.value() : v, R = I ? h.value() : h;
        return O || (O = new e()), b(k, R, x, g, O);
      }
    }
    return j ? (O || (O = new e()), n(v, h, x, g, b, O)) : !1;
  }
  return dc = y, dc;
}
var pc, yy;
function ep() {
  if (yy) return pc;
  yy = 1;
  var e = iP(), t = Ut();
  function r(n, i, a, o, u) {
    return n === i ? !0 : n == null || i == null || !t(n) && !t(i) ? n !== n && i !== i : e(n, i, a, o, r, u);
  }
  return pc = r, pc;
}
var hc, my;
function aP() {
  if (my) return hc;
  my = 1;
  var e = zx(), t = ep(), r = 1, n = 2;
  function i(a, o, u, s) {
    var c = u.length, l = c, f = !s;
    if (a == null)
      return !l;
    for (a = Object(a); c--; ) {
      var d = u[c];
      if (f && d[2] ? d[1] !== a[d[0]] : !(d[0] in a))
        return !1;
    }
    for (; ++c < l; ) {
      d = u[c];
      var p = d[0], y = a[p], v = d[1];
      if (f && d[2]) {
        if (y === void 0 && !(p in a))
          return !1;
      } else {
        var h = new e();
        if (s)
          var x = s(y, v, p, a, o, h);
        if (!(x === void 0 ? t(v, y, r | n, s, h) : x))
          return !1;
      }
    }
    return !0;
  }
  return hc = i, hc;
}
var vc, gy;
function Qx() {
  if (gy) return vc;
  gy = 1;
  var e = or();
  function t(r) {
    return r === r && !e(r);
  }
  return vc = t, vc;
}
var yc, by;
function oP() {
  if (by) return yc;
  by = 1;
  var e = Qx(), t = $o();
  function r(n) {
    for (var i = t(n), a = i.length; a--; ) {
      var o = i[a], u = n[o];
      i[a] = [o, u, e(u)];
    }
    return i;
  }
  return yc = r, yc;
}
var mc, xy;
function ew() {
  if (xy) return mc;
  xy = 1;
  function e(t, r) {
    return function(n) {
      return n == null ? !1 : n[t] === r && (r !== void 0 || t in Object(n));
    };
  }
  return mc = e, mc;
}
var gc, wy;
function uP() {
  if (wy) return gc;
  wy = 1;
  var e = aP(), t = oP(), r = ew();
  function n(i) {
    var a = t(i);
    return a.length == 1 && a[0][2] ? r(a[0][0], a[0][1]) : function(o) {
      return o === i || e(o, i, a);
    };
  }
  return gc = n, gc;
}
var bc, Oy;
function sP() {
  if (Oy) return bc;
  Oy = 1;
  function e(t, r) {
    return t != null && r in Object(t);
  }
  return bc = e, bc;
}
var xc, _y;
function cP() {
  if (_y) return xc;
  _y = 1;
  var e = gx(), t = Zd(), r = Ye(), n = Jd(), i = Qd(), a = Ao();
  function o(u, s, c) {
    s = e(s, u);
    for (var l = -1, f = s.length, d = !1; ++l < f; ) {
      var p = a(s[l]);
      if (!(d = u != null && c(u, p)))
        break;
      u = u[p];
    }
    return d || ++l != f ? d : (f = u == null ? 0 : u.length, !!f && i(f) && n(p, f) && (r(u) || t(u)));
  }
  return xc = o, xc;
}
var wc, Ay;
function lP() {
  if (Ay) return wc;
  Ay = 1;
  var e = sP(), t = cP();
  function r(n, i) {
    return n != null && t(n, i, e);
  }
  return wc = r, wc;
}
var Oc, Sy;
function fP() {
  if (Sy) return Oc;
  Sy = 1;
  var e = ep(), t = bx(), r = lP(), n = Dd(), i = Qx(), a = ew(), o = Ao(), u = 1, s = 2;
  function c(l, f) {
    return n(l) && i(f) ? a(o(l), f) : function(d) {
      var p = t(d, l);
      return p === void 0 && p === f ? r(d, l) : e(f, p, u | s);
    };
  }
  return Oc = c, Oc;
}
var _c, Py;
function $n() {
  if (Py) return _c;
  Py = 1;
  function e(t) {
    return t;
  }
  return _c = e, _c;
}
var Ac, Ey;
function dP() {
  if (Ey) return Ac;
  Ey = 1;
  function e(t) {
    return function(r) {
      return r == null ? void 0 : r[t];
    };
  }
  return Ac = e, Ac;
}
var Sc, jy;
function pP() {
  if (jy) return Sc;
  jy = 1;
  var e = Wd();
  function t(r) {
    return function(n) {
      return e(n, r);
    };
  }
  return Sc = t, Sc;
}
var Pc, Ty;
function hP() {
  if (Ty) return Pc;
  Ty = 1;
  var e = dP(), t = pP(), r = Dd(), n = Ao();
  function i(a) {
    return r(a) ? e(n(a)) : t(a);
  }
  return Pc = i, Pc;
}
var Ec, $y;
function Tt() {
  if ($y) return Ec;
  $y = 1;
  var e = uP(), t = fP(), r = $n(), n = Ye(), i = hP();
  function a(o) {
    return typeof o == "function" ? o : o == null ? r : typeof o == "object" ? n(o) ? t(o[0], o[1]) : e(o) : i(o);
  }
  return Ec = a, Ec;
}
var jc, My;
function tw() {
  if (My) return jc;
  My = 1;
  function e(t, r, n, i) {
    for (var a = t.length, o = n + (i ? 1 : -1); i ? o-- : ++o < a; )
      if (r(t[o], o, t))
        return o;
    return -1;
  }
  return jc = e, jc;
}
var Tc, Cy;
function vP() {
  if (Cy) return Tc;
  Cy = 1;
  function e(t) {
    return t !== t;
  }
  return Tc = e, Tc;
}
var $c, Iy;
function yP() {
  if (Iy) return $c;
  Iy = 1;
  function e(t, r, n) {
    for (var i = n - 1, a = t.length; ++i < a; )
      if (t[i] === r)
        return i;
    return -1;
  }
  return $c = e, $c;
}
var Mc, Ny;
function mP() {
  if (Ny) return Mc;
  Ny = 1;
  var e = tw(), t = vP(), r = yP();
  function n(i, a, o) {
    return a === a ? r(i, a, o) : e(i, t, o);
  }
  return Mc = n, Mc;
}
var Cc, ky;
function gP() {
  if (ky) return Cc;
  ky = 1;
  var e = mP();
  function t(r, n) {
    var i = r == null ? 0 : r.length;
    return !!i && e(r, n, 0) > -1;
  }
  return Cc = t, Cc;
}
var Ic, Ry;
function bP() {
  if (Ry) return Ic;
  Ry = 1;
  function e(t, r, n) {
    for (var i = -1, a = t == null ? 0 : t.length; ++i < a; )
      if (n(r, t[i]))
        return !0;
    return !1;
  }
  return Ic = e, Ic;
}
var Nc, Dy;
function xP() {
  if (Dy) return Nc;
  Dy = 1;
  function e() {
  }
  return Nc = e, Nc;
}
var kc, Ly;
function wP() {
  if (Ly) return kc;
  Ly = 1;
  var e = Jx(), t = xP(), r = Xd(), n = 1 / 0, i = e && 1 / r(new e([, -0]))[1] == n ? function(a) {
    return new e(a);
  } : t;
  return kc = i, kc;
}
var Rc, qy;
function OP() {
  if (qy) return Rc;
  qy = 1;
  var e = Wx(), t = gP(), r = bP(), n = Kx(), i = wP(), a = Xd(), o = 200;
  function u(s, c, l) {
    var f = -1, d = t, p = s.length, y = !0, v = [], h = v;
    if (l)
      y = !1, d = r;
    else if (p >= o) {
      var x = c ? null : i(s);
      if (x)
        return a(x);
      y = !1, d = n, h = new e();
    } else
      h = c ? [] : v;
    e:
      for (; ++f < p; ) {
        var g = s[f], b = c ? c(g) : g;
        if (g = l || g !== 0 ? g : 0, y && b === b) {
          for (var O = h.length; O--; )
            if (h[O] === b)
              continue e;
          c && h.push(b), v.push(g);
        } else d(h, b, l) || (h !== v && h.push(b), v.push(g));
      }
    return v;
  }
  return Rc = u, Rc;
}
var Dc, By;
function _P() {
  if (By) return Dc;
  By = 1;
  var e = Tt(), t = OP();
  function r(n, i) {
    return n && n.length ? t(n, e(i, 2)) : [];
  }
  return Dc = r, Dc;
}
var AP = _P();
const Fy = /* @__PURE__ */ ye(AP);
function rw(e, t, r) {
  return t === !0 ? Fy(e, r) : re(t) ? Fy(e, t) : e;
}
function Jr(e) {
  "@babel/helpers - typeof";
  return Jr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Jr(e);
}
var SP = ["ref"];
function zy(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ct(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zy(Object(r), !0).forEach(function(n) {
      Mo(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : zy(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function PP(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Wy(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, iw(n.key), n);
  }
}
function EP(e, t, r) {
  return t && Wy(e.prototype, t), r && Wy(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function jP(e, t, r) {
  return t = _a(t), TP(e, nw() ? Reflect.construct(t, r || [], _a(e).constructor) : t.apply(e, r));
}
function TP(e, t) {
  if (t && (Jr(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return $P(e);
}
function $P(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function nw() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (nw = function() {
    return !!e;
  })();
}
function _a(e) {
  return _a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, _a(e);
}
function MP(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Pf(e, t);
}
function Pf(e, t) {
  return Pf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Pf(e, t);
}
function Mo(e, t, r) {
  return t = iw(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function iw(e) {
  var t = CP(e, "string");
  return Jr(t) == "symbol" ? t : t + "";
}
function CP(e, t) {
  if (Jr(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Jr(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function IP(e, t) {
  if (e == null) return {};
  var r = NP(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function NP(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function kP(e) {
  return e.value;
}
function RP(e, t) {
  if (/* @__PURE__ */ S.isValidElement(e))
    return /* @__PURE__ */ S.cloneElement(e, t);
  if (typeof e == "function")
    return /* @__PURE__ */ S.createElement(e, t);
  t.ref;
  var r = IP(t, SP);
  return /* @__PURE__ */ S.createElement(Yd, r);
}
var Uy = 1, er = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    PP(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = jP(this, t, [].concat(i)), Mo(r, "lastBoundingBox", {
      width: -1,
      height: -1
    }), r;
  }
  return MP(t, e), EP(t, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        return n.height = this.wrapperNode.offsetHeight, n.width = this.wrapperNode.offsetWidth, n;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var n = this.props.onBBoxUpdate, i = this.getBBox();
      i ? (Math.abs(i.width - this.lastBoundingBox.width) > Uy || Math.abs(i.height - this.lastBoundingBox.height) > Uy) && (this.lastBoundingBox.width = i.width, this.lastBoundingBox.height = i.height, n && n(i)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, n && n(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? Ct({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(n) {
      var i = this.props, a = i.layout, o = i.align, u = i.verticalAlign, s = i.margin, c = i.chartWidth, l = i.chartHeight, f, d;
      if (!n || (n.left === void 0 || n.left === null) && (n.right === void 0 || n.right === null))
        if (o === "center" && a === "vertical") {
          var p = this.getBBoxSnapshot();
          f = {
            left: ((c || 0) - p.width) / 2
          };
        } else
          f = o === "right" ? {
            right: s && s.right || 0
          } : {
            left: s && s.left || 0
          };
      if (!n || (n.top === void 0 || n.top === null) && (n.bottom === void 0 || n.bottom === null))
        if (u === "middle") {
          var y = this.getBBoxSnapshot();
          d = {
            top: ((l || 0) - y.height) / 2
          };
        } else
          d = u === "bottom" ? {
            bottom: s && s.bottom || 0
          } : {
            top: s && s.top || 0
          };
      return Ct(Ct({}, f), d);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, i = this.props, a = i.content, o = i.width, u = i.height, s = i.wrapperStyle, c = i.payloadUniqBy, l = i.payload, f = Ct(Ct({
        position: "absolute",
        width: o || "auto",
        height: u || "auto"
      }, this.getDefaultPosition(s)), s);
      return /* @__PURE__ */ S.createElement("div", {
        className: "recharts-legend-wrapper",
        style: f,
        ref: function(p) {
          n.wrapperNode = p;
        }
      }, RP(a, Ct(Ct({}, this.props), {}, {
        payload: rw(l, c, kP)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(n, i) {
      var a = Ct(Ct({}, this.defaultProps), n.props), o = a.layout;
      return o === "vertical" && U(n.props.height) ? {
        height: n.props.height
      } : o === "horizontal" ? {
        width: n.props.width || i
      } : null;
    }
  }]);
}(tt);
Mo(er, "displayName", "Legend");
Mo(er, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var Lc, Ky;
function DP() {
  if (Ky) return Lc;
  Ky = 1;
  var e = Bi(), t = Zd(), r = Ye(), n = e ? e.isConcatSpreadable : void 0;
  function i(a) {
    return r(a) || t(a) || !!(n && a && a[n]);
  }
  return Lc = i, Lc;
}
var qc, Hy;
function aw() {
  if (Hy) return qc;
  Hy = 1;
  var e = Gx(), t = DP();
  function r(n, i, a, o, u) {
    var s = -1, c = n.length;
    for (a || (a = t), u || (u = []); ++s < c; ) {
      var l = n[s];
      i > 0 && a(l) ? i > 1 ? r(l, i - 1, a, o, u) : e(u, l) : o || (u[u.length] = l);
    }
    return u;
  }
  return qc = r, qc;
}
var Bc, Gy;
function LP() {
  if (Gy) return Bc;
  Gy = 1;
  function e(t) {
    return function(r, n, i) {
      for (var a = -1, o = Object(r), u = i(r), s = u.length; s--; ) {
        var c = u[t ? s : ++a];
        if (n(o[c], c, o) === !1)
          break;
      }
      return r;
    };
  }
  return Bc = e, Bc;
}
var Fc, Vy;
function qP() {
  if (Vy) return Fc;
  Vy = 1;
  var e = LP(), t = e();
  return Fc = t, Fc;
}
var zc, Yy;
function ow() {
  if (Yy) return zc;
  Yy = 1;
  var e = qP(), t = $o();
  function r(n, i) {
    return n && e(n, i, t);
  }
  return zc = r, zc;
}
var Wc, Xy;
function BP() {
  if (Xy) return Wc;
  Xy = 1;
  var e = Fi();
  function t(r, n) {
    return function(i, a) {
      if (i == null)
        return i;
      if (!e(i))
        return r(i, a);
      for (var o = i.length, u = n ? o : -1, s = Object(i); (n ? u-- : ++u < o) && a(s[u], u, s) !== !1; )
        ;
      return i;
    };
  }
  return Wc = t, Wc;
}
var Uc, Zy;
function tp() {
  if (Zy) return Uc;
  Zy = 1;
  var e = ow(), t = BP(), r = t(e);
  return Uc = r, Uc;
}
var Kc, Jy;
function uw() {
  if (Jy) return Kc;
  Jy = 1;
  var e = tp(), t = Fi();
  function r(n, i) {
    var a = -1, o = t(n) ? Array(n.length) : [];
    return e(n, function(u, s, c) {
      o[++a] = i(u, s, c);
    }), o;
  }
  return Kc = r, Kc;
}
var Hc, Qy;
function FP() {
  if (Qy) return Hc;
  Qy = 1;
  function e(t, r) {
    var n = t.length;
    for (t.sort(r); n--; )
      t[n] = t[n].value;
    return t;
  }
  return Hc = e, Hc;
}
var Gc, em;
function zP() {
  if (em) return Gc;
  em = 1;
  var e = En();
  function t(r, n) {
    if (r !== n) {
      var i = r !== void 0, a = r === null, o = r === r, u = e(r), s = n !== void 0, c = n === null, l = n === n, f = e(n);
      if (!c && !f && !u && r > n || u && s && l && !c && !f || a && s && l || !i && l || !o)
        return 1;
      if (!a && !u && !f && r < n || f && i && o && !a && !u || c && i && o || !s && o || !l)
        return -1;
    }
    return 0;
  }
  return Gc = t, Gc;
}
var Vc, tm;
function WP() {
  if (tm) return Vc;
  tm = 1;
  var e = zP();
  function t(r, n, i) {
    for (var a = -1, o = r.criteria, u = n.criteria, s = o.length, c = i.length; ++a < s; ) {
      var l = e(o[a], u[a]);
      if (l) {
        if (a >= c)
          return l;
        var f = i[a];
        return l * (f == "desc" ? -1 : 1);
      }
    }
    return r.index - n.index;
  }
  return Vc = t, Vc;
}
var Yc, rm;
function UP() {
  if (rm) return Yc;
  rm = 1;
  var e = zd(), t = Wd(), r = Tt(), n = uw(), i = FP(), a = Yx(), o = WP(), u = $n(), s = Ye();
  function c(l, f, d) {
    f.length ? f = e(f, function(v) {
      return s(v) ? function(h) {
        return t(h, v.length === 1 ? v[0] : v);
      } : v;
    }) : f = [u];
    var p = -1;
    f = e(f, a(r));
    var y = n(l, function(v, h, x) {
      var g = e(f, function(b) {
        return b(v);
      });
      return { criteria: g, index: ++p, value: v };
    });
    return i(y, function(v, h) {
      return o(v, h, d);
    });
  }
  return Yc = c, Yc;
}
var Xc, nm;
function KP() {
  if (nm) return Xc;
  nm = 1;
  function e(t, r, n) {
    switch (n.length) {
      case 0:
        return t.call(r);
      case 1:
        return t.call(r, n[0]);
      case 2:
        return t.call(r, n[0], n[1]);
      case 3:
        return t.call(r, n[0], n[1], n[2]);
    }
    return t.apply(r, n);
  }
  return Xc = e, Xc;
}
var Zc, im;
function HP() {
  if (im) return Zc;
  im = 1;
  var e = KP(), t = Math.max;
  function r(n, i, a) {
    return i = t(i === void 0 ? n.length - 1 : i, 0), function() {
      for (var o = arguments, u = -1, s = t(o.length - i, 0), c = Array(s); ++u < s; )
        c[u] = o[i + u];
      u = -1;
      for (var l = Array(i + 1); ++u < i; )
        l[u] = o[u];
      return l[i] = a(c), e(n, this, l);
    };
  }
  return Zc = r, Zc;
}
var Jc, am;
function GP() {
  if (am) return Jc;
  am = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return Jc = e, Jc;
}
var Qc, om;
function sw() {
  if (om) return Qc;
  om = 1;
  var e = Cr(), t = function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  }();
  return Qc = t, Qc;
}
var el, um;
function VP() {
  if (um) return el;
  um = 1;
  var e = GP(), t = sw(), r = $n(), n = t ? function(i, a) {
    return t(i, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(a),
      writable: !0
    });
  } : r;
  return el = n, el;
}
var tl, sm;
function YP() {
  if (sm) return tl;
  sm = 1;
  var e = 800, t = 16, r = Date.now;
  function n(i) {
    var a = 0, o = 0;
    return function() {
      var u = r(), s = t - (u - o);
      if (o = u, s > 0) {
        if (++a >= e)
          return arguments[0];
      } else
        a = 0;
      return i.apply(void 0, arguments);
    };
  }
  return tl = n, tl;
}
var rl, cm;
function XP() {
  if (cm) return rl;
  cm = 1;
  var e = VP(), t = YP(), r = t(e);
  return rl = r, rl;
}
var nl, lm;
function ZP() {
  if (lm) return nl;
  lm = 1;
  var e = $n(), t = HP(), r = XP();
  function n(i, a) {
    return r(t(i, a, e), i + "");
  }
  return nl = n, nl;
}
var il, fm;
function Co() {
  if (fm) return il;
  fm = 1;
  var e = qd(), t = Fi(), r = Jd(), n = or();
  function i(a, o, u) {
    if (!n(u))
      return !1;
    var s = typeof o;
    return (s == "number" ? t(u) && r(o, u.length) : s == "string" && o in u) ? e(u[o], a) : !1;
  }
  return il = i, il;
}
var al, dm;
function JP() {
  if (dm) return al;
  dm = 1;
  var e = aw(), t = UP(), r = ZP(), n = Co(), i = r(function(a, o) {
    if (a == null)
      return [];
    var u = o.length;
    return u > 1 && n(a, o[0], o[1]) ? o = [] : u > 2 && n(o[0], o[1], o[2]) && (o = [o[0]]), t(a, e(o, 1), []);
  });
  return al = i, al;
}
var QP = JP();
const rp = /* @__PURE__ */ ye(QP);
function si(e) {
  "@babel/helpers - typeof";
  return si = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, si(e);
}
function Ef() {
  return Ef = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ef.apply(this, arguments);
}
function eE(e, t) {
  return iE(e) || nE(e, t) || rE(e, t) || tE();
}
function tE() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rE(e, t) {
  if (e) {
    if (typeof e == "string") return pm(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return pm(e, t);
  }
}
function pm(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function nE(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], s = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(s = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function iE(e) {
  if (Array.isArray(e)) return e;
}
function hm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ol(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hm(Object(r), !0).forEach(function(n) {
      aE(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : hm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function aE(e, t, r) {
  return t = oE(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function oE(e) {
  var t = uE(e, "string");
  return si(t) == "symbol" ? t : t + "";
}
function uE(e, t) {
  if (si(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (si(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function sE(e) {
  return Array.isArray(e) && Ie(e[0]) && Ie(e[1]) ? e.join(" ~ ") : e;
}
var cE = function(t) {
  var r = t.separator, n = r === void 0 ? " : " : r, i = t.contentStyle, a = i === void 0 ? {} : i, o = t.itemStyle, u = o === void 0 ? {} : o, s = t.labelStyle, c = s === void 0 ? {} : s, l = t.payload, f = t.formatter, d = t.itemSorter, p = t.wrapperClassName, y = t.labelClassName, v = t.label, h = t.labelFormatter, x = t.accessibilityLayer, g = x === void 0 ? !1 : x, b = function() {
    if (l && l.length) {
      var $ = {
        padding: 0,
        margin: 0
      }, I = (d ? rp(l, d) : l).map(function(k, R) {
        if (k.type === "none")
          return null;
        var D = ol({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: k.color || "#000"
        }, u), B = k.formatter || f || sE, W = k.value, K = k.name, E = W, N = K;
        if (B && E != null && N != null) {
          var L = B(W, K, k, R, l);
          if (Array.isArray(L)) {
            var z = eE(L, 2);
            E = z[0], N = z[1];
          } else
            E = L;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ S.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(R),
            style: D
          }, Ie(N) ? /* @__PURE__ */ S.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, N) : null, Ie(N) ? /* @__PURE__ */ S.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, n) : null, /* @__PURE__ */ S.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, E), /* @__PURE__ */ S.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, k.unit || ""))
        );
      });
      return /* @__PURE__ */ S.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: $
      }, I);
    }
    return null;
  }, O = ol({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, a), m = ol({
    margin: 0
  }, c), w = !te(v), _ = w ? v : "", P = ae("recharts-default-tooltip", p), T = ae("recharts-tooltip-label", y);
  w && h && l !== void 0 && l !== null && (_ = h(v, l));
  var M = g ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ S.createElement("div", Ef({
    className: P,
    style: O
  }, M), /* @__PURE__ */ S.createElement("p", {
    className: T,
    style: m
  }, /* @__PURE__ */ S.isValidElement(_) ? _ : "".concat(_)), b());
};
function ci(e) {
  "@babel/helpers - typeof";
  return ci = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ci(e);
}
function Qi(e, t, r) {
  return t = lE(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function lE(e) {
  var t = fE(e, "string");
  return ci(t) == "symbol" ? t : t + "";
}
function fE(e, t) {
  if (ci(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ci(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var qn = "recharts-tooltip-wrapper", dE = {
  visibility: "hidden"
};
function pE(e) {
  var t = e.coordinate, r = e.translateX, n = e.translateY;
  return ae(qn, Qi(Qi(Qi(Qi({}, "".concat(qn, "-right"), U(r) && t && U(t.x) && r >= t.x), "".concat(qn, "-left"), U(r) && t && U(t.x) && r < t.x), "".concat(qn, "-bottom"), U(n) && t && U(t.y) && n >= t.y), "".concat(qn, "-top"), U(n) && t && U(t.y) && n < t.y));
}
function vm(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.key, i = e.offsetTopLeft, a = e.position, o = e.reverseDirection, u = e.tooltipDimension, s = e.viewBox, c = e.viewBoxDimension;
  if (a && U(a[n]))
    return a[n];
  var l = r[n] - u - i, f = r[n] + i;
  if (t[n])
    return o[n] ? l : f;
  if (o[n]) {
    var d = l, p = s[n];
    return d < p ? Math.max(f, s[n]) : Math.max(l, s[n]);
  }
  var y = f + u, v = s[n] + c;
  return y > v ? Math.max(l, s[n]) : Math.max(f, s[n]);
}
function hE(e) {
  var t = e.translateX, r = e.translateY, n = e.useTranslate3d;
  return {
    transform: n ? "translate3d(".concat(t, "px, ").concat(r, "px, 0)") : "translate(".concat(t, "px, ").concat(r, "px)")
  };
}
function vE(e) {
  var t = e.allowEscapeViewBox, r = e.coordinate, n = e.offsetTopLeft, i = e.position, a = e.reverseDirection, o = e.tooltipBox, u = e.useTranslate3d, s = e.viewBox, c, l, f;
  return o.height > 0 && o.width > 0 && r ? (l = vm({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "x",
    offsetTopLeft: n,
    position: i,
    reverseDirection: a,
    tooltipDimension: o.width,
    viewBox: s,
    viewBoxDimension: s.width
  }), f = vm({
    allowEscapeViewBox: t,
    coordinate: r,
    key: "y",
    offsetTopLeft: n,
    position: i,
    reverseDirection: a,
    tooltipDimension: o.height,
    viewBox: s,
    viewBoxDimension: s.height
  }), c = hE({
    translateX: l,
    translateY: f,
    useTranslate3d: u
  })) : c = dE, {
    cssProperties: c,
    cssClasses: pE({
      translateX: l,
      translateY: f,
      coordinate: r
    })
  };
}
function Qr(e) {
  "@babel/helpers - typeof";
  return Qr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Qr(e);
}
function ym(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function mm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ym(Object(r), !0).forEach(function(n) {
      Tf(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ym(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function yE(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function mE(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, lw(n.key), n);
  }
}
function gE(e, t, r) {
  return t && mE(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function bE(e, t, r) {
  return t = Aa(t), xE(e, cw() ? Reflect.construct(t, r || [], Aa(e).constructor) : t.apply(e, r));
}
function xE(e, t) {
  if (t && (Qr(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return wE(e);
}
function wE(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function cw() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (cw = function() {
    return !!e;
  })();
}
function Aa(e) {
  return Aa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Aa(e);
}
function OE(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && jf(e, t);
}
function jf(e, t) {
  return jf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, jf(e, t);
}
function Tf(e, t, r) {
  return t = lw(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function lw(e) {
  var t = _E(e, "string");
  return Qr(t) == "symbol" ? t : t + "";
}
function _E(e, t) {
  if (Qr(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Qr(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var gm = 1, AE = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    yE(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = bE(this, t, [].concat(i)), Tf(r, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), Tf(r, "handleKeyDown", function(o) {
      if (o.key === "Escape") {
        var u, s, c, l;
        r.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (u = (s = r.props.coordinate) === null || s === void 0 ? void 0 : s.x) !== null && u !== void 0 ? u : 0,
            y: (c = (l = r.props.coordinate) === null || l === void 0 ? void 0 : l.y) !== null && c !== void 0 ? c : 0
          }
        });
      }
    }), r;
  }
  return OE(t, e), gE(t, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var n = this.wrapperNode.getBoundingClientRect();
        (Math.abs(n.width - this.state.lastBoundingBox.width) > gm || Math.abs(n.height - this.state.lastBoundingBox.height) > gm) && this.setState({
          lastBoundingBox: {
            width: n.width,
            height: n.height
          }
        });
      } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var n, i;
      this.props.active && this.updateBBox(), this.state.dismissed && (((n = this.props.coordinate) === null || n === void 0 ? void 0 : n.x) !== this.state.dismissedAtCoordinate.x || ((i = this.props.coordinate) === null || i === void 0 ? void 0 : i.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, i = this.props, a = i.active, o = i.allowEscapeViewBox, u = i.animationDuration, s = i.animationEasing, c = i.children, l = i.coordinate, f = i.hasPayload, d = i.isAnimationActive, p = i.offset, y = i.position, v = i.reverseDirection, h = i.useTranslate3d, x = i.viewBox, g = i.wrapperStyle, b = vE({
        allowEscapeViewBox: o,
        coordinate: l,
        offsetTopLeft: p,
        position: y,
        reverseDirection: v,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: h,
        viewBox: x
      }), O = b.cssClasses, m = b.cssProperties, w = mm(mm({
        transition: d && a ? "transform ".concat(u, "ms ").concat(s) : void 0
      }, m), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && a && f ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, g);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ S.createElement("div", {
          tabIndex: -1,
          className: O,
          style: w,
          ref: function(P) {
            n.wrapperNode = P;
          }
        }, c)
      );
    }
  }]);
}(tt), SE = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, Kt = {
  isSsr: SE()
};
function en(e) {
  "@babel/helpers - typeof";
  return en = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, en(e);
}
function bm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function xm(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? bm(Object(r), !0).forEach(function(n) {
      np(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function PE(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function EE(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, dw(n.key), n);
  }
}
function jE(e, t, r) {
  return t && EE(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function TE(e, t, r) {
  return t = Sa(t), $E(e, fw() ? Reflect.construct(t, r || [], Sa(e).constructor) : t.apply(e, r));
}
function $E(e, t) {
  if (t && (en(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ME(e);
}
function ME(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function fw() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (fw = function() {
    return !!e;
  })();
}
function Sa(e) {
  return Sa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Sa(e);
}
function CE(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && $f(e, t);
}
function $f(e, t) {
  return $f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, $f(e, t);
}
function np(e, t, r) {
  return t = dw(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function dw(e) {
  var t = IE(e, "string");
  return en(t) == "symbol" ? t : t + "";
}
function IE(e, t) {
  if (en(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (en(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function NE(e) {
  return e.dataKey;
}
function kE(e, t) {
  return /* @__PURE__ */ S.isValidElement(e) ? /* @__PURE__ */ S.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ S.createElement(e, t) : /* @__PURE__ */ S.createElement(cE, t);
}
var ut = /* @__PURE__ */ function(e) {
  function t() {
    return PE(this, t), TE(this, t, arguments);
  }
  return CE(t, e), jE(t, [{
    key: "render",
    value: function() {
      var n = this, i = this.props, a = i.active, o = i.allowEscapeViewBox, u = i.animationDuration, s = i.animationEasing, c = i.content, l = i.coordinate, f = i.filterNull, d = i.isAnimationActive, p = i.offset, y = i.payload, v = i.payloadUniqBy, h = i.position, x = i.reverseDirection, g = i.useTranslate3d, b = i.viewBox, O = i.wrapperStyle, m = y ?? [];
      f && m.length && (m = rw(y.filter(function(_) {
        return _.value != null && (_.hide !== !0 || n.props.includeHidden);
      }), v, NE));
      var w = m.length > 0;
      return /* @__PURE__ */ S.createElement(AE, {
        allowEscapeViewBox: o,
        animationDuration: u,
        animationEasing: s,
        isAnimationActive: d,
        active: a,
        coordinate: l,
        hasPayload: w,
        offset: p,
        position: h,
        reverseDirection: x,
        useTranslate3d: g,
        viewBox: b,
        wrapperStyle: O
      }, kE(c, xm(xm({}, this.props), {}, {
        payload: m
      })));
    }
  }]);
}(tt);
np(ut, "displayName", "Tooltip");
np(ut, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !Kt.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var ul, wm;
function RE() {
  if (wm) return ul;
  wm = 1;
  var e = jt(), t = function() {
    return e.Date.now();
  };
  return ul = t, ul;
}
var sl, Om;
function DE() {
  if (Om) return sl;
  Om = 1;
  var e = /\s/;
  function t(r) {
    for (var n = r.length; n-- && e.test(r.charAt(n)); )
      ;
    return n;
  }
  return sl = t, sl;
}
var cl, _m;
function LE() {
  if (_m) return cl;
  _m = 1;
  var e = DE(), t = /^\s+/;
  function r(n) {
    return n && n.slice(0, e(n) + 1).replace(t, "");
  }
  return cl = r, cl;
}
var ll, Am;
function pw() {
  if (Am) return ll;
  Am = 1;
  var e = LE(), t = or(), r = En(), n = NaN, i = /^[-+]0x[0-9a-f]+$/i, a = /^0b[01]+$/i, o = /^0o[0-7]+$/i, u = parseInt;
  function s(c) {
    if (typeof c == "number")
      return c;
    if (r(c))
      return n;
    if (t(c)) {
      var l = typeof c.valueOf == "function" ? c.valueOf() : c;
      c = t(l) ? l + "" : l;
    }
    if (typeof c != "string")
      return c === 0 ? c : +c;
    c = e(c);
    var f = a.test(c);
    return f || o.test(c) ? u(c.slice(2), f ? 2 : 8) : i.test(c) ? n : +c;
  }
  return ll = s, ll;
}
var fl, Sm;
function qE() {
  if (Sm) return fl;
  Sm = 1;
  var e = or(), t = RE(), r = pw(), n = "Expected a function", i = Math.max, a = Math.min;
  function o(u, s, c) {
    var l, f, d, p, y, v, h = 0, x = !1, g = !1, b = !0;
    if (typeof u != "function")
      throw new TypeError(n);
    s = r(s) || 0, e(c) && (x = !!c.leading, g = "maxWait" in c, d = g ? i(r(c.maxWait) || 0, s) : d, b = "trailing" in c ? !!c.trailing : b);
    function O(I) {
      var k = l, R = f;
      return l = f = void 0, h = I, p = u.apply(R, k), p;
    }
    function m(I) {
      return h = I, y = setTimeout(P, s), x ? O(I) : p;
    }
    function w(I) {
      var k = I - v, R = I - h, D = s - k;
      return g ? a(D, d - R) : D;
    }
    function _(I) {
      var k = I - v, R = I - h;
      return v === void 0 || k >= s || k < 0 || g && R >= d;
    }
    function P() {
      var I = t();
      if (_(I))
        return T(I);
      y = setTimeout(P, w(I));
    }
    function T(I) {
      return y = void 0, b && l ? O(I) : (l = f = void 0, p);
    }
    function M() {
      y !== void 0 && clearTimeout(y), h = 0, l = v = f = y = void 0;
    }
    function j() {
      return y === void 0 ? p : T(t());
    }
    function $() {
      var I = t(), k = _(I);
      if (l = arguments, f = this, v = I, k) {
        if (y === void 0)
          return m(v);
        if (g)
          return clearTimeout(y), y = setTimeout(P, s), O(v);
      }
      return y === void 0 && (y = setTimeout(P, s)), p;
    }
    return $.cancel = M, $.flush = j, $;
  }
  return fl = o, fl;
}
var dl, Pm;
function BE() {
  if (Pm) return dl;
  Pm = 1;
  var e = qE(), t = or(), r = "Expected a function";
  function n(i, a, o) {
    var u = !0, s = !0;
    if (typeof i != "function")
      throw new TypeError(r);
    return t(o) && (u = "leading" in o ? !!o.leading : u, s = "trailing" in o ? !!o.trailing : s), e(i, a, {
      leading: u,
      maxWait: a,
      trailing: s
    });
  }
  return dl = n, dl;
}
var FE = BE();
const hw = /* @__PURE__ */ ye(FE);
function li(e) {
  "@babel/helpers - typeof";
  return li = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, li(e);
}
function Em(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ea(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Em(Object(r), !0).forEach(function(n) {
      zE(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Em(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function zE(e, t, r) {
  return t = WE(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function WE(e) {
  var t = UE(e, "string");
  return li(t) == "symbol" ? t : t + "";
}
function UE(e, t) {
  if (li(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (li(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function KE(e, t) {
  return YE(e) || VE(e, t) || GE(e, t) || HE();
}
function HE() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function GE(e, t) {
  if (e) {
    if (typeof e == "string") return jm(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return jm(e, t);
  }
}
function jm(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function VE(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], s = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(s = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function YE(e) {
  if (Array.isArray(e)) return e;
}
var ip = /* @__PURE__ */ ux(function(e, t) {
  var r = e.aspect, n = e.initialDimension, i = n === void 0 ? {
    width: -1,
    height: -1
  } : n, a = e.width, o = a === void 0 ? "100%" : a, u = e.height, s = u === void 0 ? "100%" : u, c = e.minWidth, l = c === void 0 ? 0 : c, f = e.minHeight, d = e.maxHeight, p = e.children, y = e.debounce, v = y === void 0 ? 0 : y, h = e.id, x = e.className, g = e.onResize, b = e.style, O = b === void 0 ? {} : b, m = ha(null), w = ha();
  w.current = g, V_(t, function() {
    return Object.defineProperty(m.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), m.current;
      },
      configurable: !0
    });
  });
  var _ = Pr({
    containerWidth: i.width,
    containerHeight: i.height
  }), P = KE(_, 2), T = P[0], M = P[1], j = Y_(function(I, k) {
    M(function(R) {
      var D = Math.round(I), B = Math.round(k);
      return R.containerWidth === D && R.containerHeight === B ? R : {
        containerWidth: D,
        containerHeight: B
      };
    });
  }, []);
  bo(function() {
    var I = function(K) {
      var E, N = K[0].contentRect, L = N.width, z = N.height;
      j(L, z), (E = w.current) === null || E === void 0 || E.call(w, L, z);
    };
    v > 0 && (I = hw(I, v, {
      trailing: !0,
      leading: !1
    }));
    var k = new ResizeObserver(I), R = m.current.getBoundingClientRect(), D = R.width, B = R.height;
    return j(D, B), k.observe(m.current), function() {
      k.disconnect();
    };
  }, [j, v]);
  var $ = sx(function() {
    var I = T.containerWidth, k = T.containerHeight;
    if (I < 0 || k < 0)
      return null;
    xt(gr(o) || gr(s), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, o, s), xt(!r || r > 0, "The aspect(%s) must be greater than zero.", r);
    var R = gr(o) ? I : o, D = gr(s) ? k : s;
    r && r > 0 && (R ? D = R / r : D && (R = D * r), d && D > d && (D = d)), xt(R > 0 || D > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, R, D, o, s, l, f, r);
    var B = !Array.isArray(p) && Dt(p.type).endsWith("Chart");
    return S.Children.map(p, function(W) {
      return /* @__PURE__ */ S.isValidElement(W) ? /* @__PURE__ */ Ce(W, ea({
        width: R,
        height: D
      }, B ? {
        style: ea({
          height: "100%",
          width: "100%",
          maxHeight: D,
          maxWidth: R
        }, W.props.style)
      } : {})) : W;
    });
  }, [r, p, s, d, f, l, T, o]);
  return /* @__PURE__ */ S.createElement("div", {
    id: h ? "".concat(h) : void 0,
    className: ae("recharts-responsive-container", x),
    style: ea(ea({}, O), {}, {
      width: o,
      height: s,
      minWidth: l,
      minHeight: f,
      maxHeight: d
    }),
    ref: m
  }, $);
}), Mn = function(t) {
  return null;
};
Mn.displayName = "Cell";
function fi(e) {
  "@babel/helpers - typeof";
  return fi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fi(e);
}
function Tm(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Mf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Tm(Object(r), !0).forEach(function(n) {
      XE(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Tm(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function XE(e, t, r) {
  return t = ZE(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ZE(e) {
  var t = JE(e, "string");
  return fi(t) == "symbol" ? t : t + "";
}
function JE(e, t) {
  if (fi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (fi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Lr = {
  widthCache: {},
  cacheCount: 0
}, QE = 2e3, ej = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, $m = "recharts_measurement_span";
function tj(e) {
  var t = Mf({}, e);
  return Object.keys(t).forEach(function(r) {
    t[r] || delete t[r];
  }), t;
}
var Zn = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (t == null || Kt.isSsr)
    return {
      width: 0,
      height: 0
    };
  var n = tj(r), i = JSON.stringify({
    text: t,
    copyStyle: n
  });
  if (Lr.widthCache[i])
    return Lr.widthCache[i];
  try {
    var a = document.getElementById($m);
    a || (a = document.createElement("span"), a.setAttribute("id", $m), a.setAttribute("aria-hidden", "true"), document.body.appendChild(a));
    var o = Mf(Mf({}, ej), n);
    Object.assign(a.style, o), a.textContent = "".concat(t);
    var u = a.getBoundingClientRect(), s = {
      width: u.width,
      height: u.height
    };
    return Lr.widthCache[i] = s, ++Lr.cacheCount > QE && (Lr.cacheCount = 0, Lr.widthCache = {}), s;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, rj = function(t) {
  return {
    top: t.top + window.scrollY - document.documentElement.clientTop,
    left: t.left + window.scrollX - document.documentElement.clientLeft
  };
};
function di(e) {
  "@babel/helpers - typeof";
  return di = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, di(e);
}
function Pa(e, t) {
  return oj(e) || aj(e, t) || ij(e, t) || nj();
}
function nj() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ij(e, t) {
  if (e) {
    if (typeof e == "string") return Mm(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Mm(e, t);
  }
}
function Mm(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function aj(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], s = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        s = !1;
      } else for (; !(s = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function oj(e) {
  if (Array.isArray(e)) return e;
}
function uj(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Cm(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, cj(n.key), n);
  }
}
function sj(e, t, r) {
  return t && Cm(e.prototype, t), r && Cm(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function cj(e) {
  var t = lj(e, "string");
  return di(t) == "symbol" ? t : t + "";
}
function lj(e, t) {
  if (di(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (di(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Im = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, Nm = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, fj = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, dj = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, vw = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, pj = Object.keys(vw), zr = "NaN";
function hj(e, t) {
  return e * vw[t];
}
var ta = /* @__PURE__ */ function() {
  function e(t, r) {
    uj(this, e), this.num = t, this.unit = r, this.num = t, this.unit = r, Number.isNaN(t) && (this.unit = ""), r !== "" && !fj.test(r) && (this.num = NaN, this.unit = ""), pj.includes(r) && (this.num = hj(t, r), this.unit = "px");
  }
  return sj(e, [{
    key: "add",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num + r.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(r) {
      return this.unit !== r.unit ? new e(NaN, "") : new e(this.num - r.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num * r.num, this.unit || r.unit);
    }
  }, {
    key: "divide",
    value: function(r) {
      return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num / r.num, this.unit || r.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(r) {
      var n, i = (n = dj.exec(r)) !== null && n !== void 0 ? n : [], a = Pa(i, 3), o = a[1], u = a[2];
      return new e(parseFloat(o), u ?? "");
    }
  }]);
}();
function yw(e) {
  if (e.includes(zr))
    return zr;
  for (var t = e; t.includes("*") || t.includes("/"); ) {
    var r, n = (r = Im.exec(t)) !== null && r !== void 0 ? r : [], i = Pa(n, 4), a = i[1], o = i[2], u = i[3], s = ta.parse(a ?? ""), c = ta.parse(u ?? ""), l = o === "*" ? s.multiply(c) : s.divide(c);
    if (l.isNaN())
      return zr;
    t = t.replace(Im, l.toString());
  }
  for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
    var f, d = (f = Nm.exec(t)) !== null && f !== void 0 ? f : [], p = Pa(d, 4), y = p[1], v = p[2], h = p[3], x = ta.parse(y ?? ""), g = ta.parse(h ?? ""), b = v === "+" ? x.add(g) : x.subtract(g);
    if (b.isNaN())
      return zr;
    t = t.replace(Nm, b.toString());
  }
  return t;
}
var km = /\(([^()]*)\)/;
function vj(e) {
  for (var t = e; t.includes("("); ) {
    var r = km.exec(t), n = Pa(r, 2), i = n[1];
    t = t.replace(km, yw(i));
  }
  return t;
}
function yj(e) {
  var t = e.replace(/\s+/g, "");
  return t = vj(t), t = yw(t), t;
}
function mj(e) {
  try {
    return yj(e);
  } catch {
    return zr;
  }
}
function pl(e) {
  var t = mj(e.slice(5, -1));
  return t === zr ? "" : t;
}
var gj = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], bj = ["dx", "dy", "angle", "className", "breakAll"];
function Cf() {
  return Cf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Cf.apply(this, arguments);
}
function Rm(e, t) {
  if (e == null) return {};
  var r = xj(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function xj(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Dm(e, t) {
  return Aj(e) || _j(e, t) || Oj(e, t) || wj();
}
function wj() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Oj(e, t) {
  if (e) {
    if (typeof e == "string") return Lm(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Lm(e, t);
  }
}
function Lm(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function _j(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], s = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t === 0) {
        if (Object(r) !== r) return;
        s = !1;
      } else for (; !(s = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function Aj(e) {
  if (Array.isArray(e)) return e;
}
var mw = /[ \f\n\r\t\v\u2028\u2029]+/, gw = function(t) {
  var r = t.children, n = t.breakAll, i = t.style;
  try {
    var a = [];
    te(r) || (n ? a = r.toString().split("") : a = r.toString().split(mw));
    var o = a.map(function(s) {
      return {
        word: s,
        width: Zn(s, i).width
      };
    }), u = n ? 0 : Zn(" ", i).width;
    return {
      wordsWithComputedWidth: o,
      spaceWidth: u
    };
  } catch {
    return null;
  }
}, Sj = function(t, r, n, i, a) {
  var o = t.maxLines, u = t.children, s = t.style, c = t.breakAll, l = U(o), f = u, d = function() {
    var R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return R.reduce(function(D, B) {
      var W = B.word, K = B.width, E = D[D.length - 1];
      if (E && (i == null || a || E.width + K + n < Number(i)))
        E.words.push(W), E.width += K + n;
      else {
        var N = {
          words: [W],
          width: K
        };
        D.push(N);
      }
      return D;
    }, []);
  }, p = d(r), y = function(R) {
    return R.reduce(function(D, B) {
      return D.width > B.width ? D : B;
    });
  };
  if (!l)
    return p;
  for (var v = "…", h = function(R) {
    var D = f.slice(0, R), B = gw({
      breakAll: c,
      style: s,
      children: D + v
    }).wordsWithComputedWidth, W = d(B), K = W.length > o || y(W).width > Number(i);
    return [K, W];
  }, x = 0, g = f.length - 1, b = 0, O; x <= g && b <= f.length - 1; ) {
    var m = Math.floor((x + g) / 2), w = m - 1, _ = h(w), P = Dm(_, 2), T = P[0], M = P[1], j = h(m), $ = Dm(j, 1), I = $[0];
    if (!T && !I && (x = m + 1), T && I && (g = m - 1), !T && I) {
      O = M;
      break;
    }
    b++;
  }
  return O || p;
}, qm = function(t) {
  var r = te(t) ? [] : t.toString().split(mw);
  return [{
    words: r
  }];
}, Pj = function(t) {
  var r = t.width, n = t.scaleToFit, i = t.children, a = t.style, o = t.breakAll, u = t.maxLines;
  if ((r || n) && !Kt.isSsr) {
    var s, c, l = gw({
      breakAll: o,
      children: i,
      style: a
    });
    if (l) {
      var f = l.wordsWithComputedWidth, d = l.spaceWidth;
      s = f, c = d;
    } else
      return qm(i);
    return Sj({
      breakAll: o,
      children: i,
      maxLines: u,
      style: a
    }, s, c, r, n);
  }
  return qm(i);
}, Bm = "#808080", jr = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, i = t.y, a = i === void 0 ? 0 : i, o = t.lineHeight, u = o === void 0 ? "1em" : o, s = t.capHeight, c = s === void 0 ? "0.71em" : s, l = t.scaleToFit, f = l === void 0 ? !1 : l, d = t.textAnchor, p = d === void 0 ? "start" : d, y = t.verticalAnchor, v = y === void 0 ? "end" : y, h = t.fill, x = h === void 0 ? Bm : h, g = Rm(t, gj), b = sx(function() {
    return Pj({
      breakAll: g.breakAll,
      children: g.children,
      maxLines: g.maxLines,
      scaleToFit: f,
      style: g.style,
      width: g.width
    });
  }, [g.breakAll, g.children, g.maxLines, f, g.style, g.width]), O = g.dx, m = g.dy, w = g.angle, _ = g.className, P = g.breakAll, T = Rm(g, bj);
  if (!Ie(n) || !Ie(a))
    return null;
  var M = n + (U(O) ? O : 0), j = a + (U(m) ? m : 0), $;
  switch (v) {
    case "start":
      $ = pl("calc(".concat(c, ")"));
      break;
    case "middle":
      $ = pl("calc(".concat((b.length - 1) / 2, " * -").concat(u, " + (").concat(c, " / 2))"));
      break;
    default:
      $ = pl("calc(".concat(b.length - 1, " * -").concat(u, ")"));
      break;
  }
  var I = [];
  if (f) {
    var k = b[0].width, R = g.width;
    I.push("scale(".concat((U(R) ? R / k : 1) / k, ")"));
  }
  return w && I.push("rotate(".concat(w, ", ").concat(M, ", ").concat(j, ")")), I.length && (T.transform = I.join(" ")), /* @__PURE__ */ S.createElement("text", Cf({}, J(T, !0), {
    x: M,
    y: j,
    className: ae("recharts-text", _),
    textAnchor: p,
    fill: x.includes("url") ? Bm : x
  }), b.map(function(D, B) {
    var W = D.words.join(P ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ S.createElement("tspan", {
        x: M,
        dy: B === 0 ? $ : u,
        key: "".concat(W, "-").concat(B)
      }, W)
    );
  }));
};
function tr(e, t) {
  return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function Ej(e, t) {
  return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function ap(e) {
  let t, r, n;
  e.length !== 2 ? (t = tr, r = (u, s) => tr(e(u), s), n = (u, s) => e(u) - s) : (t = e === tr || e === Ej ? e : jj, r = e, n = e);
  function i(u, s, c = 0, l = u.length) {
    if (c < l) {
      if (t(s, s) !== 0) return l;
      do {
        const f = c + l >>> 1;
        r(u[f], s) < 0 ? c = f + 1 : l = f;
      } while (c < l);
    }
    return c;
  }
  function a(u, s, c = 0, l = u.length) {
    if (c < l) {
      if (t(s, s) !== 0) return l;
      do {
        const f = c + l >>> 1;
        r(u[f], s) <= 0 ? c = f + 1 : l = f;
      } while (c < l);
    }
    return c;
  }
  function o(u, s, c = 0, l = u.length) {
    const f = i(u, s, c, l - 1);
    return f > c && n(u[f - 1], s) > -n(u[f], s) ? f - 1 : f;
  }
  return { left: i, center: o, right: a };
}
function jj() {
  return 0;
}
function bw(e) {
  return e === null ? NaN : +e;
}
function* Tj(e, t) {
  for (let r of e)
    r != null && (r = +r) >= r && (yield r);
}
const $j = ap(tr), zi = $j.right;
ap(bw).center;
class Fm extends Map {
  constructor(t, r = Ij) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), t != null) for (const [n, i] of t) this.set(n, i);
  }
  get(t) {
    return super.get(zm(this, t));
  }
  has(t) {
    return super.has(zm(this, t));
  }
  set(t, r) {
    return super.set(Mj(this, t), r);
  }
  delete(t) {
    return super.delete(Cj(this, t));
  }
}
function zm({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : r;
}
function Mj({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) ? e.get(n) : (e.set(n, r), r);
}
function Cj({ _intern: e, _key: t }, r) {
  const n = t(r);
  return e.has(n) && (r = e.get(n), e.delete(n)), r;
}
function Ij(e) {
  return e !== null && typeof e == "object" ? e.valueOf() : e;
}
function Nj(e = tr) {
  if (e === tr) return xw;
  if (typeof e != "function") throw new TypeError("compare is not a function");
  return (t, r) => {
    const n = e(t, r);
    return n || n === 0 ? n : (e(r, r) === 0) - (e(t, t) === 0);
  };
}
function xw(e, t) {
  return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
}
const kj = Math.sqrt(50), Rj = Math.sqrt(10), Dj = Math.sqrt(2);
function Ea(e, t, r) {
  const n = (t - e) / Math.max(0, r), i = Math.floor(Math.log10(n)), a = n / Math.pow(10, i), o = a >= kj ? 10 : a >= Rj ? 5 : a >= Dj ? 2 : 1;
  let u, s, c;
  return i < 0 ? (c = Math.pow(10, -i) / o, u = Math.round(e * c), s = Math.round(t * c), u / c < e && ++u, s / c > t && --s, c = -c) : (c = Math.pow(10, i) * o, u = Math.round(e / c), s = Math.round(t / c), u * c < e && ++u, s * c > t && --s), s < u && 0.5 <= r && r < 2 ? Ea(e, t, r * 2) : [u, s, c];
}
function If(e, t, r) {
  if (t = +t, e = +e, r = +r, !(r > 0)) return [];
  if (e === t) return [e];
  const n = t < e, [i, a, o] = n ? Ea(t, e, r) : Ea(e, t, r);
  if (!(a >= i)) return [];
  const u = a - i + 1, s = new Array(u);
  if (n)
    if (o < 0) for (let c = 0; c < u; ++c) s[c] = (a - c) / -o;
    else for (let c = 0; c < u; ++c) s[c] = (a - c) * o;
  else if (o < 0) for (let c = 0; c < u; ++c) s[c] = (i + c) / -o;
  else for (let c = 0; c < u; ++c) s[c] = (i + c) * o;
  return s;
}
function Nf(e, t, r) {
  return t = +t, e = +e, r = +r, Ea(e, t, r)[2];
}
function kf(e, t, r) {
  t = +t, e = +e, r = +r;
  const n = t < e, i = n ? Nf(t, e, r) : Nf(e, t, r);
  return (n ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function Wm(e, t) {
  let r;
  for (const n of e)
    n != null && (r < n || r === void 0 && n >= n) && (r = n);
  return r;
}
function Um(e, t) {
  let r;
  for (const n of e)
    n != null && (r > n || r === void 0 && n >= n) && (r = n);
  return r;
}
function ww(e, t, r = 0, n = 1 / 0, i) {
  if (t = Math.floor(t), r = Math.floor(Math.max(0, r)), n = Math.floor(Math.min(e.length - 1, n)), !(r <= t && t <= n)) return e;
  for (i = i === void 0 ? xw : Nj(i); n > r; ) {
    if (n - r > 600) {
      const s = n - r + 1, c = t - r + 1, l = Math.log(s), f = 0.5 * Math.exp(2 * l / 3), d = 0.5 * Math.sqrt(l * f * (s - f) / s) * (c - s / 2 < 0 ? -1 : 1), p = Math.max(r, Math.floor(t - c * f / s + d)), y = Math.min(n, Math.floor(t + (s - c) * f / s + d));
      ww(e, t, p, y, i);
    }
    const a = e[t];
    let o = r, u = n;
    for (Bn(e, r, t), i(e[n], a) > 0 && Bn(e, r, n); o < u; ) {
      for (Bn(e, o, u), ++o, --u; i(e[o], a) < 0; ) ++o;
      for (; i(e[u], a) > 0; ) --u;
    }
    i(e[r], a) === 0 ? Bn(e, r, u) : (++u, Bn(e, u, n)), u <= t && (r = u + 1), t <= u && (n = u - 1);
  }
  return e;
}
function Bn(e, t, r) {
  const n = e[t];
  e[t] = e[r], e[r] = n;
}
function Lj(e, t, r) {
  if (e = Float64Array.from(Tj(e)), !(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2) return Um(e);
    if (t >= 1) return Wm(e);
    var n, i = (n - 1) * t, a = Math.floor(i), o = Wm(ww(e, a).subarray(0, a + 1)), u = Um(e.subarray(a + 1));
    return o + (u - o) * (i - a);
  }
}
function qj(e, t, r = bw) {
  if (!(!(n = e.length) || isNaN(t = +t))) {
    if (t <= 0 || n < 2) return +r(e[0], 0, e);
    if (t >= 1) return +r(e[n - 1], n - 1, e);
    var n, i = (n - 1) * t, a = Math.floor(i), o = +r(e[a], a, e), u = +r(e[a + 1], a + 1, e);
    return o + (u - o) * (i - a);
  }
}
function Bj(e, t, r) {
  e = +e, t = +t, r = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +r;
  for (var n = -1, i = Math.max(0, Math.ceil((t - e) / r)) | 0, a = new Array(i); ++n < i; )
    a[n] = e + n * r;
  return a;
}
function ht(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
function Ht(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
    default: {
      this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
      break;
    }
  }
  return this;
}
const Rf = Symbol("implicit");
function op() {
  var e = new Fm(), t = [], r = [], n = Rf;
  function i(a) {
    let o = e.get(a);
    if (o === void 0) {
      if (n !== Rf) return n;
      e.set(a, o = t.push(a) - 1);
    }
    return r[o % r.length];
  }
  return i.domain = function(a) {
    if (!arguments.length) return t.slice();
    t = [], e = new Fm();
    for (const o of a)
      e.has(o) || e.set(o, t.push(o) - 1);
    return i;
  }, i.range = function(a) {
    return arguments.length ? (r = Array.from(a), i) : r.slice();
  }, i.unknown = function(a) {
    return arguments.length ? (n = a, i) : n;
  }, i.copy = function() {
    return op(t, r).unknown(n);
  }, ht.apply(i, arguments), i;
}
function pi() {
  var e = op().unknown(void 0), t = e.domain, r = e.range, n = 0, i = 1, a, o, u = !1, s = 0, c = 0, l = 0.5;
  delete e.unknown;
  function f() {
    var d = t().length, p = i < n, y = p ? i : n, v = p ? n : i;
    a = (v - y) / Math.max(1, d - s + c * 2), u && (a = Math.floor(a)), y += (v - y - a * (d - s)) * l, o = a * (1 - s), u && (y = Math.round(y), o = Math.round(o));
    var h = Bj(d).map(function(x) {
      return y + a * x;
    });
    return r(p ? h.reverse() : h);
  }
  return e.domain = function(d) {
    return arguments.length ? (t(d), f()) : t();
  }, e.range = function(d) {
    return arguments.length ? ([n, i] = d, n = +n, i = +i, f()) : [n, i];
  }, e.rangeRound = function(d) {
    return [n, i] = d, n = +n, i = +i, u = !0, f();
  }, e.bandwidth = function() {
    return o;
  }, e.step = function() {
    return a;
  }, e.round = function(d) {
    return arguments.length ? (u = !!d, f()) : u;
  }, e.padding = function(d) {
    return arguments.length ? (s = Math.min(1, c = +d), f()) : s;
  }, e.paddingInner = function(d) {
    return arguments.length ? (s = Math.min(1, d), f()) : s;
  }, e.paddingOuter = function(d) {
    return arguments.length ? (c = +d, f()) : c;
  }, e.align = function(d) {
    return arguments.length ? (l = Math.max(0, Math.min(1, d)), f()) : l;
  }, e.copy = function() {
    return pi(t(), [n, i]).round(u).paddingInner(s).paddingOuter(c).align(l);
  }, ht.apply(f(), arguments);
}
function Ow(e) {
  var t = e.copy;
  return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
    return Ow(t());
  }, e;
}
function Jn() {
  return Ow(pi.apply(null, arguments).paddingInner(1));
}
function up(e, t, r) {
  e.prototype = t.prototype = r, r.constructor = e;
}
function _w(e, t) {
  var r = Object.create(e.prototype);
  for (var n in t) r[n] = t[n];
  return r;
}
function Wi() {
}
var hi = 0.7, ja = 1 / hi, Vr = "\\s*([+-]?\\d+)\\s*", vi = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", St = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Fj = /^#([0-9a-f]{3,8})$/, zj = new RegExp(`^rgb\\(${Vr},${Vr},${Vr}\\)$`), Wj = new RegExp(`^rgb\\(${St},${St},${St}\\)$`), Uj = new RegExp(`^rgba\\(${Vr},${Vr},${Vr},${vi}\\)$`), Kj = new RegExp(`^rgba\\(${St},${St},${St},${vi}\\)$`), Hj = new RegExp(`^hsl\\(${vi},${St},${St}\\)$`), Gj = new RegExp(`^hsla\\(${vi},${St},${St},${vi}\\)$`), Km = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
up(Wi, yi, {
  copy(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Hm,
  // Deprecated! Use color.formatHex.
  formatHex: Hm,
  formatHex8: Vj,
  formatHsl: Yj,
  formatRgb: Gm,
  toString: Gm
});
function Hm() {
  return this.rgb().formatHex();
}
function Vj() {
  return this.rgb().formatHex8();
}
function Yj() {
  return Aw(this).formatHsl();
}
function Gm() {
  return this.rgb().formatRgb();
}
function yi(e) {
  var t, r;
  return e = (e + "").trim().toLowerCase(), (t = Fj.exec(e)) ? (r = t[1].length, t = parseInt(t[1], 16), r === 6 ? Vm(t) : r === 3 ? new Ge(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : r === 8 ? ra(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : r === 4 ? ra(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = zj.exec(e)) ? new Ge(t[1], t[2], t[3], 1) : (t = Wj.exec(e)) ? new Ge(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Uj.exec(e)) ? ra(t[1], t[2], t[3], t[4]) : (t = Kj.exec(e)) ? ra(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = Hj.exec(e)) ? Zm(t[1], t[2] / 100, t[3] / 100, 1) : (t = Gj.exec(e)) ? Zm(t[1], t[2] / 100, t[3] / 100, t[4]) : Km.hasOwnProperty(e) ? Vm(Km[e]) : e === "transparent" ? new Ge(NaN, NaN, NaN, 0) : null;
}
function Vm(e) {
  return new Ge(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function ra(e, t, r, n) {
  return n <= 0 && (e = t = r = NaN), new Ge(e, t, r, n);
}
function Xj(e) {
  return e instanceof Wi || (e = yi(e)), e ? (e = e.rgb(), new Ge(e.r, e.g, e.b, e.opacity)) : new Ge();
}
function Df(e, t, r, n) {
  return arguments.length === 1 ? Xj(e) : new Ge(e, t, r, n ?? 1);
}
function Ge(e, t, r, n) {
  this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
}
up(Ge, Df, _w(Wi, {
  brighter(e) {
    return e = e == null ? ja : Math.pow(ja, e), new Ge(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? hi : Math.pow(hi, e), new Ge(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Ge(Ar(this.r), Ar(this.g), Ar(this.b), Ta(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Ym,
  // Deprecated! Use color.formatHex.
  formatHex: Ym,
  formatHex8: Zj,
  formatRgb: Xm,
  toString: Xm
}));
function Ym() {
  return `#${br(this.r)}${br(this.g)}${br(this.b)}`;
}
function Zj() {
  return `#${br(this.r)}${br(this.g)}${br(this.b)}${br((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Xm() {
  const e = Ta(this.opacity);
  return `${e === 1 ? "rgb(" : "rgba("}${Ar(this.r)}, ${Ar(this.g)}, ${Ar(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function Ta(e) {
  return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function Ar(e) {
  return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function br(e) {
  return e = Ar(e), (e < 16 ? "0" : "") + e.toString(16);
}
function Zm(e, t, r, n) {
  return n <= 0 ? e = t = r = NaN : r <= 0 || r >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new gt(e, t, r, n);
}
function Aw(e) {
  if (e instanceof gt) return new gt(e.h, e.s, e.l, e.opacity);
  if (e instanceof Wi || (e = yi(e)), !e) return new gt();
  if (e instanceof gt) return e;
  e = e.rgb();
  var t = e.r / 255, r = e.g / 255, n = e.b / 255, i = Math.min(t, r, n), a = Math.max(t, r, n), o = NaN, u = a - i, s = (a + i) / 2;
  return u ? (t === a ? o = (r - n) / u + (r < n) * 6 : r === a ? o = (n - t) / u + 2 : o = (t - r) / u + 4, u /= s < 0.5 ? a + i : 2 - a - i, o *= 60) : u = s > 0 && s < 1 ? 0 : o, new gt(o, u, s, e.opacity);
}
function Jj(e, t, r, n) {
  return arguments.length === 1 ? Aw(e) : new gt(e, t, r, n ?? 1);
}
function gt(e, t, r, n) {
  this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
}
up(gt, Jj, _w(Wi, {
  brighter(e) {
    return e = e == null ? ja : Math.pow(ja, e), new gt(this.h, this.s, this.l * e, this.opacity);
  },
  darker(e) {
    return e = e == null ? hi : Math.pow(hi, e), new gt(this.h, this.s, this.l * e, this.opacity);
  },
  rgb() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * t, i = 2 * r - n;
    return new Ge(
      hl(e >= 240 ? e - 240 : e + 120, i, n),
      hl(e, i, n),
      hl(e < 120 ? e + 240 : e - 120, i, n),
      this.opacity
    );
  },
  clamp() {
    return new gt(Jm(this.h), na(this.s), na(this.l), Ta(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const e = Ta(this.opacity);
    return `${e === 1 ? "hsl(" : "hsla("}${Jm(this.h)}, ${na(this.s) * 100}%, ${na(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
  }
}));
function Jm(e) {
  return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function na(e) {
  return Math.max(0, Math.min(1, e || 0));
}
function hl(e, t, r) {
  return (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t) * 255;
}
const sp = (e) => () => e;
function Qj(e, t) {
  return function(r) {
    return e + r * t;
  };
}
function eT(e, t, r) {
  return e = Math.pow(e, r), t = Math.pow(t, r) - e, r = 1 / r, function(n) {
    return Math.pow(e + n * t, r);
  };
}
function tT(e) {
  return (e = +e) == 1 ? Sw : function(t, r) {
    return r - t ? eT(t, r, e) : sp(isNaN(t) ? r : t);
  };
}
function Sw(e, t) {
  var r = t - e;
  return r ? Qj(e, r) : sp(isNaN(e) ? t : e);
}
const Qm = function e(t) {
  var r = tT(t);
  function n(i, a) {
    var o = r((i = Df(i)).r, (a = Df(a)).r), u = r(i.g, a.g), s = r(i.b, a.b), c = Sw(i.opacity, a.opacity);
    return function(l) {
      return i.r = o(l), i.g = u(l), i.b = s(l), i.opacity = c(l), i + "";
    };
  }
  return n.gamma = e, n;
}(1);
function rT(e, t) {
  t || (t = []);
  var r = e ? Math.min(t.length, e.length) : 0, n = t.slice(), i;
  return function(a) {
    for (i = 0; i < r; ++i) n[i] = e[i] * (1 - a) + t[i] * a;
    return n;
  };
}
function nT(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function iT(e, t) {
  var r = t ? t.length : 0, n = e ? Math.min(r, e.length) : 0, i = new Array(n), a = new Array(r), o;
  for (o = 0; o < n; ++o) i[o] = Cn(e[o], t[o]);
  for (; o < r; ++o) a[o] = t[o];
  return function(u) {
    for (o = 0; o < n; ++o) a[o] = i[o](u);
    return a;
  };
}
function aT(e, t) {
  var r = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(n) {
    return r.setTime(e * (1 - n) + t * n), r;
  };
}
function $a(e, t) {
  return e = +e, t = +t, function(r) {
    return e * (1 - r) + t * r;
  };
}
function oT(e, t) {
  var r = {}, n = {}, i;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in e ? r[i] = Cn(e[i], t[i]) : n[i] = t[i];
  return function(a) {
    for (i in r) n[i] = r[i](a);
    return n;
  };
}
var Lf = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, vl = new RegExp(Lf.source, "g");
function uT(e) {
  return function() {
    return e;
  };
}
function sT(e) {
  return function(t) {
    return e(t) + "";
  };
}
function cT(e, t) {
  var r = Lf.lastIndex = vl.lastIndex = 0, n, i, a, o = -1, u = [], s = [];
  for (e = e + "", t = t + ""; (n = Lf.exec(e)) && (i = vl.exec(t)); )
    (a = i.index) > r && (a = t.slice(r, a), u[o] ? u[o] += a : u[++o] = a), (n = n[0]) === (i = i[0]) ? u[o] ? u[o] += i : u[++o] = i : (u[++o] = null, s.push({ i: o, x: $a(n, i) })), r = vl.lastIndex;
  return r < t.length && (a = t.slice(r), u[o] ? u[o] += a : u[++o] = a), u.length < 2 ? s[0] ? sT(s[0].x) : uT(t) : (t = s.length, function(c) {
    for (var l = 0, f; l < t; ++l) u[(f = s[l]).i] = f.x(c);
    return u.join("");
  });
}
function Cn(e, t) {
  var r = typeof t, n;
  return t == null || r === "boolean" ? sp(t) : (r === "number" ? $a : r === "string" ? (n = yi(t)) ? (t = n, Qm) : cT : t instanceof yi ? Qm : t instanceof Date ? aT : nT(t) ? rT : Array.isArray(t) ? iT : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? oT : $a)(e, t);
}
function cp(e, t) {
  return e = +e, t = +t, function(r) {
    return Math.round(e * (1 - r) + t * r);
  };
}
function lT(e, t) {
  t === void 0 && (t = e, e = Cn);
  for (var r = 0, n = t.length - 1, i = t[0], a = new Array(n < 0 ? 0 : n); r < n; ) a[r] = e(i, i = t[++r]);
  return function(o) {
    var u = Math.max(0, Math.min(n - 1, Math.floor(o *= n)));
    return a[u](o - u);
  };
}
function fT(e) {
  return function() {
    return e;
  };
}
function Ma(e) {
  return +e;
}
var eg = [0, 1];
function Ke(e) {
  return e;
}
function qf(e, t) {
  return (t -= e = +e) ? function(r) {
    return (r - e) / t;
  } : fT(isNaN(t) ? NaN : 0.5);
}
function dT(e, t) {
  var r;
  return e > t && (r = e, e = t, t = r), function(n) {
    return Math.max(e, Math.min(t, n));
  };
}
function pT(e, t, r) {
  var n = e[0], i = e[1], a = t[0], o = t[1];
  return i < n ? (n = qf(i, n), a = r(o, a)) : (n = qf(n, i), a = r(a, o)), function(u) {
    return a(n(u));
  };
}
function hT(e, t, r) {
  var n = Math.min(e.length, t.length) - 1, i = new Array(n), a = new Array(n), o = -1;
  for (e[n] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++o < n; )
    i[o] = qf(e[o], e[o + 1]), a[o] = r(t[o], t[o + 1]);
  return function(u) {
    var s = zi(e, u, 1, n) - 1;
    return a[s](i[s](u));
  };
}
function Ui(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function Io() {
  var e = eg, t = eg, r = Cn, n, i, a, o = Ke, u, s, c;
  function l() {
    var d = Math.min(e.length, t.length);
    return o !== Ke && (o = dT(e[0], e[d - 1])), u = d > 2 ? hT : pT, s = c = null, f;
  }
  function f(d) {
    return d == null || isNaN(d = +d) ? a : (s || (s = u(e.map(n), t, r)))(n(o(d)));
  }
  return f.invert = function(d) {
    return o(i((c || (c = u(t, e.map(n), $a)))(d)));
  }, f.domain = function(d) {
    return arguments.length ? (e = Array.from(d, Ma), l()) : e.slice();
  }, f.range = function(d) {
    return arguments.length ? (t = Array.from(d), l()) : t.slice();
  }, f.rangeRound = function(d) {
    return t = Array.from(d), r = cp, l();
  }, f.clamp = function(d) {
    return arguments.length ? (o = d ? !0 : Ke, l()) : o !== Ke;
  }, f.interpolate = function(d) {
    return arguments.length ? (r = d, l()) : r;
  }, f.unknown = function(d) {
    return arguments.length ? (a = d, f) : a;
  }, function(d, p) {
    return n = d, i = p, l();
  };
}
function lp() {
  return Io()(Ke, Ke);
}
function vT(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function Ca(e, t) {
  if ((r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var r, n = e.slice(0, r);
  return [
    n.length > 1 ? n[0] + n.slice(2) : n,
    +e.slice(r + 1)
  ];
}
function tn(e) {
  return e = Ca(Math.abs(e)), e ? e[1] : NaN;
}
function yT(e, t) {
  return function(r, n) {
    for (var i = r.length, a = [], o = 0, u = e[0], s = 0; i > 0 && u > 0 && (s + u + 1 > n && (u = Math.max(1, n - s)), a.push(r.substring(i -= u, i + u)), !((s += u + 1) > n)); )
      u = e[o = (o + 1) % e.length];
    return a.reverse().join(t);
  };
}
function mT(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(r) {
      return e[+r];
    });
  };
}
var gT = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function mi(e) {
  if (!(t = gT.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new fp({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
mi.prototype = fp.prototype;
function fp(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
fp.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function bT(e) {
  e: for (var t = e.length, r = 1, n = -1, i; r < t; ++r)
    switch (e[r]) {
      case ".":
        n = i = r;
        break;
      case "0":
        n === 0 && (n = r), i = r;
        break;
      default:
        if (!+e[r]) break e;
        n > 0 && (n = 0);
        break;
    }
  return n > 0 ? e.slice(0, n) + e.slice(i + 1) : e;
}
var Pw;
function xT(e, t) {
  var r = Ca(e, t);
  if (!r) return e + "";
  var n = r[0], i = r[1], a = i - (Pw = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = n.length;
  return a === o ? n : a > o ? n + new Array(a - o + 1).join("0") : a > 0 ? n.slice(0, a) + "." + n.slice(a) : "0." + new Array(1 - a).join("0") + Ca(e, Math.max(0, t + a - 1))[0];
}
function tg(e, t) {
  var r = Ca(e, t);
  if (!r) return e + "";
  var n = r[0], i = r[1];
  return i < 0 ? "0." + new Array(-i).join("0") + n : n.length > i + 1 ? n.slice(0, i + 1) + "." + n.slice(i + 1) : n + new Array(i - n.length + 2).join("0");
}
const rg = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: vT,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => tg(e * 100, t),
  r: tg,
  s: xT,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function ng(e) {
  return e;
}
var ig = Array.prototype.map, ag = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function wT(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? ng : yT(ig.call(e.grouping, Number), e.thousands + ""), r = e.currency === void 0 ? "" : e.currency[0] + "", n = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", a = e.numerals === void 0 ? ng : mT(ig.call(e.numerals, String)), o = e.percent === void 0 ? "%" : e.percent + "", u = e.minus === void 0 ? "−" : e.minus + "", s = e.nan === void 0 ? "NaN" : e.nan + "";
  function c(f) {
    f = mi(f);
    var d = f.fill, p = f.align, y = f.sign, v = f.symbol, h = f.zero, x = f.width, g = f.comma, b = f.precision, O = f.trim, m = f.type;
    m === "n" ? (g = !0, m = "g") : rg[m] || (b === void 0 && (b = 12), O = !0, m = "g"), (h || d === "0" && p === "=") && (h = !0, d = "0", p = "=");
    var w = v === "$" ? r : v === "#" && /[boxX]/.test(m) ? "0" + m.toLowerCase() : "", _ = v === "$" ? n : /[%p]/.test(m) ? o : "", P = rg[m], T = /[defgprs%]/.test(m);
    b = b === void 0 ? 6 : /[gprs]/.test(m) ? Math.max(1, Math.min(21, b)) : Math.max(0, Math.min(20, b));
    function M(j) {
      var $ = w, I = _, k, R, D;
      if (m === "c")
        I = P(j) + I, j = "";
      else {
        j = +j;
        var B = j < 0 || 1 / j < 0;
        if (j = isNaN(j) ? s : P(Math.abs(j), b), O && (j = bT(j)), B && +j == 0 && y !== "+" && (B = !1), $ = (B ? y === "(" ? y : u : y === "-" || y === "(" ? "" : y) + $, I = (m === "s" ? ag[8 + Pw / 3] : "") + I + (B && y === "(" ? ")" : ""), T) {
          for (k = -1, R = j.length; ++k < R; )
            if (D = j.charCodeAt(k), 48 > D || D > 57) {
              I = (D === 46 ? i + j.slice(k + 1) : j.slice(k)) + I, j = j.slice(0, k);
              break;
            }
        }
      }
      g && !h && (j = t(j, 1 / 0));
      var W = $.length + j.length + I.length, K = W < x ? new Array(x - W + 1).join(d) : "";
      switch (g && h && (j = t(K + j, K.length ? x - I.length : 1 / 0), K = ""), p) {
        case "<":
          j = $ + j + I + K;
          break;
        case "=":
          j = $ + K + j + I;
          break;
        case "^":
          j = K.slice(0, W = K.length >> 1) + $ + j + I + K.slice(W);
          break;
        default:
          j = K + $ + j + I;
          break;
      }
      return a(j);
    }
    return M.toString = function() {
      return f + "";
    }, M;
  }
  function l(f, d) {
    var p = c((f = mi(f), f.type = "f", f)), y = Math.max(-8, Math.min(8, Math.floor(tn(d) / 3))) * 3, v = Math.pow(10, -y), h = ag[8 + y / 3];
    return function(x) {
      return p(v * x) + h;
    };
  }
  return {
    format: c,
    formatPrefix: l
  };
}
var ia, dp, Ew;
OT({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function OT(e) {
  return ia = wT(e), dp = ia.format, Ew = ia.formatPrefix, ia;
}
function _T(e) {
  return Math.max(0, -tn(Math.abs(e)));
}
function AT(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(tn(t) / 3))) * 3 - tn(Math.abs(e)));
}
function ST(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, tn(t) - tn(e)) + 1;
}
function jw(e, t, r, n) {
  var i = kf(e, t, r), a;
  switch (n = mi(n ?? ",f"), n.type) {
    case "s": {
      var o = Math.max(Math.abs(e), Math.abs(t));
      return n.precision == null && !isNaN(a = AT(i, o)) && (n.precision = a), Ew(n, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      n.precision == null && !isNaN(a = ST(i, Math.max(Math.abs(e), Math.abs(t)))) && (n.precision = a - (n.type === "e"));
      break;
    }
    case "f":
    case "%": {
      n.precision == null && !isNaN(a = _T(i)) && (n.precision = a - (n.type === "%") * 2);
      break;
    }
  }
  return dp(n);
}
function sr(e) {
  var t = e.domain;
  return e.ticks = function(r) {
    var n = t();
    return If(n[0], n[n.length - 1], r ?? 10);
  }, e.tickFormat = function(r, n) {
    var i = t();
    return jw(i[0], i[i.length - 1], r ?? 10, n);
  }, e.nice = function(r) {
    r == null && (r = 10);
    var n = t(), i = 0, a = n.length - 1, o = n[i], u = n[a], s, c, l = 10;
    for (u < o && (c = o, o = u, u = c, c = i, i = a, a = c); l-- > 0; ) {
      if (c = Nf(o, u, r), c === s)
        return n[i] = o, n[a] = u, t(n);
      if (c > 0)
        o = Math.floor(o / c) * c, u = Math.ceil(u / c) * c;
      else if (c < 0)
        o = Math.ceil(o * c) / c, u = Math.floor(u * c) / c;
      else
        break;
      s = c;
    }
    return e;
  }, e;
}
function Ia() {
  var e = lp();
  return e.copy = function() {
    return Ui(e, Ia());
  }, ht.apply(e, arguments), sr(e);
}
function Tw(e) {
  var t;
  function r(n) {
    return n == null || isNaN(n = +n) ? t : n;
  }
  return r.invert = r, r.domain = r.range = function(n) {
    return arguments.length ? (e = Array.from(n, Ma), r) : e.slice();
  }, r.unknown = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.copy = function() {
    return Tw(e).unknown(t);
  }, e = arguments.length ? Array.from(e, Ma) : [0, 1], sr(r);
}
function $w(e, t) {
  e = e.slice();
  var r = 0, n = e.length - 1, i = e[r], a = e[n], o;
  return a < i && (o = r, r = n, n = o, o = i, i = a, a = o), e[r] = t.floor(i), e[n] = t.ceil(a), e;
}
function og(e) {
  return Math.log(e);
}
function ug(e) {
  return Math.exp(e);
}
function PT(e) {
  return -Math.log(-e);
}
function ET(e) {
  return -Math.exp(-e);
}
function jT(e) {
  return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
}
function TT(e) {
  return e === 10 ? jT : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
}
function $T(e) {
  return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
}
function sg(e) {
  return (t, r) => -e(-t, r);
}
function pp(e) {
  const t = e(og, ug), r = t.domain;
  let n = 10, i, a;
  function o() {
    return i = $T(n), a = TT(n), r()[0] < 0 ? (i = sg(i), a = sg(a), e(PT, ET)) : e(og, ug), t;
  }
  return t.base = function(u) {
    return arguments.length ? (n = +u, o()) : n;
  }, t.domain = function(u) {
    return arguments.length ? (r(u), o()) : r();
  }, t.ticks = (u) => {
    const s = r();
    let c = s[0], l = s[s.length - 1];
    const f = l < c;
    f && ([c, l] = [l, c]);
    let d = i(c), p = i(l), y, v;
    const h = u == null ? 10 : +u;
    let x = [];
    if (!(n % 1) && p - d < h) {
      if (d = Math.floor(d), p = Math.ceil(p), c > 0) {
        for (; d <= p; ++d)
          for (y = 1; y < n; ++y)
            if (v = d < 0 ? y / a(-d) : y * a(d), !(v < c)) {
              if (v > l) break;
              x.push(v);
            }
      } else for (; d <= p; ++d)
        for (y = n - 1; y >= 1; --y)
          if (v = d > 0 ? y / a(-d) : y * a(d), !(v < c)) {
            if (v > l) break;
            x.push(v);
          }
      x.length * 2 < h && (x = If(c, l, h));
    } else
      x = If(d, p, Math.min(p - d, h)).map(a);
    return f ? x.reverse() : x;
  }, t.tickFormat = (u, s) => {
    if (u == null && (u = 10), s == null && (s = n === 10 ? "s" : ","), typeof s != "function" && (!(n % 1) && (s = mi(s)).precision == null && (s.trim = !0), s = dp(s)), u === 1 / 0) return s;
    const c = Math.max(1, n * u / t.ticks().length);
    return (l) => {
      let f = l / a(Math.round(i(l)));
      return f * n < n - 0.5 && (f *= n), f <= c ? s(l) : "";
    };
  }, t.nice = () => r($w(r(), {
    floor: (u) => a(Math.floor(i(u))),
    ceil: (u) => a(Math.ceil(i(u)))
  })), t;
}
function Mw() {
  const e = pp(Io()).domain([1, 10]);
  return e.copy = () => Ui(e, Mw()).base(e.base()), ht.apply(e, arguments), e;
}
function cg(e) {
  return function(t) {
    return Math.sign(t) * Math.log1p(Math.abs(t / e));
  };
}
function lg(e) {
  return function(t) {
    return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
  };
}
function hp(e) {
  var t = 1, r = e(cg(t), lg(t));
  return r.constant = function(n) {
    return arguments.length ? e(cg(t = +n), lg(t)) : t;
  }, sr(r);
}
function Cw() {
  var e = hp(Io());
  return e.copy = function() {
    return Ui(e, Cw()).constant(e.constant());
  }, ht.apply(e, arguments);
}
function fg(e) {
  return function(t) {
    return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
  };
}
function MT(e) {
  return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
}
function CT(e) {
  return e < 0 ? -e * e : e * e;
}
function vp(e) {
  var t = e(Ke, Ke), r = 1;
  function n() {
    return r === 1 ? e(Ke, Ke) : r === 0.5 ? e(MT, CT) : e(fg(r), fg(1 / r));
  }
  return t.exponent = function(i) {
    return arguments.length ? (r = +i, n()) : r;
  }, sr(t);
}
function yp() {
  var e = vp(Io());
  return e.copy = function() {
    return Ui(e, yp()).exponent(e.exponent());
  }, ht.apply(e, arguments), e;
}
function IT() {
  return yp.apply(null, arguments).exponent(0.5);
}
function dg(e) {
  return Math.sign(e) * e * e;
}
function NT(e) {
  return Math.sign(e) * Math.sqrt(Math.abs(e));
}
function Iw() {
  var e = lp(), t = [0, 1], r = !1, n;
  function i(a) {
    var o = NT(e(a));
    return isNaN(o) ? n : r ? Math.round(o) : o;
  }
  return i.invert = function(a) {
    return e.invert(dg(a));
  }, i.domain = function(a) {
    return arguments.length ? (e.domain(a), i) : e.domain();
  }, i.range = function(a) {
    return arguments.length ? (e.range((t = Array.from(a, Ma)).map(dg)), i) : t.slice();
  }, i.rangeRound = function(a) {
    return i.range(a).round(!0);
  }, i.round = function(a) {
    return arguments.length ? (r = !!a, i) : r;
  }, i.clamp = function(a) {
    return arguments.length ? (e.clamp(a), i) : e.clamp();
  }, i.unknown = function(a) {
    return arguments.length ? (n = a, i) : n;
  }, i.copy = function() {
    return Iw(e.domain(), t).round(r).clamp(e.clamp()).unknown(n);
  }, ht.apply(i, arguments), sr(i);
}
function Nw() {
  var e = [], t = [], r = [], n;
  function i() {
    var o = 0, u = Math.max(1, t.length);
    for (r = new Array(u - 1); ++o < u; ) r[o - 1] = qj(e, o / u);
    return a;
  }
  function a(o) {
    return o == null || isNaN(o = +o) ? n : t[zi(r, o)];
  }
  return a.invertExtent = function(o) {
    var u = t.indexOf(o);
    return u < 0 ? [NaN, NaN] : [
      u > 0 ? r[u - 1] : e[0],
      u < r.length ? r[u] : e[e.length - 1]
    ];
  }, a.domain = function(o) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let u of o) u != null && !isNaN(u = +u) && e.push(u);
    return e.sort(tr), i();
  }, a.range = function(o) {
    return arguments.length ? (t = Array.from(o), i()) : t.slice();
  }, a.unknown = function(o) {
    return arguments.length ? (n = o, a) : n;
  }, a.quantiles = function() {
    return r.slice();
  }, a.copy = function() {
    return Nw().domain(e).range(t).unknown(n);
  }, ht.apply(a, arguments);
}
function kw() {
  var e = 0, t = 1, r = 1, n = [0.5], i = [0, 1], a;
  function o(s) {
    return s != null && s <= s ? i[zi(n, s, 0, r)] : a;
  }
  function u() {
    var s = -1;
    for (n = new Array(r); ++s < r; ) n[s] = ((s + 1) * t - (s - r) * e) / (r + 1);
    return o;
  }
  return o.domain = function(s) {
    return arguments.length ? ([e, t] = s, e = +e, t = +t, u()) : [e, t];
  }, o.range = function(s) {
    return arguments.length ? (r = (i = Array.from(s)).length - 1, u()) : i.slice();
  }, o.invertExtent = function(s) {
    var c = i.indexOf(s);
    return c < 0 ? [NaN, NaN] : c < 1 ? [e, n[0]] : c >= r ? [n[r - 1], t] : [n[c - 1], n[c]];
  }, o.unknown = function(s) {
    return arguments.length && (a = s), o;
  }, o.thresholds = function() {
    return n.slice();
  }, o.copy = function() {
    return kw().domain([e, t]).range(i).unknown(a);
  }, ht.apply(sr(o), arguments);
}
function Rw() {
  var e = [0.5], t = [0, 1], r, n = 1;
  function i(a) {
    return a != null && a <= a ? t[zi(e, a, 0, n)] : r;
  }
  return i.domain = function(a) {
    return arguments.length ? (e = Array.from(a), n = Math.min(e.length, t.length - 1), i) : e.slice();
  }, i.range = function(a) {
    return arguments.length ? (t = Array.from(a), n = Math.min(e.length, t.length - 1), i) : t.slice();
  }, i.invertExtent = function(a) {
    var o = t.indexOf(a);
    return [e[o - 1], e[o]];
  }, i.unknown = function(a) {
    return arguments.length ? (r = a, i) : r;
  }, i.copy = function() {
    return Rw().domain(e).range(t).unknown(r);
  }, ht.apply(i, arguments);
}
const yl = /* @__PURE__ */ new Date(), ml = /* @__PURE__ */ new Date();
function Ne(e, t, r, n) {
  function i(a) {
    return e(a = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+a)), a;
  }
  return i.floor = (a) => (e(a = /* @__PURE__ */ new Date(+a)), a), i.ceil = (a) => (e(a = new Date(a - 1)), t(a, 1), e(a), a), i.round = (a) => {
    const o = i(a), u = i.ceil(a);
    return a - o < u - a ? o : u;
  }, i.offset = (a, o) => (t(a = /* @__PURE__ */ new Date(+a), o == null ? 1 : Math.floor(o)), a), i.range = (a, o, u) => {
    const s = [];
    if (a = i.ceil(a), u = u == null ? 1 : Math.floor(u), !(a < o) || !(u > 0)) return s;
    let c;
    do
      s.push(c = /* @__PURE__ */ new Date(+a)), t(a, u), e(a);
    while (c < a && a < o);
    return s;
  }, i.filter = (a) => Ne((o) => {
    if (o >= o) for (; e(o), !a(o); ) o.setTime(o - 1);
  }, (o, u) => {
    if (o >= o)
      if (u < 0) for (; ++u <= 0; )
        for (; t(o, -1), !a(o); )
          ;
      else for (; --u >= 0; )
        for (; t(o, 1), !a(o); )
          ;
  }), r && (i.count = (a, o) => (yl.setTime(+a), ml.setTime(+o), e(yl), e(ml), Math.floor(r(yl, ml))), i.every = (a) => (a = Math.floor(a), !isFinite(a) || !(a > 0) ? null : a > 1 ? i.filter(n ? (o) => n(o) % a === 0 : (o) => i.count(0, o) % a === 0) : i)), i;
}
const Na = Ne(() => {
}, (e, t) => {
  e.setTime(+e + t);
}, (e, t) => t - e);
Na.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? Ne((t) => {
  t.setTime(Math.floor(t / e) * e);
}, (t, r) => {
  t.setTime(+t + r * e);
}, (t, r) => (r - t) / e) : Na);
Na.range;
const Nt = 1e3, ct = Nt * 60, kt = ct * 60, qt = kt * 24, mp = qt * 7, pg = qt * 30, gl = qt * 365, xr = Ne((e) => {
  e.setTime(e - e.getMilliseconds());
}, (e, t) => {
  e.setTime(+e + t * Nt);
}, (e, t) => (t - e) / Nt, (e) => e.getUTCSeconds());
xr.range;
const gp = Ne((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Nt);
}, (e, t) => {
  e.setTime(+e + t * ct);
}, (e, t) => (t - e) / ct, (e) => e.getMinutes());
gp.range;
const bp = Ne((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * ct);
}, (e, t) => (t - e) / ct, (e) => e.getUTCMinutes());
bp.range;
const xp = Ne((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * Nt - e.getMinutes() * ct);
}, (e, t) => {
  e.setTime(+e + t * kt);
}, (e, t) => (t - e) / kt, (e) => e.getHours());
xp.range;
const wp = Ne((e) => {
  e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
  e.setTime(+e + t * kt);
}, (e, t) => (t - e) / kt, (e) => e.getUTCHours());
wp.range;
const Ki = Ne(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * ct) / qt,
  (e) => e.getDate() - 1
);
Ki.range;
const No = Ne((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / qt, (e) => e.getUTCDate() - 1);
No.range;
const Dw = Ne((e) => {
  e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / qt, (e) => Math.floor(e / qt));
Dw.range;
function Ir(e) {
  return Ne((t) => {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setDate(t.getDate() + r * 7);
  }, (t, r) => (r - t - (r.getTimezoneOffset() - t.getTimezoneOffset()) * ct) / mp);
}
const ko = Ir(0), ka = Ir(1), kT = Ir(2), RT = Ir(3), rn = Ir(4), DT = Ir(5), LT = Ir(6);
ko.range;
ka.range;
kT.range;
RT.range;
rn.range;
DT.range;
LT.range;
function Nr(e) {
  return Ne((t) => {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setUTCDate(t.getUTCDate() + r * 7);
  }, (t, r) => (r - t) / mp);
}
const Ro = Nr(0), Ra = Nr(1), qT = Nr(2), BT = Nr(3), nn = Nr(4), FT = Nr(5), zT = Nr(6);
Ro.range;
Ra.range;
qT.range;
BT.range;
nn.range;
FT.range;
zT.range;
const Op = Ne((e) => {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
Op.range;
const _p = Ne((e) => {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
_p.range;
const Bt = Ne((e) => {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
Bt.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Ne((t) => {
  t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, r) => {
  t.setFullYear(t.getFullYear() + r * e);
});
Bt.range;
const Ft = Ne((e) => {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
Ft.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : Ne((t) => {
  t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, r) => {
  t.setUTCFullYear(t.getUTCFullYear() + r * e);
});
Ft.range;
function Lw(e, t, r, n, i, a) {
  const o = [
    [xr, 1, Nt],
    [xr, 5, 5 * Nt],
    [xr, 15, 15 * Nt],
    [xr, 30, 30 * Nt],
    [a, 1, ct],
    [a, 5, 5 * ct],
    [a, 15, 15 * ct],
    [a, 30, 30 * ct],
    [i, 1, kt],
    [i, 3, 3 * kt],
    [i, 6, 6 * kt],
    [i, 12, 12 * kt],
    [n, 1, qt],
    [n, 2, 2 * qt],
    [r, 1, mp],
    [t, 1, pg],
    [t, 3, 3 * pg],
    [e, 1, gl]
  ];
  function u(c, l, f) {
    const d = l < c;
    d && ([c, l] = [l, c]);
    const p = f && typeof f.range == "function" ? f : s(c, l, f), y = p ? p.range(c, +l + 1) : [];
    return d ? y.reverse() : y;
  }
  function s(c, l, f) {
    const d = Math.abs(l - c) / f, p = ap(([, , h]) => h).right(o, d);
    if (p === o.length) return e.every(kf(c / gl, l / gl, f));
    if (p === 0) return Na.every(Math.max(kf(c, l, f), 1));
    const [y, v] = o[d / o[p - 1][2] < o[p][2] / d ? p - 1 : p];
    return y.every(v);
  }
  return [u, s];
}
const [WT, UT] = Lw(Ft, _p, Ro, Dw, wp, bp), [KT, HT] = Lw(Bt, Op, ko, Ki, xp, gp);
function bl(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
    return t.setFullYear(e.y), t;
  }
  return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function xl(e) {
  if (0 <= e.y && e.y < 100) {
    var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
    return t.setUTCFullYear(e.y), t;
  }
  return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function Fn(e, t, r) {
  return { y: e, m: t, d: r, H: 0, M: 0, S: 0, L: 0 };
}
function GT(e) {
  var t = e.dateTime, r = e.date, n = e.time, i = e.periods, a = e.days, o = e.shortDays, u = e.months, s = e.shortMonths, c = zn(i), l = Wn(i), f = zn(a), d = Wn(a), p = zn(o), y = Wn(o), v = zn(u), h = Wn(u), x = zn(s), g = Wn(s), b = {
    a: B,
    A: W,
    b: K,
    B: E,
    c: null,
    d: bg,
    e: bg,
    f: y$,
    g: P$,
    G: j$,
    H: p$,
    I: h$,
    j: v$,
    L: qw,
    m: m$,
    M: g$,
    p: N,
    q: L,
    Q: Og,
    s: _g,
    S: b$,
    u: x$,
    U: w$,
    V: O$,
    w: _$,
    W: A$,
    x: null,
    X: null,
    y: S$,
    Y: E$,
    Z: T$,
    "%": wg
  }, O = {
    a: z,
    A: V,
    b: Y,
    B: ee,
    c: null,
    d: xg,
    e: xg,
    f: I$,
    g: W$,
    G: K$,
    H: $$,
    I: M$,
    j: C$,
    L: Fw,
    m: N$,
    M: k$,
    p: ne,
    q: X,
    Q: Og,
    s: _g,
    S: R$,
    u: D$,
    U: L$,
    V: q$,
    w: B$,
    W: F$,
    x: null,
    X: null,
    y: z$,
    Y: U$,
    Z: H$,
    "%": wg
  }, m = {
    a: M,
    A: j,
    b: $,
    B: I,
    c: k,
    d: mg,
    e: mg,
    f: c$,
    g: yg,
    G: vg,
    H: gg,
    I: gg,
    j: a$,
    L: s$,
    m: i$,
    M: o$,
    p: T,
    q: n$,
    Q: f$,
    s: d$,
    S: u$,
    u: JT,
    U: QT,
    V: e$,
    w: ZT,
    W: t$,
    x: R,
    X: D,
    y: yg,
    Y: vg,
    Z: r$,
    "%": l$
  };
  b.x = w(r, b), b.X = w(n, b), b.c = w(t, b), O.x = w(r, O), O.X = w(n, O), O.c = w(t, O);
  function w(F, G) {
    return function(Q) {
      var C = [], ue = -1, H = 0, ge = F.length, Ae, Le, Gt;
      for (Q instanceof Date || (Q = /* @__PURE__ */ new Date(+Q)); ++ue < ge; )
        F.charCodeAt(ue) === 37 && (C.push(F.slice(H, ue)), (Le = hg[Ae = F.charAt(++ue)]) != null ? Ae = F.charAt(++ue) : Le = Ae === "e" ? " " : "0", (Gt = G[Ae]) && (Ae = Gt(Q, Le)), C.push(Ae), H = ue + 1);
      return C.push(F.slice(H, ue)), C.join("");
    };
  }
  function _(F, G) {
    return function(Q) {
      var C = Fn(1900, void 0, 1), ue = P(C, F, Q += "", 0), H, ge;
      if (ue != Q.length) return null;
      if ("Q" in C) return new Date(C.Q);
      if ("s" in C) return new Date(C.s * 1e3 + ("L" in C ? C.L : 0));
      if (G && !("Z" in C) && (C.Z = 0), "p" in C && (C.H = C.H % 12 + C.p * 12), C.m === void 0 && (C.m = "q" in C ? C.q : 0), "V" in C) {
        if (C.V < 1 || C.V > 53) return null;
        "w" in C || (C.w = 1), "Z" in C ? (H = xl(Fn(C.y, 0, 1)), ge = H.getUTCDay(), H = ge > 4 || ge === 0 ? Ra.ceil(H) : Ra(H), H = No.offset(H, (C.V - 1) * 7), C.y = H.getUTCFullYear(), C.m = H.getUTCMonth(), C.d = H.getUTCDate() + (C.w + 6) % 7) : (H = bl(Fn(C.y, 0, 1)), ge = H.getDay(), H = ge > 4 || ge === 0 ? ka.ceil(H) : ka(H), H = Ki.offset(H, (C.V - 1) * 7), C.y = H.getFullYear(), C.m = H.getMonth(), C.d = H.getDate() + (C.w + 6) % 7);
      } else ("W" in C || "U" in C) && ("w" in C || (C.w = "u" in C ? C.u % 7 : "W" in C ? 1 : 0), ge = "Z" in C ? xl(Fn(C.y, 0, 1)).getUTCDay() : bl(Fn(C.y, 0, 1)).getDay(), C.m = 0, C.d = "W" in C ? (C.w + 6) % 7 + C.W * 7 - (ge + 5) % 7 : C.w + C.U * 7 - (ge + 6) % 7);
      return "Z" in C ? (C.H += C.Z / 100 | 0, C.M += C.Z % 100, xl(C)) : bl(C);
    };
  }
  function P(F, G, Q, C) {
    for (var ue = 0, H = G.length, ge = Q.length, Ae, Le; ue < H; ) {
      if (C >= ge) return -1;
      if (Ae = G.charCodeAt(ue++), Ae === 37) {
        if (Ae = G.charAt(ue++), Le = m[Ae in hg ? G.charAt(ue++) : Ae], !Le || (C = Le(F, Q, C)) < 0) return -1;
      } else if (Ae != Q.charCodeAt(C++))
        return -1;
    }
    return C;
  }
  function T(F, G, Q) {
    var C = c.exec(G.slice(Q));
    return C ? (F.p = l.get(C[0].toLowerCase()), Q + C[0].length) : -1;
  }
  function M(F, G, Q) {
    var C = p.exec(G.slice(Q));
    return C ? (F.w = y.get(C[0].toLowerCase()), Q + C[0].length) : -1;
  }
  function j(F, G, Q) {
    var C = f.exec(G.slice(Q));
    return C ? (F.w = d.get(C[0].toLowerCase()), Q + C[0].length) : -1;
  }
  function $(F, G, Q) {
    var C = x.exec(G.slice(Q));
    return C ? (F.m = g.get(C[0].toLowerCase()), Q + C[0].length) : -1;
  }
  function I(F, G, Q) {
    var C = v.exec(G.slice(Q));
    return C ? (F.m = h.get(C[0].toLowerCase()), Q + C[0].length) : -1;
  }
  function k(F, G, Q) {
    return P(F, t, G, Q);
  }
  function R(F, G, Q) {
    return P(F, r, G, Q);
  }
  function D(F, G, Q) {
    return P(F, n, G, Q);
  }
  function B(F) {
    return o[F.getDay()];
  }
  function W(F) {
    return a[F.getDay()];
  }
  function K(F) {
    return s[F.getMonth()];
  }
  function E(F) {
    return u[F.getMonth()];
  }
  function N(F) {
    return i[+(F.getHours() >= 12)];
  }
  function L(F) {
    return 1 + ~~(F.getMonth() / 3);
  }
  function z(F) {
    return o[F.getUTCDay()];
  }
  function V(F) {
    return a[F.getUTCDay()];
  }
  function Y(F) {
    return s[F.getUTCMonth()];
  }
  function ee(F) {
    return u[F.getUTCMonth()];
  }
  function ne(F) {
    return i[+(F.getUTCHours() >= 12)];
  }
  function X(F) {
    return 1 + ~~(F.getUTCMonth() / 3);
  }
  return {
    format: function(F) {
      var G = w(F += "", b);
      return G.toString = function() {
        return F;
      }, G;
    },
    parse: function(F) {
      var G = _(F += "", !1);
      return G.toString = function() {
        return F;
      }, G;
    },
    utcFormat: function(F) {
      var G = w(F += "", O);
      return G.toString = function() {
        return F;
      }, G;
    },
    utcParse: function(F) {
      var G = _(F += "", !0);
      return G.toString = function() {
        return F;
      }, G;
    }
  };
}
var hg = { "-": "", _: " ", 0: "0" }, De = /^\s*\d+/, VT = /^%/, YT = /[\\^$*+?|[\]().{}]/g;
function ce(e, t, r) {
  var n = e < 0 ? "-" : "", i = (n ? -e : e) + "", a = i.length;
  return n + (a < r ? new Array(r - a + 1).join(t) + i : i);
}
function XT(e) {
  return e.replace(YT, "\\$&");
}
function zn(e) {
  return new RegExp("^(?:" + e.map(XT).join("|") + ")", "i");
}
function Wn(e) {
  return new Map(e.map((t, r) => [t.toLowerCase(), r]));
}
function ZT(e, t, r) {
  var n = De.exec(t.slice(r, r + 1));
  return n ? (e.w = +n[0], r + n[0].length) : -1;
}
function JT(e, t, r) {
  var n = De.exec(t.slice(r, r + 1));
  return n ? (e.u = +n[0], r + n[0].length) : -1;
}
function QT(e, t, r) {
  var n = De.exec(t.slice(r, r + 2));
  return n ? (e.U = +n[0], r + n[0].length) : -1;
}
function e$(e, t, r) {
  var n = De.exec(t.slice(r, r + 2));
  return n ? (e.V = +n[0], r + n[0].length) : -1;
}
function t$(e, t, r) {
  var n = De.exec(t.slice(r, r + 2));
  return n ? (e.W = +n[0], r + n[0].length) : -1;
}
function vg(e, t, r) {
  var n = De.exec(t.slice(r, r + 4));
  return n ? (e.y = +n[0], r + n[0].length) : -1;
}
function yg(e, t, r) {
  var n = De.exec(t.slice(r, r + 2));
  return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
}
function r$(e, t, r) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
  return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
}
function n$(e, t, r) {
  var n = De.exec(t.slice(r, r + 1));
  return n ? (e.q = n[0] * 3 - 3, r + n[0].length) : -1;
}
function i$(e, t, r) {
  var n = De.exec(t.slice(r, r + 2));
  return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
}
function mg(e, t, r) {
  var n = De.exec(t.slice(r, r + 2));
  return n ? (e.d = +n[0], r + n[0].length) : -1;
}
function a$(e, t, r) {
  var n = De.exec(t.slice(r, r + 3));
  return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
}
function gg(e, t, r) {
  var n = De.exec(t.slice(r, r + 2));
  return n ? (e.H = +n[0], r + n[0].length) : -1;
}
function o$(e, t, r) {
  var n = De.exec(t.slice(r, r + 2));
  return n ? (e.M = +n[0], r + n[0].length) : -1;
}
function u$(e, t, r) {
  var n = De.exec(t.slice(r, r + 2));
  return n ? (e.S = +n[0], r + n[0].length) : -1;
}
function s$(e, t, r) {
  var n = De.exec(t.slice(r, r + 3));
  return n ? (e.L = +n[0], r + n[0].length) : -1;
}
function c$(e, t, r) {
  var n = De.exec(t.slice(r, r + 6));
  return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
}
function l$(e, t, r) {
  var n = VT.exec(t.slice(r, r + 1));
  return n ? r + n[0].length : -1;
}
function f$(e, t, r) {
  var n = De.exec(t.slice(r));
  return n ? (e.Q = +n[0], r + n[0].length) : -1;
}
function d$(e, t, r) {
  var n = De.exec(t.slice(r));
  return n ? (e.s = +n[0], r + n[0].length) : -1;
}
function bg(e, t) {
  return ce(e.getDate(), t, 2);
}
function p$(e, t) {
  return ce(e.getHours(), t, 2);
}
function h$(e, t) {
  return ce(e.getHours() % 12 || 12, t, 2);
}
function v$(e, t) {
  return ce(1 + Ki.count(Bt(e), e), t, 3);
}
function qw(e, t) {
  return ce(e.getMilliseconds(), t, 3);
}
function y$(e, t) {
  return qw(e, t) + "000";
}
function m$(e, t) {
  return ce(e.getMonth() + 1, t, 2);
}
function g$(e, t) {
  return ce(e.getMinutes(), t, 2);
}
function b$(e, t) {
  return ce(e.getSeconds(), t, 2);
}
function x$(e) {
  var t = e.getDay();
  return t === 0 ? 7 : t;
}
function w$(e, t) {
  return ce(ko.count(Bt(e) - 1, e), t, 2);
}
function Bw(e) {
  var t = e.getDay();
  return t >= 4 || t === 0 ? rn(e) : rn.ceil(e);
}
function O$(e, t) {
  return e = Bw(e), ce(rn.count(Bt(e), e) + (Bt(e).getDay() === 4), t, 2);
}
function _$(e) {
  return e.getDay();
}
function A$(e, t) {
  return ce(ka.count(Bt(e) - 1, e), t, 2);
}
function S$(e, t) {
  return ce(e.getFullYear() % 100, t, 2);
}
function P$(e, t) {
  return e = Bw(e), ce(e.getFullYear() % 100, t, 2);
}
function E$(e, t) {
  return ce(e.getFullYear() % 1e4, t, 4);
}
function j$(e, t) {
  var r = e.getDay();
  return e = r >= 4 || r === 0 ? rn(e) : rn.ceil(e), ce(e.getFullYear() % 1e4, t, 4);
}
function T$(e) {
  var t = e.getTimezoneOffset();
  return (t > 0 ? "-" : (t *= -1, "+")) + ce(t / 60 | 0, "0", 2) + ce(t % 60, "0", 2);
}
function xg(e, t) {
  return ce(e.getUTCDate(), t, 2);
}
function $$(e, t) {
  return ce(e.getUTCHours(), t, 2);
}
function M$(e, t) {
  return ce(e.getUTCHours() % 12 || 12, t, 2);
}
function C$(e, t) {
  return ce(1 + No.count(Ft(e), e), t, 3);
}
function Fw(e, t) {
  return ce(e.getUTCMilliseconds(), t, 3);
}
function I$(e, t) {
  return Fw(e, t) + "000";
}
function N$(e, t) {
  return ce(e.getUTCMonth() + 1, t, 2);
}
function k$(e, t) {
  return ce(e.getUTCMinutes(), t, 2);
}
function R$(e, t) {
  return ce(e.getUTCSeconds(), t, 2);
}
function D$(e) {
  var t = e.getUTCDay();
  return t === 0 ? 7 : t;
}
function L$(e, t) {
  return ce(Ro.count(Ft(e) - 1, e), t, 2);
}
function zw(e) {
  var t = e.getUTCDay();
  return t >= 4 || t === 0 ? nn(e) : nn.ceil(e);
}
function q$(e, t) {
  return e = zw(e), ce(nn.count(Ft(e), e) + (Ft(e).getUTCDay() === 4), t, 2);
}
function B$(e) {
  return e.getUTCDay();
}
function F$(e, t) {
  return ce(Ra.count(Ft(e) - 1, e), t, 2);
}
function z$(e, t) {
  return ce(e.getUTCFullYear() % 100, t, 2);
}
function W$(e, t) {
  return e = zw(e), ce(e.getUTCFullYear() % 100, t, 2);
}
function U$(e, t) {
  return ce(e.getUTCFullYear() % 1e4, t, 4);
}
function K$(e, t) {
  var r = e.getUTCDay();
  return e = r >= 4 || r === 0 ? nn(e) : nn.ceil(e), ce(e.getUTCFullYear() % 1e4, t, 4);
}
function H$() {
  return "+0000";
}
function wg() {
  return "%";
}
function Og(e) {
  return +e;
}
function _g(e) {
  return Math.floor(+e / 1e3);
}
var qr, Ww, Uw;
G$({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function G$(e) {
  return qr = GT(e), Ww = qr.format, qr.parse, Uw = qr.utcFormat, qr.utcParse, qr;
}
function V$(e) {
  return new Date(e);
}
function Y$(e) {
  return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function Ap(e, t, r, n, i, a, o, u, s, c) {
  var l = lp(), f = l.invert, d = l.domain, p = c(".%L"), y = c(":%S"), v = c("%I:%M"), h = c("%I %p"), x = c("%a %d"), g = c("%b %d"), b = c("%B"), O = c("%Y");
  function m(w) {
    return (s(w) < w ? p : u(w) < w ? y : o(w) < w ? v : a(w) < w ? h : n(w) < w ? i(w) < w ? x : g : r(w) < w ? b : O)(w);
  }
  return l.invert = function(w) {
    return new Date(f(w));
  }, l.domain = function(w) {
    return arguments.length ? d(Array.from(w, Y$)) : d().map(V$);
  }, l.ticks = function(w) {
    var _ = d();
    return e(_[0], _[_.length - 1], w ?? 10);
  }, l.tickFormat = function(w, _) {
    return _ == null ? m : c(_);
  }, l.nice = function(w) {
    var _ = d();
    return (!w || typeof w.range != "function") && (w = t(_[0], _[_.length - 1], w ?? 10)), w ? d($w(_, w)) : l;
  }, l.copy = function() {
    return Ui(l, Ap(e, t, r, n, i, a, o, u, s, c));
  }, l;
}
function X$() {
  return ht.apply(Ap(KT, HT, Bt, Op, ko, Ki, xp, gp, xr, Ww).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function Z$() {
  return ht.apply(Ap(WT, UT, Ft, _p, Ro, No, wp, bp, xr, Uw).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function Do() {
  var e = 0, t = 1, r, n, i, a, o = Ke, u = !1, s;
  function c(f) {
    return f == null || isNaN(f = +f) ? s : o(i === 0 ? 0.5 : (f = (a(f) - r) * i, u ? Math.max(0, Math.min(1, f)) : f));
  }
  c.domain = function(f) {
    return arguments.length ? ([e, t] = f, r = a(e = +e), n = a(t = +t), i = r === n ? 0 : 1 / (n - r), c) : [e, t];
  }, c.clamp = function(f) {
    return arguments.length ? (u = !!f, c) : u;
  }, c.interpolator = function(f) {
    return arguments.length ? (o = f, c) : o;
  };
  function l(f) {
    return function(d) {
      var p, y;
      return arguments.length ? ([p, y] = d, o = f(p, y), c) : [o(0), o(1)];
    };
  }
  return c.range = l(Cn), c.rangeRound = l(cp), c.unknown = function(f) {
    return arguments.length ? (s = f, c) : s;
  }, function(f) {
    return a = f, r = f(e), n = f(t), i = r === n ? 0 : 1 / (n - r), c;
  };
}
function cr(e, t) {
  return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
}
function Kw() {
  var e = sr(Do()(Ke));
  return e.copy = function() {
    return cr(e, Kw());
  }, Ht.apply(e, arguments);
}
function Hw() {
  var e = pp(Do()).domain([1, 10]);
  return e.copy = function() {
    return cr(e, Hw()).base(e.base());
  }, Ht.apply(e, arguments);
}
function Gw() {
  var e = hp(Do());
  return e.copy = function() {
    return cr(e, Gw()).constant(e.constant());
  }, Ht.apply(e, arguments);
}
function Sp() {
  var e = vp(Do());
  return e.copy = function() {
    return cr(e, Sp()).exponent(e.exponent());
  }, Ht.apply(e, arguments);
}
function J$() {
  return Sp.apply(null, arguments).exponent(0.5);
}
function Vw() {
  var e = [], t = Ke;
  function r(n) {
    if (n != null && !isNaN(n = +n)) return t((zi(e, n, 1) - 1) / (e.length - 1));
  }
  return r.domain = function(n) {
    if (!arguments.length) return e.slice();
    e = [];
    for (let i of n) i != null && !isNaN(i = +i) && e.push(i);
    return e.sort(tr), r;
  }, r.interpolator = function(n) {
    return arguments.length ? (t = n, r) : t;
  }, r.range = function() {
    return e.map((n, i) => t(i / (e.length - 1)));
  }, r.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (i, a) => Lj(e, a / n));
  }, r.copy = function() {
    return Vw(t).domain(e);
  }, Ht.apply(r, arguments);
}
function Lo() {
  var e = 0, t = 0.5, r = 1, n = 1, i, a, o, u, s, c = Ke, l, f = !1, d;
  function p(v) {
    return isNaN(v = +v) ? d : (v = 0.5 + ((v = +l(v)) - a) * (n * v < n * a ? u : s), c(f ? Math.max(0, Math.min(1, v)) : v));
  }
  p.domain = function(v) {
    return arguments.length ? ([e, t, r] = v, i = l(e = +e), a = l(t = +t), o = l(r = +r), u = i === a ? 0 : 0.5 / (a - i), s = a === o ? 0 : 0.5 / (o - a), n = a < i ? -1 : 1, p) : [e, t, r];
  }, p.clamp = function(v) {
    return arguments.length ? (f = !!v, p) : f;
  }, p.interpolator = function(v) {
    return arguments.length ? (c = v, p) : c;
  };
  function y(v) {
    return function(h) {
      var x, g, b;
      return arguments.length ? ([x, g, b] = h, c = lT(v, [x, g, b]), p) : [c(0), c(0.5), c(1)];
    };
  }
  return p.range = y(Cn), p.rangeRound = y(cp), p.unknown = function(v) {
    return arguments.length ? (d = v, p) : d;
  }, function(v) {
    return l = v, i = v(e), a = v(t), o = v(r), u = i === a ? 0 : 0.5 / (a - i), s = a === o ? 0 : 0.5 / (o - a), n = a < i ? -1 : 1, p;
  };
}
function Yw() {
  var e = sr(Lo()(Ke));
  return e.copy = function() {
    return cr(e, Yw());
  }, Ht.apply(e, arguments);
}
function Xw() {
  var e = pp(Lo()).domain([0.1, 1, 10]);
  return e.copy = function() {
    return cr(e, Xw()).base(e.base());
  }, Ht.apply(e, arguments);
}
function Zw() {
  var e = hp(Lo());
  return e.copy = function() {
    return cr(e, Zw()).constant(e.constant());
  }, Ht.apply(e, arguments);
}
function Pp() {
  var e = vp(Lo());
  return e.copy = function() {
    return cr(e, Pp()).exponent(e.exponent());
  }, Ht.apply(e, arguments);
}
function Q$() {
  return Pp.apply(null, arguments).exponent(0.5);
}
const Ag = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: pi,
  scaleDiverging: Yw,
  scaleDivergingLog: Xw,
  scaleDivergingPow: Pp,
  scaleDivergingSqrt: Q$,
  scaleDivergingSymlog: Zw,
  scaleIdentity: Tw,
  scaleImplicit: Rf,
  scaleLinear: Ia,
  scaleLog: Mw,
  scaleOrdinal: op,
  scalePoint: Jn,
  scalePow: yp,
  scaleQuantile: Nw,
  scaleQuantize: kw,
  scaleRadial: Iw,
  scaleSequential: Kw,
  scaleSequentialLog: Hw,
  scaleSequentialPow: Sp,
  scaleSequentialQuantile: Vw,
  scaleSequentialSqrt: J$,
  scaleSequentialSymlog: Gw,
  scaleSqrt: IT,
  scaleSymlog: Cw,
  scaleThreshold: Rw,
  scaleTime: X$,
  scaleUtc: Z$,
  tickFormat: jw
}, Symbol.toStringTag, { value: "Module" }));
var wl, Sg;
function qo() {
  if (Sg) return wl;
  Sg = 1;
  var e = En();
  function t(r, n, i) {
    for (var a = -1, o = r.length; ++a < o; ) {
      var u = r[a], s = n(u);
      if (s != null && (c === void 0 ? s === s && !e(s) : i(s, c)))
        var c = s, l = u;
    }
    return l;
  }
  return wl = t, wl;
}
var Ol, Pg;
function Jw() {
  if (Pg) return Ol;
  Pg = 1;
  function e(t, r) {
    return t > r;
  }
  return Ol = e, Ol;
}
var _l, Eg;
function eM() {
  if (Eg) return _l;
  Eg = 1;
  var e = qo(), t = Jw(), r = $n();
  function n(i) {
    return i && i.length ? e(i, r, t) : void 0;
  }
  return _l = n, _l;
}
var tM = eM();
const Zt = /* @__PURE__ */ ye(tM);
var Al, jg;
function Qw() {
  if (jg) return Al;
  jg = 1;
  function e(t, r) {
    return t < r;
  }
  return Al = e, Al;
}
var Sl, Tg;
function rM() {
  if (Tg) return Sl;
  Tg = 1;
  var e = qo(), t = Qw(), r = $n();
  function n(i) {
    return i && i.length ? e(i, r, t) : void 0;
  }
  return Sl = n, Sl;
}
var nM = rM();
const Bo = /* @__PURE__ */ ye(nM);
var Pl, $g;
function iM() {
  if ($g) return Pl;
  $g = 1;
  var e = zd(), t = Tt(), r = uw(), n = Ye();
  function i(a, o) {
    var u = n(a) ? e : r;
    return u(a, t(o, 3));
  }
  return Pl = i, Pl;
}
var El, Mg;
function aM() {
  if (Mg) return El;
  Mg = 1;
  var e = aw(), t = iM();
  function r(n, i) {
    return e(t(n, i), 1);
  }
  return El = r, El;
}
var oM = aM();
const uM = /* @__PURE__ */ ye(oM);
var jl, Cg;
function sM() {
  if (Cg) return jl;
  Cg = 1;
  var e = ep();
  function t(r, n) {
    return e(r, n);
  }
  return jl = t, jl;
}
var cM = sM();
const ir = /* @__PURE__ */ ye(cM);
var In = 1e9, lM = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, jp, Se = !0, dt = "[DecimalError] ", Sr = dt + "Invalid argument: ", Ep = dt + "Exponent out of range: ", Nn = Math.floor, yr = Math.pow, fM = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Qe, ke = 1e7, Oe = 7, eO = 9007199254740991, Da = Nn(eO / Oe), Z = {};
Z.absoluteValue = Z.abs = function() {
  var e = new this.constructor(this);
  return e.s && (e.s = 1), e;
};
Z.comparedTo = Z.cmp = function(e) {
  var t, r, n, i, a = this;
  if (e = new a.constructor(e), a.s !== e.s) return a.s || -e.s;
  if (a.e !== e.e) return a.e > e.e ^ a.s < 0 ? 1 : -1;
  for (n = a.d.length, i = e.d.length, t = 0, r = n < i ? n : i; t < r; ++t)
    if (a.d[t] !== e.d[t]) return a.d[t] > e.d[t] ^ a.s < 0 ? 1 : -1;
  return n === i ? 0 : n > i ^ a.s < 0 ? 1 : -1;
};
Z.decimalPlaces = Z.dp = function() {
  var e = this, t = e.d.length - 1, r = (t - e.e) * Oe;
  if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) r--;
  return r < 0 ? 0 : r;
};
Z.dividedBy = Z.div = function(e) {
  return Lt(this, new this.constructor(e));
};
Z.dividedToIntegerBy = Z.idiv = function(e) {
  var t = this, r = t.constructor;
  return me(Lt(t, new r(e), 0, 1), r.precision);
};
Z.equals = Z.eq = function(e) {
  return !this.cmp(e);
};
Z.exponent = function() {
  return Te(this);
};
Z.greaterThan = Z.gt = function(e) {
  return this.cmp(e) > 0;
};
Z.greaterThanOrEqualTo = Z.gte = function(e) {
  return this.cmp(e) >= 0;
};
Z.isInteger = Z.isint = function() {
  return this.e > this.d.length - 2;
};
Z.isNegative = Z.isneg = function() {
  return this.s < 0;
};
Z.isPositive = Z.ispos = function() {
  return this.s > 0;
};
Z.isZero = function() {
  return this.s === 0;
};
Z.lessThan = Z.lt = function(e) {
  return this.cmp(e) < 0;
};
Z.lessThanOrEqualTo = Z.lte = function(e) {
  return this.cmp(e) < 1;
};
Z.logarithm = Z.log = function(e) {
  var t, r = this, n = r.constructor, i = n.precision, a = i + 5;
  if (e === void 0)
    e = new n(10);
  else if (e = new n(e), e.s < 1 || e.eq(Qe)) throw Error(dt + "NaN");
  if (r.s < 1) throw Error(dt + (r.s ? "NaN" : "-Infinity"));
  return r.eq(Qe) ? new n(0) : (Se = !1, t = Lt(gi(r, a), gi(e, a), a), Se = !0, me(t, i));
};
Z.minus = Z.sub = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? nO(t, e) : tO(t, (e.s = -e.s, e));
};
Z.modulo = Z.mod = function(e) {
  var t, r = this, n = r.constructor, i = n.precision;
  if (e = new n(e), !e.s) throw Error(dt + "NaN");
  return r.s ? (Se = !1, t = Lt(r, e, 0, 1).times(e), Se = !0, r.minus(t)) : me(new n(r), i);
};
Z.naturalExponential = Z.exp = function() {
  return rO(this);
};
Z.naturalLogarithm = Z.ln = function() {
  return gi(this);
};
Z.negated = Z.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s || 0, e;
};
Z.plus = Z.add = function(e) {
  var t = this;
  return e = new t.constructor(e), t.s == e.s ? tO(t, e) : nO(t, (e.s = -e.s, e));
};
Z.precision = Z.sd = function(e) {
  var t, r, n, i = this;
  if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Sr + e);
  if (t = Te(i) + 1, n = i.d.length - 1, r = n * Oe + 1, n = i.d[n], n) {
    for (; n % 10 == 0; n /= 10) r--;
    for (n = i.d[0]; n >= 10; n /= 10) r++;
  }
  return e && t > r ? t : r;
};
Z.squareRoot = Z.sqrt = function() {
  var e, t, r, n, i, a, o, u = this, s = u.constructor;
  if (u.s < 1) {
    if (!u.s) return new s(0);
    throw Error(dt + "NaN");
  }
  for (e = Te(u), Se = !1, i = Math.sqrt(+u), i == 0 || i == 1 / 0 ? (t = _t(u.d), (t.length + e) % 2 == 0 && (t += "0"), i = Math.sqrt(t), e = Nn((e + 1) / 2) - (e < 0 || e % 2), i == 1 / 0 ? t = "5e" + e : (t = i.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), n = new s(t)) : n = new s(i.toString()), r = s.precision, i = o = r + 3; ; )
    if (a = n, n = a.plus(Lt(u, a, o + 2)).times(0.5), _t(a.d).slice(0, o) === (t = _t(n.d)).slice(0, o)) {
      if (t = t.slice(o - 3, o + 1), i == o && t == "4999") {
        if (me(a, r + 1, 0), a.times(a).eq(u)) {
          n = a;
          break;
        }
      } else if (t != "9999")
        break;
      o += 4;
    }
  return Se = !0, me(n, r);
};
Z.times = Z.mul = function(e) {
  var t, r, n, i, a, o, u, s, c, l = this, f = l.constructor, d = l.d, p = (e = new f(e)).d;
  if (!l.s || !e.s) return new f(0);
  for (e.s *= l.s, r = l.e + e.e, s = d.length, c = p.length, s < c && (a = d, d = p, p = a, o = s, s = c, c = o), a = [], o = s + c, n = o; n--; ) a.push(0);
  for (n = c; --n >= 0; ) {
    for (t = 0, i = s + n; i > n; )
      u = a[i] + p[n] * d[i - n - 1] + t, a[i--] = u % ke | 0, t = u / ke | 0;
    a[i] = (a[i] + t) % ke | 0;
  }
  for (; !a[--o]; ) a.pop();
  return t ? ++r : a.shift(), e.d = a, e.e = r, Se ? me(e, f.precision) : e;
};
Z.toDecimalPlaces = Z.todp = function(e, t) {
  var r = this, n = r.constructor;
  return r = new n(r), e === void 0 ? r : (Et(e, 0, In), t === void 0 ? t = n.rounding : Et(t, 0, 8), me(r, e + Te(r) + 1, t));
};
Z.toExponential = function(e, t) {
  var r, n = this, i = n.constructor;
  return e === void 0 ? r = Tr(n, !0) : (Et(e, 0, In), t === void 0 ? t = i.rounding : Et(t, 0, 8), n = me(new i(n), e + 1, t), r = Tr(n, !0, e + 1)), r;
};
Z.toFixed = function(e, t) {
  var r, n, i = this, a = i.constructor;
  return e === void 0 ? Tr(i) : (Et(e, 0, In), t === void 0 ? t = a.rounding : Et(t, 0, 8), n = me(new a(i), e + Te(i) + 1, t), r = Tr(n.abs(), !1, e + Te(n) + 1), i.isneg() && !i.isZero() ? "-" + r : r);
};
Z.toInteger = Z.toint = function() {
  var e = this, t = e.constructor;
  return me(new t(e), Te(e) + 1, t.rounding);
};
Z.toNumber = function() {
  return +this;
};
Z.toPower = Z.pow = function(e) {
  var t, r, n, i, a, o, u = this, s = u.constructor, c = 12, l = +(e = new s(e));
  if (!e.s) return new s(Qe);
  if (u = new s(u), !u.s) {
    if (e.s < 1) throw Error(dt + "Infinity");
    return u;
  }
  if (u.eq(Qe)) return u;
  if (n = s.precision, e.eq(Qe)) return me(u, n);
  if (t = e.e, r = e.d.length - 1, o = t >= r, a = u.s, o) {
    if ((r = l < 0 ? -l : l) <= eO) {
      for (i = new s(Qe), t = Math.ceil(n / Oe + 4), Se = !1; r % 2 && (i = i.times(u), Ng(i.d, t)), r = Nn(r / 2), r !== 0; )
        u = u.times(u), Ng(u.d, t);
      return Se = !0, e.s < 0 ? new s(Qe).div(i) : me(i, n);
    }
  } else if (a < 0) throw Error(dt + "NaN");
  return a = a < 0 && e.d[Math.max(t, r)] & 1 ? -1 : 1, u.s = 1, Se = !1, i = e.times(gi(u, n + c)), Se = !0, i = rO(i), i.s = a, i;
};
Z.toPrecision = function(e, t) {
  var r, n, i = this, a = i.constructor;
  return e === void 0 ? (r = Te(i), n = Tr(i, r <= a.toExpNeg || r >= a.toExpPos)) : (Et(e, 1, In), t === void 0 ? t = a.rounding : Et(t, 0, 8), i = me(new a(i), e, t), r = Te(i), n = Tr(i, e <= r || r <= a.toExpNeg, e)), n;
};
Z.toSignificantDigits = Z.tosd = function(e, t) {
  var r = this, n = r.constructor;
  return e === void 0 ? (e = n.precision, t = n.rounding) : (Et(e, 1, In), t === void 0 ? t = n.rounding : Et(t, 0, 8)), me(new n(r), e, t);
};
Z.toString = Z.valueOf = Z.val = Z.toJSON = Z[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var e = this, t = Te(e), r = e.constructor;
  return Tr(e, t <= r.toExpNeg || t >= r.toExpPos);
};
function tO(e, t) {
  var r, n, i, a, o, u, s, c, l = e.constructor, f = l.precision;
  if (!e.s || !t.s)
    return t.s || (t = new l(e)), Se ? me(t, f) : t;
  if (s = e.d, c = t.d, o = e.e, i = t.e, s = s.slice(), a = o - i, a) {
    for (a < 0 ? (n = s, a = -a, u = c.length) : (n = c, i = o, u = s.length), o = Math.ceil(f / Oe), u = o > u ? o + 1 : u + 1, a > u && (a = u, n.length = 1), n.reverse(); a--; ) n.push(0);
    n.reverse();
  }
  for (u = s.length, a = c.length, u - a < 0 && (a = u, n = c, c = s, s = n), r = 0; a; )
    r = (s[--a] = s[a] + c[a] + r) / ke | 0, s[a] %= ke;
  for (r && (s.unshift(r), ++i), u = s.length; s[--u] == 0; ) s.pop();
  return t.d = s, t.e = i, Se ? me(t, f) : t;
}
function Et(e, t, r) {
  if (e !== ~~e || e < t || e > r)
    throw Error(Sr + e);
}
function _t(e) {
  var t, r, n, i = e.length - 1, a = "", o = e[0];
  if (i > 0) {
    for (a += o, t = 1; t < i; t++)
      n = e[t] + "", r = Oe - n.length, r && (a += Yt(r)), a += n;
    o = e[t], n = o + "", r = Oe - n.length, r && (a += Yt(r));
  } else if (o === 0)
    return "0";
  for (; o % 10 === 0; ) o /= 10;
  return a + o;
}
var Lt = /* @__PURE__ */ function() {
  function e(n, i) {
    var a, o = 0, u = n.length;
    for (n = n.slice(); u--; )
      a = n[u] * i + o, n[u] = a % ke | 0, o = a / ke | 0;
    return o && n.unshift(o), n;
  }
  function t(n, i, a, o) {
    var u, s;
    if (a != o)
      s = a > o ? 1 : -1;
    else
      for (u = s = 0; u < a; u++)
        if (n[u] != i[u]) {
          s = n[u] > i[u] ? 1 : -1;
          break;
        }
    return s;
  }
  function r(n, i, a) {
    for (var o = 0; a--; )
      n[a] -= o, o = n[a] < i[a] ? 1 : 0, n[a] = o * ke + n[a] - i[a];
    for (; !n[0] && n.length > 1; ) n.shift();
  }
  return function(n, i, a, o) {
    var u, s, c, l, f, d, p, y, v, h, x, g, b, O, m, w, _, P, T = n.constructor, M = n.s == i.s ? 1 : -1, j = n.d, $ = i.d;
    if (!n.s) return new T(n);
    if (!i.s) throw Error(dt + "Division by zero");
    for (s = n.e - i.e, _ = $.length, m = j.length, p = new T(M), y = p.d = [], c = 0; $[c] == (j[c] || 0); ) ++c;
    if ($[c] > (j[c] || 0) && --s, a == null ? g = a = T.precision : o ? g = a + (Te(n) - Te(i)) + 1 : g = a, g < 0) return new T(0);
    if (g = g / Oe + 2 | 0, c = 0, _ == 1)
      for (l = 0, $ = $[0], g++; (c < m || l) && g--; c++)
        b = l * ke + (j[c] || 0), y[c] = b / $ | 0, l = b % $ | 0;
    else {
      for (l = ke / ($[0] + 1) | 0, l > 1 && ($ = e($, l), j = e(j, l), _ = $.length, m = j.length), O = _, v = j.slice(0, _), h = v.length; h < _; ) v[h++] = 0;
      P = $.slice(), P.unshift(0), w = $[0], $[1] >= ke / 2 && ++w;
      do
        l = 0, u = t($, v, _, h), u < 0 ? (x = v[0], _ != h && (x = x * ke + (v[1] || 0)), l = x / w | 0, l > 1 ? (l >= ke && (l = ke - 1), f = e($, l), d = f.length, h = v.length, u = t(f, v, d, h), u == 1 && (l--, r(f, _ < d ? P : $, d))) : (l == 0 && (u = l = 1), f = $.slice()), d = f.length, d < h && f.unshift(0), r(v, f, h), u == -1 && (h = v.length, u = t($, v, _, h), u < 1 && (l++, r(v, _ < h ? P : $, h))), h = v.length) : u === 0 && (l++, v = [0]), y[c++] = l, u && v[0] ? v[h++] = j[O] || 0 : (v = [j[O]], h = 1);
      while ((O++ < m || v[0] !== void 0) && g--);
    }
    return y[0] || y.shift(), p.e = s, me(p, o ? a + Te(p) + 1 : a);
  };
}();
function rO(e, t) {
  var r, n, i, a, o, u, s = 0, c = 0, l = e.constructor, f = l.precision;
  if (Te(e) > 16) throw Error(Ep + Te(e));
  if (!e.s) return new l(Qe);
  for (Se = !1, u = f, o = new l(0.03125); e.abs().gte(0.1); )
    e = e.times(o), c += 5;
  for (n = Math.log(yr(2, c)) / Math.LN10 * 2 + 5 | 0, u += n, r = i = a = new l(Qe), l.precision = u; ; ) {
    if (i = me(i.times(e), u), r = r.times(++s), o = a.plus(Lt(i, r, u)), _t(o.d).slice(0, u) === _t(a.d).slice(0, u)) {
      for (; c--; ) a = me(a.times(a), u);
      return l.precision = f, t == null ? (Se = !0, me(a, f)) : a;
    }
    a = o;
  }
}
function Te(e) {
  for (var t = e.e * Oe, r = e.d[0]; r >= 10; r /= 10) t++;
  return t;
}
function Tl(e, t, r) {
  if (t > e.LN10.sd())
    throw Se = !0, r && (e.precision = r), Error(dt + "LN10 precision limit exceeded");
  return me(new e(e.LN10), t);
}
function Yt(e) {
  for (var t = ""; e--; ) t += "0";
  return t;
}
function gi(e, t) {
  var r, n, i, a, o, u, s, c, l, f = 1, d = 10, p = e, y = p.d, v = p.constructor, h = v.precision;
  if (p.s < 1) throw Error(dt + (p.s ? "NaN" : "-Infinity"));
  if (p.eq(Qe)) return new v(0);
  if (t == null ? (Se = !1, c = h) : c = t, p.eq(10))
    return t == null && (Se = !0), Tl(v, c);
  if (c += d, v.precision = c, r = _t(y), n = r.charAt(0), a = Te(p), Math.abs(a) < 15e14) {
    for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
      p = p.times(e), r = _t(p.d), n = r.charAt(0), f++;
    a = Te(p), n > 1 ? (p = new v("0." + r), a++) : p = new v(n + "." + r.slice(1));
  } else
    return s = Tl(v, c + 2, h).times(a + ""), p = gi(new v(n + "." + r.slice(1)), c - d).plus(s), v.precision = h, t == null ? (Se = !0, me(p, h)) : p;
  for (u = o = p = Lt(p.minus(Qe), p.plus(Qe), c), l = me(p.times(p), c), i = 3; ; ) {
    if (o = me(o.times(l), c), s = u.plus(Lt(o, new v(i), c)), _t(s.d).slice(0, c) === _t(u.d).slice(0, c))
      return u = u.times(2), a !== 0 && (u = u.plus(Tl(v, c + 2, h).times(a + ""))), u = Lt(u, new v(f), c), v.precision = h, t == null ? (Se = !0, me(u, h)) : u;
    u = s, i += 2;
  }
}
function Ig(e, t) {
  var r, n, i;
  for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; ) ++n;
  for (i = t.length; t.charCodeAt(i - 1) === 48; ) --i;
  if (t = t.slice(n, i), t) {
    if (i -= n, r = r - n - 1, e.e = Nn(r / Oe), e.d = [], n = (r + 1) % Oe, r < 0 && (n += Oe), n < i) {
      for (n && e.d.push(+t.slice(0, n)), i -= Oe; n < i; ) e.d.push(+t.slice(n, n += Oe));
      t = t.slice(n), n = Oe - t.length;
    } else
      n -= i;
    for (; n--; ) t += "0";
    if (e.d.push(+t), Se && (e.e > Da || e.e < -Da)) throw Error(Ep + r);
  } else
    e.s = 0, e.e = 0, e.d = [0];
  return e;
}
function me(e, t, r) {
  var n, i, a, o, u, s, c, l, f = e.d;
  for (o = 1, a = f[0]; a >= 10; a /= 10) o++;
  if (n = t - o, n < 0)
    n += Oe, i = t, c = f[l = 0];
  else {
    if (l = Math.ceil((n + 1) / Oe), a = f.length, l >= a) return e;
    for (c = a = f[l], o = 1; a >= 10; a /= 10) o++;
    n %= Oe, i = n - Oe + o;
  }
  if (r !== void 0 && (a = yr(10, o - i - 1), u = c / a % 10 | 0, s = t < 0 || f[l + 1] !== void 0 || c % a, s = r < 4 ? (u || s) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : u > 5 || u == 5 && (r == 4 || s || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (n > 0 ? i > 0 ? c / yr(10, o - i) : 0 : f[l - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), t < 1 || !f[0])
    return s ? (a = Te(e), f.length = 1, t = t - a - 1, f[0] = yr(10, (Oe - t % Oe) % Oe), e.e = Nn(-t / Oe) || 0) : (f.length = 1, f[0] = e.e = e.s = 0), e;
  if (n == 0 ? (f.length = l, a = 1, l--) : (f.length = l + 1, a = yr(10, Oe - n), f[l] = i > 0 ? (c / yr(10, o - i) % yr(10, i) | 0) * a : 0), s)
    for (; ; )
      if (l == 0) {
        (f[0] += a) == ke && (f[0] = 1, ++e.e);
        break;
      } else {
        if (f[l] += a, f[l] != ke) break;
        f[l--] = 0, a = 1;
      }
  for (n = f.length; f[--n] === 0; ) f.pop();
  if (Se && (e.e > Da || e.e < -Da))
    throw Error(Ep + Te(e));
  return e;
}
function nO(e, t) {
  var r, n, i, a, o, u, s, c, l, f, d = e.constructor, p = d.precision;
  if (!e.s || !t.s)
    return t.s ? t.s = -t.s : t = new d(e), Se ? me(t, p) : t;
  if (s = e.d, f = t.d, n = t.e, c = e.e, s = s.slice(), o = c - n, o) {
    for (l = o < 0, l ? (r = s, o = -o, u = f.length) : (r = f, n = c, u = s.length), i = Math.max(Math.ceil(p / Oe), u) + 2, o > i && (o = i, r.length = 1), r.reverse(), i = o; i--; ) r.push(0);
    r.reverse();
  } else {
    for (i = s.length, u = f.length, l = i < u, l && (u = i), i = 0; i < u; i++)
      if (s[i] != f[i]) {
        l = s[i] < f[i];
        break;
      }
    o = 0;
  }
  for (l && (r = s, s = f, f = r, t.s = -t.s), u = s.length, i = f.length - u; i > 0; --i) s[u++] = 0;
  for (i = f.length; i > o; ) {
    if (s[--i] < f[i]) {
      for (a = i; a && s[--a] === 0; ) s[a] = ke - 1;
      --s[a], s[i] += ke;
    }
    s[i] -= f[i];
  }
  for (; s[--u] === 0; ) s.pop();
  for (; s[0] === 0; s.shift()) --n;
  return s[0] ? (t.d = s, t.e = n, Se ? me(t, p) : t) : new d(0);
}
function Tr(e, t, r) {
  var n, i = Te(e), a = _t(e.d), o = a.length;
  return t ? (r && (n = r - o) > 0 ? a = a.charAt(0) + "." + a.slice(1) + Yt(n) : o > 1 && (a = a.charAt(0) + "." + a.slice(1)), a = a + (i < 0 ? "e" : "e+") + i) : i < 0 ? (a = "0." + Yt(-i - 1) + a, r && (n = r - o) > 0 && (a += Yt(n))) : i >= o ? (a += Yt(i + 1 - o), r && (n = r - i - 1) > 0 && (a = a + "." + Yt(n))) : ((n = i + 1) < o && (a = a.slice(0, n) + "." + a.slice(n)), r && (n = r - o) > 0 && (i + 1 === o && (a += "."), a += Yt(n))), e.s < 0 ? "-" + a : a;
}
function Ng(e, t) {
  if (e.length > t)
    return e.length = t, !0;
}
function iO(e) {
  var t, r, n;
  function i(a) {
    var o = this;
    if (!(o instanceof i)) return new i(a);
    if (o.constructor = i, a instanceof i) {
      o.s = a.s, o.e = a.e, o.d = (a = a.d) ? a.slice() : a;
      return;
    }
    if (typeof a == "number") {
      if (a * 0 !== 0)
        throw Error(Sr + a);
      if (a > 0)
        o.s = 1;
      else if (a < 0)
        a = -a, o.s = -1;
      else {
        o.s = 0, o.e = 0, o.d = [0];
        return;
      }
      if (a === ~~a && a < 1e7) {
        o.e = 0, o.d = [a];
        return;
      }
      return Ig(o, a.toString());
    } else if (typeof a != "string")
      throw Error(Sr + a);
    if (a.charCodeAt(0) === 45 ? (a = a.slice(1), o.s = -1) : o.s = 1, fM.test(a)) Ig(o, a);
    else throw Error(Sr + a);
  }
  if (i.prototype = Z, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.clone = iO, i.config = i.set = dM, e === void 0 && (e = {}), e)
    for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < n.length; ) e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
  return i.config(e), i;
}
function dM(e) {
  if (!e || typeof e != "object")
    throw Error(dt + "Object expected");
  var t, r, n, i = [
    "precision",
    1,
    In,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (t = 0; t < i.length; t += 3)
    if ((n = e[r = i[t]]) !== void 0)
      if (Nn(n) === n && n >= i[t + 1] && n <= i[t + 2]) this[r] = n;
      else throw Error(Sr + r + ": " + n);
  if ((n = e[r = "LN10"]) !== void 0)
    if (n == Math.LN10) this[r] = new this(n);
    else throw Error(Sr + r + ": " + n);
  return this;
}
var jp = iO(lM);
Qe = new jp(1);
const ve = jp;
function pM(e) {
  return mM(e) || yM(e) || vM(e) || hM();
}
function hM() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vM(e, t) {
  if (e) {
    if (typeof e == "string") return Bf(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Bf(e, t);
  }
}
function yM(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function mM(e) {
  if (Array.isArray(e)) return Bf(e);
}
function Bf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
var gM = function(t) {
  return t;
}, aO = {}, oO = function(t) {
  return t === aO;
}, kg = function(t) {
  return function r() {
    return arguments.length === 0 || arguments.length === 1 && oO(arguments.length <= 0 ? void 0 : arguments[0]) ? r : t.apply(void 0, arguments);
  };
}, bM = function e(t, r) {
  return t === 1 ? r : kg(function() {
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    var o = i.filter(function(u) {
      return u !== aO;
    }).length;
    return o >= t ? r.apply(void 0, i) : e(t - o, kg(function() {
      for (var u = arguments.length, s = new Array(u), c = 0; c < u; c++)
        s[c] = arguments[c];
      var l = i.map(function(f) {
        return oO(f) ? s.shift() : f;
      });
      return r.apply(void 0, pM(l).concat(s));
    }));
  });
}, Fo = function(t) {
  return bM(t.length, t);
}, Ff = function(t, r) {
  for (var n = [], i = t; i < r; ++i)
    n[i - t] = i;
  return n;
}, xM = Fo(function(e, t) {
  return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(r) {
    return t[r];
  }).map(e);
}), wM = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  if (!r.length)
    return gM;
  var i = r.reverse(), a = i[0], o = i.slice(1);
  return function() {
    return o.reduce(function(u, s) {
      return s(u);
    }, a.apply(void 0, arguments));
  };
}, zf = function(t) {
  return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
}, uO = function(t) {
  var r = null, n = null;
  return function() {
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    return r && a.every(function(u, s) {
      return u === r[s];
    }) || (r = a, n = t.apply(void 0, a)), n;
  };
};
function OM(e) {
  var t;
  return e === 0 ? t = 1 : t = Math.floor(new ve(e).abs().log(10).toNumber()) + 1, t;
}
function _M(e, t, r) {
  for (var n = new ve(e), i = 0, a = []; n.lt(t) && i < 1e5; )
    a.push(n.toNumber()), n = n.add(r), i++;
  return a;
}
var AM = Fo(function(e, t, r) {
  var n = +e, i = +t;
  return n + r * (i - n);
}), SM = Fo(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, (r - e) / n;
}), PM = Fo(function(e, t, r) {
  var n = t - +e;
  return n = n || 1 / 0, Math.max(0, Math.min(1, (r - e) / n));
});
const zo = {
  rangeStep: _M,
  getDigitCount: OM,
  interpolateNumber: AM,
  uninterpolateNumber: SM,
  uninterpolateTruncation: PM
};
function Wf(e) {
  return TM(e) || jM(e) || sO(e) || EM();
}
function EM() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jM(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function TM(e) {
  if (Array.isArray(e)) return Uf(e);
}
function bi(e, t) {
  return CM(e) || MM(e, t) || sO(e, t) || $M();
}
function $M() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function sO(e, t) {
  if (e) {
    if (typeof e == "string") return Uf(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Uf(e, t);
  }
}
function Uf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function MM(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], n = !0, i = !1, a = void 0;
    try {
      for (var o = e[Symbol.iterator](), u; !(n = (u = o.next()).done) && (r.push(u.value), !(t && r.length === t)); n = !0)
        ;
    } catch (s) {
      i = !0, a = s;
    } finally {
      try {
        !n && o.return != null && o.return();
      } finally {
        if (i) throw a;
      }
    }
    return r;
  }
}
function CM(e) {
  if (Array.isArray(e)) return e;
}
function cO(e) {
  var t = bi(e, 2), r = t[0], n = t[1], i = r, a = n;
  return r > n && (i = n, a = r), [i, a];
}
function lO(e, t, r) {
  if (e.lte(0))
    return new ve(0);
  var n = zo.getDigitCount(e.toNumber()), i = new ve(10).pow(n), a = e.div(i), o = n !== 1 ? 0.05 : 0.1, u = new ve(Math.ceil(a.div(o).toNumber())).add(r).mul(o), s = u.mul(i);
  return t ? s : new ve(Math.ceil(s));
}
function IM(e, t, r) {
  var n = 1, i = new ve(e);
  if (!i.isint() && r) {
    var a = Math.abs(e);
    a < 1 ? (n = new ve(10).pow(zo.getDigitCount(e) - 1), i = new ve(Math.floor(i.div(n).toNumber())).mul(n)) : a > 1 && (i = new ve(Math.floor(e)));
  } else e === 0 ? i = new ve(Math.floor((t - 1) / 2)) : r || (i = new ve(Math.floor(e)));
  var o = Math.floor((t - 1) / 2), u = wM(xM(function(s) {
    return i.add(new ve(s - o).mul(n)).toNumber();
  }), Ff);
  return u(0, t);
}
function fO(e, t, r, n) {
  var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (r - 1)))
    return {
      step: new ve(0),
      tickMin: new ve(0),
      tickMax: new ve(0)
    };
  var a = lO(new ve(t).sub(e).div(r - 1), n, i), o;
  e <= 0 && t >= 0 ? o = new ve(0) : (o = new ve(e).add(t).div(2), o = o.sub(new ve(o).mod(a)));
  var u = Math.ceil(o.sub(e).div(a).toNumber()), s = Math.ceil(new ve(t).sub(o).div(a).toNumber()), c = u + s + 1;
  return c > r ? fO(e, t, r, n, i + 1) : (c < r && (s = t > 0 ? s + (r - c) : s, u = t > 0 ? u : u + (r - c)), {
    step: a,
    tickMin: o.sub(new ve(u).mul(a)),
    tickMax: o.add(new ve(s).mul(a))
  });
}
function NM(e) {
  var t = bi(e, 2), r = t[0], n = t[1], i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = Math.max(i, 2), u = cO([r, n]), s = bi(u, 2), c = s[0], l = s[1];
  if (c === -1 / 0 || l === 1 / 0) {
    var f = l === 1 / 0 ? [c].concat(Wf(Ff(0, i - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(Wf(Ff(0, i - 1).map(function() {
      return -1 / 0;
    })), [l]);
    return r > n ? zf(f) : f;
  }
  if (c === l)
    return IM(c, i, a);
  var d = fO(c, l, o, a), p = d.step, y = d.tickMin, v = d.tickMax, h = zo.rangeStep(y, v.add(new ve(0.1).mul(p)), p);
  return r > n ? zf(h) : h;
}
function kM(e, t) {
  var r = bi(e, 2), n = r[0], i = r[1], a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = cO([n, i]), u = bi(o, 2), s = u[0], c = u[1];
  if (s === -1 / 0 || c === 1 / 0)
    return [n, i];
  if (s === c)
    return [s];
  var l = Math.max(t, 2), f = lO(new ve(c).sub(s).div(l - 1), a, 0), d = [].concat(Wf(zo.rangeStep(new ve(s), new ve(c).sub(new ve(0.99).mul(f)), f)), [c]);
  return n > i ? zf(d) : d;
}
var RM = uO(NM), DM = uO(kM), LM = process.env.NODE_ENV === "production", $l = "Invariant failed";
function Ve(e, t) {
  if (LM)
    throw new Error($l);
  var r = typeof t == "function" ? t() : t, n = r ? "".concat($l, ": ").concat(r) : $l;
  throw new Error(n);
}
var qM = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function an(e) {
  "@babel/helpers - typeof";
  return an = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, an(e);
}
function La() {
  return La = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, La.apply(this, arguments);
}
function BM(e, t) {
  return UM(e) || WM(e, t) || zM(e, t) || FM();
}
function FM() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zM(e, t) {
  if (e) {
    if (typeof e == "string") return Rg(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Rg(e, t);
  }
}
function Rg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function WM(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], s = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(s = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function UM(e) {
  if (Array.isArray(e)) return e;
}
function KM(e, t) {
  if (e == null) return {};
  var r = HM(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function HM(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function GM(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function VM(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, hO(n.key), n);
  }
}
function YM(e, t, r) {
  return t && VM(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function XM(e, t, r) {
  return t = qa(t), ZM(e, dO() ? Reflect.construct(t, r || [], qa(e).constructor) : t.apply(e, r));
}
function ZM(e, t) {
  if (t && (an(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return JM(e);
}
function JM(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function dO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (dO = function() {
    return !!e;
  })();
}
function qa(e) {
  return qa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, qa(e);
}
function QM(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Kf(e, t);
}
function Kf(e, t) {
  return Kf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Kf(e, t);
}
function pO(e, t, r) {
  return t = hO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function hO(e) {
  var t = eC(e, "string");
  return an(t) == "symbol" ? t : t + "";
}
function eC(e, t) {
  if (an(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (an(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var kn = /* @__PURE__ */ function(e) {
  function t() {
    return GM(this, t), XM(this, t, arguments);
  }
  return QM(t, e), YM(t, [{
    key: "render",
    value: function() {
      var n = this.props, i = n.offset, a = n.layout, o = n.width, u = n.dataKey, s = n.data, c = n.dataPointFormatter, l = n.xAxis, f = n.yAxis, d = KM(n, qM), p = J(d, !1);
      this.props.direction === "x" && l.type !== "number" && (process.env.NODE_ENV !== "production" ? Ve(!1, 'ErrorBar requires Axis type property to be "number".') : Ve());
      var y = s.map(function(v) {
        var h = c(v, u), x = h.x, g = h.y, b = h.value, O = h.errorVal;
        if (!O)
          return null;
        var m = [], w, _;
        if (Array.isArray(O)) {
          var P = BM(O, 2);
          w = P[0], _ = P[1];
        } else
          w = _ = O;
        if (a === "vertical") {
          var T = l.scale, M = g + i, j = M + o, $ = M - o, I = T(b - w), k = T(b + _);
          m.push({
            x1: k,
            y1: j,
            x2: k,
            y2: $
          }), m.push({
            x1: I,
            y1: M,
            x2: k,
            y2: M
          }), m.push({
            x1: I,
            y1: j,
            x2: I,
            y2: $
          });
        } else if (a === "horizontal") {
          var R = f.scale, D = x + i, B = D - o, W = D + o, K = R(b - w), E = R(b + _);
          m.push({
            x1: B,
            y1: E,
            x2: W,
            y2: E
          }), m.push({
            x1: D,
            y1: K,
            x2: D,
            y2: E
          }), m.push({
            x1: B,
            y1: K,
            x2: W,
            y2: K
          });
        }
        return /* @__PURE__ */ S.createElement(oe, La({
          className: "recharts-errorBar",
          key: "bar-".concat(m.map(function(N) {
            return "".concat(N.x1, "-").concat(N.x2, "-").concat(N.y1, "-").concat(N.y2);
          }))
        }, p), m.map(function(N) {
          return /* @__PURE__ */ S.createElement("line", La({}, N, {
            key: "line-".concat(N.x1, "-").concat(N.x2, "-").concat(N.y1, "-").concat(N.y2)
          }));
        }));
      });
      return /* @__PURE__ */ S.createElement(oe, {
        className: "recharts-errorBars"
      }, y);
    }
  }]);
}(S.Component);
pO(kn, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
pO(kn, "displayName", "ErrorBar");
function xi(e) {
  "@babel/helpers - typeof";
  return xi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xi(e);
}
function Dg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function dr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Dg(Object(r), !0).forEach(function(n) {
      tC(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Dg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function tC(e, t, r) {
  return t = rC(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function rC(e) {
  var t = nC(e, "string");
  return xi(t) == "symbol" ? t : t + "";
}
function nC(e, t) {
  if (xi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (xi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var vO = function(t) {
  var r = t.children, n = t.formattedGraphicalItems, i = t.legendWidth, a = t.legendContent, o = Je(r, er);
  if (!o)
    return null;
  var u = er.defaultProps, s = u !== void 0 ? dr(dr({}, u), o.props) : {}, c;
  return o.props && o.props.payload ? c = o.props && o.props.payload : a === "children" ? c = (n || []).reduce(function(l, f) {
    var d = f.item, p = f.props, y = p.sectors || p.data || [];
    return l.concat(y.map(function(v) {
      return {
        type: o.props.iconType || d.props.legendType,
        value: v.name,
        color: v.fill,
        payload: v
      };
    }));
  }, []) : c = (n || []).map(function(l) {
    var f = l.item, d = f.type.defaultProps, p = d !== void 0 ? dr(dr({}, d), f.props) : {}, y = p.dataKey, v = p.name, h = p.legendType, x = p.hide;
    return {
      inactive: x,
      dataKey: y,
      type: s.iconType || h || "square",
      color: Tp(f),
      value: v || y,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: p
    };
  }), dr(dr(dr({}, s), er.getWithHeight(o, i)), {}, {
    payload: c,
    item: o
  });
};
function wi(e) {
  "@babel/helpers - typeof";
  return wi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wi(e);
}
function Lg(e) {
  return uC(e) || oC(e) || aC(e) || iC();
}
function iC() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function aC(e, t) {
  if (e) {
    if (typeof e == "string") return Hf(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Hf(e, t);
  }
}
function oC(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function uC(e) {
  if (Array.isArray(e)) return Hf(e);
}
function Hf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function qg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Ee(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? qg(Object(r), !0).forEach(function(n) {
      Yr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : qg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Yr(e, t, r) {
  return t = sC(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function sC(e) {
  var t = cC(e, "string");
  return wi(t) == "symbol" ? t : t + "";
}
function cC(e, t) {
  if (wi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (wi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function _e(e, t, r) {
  return te(e) || te(t) ? r : Ie(t) ? et(e, t, r) : re(t) ? t(e) : r;
}
function Qn(e, t, r, n) {
  var i = uM(e, function(u) {
    return _e(u, t);
  });
  if (r === "number") {
    var a = i.filter(function(u) {
      return U(u) || parseFloat(u);
    });
    return a.length ? [Bo(a), Zt(a)] : [1 / 0, -1 / 0];
  }
  var o = n ? i.filter(function(u) {
    return !te(u);
  }) : i;
  return o.map(function(u) {
    return Ie(u) || u instanceof Date ? u : "";
  });
}
var lC = function(t) {
  var r, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = arguments.length > 2 ? arguments[2] : void 0, a = arguments.length > 3 ? arguments[3] : void 0, o = -1, u = (r = n == null ? void 0 : n.length) !== null && r !== void 0 ? r : 0;
  if (u <= 1)
    return 0;
  if (a && a.axisType === "angleAxis" && Math.abs(Math.abs(a.range[1] - a.range[0]) - 360) <= 1e-6)
    for (var s = a.range, c = 0; c < u; c++) {
      var l = c > 0 ? i[c - 1].coordinate : i[u - 1].coordinate, f = i[c].coordinate, d = c >= u - 1 ? i[0].coordinate : i[c + 1].coordinate, p = void 0;
      if (We(f - l) !== We(d - f)) {
        var y = [];
        if (We(d - f) === We(s[1] - s[0])) {
          p = d;
          var v = f + s[1] - s[0];
          y[0] = Math.min(v, (v + l) / 2), y[1] = Math.max(v, (v + l) / 2);
        } else {
          p = l;
          var h = d + s[1] - s[0];
          y[0] = Math.min(f, (h + f) / 2), y[1] = Math.max(f, (h + f) / 2);
        }
        var x = [Math.min(f, (p + f) / 2), Math.max(f, (p + f) / 2)];
        if (t > x[0] && t <= x[1] || t >= y[0] && t <= y[1]) {
          o = i[c].index;
          break;
        }
      } else {
        var g = Math.min(l, d), b = Math.max(l, d);
        if (t > (g + f) / 2 && t <= (b + f) / 2) {
          o = i[c].index;
          break;
        }
      }
    }
  else
    for (var O = 0; O < u; O++)
      if (O === 0 && t <= (n[O].coordinate + n[O + 1].coordinate) / 2 || O > 0 && O < u - 1 && t > (n[O].coordinate + n[O - 1].coordinate) / 2 && t <= (n[O].coordinate + n[O + 1].coordinate) / 2 || O === u - 1 && t > (n[O].coordinate + n[O - 1].coordinate) / 2) {
        o = n[O].index;
        break;
      }
  return o;
}, Tp = function(t) {
  var r, n = t, i = n.type.displayName, a = (r = t.type) !== null && r !== void 0 && r.defaultProps ? Ee(Ee({}, t.type.defaultProps), t.props) : t.props, o = a.stroke, u = a.fill, s;
  switch (i) {
    case "Line":
      s = o;
      break;
    case "Area":
    case "Radar":
      s = o && o !== "none" ? o : u;
      break;
    default:
      s = u;
      break;
  }
  return s;
}, fC = function(t) {
  var r = t.barSize, n = t.totalSize, i = t.stackGroups, a = i === void 0 ? {} : i;
  if (!a)
    return {};
  for (var o = {}, u = Object.keys(a), s = 0, c = u.length; s < c; s++)
    for (var l = a[u[s]].stackGroups, f = Object.keys(l), d = 0, p = f.length; d < p; d++) {
      var y = l[f[d]], v = y.items, h = y.cateAxisId, x = v.filter(function(_) {
        return Dt(_.type).indexOf("Bar") >= 0;
      });
      if (x && x.length) {
        var g = x[0].type.defaultProps, b = g !== void 0 ? Ee(Ee({}, g), x[0].props) : x[0].props, O = b.barSize, m = b[h];
        o[m] || (o[m] = []);
        var w = te(O) ? r : O;
        o[m].push({
          item: x[0],
          stackList: x.slice(1),
          barSize: te(w) ? void 0 : Ue(w, n, 0)
        });
      }
    }
  return o;
}, dC = function(t) {
  var r = t.barGap, n = t.barCategoryGap, i = t.bandSize, a = t.sizeList, o = a === void 0 ? [] : a, u = t.maxBarSize, s = o.length;
  if (s < 1) return null;
  var c = Ue(r, i, 0, !0), l, f = [];
  if (o[0].barSize === +o[0].barSize) {
    var d = !1, p = i / s, y = o.reduce(function(O, m) {
      return O + m.barSize || 0;
    }, 0);
    y += (s - 1) * c, y >= i && (y -= (s - 1) * c, c = 0), y >= i && p > 0 && (d = !0, p *= 0.9, y = s * p);
    var v = (i - y) / 2 >> 0, h = {
      offset: v - c,
      size: 0
    };
    l = o.reduce(function(O, m) {
      var w = {
        item: m.item,
        position: {
          offset: h.offset + h.size + c,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: d ? p : m.barSize
        }
      }, _ = [].concat(Lg(O), [w]);
      return h = _[_.length - 1].position, m.stackList && m.stackList.length && m.stackList.forEach(function(P) {
        _.push({
          item: P,
          position: h
        });
      }), _;
    }, f);
  } else {
    var x = Ue(n, i, 0, !0);
    i - 2 * x - (s - 1) * c <= 0 && (c = 0);
    var g = (i - 2 * x - (s - 1) * c) / s;
    g > 1 && (g >>= 0);
    var b = u === +u ? Math.min(g, u) : g;
    l = o.reduce(function(O, m, w) {
      var _ = [].concat(Lg(O), [{
        item: m.item,
        position: {
          offset: x + (g + c) * w + (g - b) / 2,
          size: b
        }
      }]);
      return m.stackList && m.stackList.length && m.stackList.forEach(function(P) {
        _.push({
          item: P,
          position: _[_.length - 1].position
        });
      }), _;
    }, f);
  }
  return l;
}, pC = function(t, r, n, i) {
  var a = n.children, o = n.width, u = n.margin, s = o - (u.left || 0) - (u.right || 0), c = vO({
    children: a,
    legendWidth: s
  });
  if (c) {
    var l = i || {}, f = l.width, d = l.height, p = c.align, y = c.verticalAlign, v = c.layout;
    if ((v === "vertical" || v === "horizontal" && y === "middle") && p !== "center" && U(t[p]))
      return Ee(Ee({}, t), {}, Yr({}, p, t[p] + (f || 0)));
    if ((v === "horizontal" || v === "vertical" && p === "center") && y !== "middle" && U(t[y]))
      return Ee(Ee({}, t), {}, Yr({}, y, t[y] + (d || 0)));
  }
  return t;
}, hC = function(t, r, n) {
  return te(r) ? !0 : t === "horizontal" ? r === "yAxis" : t === "vertical" || n === "x" ? r === "xAxis" : n === "y" ? r === "yAxis" : !0;
}, yO = function(t, r, n, i, a) {
  var o = r.props.children, u = He(o, kn).filter(function(c) {
    return hC(i, a, c.props.direction);
  });
  if (u && u.length) {
    var s = u.map(function(c) {
      return c.props.dataKey;
    });
    return t.reduce(function(c, l) {
      var f = _e(l, n);
      if (te(f)) return c;
      var d = Array.isArray(f) ? [Bo(f), Zt(f)] : [f, f], p = s.reduce(function(y, v) {
        var h = _e(l, v, 0), x = d[0] - Math.abs(Array.isArray(h) ? h[0] : h), g = d[1] + Math.abs(Array.isArray(h) ? h[1] : h);
        return [Math.min(x, y[0]), Math.max(g, y[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(p[0], c[0]), Math.max(p[1], c[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, vC = function(t, r, n, i, a) {
  var o = r.map(function(u) {
    return yO(t, u, n, a, i);
  }).filter(function(u) {
    return !te(u);
  });
  return o && o.length ? o.reduce(function(u, s) {
    return [Math.min(u[0], s[0]), Math.max(u[1], s[1])];
  }, [1 / 0, -1 / 0]) : null;
}, mO = function(t, r, n, i, a) {
  var o = r.map(function(s) {
    var c = s.props.dataKey;
    return n === "number" && c && yO(t, s, c, i) || Qn(t, c, n, a);
  });
  if (n === "number")
    return o.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(s, c) {
        return [Math.min(s[0], c[0]), Math.max(s[1], c[1])];
      },
      [1 / 0, -1 / 0]
    );
  var u = {};
  return o.reduce(function(s, c) {
    for (var l = 0, f = c.length; l < f; l++)
      u[c[l]] || (u[c[l]] = !0, s.push(c[l]));
    return s;
  }, []);
}, gO = function(t, r) {
  return t === "horizontal" && r === "xAxis" || t === "vertical" && r === "yAxis" || t === "centric" && r === "angleAxis" || t === "radial" && r === "radiusAxis";
}, bO = function(t, r, n, i) {
  if (i)
    return t.map(function(s) {
      return s.coordinate;
    });
  var a, o, u = t.map(function(s) {
    return s.coordinate === r && (a = !0), s.coordinate === n && (o = !0), s.coordinate;
  });
  return a || u.push(r), o || u.push(n), u;
}, Rt = function(t, r, n) {
  if (!t) return null;
  var i = t.scale, a = t.duplicateDomain, o = t.type, u = t.range, s = t.realScaleType === "scaleBand" ? i.bandwidth() / 2 : 2, c = (r || n) && o === "category" && i.bandwidth ? i.bandwidth() / s : 0;
  if (c = t.axisType === "angleAxis" && (u == null ? void 0 : u.length) >= 2 ? We(u[0] - u[1]) * 2 * c : c, r && (t.ticks || t.niceTicks)) {
    var l = (t.ticks || t.niceTicks).map(function(f) {
      var d = a ? a.indexOf(f) : f;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: i(d) + c,
        value: f,
        offset: c
      };
    });
    return l.filter(function(f) {
      return !Tn(f.coordinate);
    });
  }
  return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(f, d) {
    return {
      coordinate: i(f) + c,
      value: f,
      index: d,
      offset: c
    };
  }) : i.ticks && !n ? i.ticks(t.tickCount).map(function(f) {
    return {
      coordinate: i(f) + c,
      value: f,
      offset: c
    };
  }) : i.domain().map(function(f, d) {
    return {
      coordinate: i(f) + c,
      value: a ? a[f] : f,
      index: d,
      offset: c
    };
  });
}, Ml = /* @__PURE__ */ new WeakMap(), aa = function(t, r) {
  if (typeof r != "function")
    return t;
  Ml.has(t) || Ml.set(t, /* @__PURE__ */ new WeakMap());
  var n = Ml.get(t);
  if (n.has(r))
    return n.get(r);
  var i = function() {
    t.apply(void 0, arguments), r.apply(void 0, arguments);
  };
  return n.set(r, i), i;
}, xO = function(t, r, n) {
  var i = t.scale, a = t.type, o = t.layout, u = t.axisType;
  if (i === "auto")
    return o === "radial" && u === "radiusAxis" ? {
      scale: pi(),
      realScaleType: "band"
    } : o === "radial" && u === "angleAxis" ? {
      scale: Ia(),
      realScaleType: "linear"
    } : a === "category" && r && (r.indexOf("LineChart") >= 0 || r.indexOf("AreaChart") >= 0 || r.indexOf("ComposedChart") >= 0 && !n) ? {
      scale: Jn(),
      realScaleType: "point"
    } : a === "category" ? {
      scale: pi(),
      realScaleType: "band"
    } : {
      scale: Ia(),
      realScaleType: "linear"
    };
  if (Er(i)) {
    var s = "scale".concat(So(i));
    return {
      scale: (Ag[s] || Jn)(),
      realScaleType: Ag[s] ? s : "point"
    };
  }
  return re(i) ? {
    scale: i
  } : {
    scale: Jn(),
    realScaleType: "point"
  };
}, Bg = 1e-4, wO = function(t) {
  var r = t.domain();
  if (!(!r || r.length <= 2)) {
    var n = r.length, i = t.range(), a = Math.min(i[0], i[1]) - Bg, o = Math.max(i[0], i[1]) + Bg, u = t(r[0]), s = t(r[n - 1]);
    (u < a || u > o || s < a || s > o) && t.domain([r[0], r[n - 1]]);
  }
}, yC = function(t, r) {
  if (!t)
    return null;
  for (var n = 0, i = t.length; n < i; n++)
    if (t[n].item === r)
      return t[n].position;
  return null;
}, mC = function(t, r) {
  if (!r || r.length !== 2 || !U(r[0]) || !U(r[1]))
    return t;
  var n = Math.min(r[0], r[1]), i = Math.max(r[0], r[1]), a = [t[0], t[1]];
  return (!U(t[0]) || t[0] < n) && (a[0] = n), (!U(t[1]) || t[1] > i) && (a[1] = i), a[0] > i && (a[0] = i), a[1] < n && (a[1] = n), a;
}, gC = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, i = t[0].length; n < i; ++n)
      for (var a = 0, o = 0, u = 0; u < r; ++u) {
        var s = Tn(t[u][n][1]) ? t[u][n][0] : t[u][n][1];
        s >= 0 ? (t[u][n][0] = a, t[u][n][1] = a + s, a = t[u][n][1]) : (t[u][n][0] = o, t[u][n][1] = o + s, o = t[u][n][1]);
      }
}, bC = function(t) {
  var r = t.length;
  if (!(r <= 0))
    for (var n = 0, i = t[0].length; n < i; ++n)
      for (var a = 0, o = 0; o < r; ++o) {
        var u = Tn(t[o][n][1]) ? t[o][n][0] : t[o][n][1];
        u >= 0 ? (t[o][n][0] = a, t[o][n][1] = a + u, a = t[o][n][1]) : (t[o][n][0] = 0, t[o][n][1] = 0);
      }
}, xC = {
  sign: gC,
  // @ts-expect-error definitelytyped types are incorrect
  expand: uS,
  // @ts-expect-error definitelytyped types are incorrect
  none: Xr,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: sS,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: cS,
  positive: bC
}, wC = function(t, r, n) {
  var i = r.map(function(u) {
    return u.props.dataKey;
  }), a = xC[n], o = oS().keys(i).value(function(u, s) {
    return +_e(u, s, 0);
  }).order(Of).offset(a);
  return o(t);
}, OC = function(t, r, n, i, a, o) {
  if (!t)
    return null;
  var u = o ? r.reverse() : r, s = {}, c = u.reduce(function(f, d) {
    var p, y = (p = d.type) !== null && p !== void 0 && p.defaultProps ? Ee(Ee({}, d.type.defaultProps), d.props) : d.props, v = y.stackId, h = y.hide;
    if (h)
      return f;
    var x = y[n], g = f[x] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (Ie(v)) {
      var b = g.stackGroups[v] || {
        numericAxisId: n,
        cateAxisId: i,
        items: []
      };
      b.items.push(d), g.hasStack = !0, g.stackGroups[v] = b;
    } else
      g.stackGroups[ur("_stackId_")] = {
        numericAxisId: n,
        cateAxisId: i,
        items: [d]
      };
    return Ee(Ee({}, f), {}, Yr({}, x, g));
  }, s), l = {};
  return Object.keys(c).reduce(function(f, d) {
    var p = c[d];
    if (p.hasStack) {
      var y = {};
      p.stackGroups = Object.keys(p.stackGroups).reduce(function(v, h) {
        var x = p.stackGroups[h];
        return Ee(Ee({}, v), {}, Yr({}, h, {
          numericAxisId: n,
          cateAxisId: i,
          items: x.items,
          stackedData: wC(t, x.items, a)
        }));
      }, y);
    }
    return Ee(Ee({}, f), {}, Yr({}, d, p));
  }, l);
}, OO = function(t, r) {
  var n = r.realScaleType, i = r.type, a = r.tickCount, o = r.originalDomain, u = r.allowDecimals, s = n || r.scale;
  if (s !== "auto" && s !== "linear")
    return null;
  if (a && i === "number" && o && (o[0] === "auto" || o[1] === "auto")) {
    var c = t.domain();
    if (!c.length)
      return null;
    var l = RM(c, a, u);
    return t.domain([Bo(l), Zt(l)]), {
      niceTicks: l
    };
  }
  if (a && i === "number") {
    var f = t.domain(), d = DM(f, a, u);
    return {
      niceTicks: d
    };
  }
  return null;
};
function on(e) {
  var t = e.axis, r = e.ticks, n = e.bandSize, i = e.entry, a = e.index, o = e.dataKey;
  if (t.type === "category") {
    if (!t.allowDuplicatedCategory && t.dataKey && !te(i[t.dataKey])) {
      var u = va(r, "value", i[t.dataKey]);
      if (u)
        return u.coordinate + n / 2;
    }
    return r[a] ? r[a].coordinate + n / 2 : null;
  }
  var s = _e(i, te(o) ? t.dataKey : o);
  return te(s) ? null : t.scale(s);
}
var Fg = function(t) {
  var r = t.axis, n = t.ticks, i = t.offset, a = t.bandSize, o = t.entry, u = t.index;
  if (r.type === "category")
    return n[u] ? n[u].coordinate + i : null;
  var s = _e(o, r.dataKey, r.domain[u]);
  return te(s) ? null : r.scale(s) - a / 2 + i;
}, _C = function(t) {
  var r = t.numericAxis, n = r.scale.domain();
  if (r.type === "number") {
    var i = Math.min(n[0], n[1]), a = Math.max(n[0], n[1]);
    return i <= 0 && a >= 0 ? 0 : a < 0 ? a : i;
  }
  return n[0];
}, AC = function(t, r) {
  var n, i = (n = t.type) !== null && n !== void 0 && n.defaultProps ? Ee(Ee({}, t.type.defaultProps), t.props) : t.props, a = i.stackId;
  if (Ie(a)) {
    var o = r[a];
    if (o) {
      var u = o.items.indexOf(t);
      return u >= 0 ? o.stackedData[u] : null;
    }
  }
  return null;
}, SC = function(t) {
  return t.reduce(function(r, n) {
    return [Bo(n.concat([r[0]]).filter(U)), Zt(n.concat([r[1]]).filter(U))];
  }, [1 / 0, -1 / 0]);
}, _O = function(t, r, n) {
  return Object.keys(t).reduce(function(i, a) {
    var o = t[a], u = o.stackedData, s = u.reduce(function(c, l) {
      var f = SC(l.slice(r, n + 1));
      return [Math.min(c[0], f[0]), Math.max(c[1], f[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(s[0], i[0]), Math.max(s[1], i[1])];
  }, [1 / 0, -1 / 0]).map(function(i) {
    return i === 1 / 0 || i === -1 / 0 ? 0 : i;
  });
}, zg = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, Wg = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, Gf = function(t, r, n) {
  if (re(t))
    return t(r, n);
  if (!Array.isArray(t))
    return r;
  var i = [];
  if (U(t[0]))
    i[0] = n ? t[0] : Math.min(t[0], r[0]);
  else if (zg.test(t[0])) {
    var a = +zg.exec(t[0])[1];
    i[0] = r[0] - a;
  } else re(t[0]) ? i[0] = t[0](r[0]) : i[0] = r[0];
  if (U(t[1]))
    i[1] = n ? t[1] : Math.max(t[1], r[1]);
  else if (Wg.test(t[1])) {
    var o = +Wg.exec(t[1])[1];
    i[1] = r[1] + o;
  } else re(t[1]) ? i[1] = t[1](r[1]) : i[1] = r[1];
  return i;
}, Ba = function(t, r, n) {
  if (t && t.scale && t.scale.bandwidth) {
    var i = t.scale.bandwidth();
    if (!n || i > 0)
      return i;
  }
  if (t && r && r.length >= 2) {
    for (var a = rp(r, function(f) {
      return f.coordinate;
    }), o = 1 / 0, u = 1, s = a.length; u < s; u++) {
      var c = a[u], l = a[u - 1];
      o = Math.min((c.coordinate || 0) - (l.coordinate || 0), o);
    }
    return o === 1 / 0 ? 0 : o;
  }
  return n ? void 0 : 0;
}, Ug = function(t, r, n) {
  return !t || !t.length || ir(t, et(n, "type.defaultProps.domain")) ? r : t;
}, AO = function(t, r) {
  var n = t.type.defaultProps ? Ee(Ee({}, t.type.defaultProps), t.props) : t.props, i = n.dataKey, a = n.name, o = n.unit, u = n.formatter, s = n.tooltipType, c = n.chartType, l = n.hide;
  return Ee(Ee({}, J(t, !1)), {}, {
    dataKey: i,
    unit: o,
    formatter: u,
    name: a || i,
    color: Tp(t),
    value: _e(r, i),
    type: s,
    payload: r,
    chartType: c,
    hide: l
  });
};
function Oi(e) {
  "@babel/helpers - typeof";
  return Oi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Oi(e);
}
function Kg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function It(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Kg(Object(r), !0).forEach(function(n) {
      SO(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Kg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function SO(e, t, r) {
  return t = PC(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function PC(e) {
  var t = EC(e, "string");
  return Oi(t) == "symbol" ? t : t + "";
}
function EC(e, t) {
  if (Oi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Oi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function jC(e, t) {
  return CC(e) || MC(e, t) || $C(e, t) || TC();
}
function TC() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $C(e, t) {
  if (e) {
    if (typeof e == "string") return Hg(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Hg(e, t);
  }
}
function Hg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function MC(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], s = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(s = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function CC(e) {
  if (Array.isArray(e)) return e;
}
var Fa = Math.PI / 180, IC = function(t) {
  return t * 180 / Math.PI;
}, we = function(t, r, n, i) {
  return {
    x: t + Math.cos(-Fa * i) * n,
    y: r + Math.sin(-Fa * i) * n
  };
}, PO = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(t - (n.left || 0) - (n.right || 0)), Math.abs(r - (n.top || 0) - (n.bottom || 0))) / 2;
}, NC = function(t, r, n, i, a) {
  var o = t.width, u = t.height, s = t.startAngle, c = t.endAngle, l = Ue(t.cx, o, o / 2), f = Ue(t.cy, u, u / 2), d = PO(o, u, n), p = Ue(t.innerRadius, d, 0), y = Ue(t.outerRadius, d, d * 0.8), v = Object.keys(r);
  return v.reduce(function(h, x) {
    var g = r[x], b = g.domain, O = g.reversed, m;
    if (te(g.range))
      i === "angleAxis" ? m = [s, c] : i === "radiusAxis" && (m = [p, y]), O && (m = [m[1], m[0]]);
    else {
      m = g.range;
      var w = m, _ = jC(w, 2);
      s = _[0], c = _[1];
    }
    var P = xO(g, a), T = P.realScaleType, M = P.scale;
    M.domain(b).range(m), wO(M);
    var j = OO(M, It(It({}, g), {}, {
      realScaleType: T
    })), $ = It(It(It({}, g), j), {}, {
      range: m,
      radius: y,
      realScaleType: T,
      scale: M,
      cx: l,
      cy: f,
      innerRadius: p,
      outerRadius: y,
      startAngle: s,
      endAngle: c
    });
    return It(It({}, h), {}, SO({}, x, $));
  }, {});
}, kC = function(t, r) {
  var n = t.x, i = t.y, a = r.x, o = r.y;
  return Math.sqrt(Math.pow(n - a, 2) + Math.pow(i - o, 2));
}, RC = function(t, r) {
  var n = t.x, i = t.y, a = r.cx, o = r.cy, u = kC({
    x: n,
    y: i
  }, {
    x: a,
    y: o
  });
  if (u <= 0)
    return {
      radius: u
    };
  var s = (n - a) / u, c = Math.acos(s);
  return i > o && (c = 2 * Math.PI - c), {
    radius: u,
    angle: IC(c),
    angleInRadian: c
  };
}, DC = function(t) {
  var r = t.startAngle, n = t.endAngle, i = Math.floor(r / 360), a = Math.floor(n / 360), o = Math.min(i, a);
  return {
    startAngle: r - o * 360,
    endAngle: n - o * 360
  };
}, LC = function(t, r) {
  var n = r.startAngle, i = r.endAngle, a = Math.floor(n / 360), o = Math.floor(i / 360), u = Math.min(a, o);
  return t + u * 360;
}, Gg = function(t, r) {
  var n = t.x, i = t.y, a = RC({
    x: n,
    y: i
  }, r), o = a.radius, u = a.angle, s = r.innerRadius, c = r.outerRadius;
  if (o < s || o > c)
    return !1;
  if (o === 0)
    return !0;
  var l = DC(r), f = l.startAngle, d = l.endAngle, p = u, y;
  if (f <= d) {
    for (; p > d; )
      p -= 360;
    for (; p < f; )
      p += 360;
    y = p >= f && p <= d;
  } else {
    for (; p > f; )
      p -= 360;
    for (; p < d; )
      p += 360;
    y = p >= d && p <= f;
  }
  return y ? It(It({}, r), {}, {
    radius: o,
    angle: LC(p, r)
  }) : null;
}, EO = function(t) {
  return !/* @__PURE__ */ bt(t) && !re(t) && typeof t != "boolean" ? t.className : "";
};
function _i(e) {
  "@babel/helpers - typeof";
  return _i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _i(e);
}
var qC = ["offset"];
function BC(e) {
  return UC(e) || WC(e) || zC(e) || FC();
}
function FC() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zC(e, t) {
  if (e) {
    if (typeof e == "string") return Vf(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Vf(e, t);
  }
}
function WC(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function UC(e) {
  if (Array.isArray(e)) return Vf(e);
}
function Vf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function KC(e, t) {
  if (e == null) return {};
  var r = HC(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function HC(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Vg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Me(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Vg(Object(r), !0).forEach(function(n) {
      GC(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Vg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function GC(e, t, r) {
  return t = VC(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function VC(e) {
  var t = YC(e, "string");
  return _i(t) == "symbol" ? t : t + "";
}
function YC(e, t) {
  if (_i(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (_i(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Ai() {
  return Ai = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ai.apply(this, arguments);
}
var XC = function(t) {
  var r = t.value, n = t.formatter, i = te(t.children) ? r : t.children;
  return re(n) ? n(i) : i;
}, ZC = function(t, r) {
  var n = We(r - t), i = Math.min(Math.abs(r - t), 360);
  return n * i;
}, JC = function(t, r, n) {
  var i = t.position, a = t.viewBox, o = t.offset, u = t.className, s = a, c = s.cx, l = s.cy, f = s.innerRadius, d = s.outerRadius, p = s.startAngle, y = s.endAngle, v = s.clockWise, h = (f + d) / 2, x = ZC(p, y), g = x >= 0 ? 1 : -1, b, O;
  i === "insideStart" ? (b = p + g * o, O = v) : i === "insideEnd" ? (b = y - g * o, O = !v) : i === "end" && (b = y + g * o, O = v), O = x <= 0 ? O : !O;
  var m = we(c, l, h, b), w = we(c, l, h, b + (O ? 1 : -1) * 359), _ = "M".concat(m.x, ",").concat(m.y, `
    A`).concat(h, ",").concat(h, ",0,1,").concat(O ? 0 : 1, `,
    `).concat(w.x, ",").concat(w.y), P = te(t.id) ? ur("recharts-radial-line-") : t.id;
  return /* @__PURE__ */ S.createElement("text", Ai({}, n, {
    dominantBaseline: "central",
    className: ae("recharts-radial-bar-label", u)
  }), /* @__PURE__ */ S.createElement("defs", null, /* @__PURE__ */ S.createElement("path", {
    id: P,
    d: _
  })), /* @__PURE__ */ S.createElement("textPath", {
    xlinkHref: "#".concat(P)
  }, r));
}, QC = function(t) {
  var r = t.viewBox, n = t.offset, i = t.position, a = r, o = a.cx, u = a.cy, s = a.innerRadius, c = a.outerRadius, l = a.startAngle, f = a.endAngle, d = (l + f) / 2;
  if (i === "outside") {
    var p = we(o, u, c + n, d), y = p.x, v = p.y;
    return {
      x: y,
      y: v,
      textAnchor: y >= o ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (i === "center")
    return {
      x: o,
      y: u,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (i === "centerTop")
    return {
      x: o,
      y: u,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (i === "centerBottom")
    return {
      x: o,
      y: u,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var h = (s + c) / 2, x = we(o, u, h, d), g = x.x, b = x.y;
  return {
    x: g,
    y: b,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, eI = function(t) {
  var r = t.viewBox, n = t.parentViewBox, i = t.offset, a = t.position, o = r, u = o.x, s = o.y, c = o.width, l = o.height, f = l >= 0 ? 1 : -1, d = f * i, p = f > 0 ? "end" : "start", y = f > 0 ? "start" : "end", v = c >= 0 ? 1 : -1, h = v * i, x = v > 0 ? "end" : "start", g = v > 0 ? "start" : "end";
  if (a === "top") {
    var b = {
      x: u + c / 2,
      y: s - f * i,
      textAnchor: "middle",
      verticalAnchor: p
    };
    return Me(Me({}, b), n ? {
      height: Math.max(s - n.y, 0),
      width: c
    } : {});
  }
  if (a === "bottom") {
    var O = {
      x: u + c / 2,
      y: s + l + d,
      textAnchor: "middle",
      verticalAnchor: y
    };
    return Me(Me({}, O), n ? {
      height: Math.max(n.y + n.height - (s + l), 0),
      width: c
    } : {});
  }
  if (a === "left") {
    var m = {
      x: u - h,
      y: s + l / 2,
      textAnchor: x,
      verticalAnchor: "middle"
    };
    return Me(Me({}, m), n ? {
      width: Math.max(m.x - n.x, 0),
      height: l
    } : {});
  }
  if (a === "right") {
    var w = {
      x: u + c + h,
      y: s + l / 2,
      textAnchor: g,
      verticalAnchor: "middle"
    };
    return Me(Me({}, w), n ? {
      width: Math.max(n.x + n.width - w.x, 0),
      height: l
    } : {});
  }
  var _ = n ? {
    width: c,
    height: l
  } : {};
  return a === "insideLeft" ? Me({
    x: u + h,
    y: s + l / 2,
    textAnchor: g,
    verticalAnchor: "middle"
  }, _) : a === "insideRight" ? Me({
    x: u + c - h,
    y: s + l / 2,
    textAnchor: x,
    verticalAnchor: "middle"
  }, _) : a === "insideTop" ? Me({
    x: u + c / 2,
    y: s + d,
    textAnchor: "middle",
    verticalAnchor: y
  }, _) : a === "insideBottom" ? Me({
    x: u + c / 2,
    y: s + l - d,
    textAnchor: "middle",
    verticalAnchor: p
  }, _) : a === "insideTopLeft" ? Me({
    x: u + h,
    y: s + d,
    textAnchor: g,
    verticalAnchor: y
  }, _) : a === "insideTopRight" ? Me({
    x: u + c - h,
    y: s + d,
    textAnchor: x,
    verticalAnchor: y
  }, _) : a === "insideBottomLeft" ? Me({
    x: u + h,
    y: s + l - d,
    textAnchor: g,
    verticalAnchor: p
  }, _) : a === "insideBottomRight" ? Me({
    x: u + c - h,
    y: s + l - d,
    textAnchor: x,
    verticalAnchor: p
  }, _) : jn(a) && (U(a.x) || gr(a.x)) && (U(a.y) || gr(a.y)) ? Me({
    x: u + Ue(a.x, c),
    y: s + Ue(a.y, l),
    textAnchor: "end",
    verticalAnchor: "end"
  }, _) : Me({
    x: u + c / 2,
    y: s + l / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, _);
}, tI = function(t) {
  return "cx" in t && U(t.cx);
};
function Re(e) {
  var t = e.offset, r = t === void 0 ? 5 : t, n = KC(e, qC), i = Me({
    offset: r
  }, n), a = i.viewBox, o = i.position, u = i.value, s = i.children, c = i.content, l = i.className, f = l === void 0 ? "" : l, d = i.textBreakAll;
  if (!a || te(u) && te(s) && !/* @__PURE__ */ bt(c) && !re(c))
    return null;
  if (/* @__PURE__ */ bt(c))
    return /* @__PURE__ */ Ce(c, i);
  var p;
  if (re(c)) {
    if (p = /* @__PURE__ */ cx(c, i), /* @__PURE__ */ bt(p))
      return p;
  } else
    p = XC(i);
  var y = tI(a), v = J(i, !0);
  if (y && (o === "insideStart" || o === "insideEnd" || o === "end"))
    return JC(i, p, v);
  var h = y ? QC(i) : eI(i);
  return /* @__PURE__ */ S.createElement(jr, Ai({
    className: ae("recharts-label", f)
  }, v, h, {
    breakAll: d
  }), p);
}
Re.displayName = "Label";
var jO = function(t) {
  var r = t.cx, n = t.cy, i = t.angle, a = t.startAngle, o = t.endAngle, u = t.r, s = t.radius, c = t.innerRadius, l = t.outerRadius, f = t.x, d = t.y, p = t.top, y = t.left, v = t.width, h = t.height, x = t.clockWise, g = t.labelViewBox;
  if (g)
    return g;
  if (U(v) && U(h)) {
    if (U(f) && U(d))
      return {
        x: f,
        y: d,
        width: v,
        height: h
      };
    if (U(p) && U(y))
      return {
        x: p,
        y,
        width: v,
        height: h
      };
  }
  return U(f) && U(d) ? {
    x: f,
    y: d,
    width: 0,
    height: 0
  } : U(r) && U(n) ? {
    cx: r,
    cy: n,
    startAngle: a || i || 0,
    endAngle: o || i || 0,
    innerRadius: c || 0,
    outerRadius: l || s || u || 0,
    clockWise: x
  } : t.viewBox ? t.viewBox : {};
}, rI = function(t, r) {
  return t ? t === !0 ? /* @__PURE__ */ S.createElement(Re, {
    key: "label-implicit",
    viewBox: r
  }) : Ie(t) ? /* @__PURE__ */ S.createElement(Re, {
    key: "label-implicit",
    viewBox: r,
    value: t
  }) : /* @__PURE__ */ bt(t) ? t.type === Re ? /* @__PURE__ */ Ce(t, {
    key: "label-implicit",
    viewBox: r
  }) : /* @__PURE__ */ S.createElement(Re, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : re(t) ? /* @__PURE__ */ S.createElement(Re, {
    key: "label-implicit",
    content: t,
    viewBox: r
  }) : jn(t) ? /* @__PURE__ */ S.createElement(Re, Ai({
    viewBox: r
  }, t, {
    key: "label-implicit"
  })) : null : null;
}, nI = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!t || !t.children && n && !t.label)
    return null;
  var i = t.children, a = jO(t), o = He(i, Re).map(function(s, c) {
    return /* @__PURE__ */ Ce(s, {
      viewBox: r || a,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(c)
    });
  });
  if (!n)
    return o;
  var u = rI(t.label, r || a);
  return [u].concat(BC(o));
};
Re.parseViewBox = jO;
Re.renderCallByParent = nI;
var Cl, Yg;
function iI() {
  if (Yg) return Cl;
  Yg = 1;
  function e(t) {
    var r = t == null ? 0 : t.length;
    return r ? t[r - 1] : void 0;
  }
  return Cl = e, Cl;
}
var aI = iI();
const oI = /* @__PURE__ */ ye(aI);
function Si(e) {
  "@babel/helpers - typeof";
  return Si = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Si(e);
}
var uI = ["valueAccessor"], sI = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function cI(e) {
  return pI(e) || dI(e) || fI(e) || lI();
}
function lI() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function fI(e, t) {
  if (e) {
    if (typeof e == "string") return Yf(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Yf(e, t);
  }
}
function dI(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function pI(e) {
  if (Array.isArray(e)) return Yf(e);
}
function Yf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function za() {
  return za = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, za.apply(this, arguments);
}
function Xg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Zg(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Xg(Object(r), !0).forEach(function(n) {
      hI(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Xg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function hI(e, t, r) {
  return t = vI(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function vI(e) {
  var t = yI(e, "string");
  return Si(t) == "symbol" ? t : t + "";
}
function yI(e, t) {
  if (Si(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Si(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Jg(e, t) {
  if (e == null) return {};
  var r = mI(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function mI(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var gI = function(t) {
  return Array.isArray(t.value) ? oI(t.value) : t.value;
};
function wt(e) {
  var t = e.valueAccessor, r = t === void 0 ? gI : t, n = Jg(e, uI), i = n.data, a = n.dataKey, o = n.clockWise, u = n.id, s = n.textBreakAll, c = Jg(n, sI);
  return !i || !i.length ? null : /* @__PURE__ */ S.createElement(oe, {
    className: "recharts-label-list"
  }, i.map(function(l, f) {
    var d = te(a) ? r(l, f) : _e(l && l.payload, a), p = te(u) ? {} : {
      id: "".concat(u, "-").concat(f)
    };
    return /* @__PURE__ */ S.createElement(Re, za({}, J(l, !0), c, p, {
      parentViewBox: l.parentViewBox,
      value: d,
      textBreakAll: s,
      viewBox: Re.parseViewBox(te(o) ? l : Zg(Zg({}, l), {}, {
        clockWise: o
      })),
      key: "label-".concat(f),
      index: f
    }));
  }));
}
wt.displayName = "LabelList";
function bI(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ S.createElement(wt, {
    key: "labelList-implicit",
    data: t
  }) : /* @__PURE__ */ S.isValidElement(e) || re(e) ? /* @__PURE__ */ S.createElement(wt, {
    key: "labelList-implicit",
    data: t,
    content: e
  }) : jn(e) ? /* @__PURE__ */ S.createElement(wt, za({
    data: t
  }, e, {
    key: "labelList-implicit"
  })) : null : null;
}
function xI(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && r && !e.label)
    return null;
  var n = e.children, i = He(n, wt).map(function(o, u) {
    return /* @__PURE__ */ Ce(o, {
      data: t,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(u)
    });
  });
  if (!r)
    return i;
  var a = bI(e.label, t);
  return [a].concat(cI(i));
}
wt.renderCallByParent = xI;
function Pi(e) {
  "@babel/helpers - typeof";
  return Pi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Pi(e);
}
function Xf() {
  return Xf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xf.apply(this, arguments);
}
function Qg(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function eb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Qg(Object(r), !0).forEach(function(n) {
      wI(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Qg(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function wI(e, t, r) {
  return t = OI(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function OI(e) {
  var t = _I(e, "string");
  return Pi(t) == "symbol" ? t : t + "";
}
function _I(e, t) {
  if (Pi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Pi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var AI = function(t, r) {
  var n = We(r - t), i = Math.min(Math.abs(r - t), 359.999);
  return n * i;
}, oa = function(t) {
  var r = t.cx, n = t.cy, i = t.radius, a = t.angle, o = t.sign, u = t.isExternal, s = t.cornerRadius, c = t.cornerIsExternal, l = s * (u ? 1 : -1) + i, f = Math.asin(s / l) / Fa, d = c ? a : a + o * f, p = we(r, n, l, d), y = we(r, n, i, d), v = c ? a - o * f : a, h = we(r, n, l * Math.cos(f * Fa), v);
  return {
    center: p,
    circleTangency: y,
    lineTangency: h,
    theta: f
  };
}, TO = function(t) {
  var r = t.cx, n = t.cy, i = t.innerRadius, a = t.outerRadius, o = t.startAngle, u = t.endAngle, s = AI(o, u), c = o + s, l = we(r, n, a, o), f = we(r, n, a, c), d = "M ".concat(l.x, ",").concat(l.y, `
    A `).concat(a, ",").concat(a, `,0,
    `).concat(+(Math.abs(s) > 180), ",").concat(+(o > c), `,
    `).concat(f.x, ",").concat(f.y, `
  `);
  if (i > 0) {
    var p = we(r, n, i, o), y = we(r, n, i, c);
    d += "L ".concat(y.x, ",").concat(y.y, `
            A `).concat(i, ",").concat(i, `,0,
            `).concat(+(Math.abs(s) > 180), ",").concat(+(o <= c), `,
            `).concat(p.x, ",").concat(p.y, " Z");
  } else
    d += "L ".concat(r, ",").concat(n, " Z");
  return d;
}, SI = function(t) {
  var r = t.cx, n = t.cy, i = t.innerRadius, a = t.outerRadius, o = t.cornerRadius, u = t.forceCornerRadius, s = t.cornerIsExternal, c = t.startAngle, l = t.endAngle, f = We(l - c), d = oa({
    cx: r,
    cy: n,
    radius: a,
    angle: c,
    sign: f,
    cornerRadius: o,
    cornerIsExternal: s
  }), p = d.circleTangency, y = d.lineTangency, v = d.theta, h = oa({
    cx: r,
    cy: n,
    radius: a,
    angle: l,
    sign: -f,
    cornerRadius: o,
    cornerIsExternal: s
  }), x = h.circleTangency, g = h.lineTangency, b = h.theta, O = s ? Math.abs(c - l) : Math.abs(c - l) - v - b;
  if (O < 0)
    return u ? "M ".concat(y.x, ",").concat(y.y, `
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(o * 2, `,0
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(-o * 2, `,0
      `) : TO({
      cx: r,
      cy: n,
      innerRadius: i,
      outerRadius: a,
      startAngle: c,
      endAngle: l
    });
  var m = "M ".concat(y.x, ",").concat(y.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(p.x, ",").concat(p.y, `
    A`).concat(a, ",").concat(a, ",0,").concat(+(O > 180), ",").concat(+(f < 0), ",").concat(x.x, ",").concat(x.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(g.x, ",").concat(g.y, `
  `);
  if (i > 0) {
    var w = oa({
      cx: r,
      cy: n,
      radius: i,
      angle: c,
      sign: f,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: s
    }), _ = w.circleTangency, P = w.lineTangency, T = w.theta, M = oa({
      cx: r,
      cy: n,
      radius: i,
      angle: l,
      sign: -f,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: s
    }), j = M.circleTangency, $ = M.lineTangency, I = M.theta, k = s ? Math.abs(c - l) : Math.abs(c - l) - T - I;
    if (k < 0 && o === 0)
      return "".concat(m, "L").concat(r, ",").concat(n, "Z");
    m += "L".concat($.x, ",").concat($.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(j.x, ",").concat(j.y, `
      A`).concat(i, ",").concat(i, ",0,").concat(+(k > 180), ",").concat(+(f > 0), ",").concat(_.x, ",").concat(_.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(f < 0), ",").concat(P.x, ",").concat(P.y, "Z");
  } else
    m += "L".concat(r, ",").concat(n, "Z");
  return m;
}, PI = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, $O = function(t) {
  var r = eb(eb({}, PI), t), n = r.cx, i = r.cy, a = r.innerRadius, o = r.outerRadius, u = r.cornerRadius, s = r.forceCornerRadius, c = r.cornerIsExternal, l = r.startAngle, f = r.endAngle, d = r.className;
  if (o < a || l === f)
    return null;
  var p = ae("recharts-sector", d), y = o - a, v = Ue(u, y, 0, !0), h;
  return v > 0 && Math.abs(l - f) < 360 ? h = SI({
    cx: n,
    cy: i,
    innerRadius: a,
    outerRadius: o,
    cornerRadius: Math.min(v, y / 2),
    forceCornerRadius: s,
    cornerIsExternal: c,
    startAngle: l,
    endAngle: f
  }) : h = TO({
    cx: n,
    cy: i,
    innerRadius: a,
    outerRadius: o,
    startAngle: l,
    endAngle: f
  }), /* @__PURE__ */ S.createElement("path", Xf({}, J(r, !0), {
    className: p,
    d: h,
    role: "img"
  }));
};
function Ei(e) {
  "@babel/helpers - typeof";
  return Ei = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ei(e);
}
function Zf() {
  return Zf = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Zf.apply(this, arguments);
}
function tb(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function rb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tb(Object(r), !0).forEach(function(n) {
      EI(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : tb(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function EI(e, t, r) {
  return t = jI(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function jI(e) {
  var t = TI(e, "string");
  return Ei(t) == "symbol" ? t : t + "";
}
function TI(e, t) {
  if (Ei(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ei(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var nb = {
  curveBasisClosed: YA,
  curveBasisOpen: XA,
  curveBasis: VA,
  curveBumpX: NA,
  curveBumpY: kA,
  curveLinearClosed: ZA,
  curveLinear: Eo,
  curveMonotoneX: JA,
  curveMonotoneY: QA,
  curveNatural: eS,
  curveStep: tS,
  curveStepAfter: nS,
  curveStepBefore: rS
}, ua = function(t) {
  return t.x === +t.x && t.y === +t.y;
}, Un = function(t) {
  return t.x;
}, Kn = function(t) {
  return t.y;
}, $I = function(t, r) {
  if (re(t))
    return t;
  var n = "curve".concat(So(t));
  return (n === "curveMonotone" || n === "curveBump") && r ? nb["".concat(n).concat(r === "vertical" ? "Y" : "X")] : nb[n] || Eo;
}, MI = function(t) {
  var r = t.type, n = r === void 0 ? "linear" : r, i = t.points, a = i === void 0 ? [] : i, o = t.baseLine, u = t.layout, s = t.connectNulls, c = s === void 0 ? !1 : s, l = $I(n, u), f = c ? a.filter(function(v) {
    return ua(v);
  }) : a, d;
  if (Array.isArray(o)) {
    var p = c ? o.filter(function(v) {
      return ua(v);
    }) : o, y = f.map(function(v, h) {
      return rb(rb({}, v), {}, {
        base: p[h]
      });
    });
    return u === "vertical" ? d = Ji().y(Kn).x1(Un).x0(function(v) {
      return v.base.x;
    }) : d = Ji().x(Un).y1(Kn).y0(function(v) {
      return v.base.y;
    }), d.defined(ua).curve(l), d(y);
  }
  return u === "vertical" && U(o) ? d = Ji().y(Kn).x1(Un).x0(o) : U(o) ? d = Ji().x(Un).y1(Kn).y0(o) : d = jx().x(Un).y(Kn), d.defined(ua).curve(l), d(f);
}, rr = function(t) {
  var r = t.className, n = t.points, i = t.path, a = t.pathRef;
  if ((!n || !n.length) && !i)
    return null;
  var o = n && n.length ? MI(t) : i;
  return /* @__PURE__ */ ft.createElement("path", Zf({}, J(t, !1), ya(t), {
    className: ae("recharts-curve", r),
    d: o,
    ref: a
  }));
}, sa = { exports: {} }, ca = { exports: {} }, de = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ib;
function CI() {
  if (ib) return de;
  ib = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
  function b(m) {
    if (typeof m == "object" && m !== null) {
      var w = m.$$typeof;
      switch (w) {
        case t:
          switch (m = m.type, m) {
            case s:
            case c:
            case n:
            case a:
            case i:
            case f:
              return m;
            default:
              switch (m = m && m.$$typeof, m) {
                case u:
                case l:
                case y:
                case p:
                case o:
                  return m;
                default:
                  return w;
              }
          }
        case r:
          return w;
      }
    }
  }
  function O(m) {
    return b(m) === c;
  }
  return de.AsyncMode = s, de.ConcurrentMode = c, de.ContextConsumer = u, de.ContextProvider = o, de.Element = t, de.ForwardRef = l, de.Fragment = n, de.Lazy = y, de.Memo = p, de.Portal = r, de.Profiler = a, de.StrictMode = i, de.Suspense = f, de.isAsyncMode = function(m) {
    return O(m) || b(m) === s;
  }, de.isConcurrentMode = O, de.isContextConsumer = function(m) {
    return b(m) === u;
  }, de.isContextProvider = function(m) {
    return b(m) === o;
  }, de.isElement = function(m) {
    return typeof m == "object" && m !== null && m.$$typeof === t;
  }, de.isForwardRef = function(m) {
    return b(m) === l;
  }, de.isFragment = function(m) {
    return b(m) === n;
  }, de.isLazy = function(m) {
    return b(m) === y;
  }, de.isMemo = function(m) {
    return b(m) === p;
  }, de.isPortal = function(m) {
    return b(m) === r;
  }, de.isProfiler = function(m) {
    return b(m) === a;
  }, de.isStrictMode = function(m) {
    return b(m) === i;
  }, de.isSuspense = function(m) {
    return b(m) === f;
  }, de.isValidElementType = function(m) {
    return typeof m == "string" || typeof m == "function" || m === n || m === c || m === a || m === i || m === f || m === d || typeof m == "object" && m !== null && (m.$$typeof === y || m.$$typeof === p || m.$$typeof === o || m.$$typeof === u || m.$$typeof === l || m.$$typeof === h || m.$$typeof === x || m.$$typeof === g || m.$$typeof === v);
  }, de.typeOf = b, de;
}
var pe = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ab;
function II() {
  return ab || (ab = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
    function b(C) {
      return typeof C == "string" || typeof C == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      C === n || C === c || C === a || C === i || C === f || C === d || typeof C == "object" && C !== null && (C.$$typeof === y || C.$$typeof === p || C.$$typeof === o || C.$$typeof === u || C.$$typeof === l || C.$$typeof === h || C.$$typeof === x || C.$$typeof === g || C.$$typeof === v);
    }
    function O(C) {
      if (typeof C == "object" && C !== null) {
        var ue = C.$$typeof;
        switch (ue) {
          case t:
            var H = C.type;
            switch (H) {
              case s:
              case c:
              case n:
              case a:
              case i:
              case f:
                return H;
              default:
                var ge = H && H.$$typeof;
                switch (ge) {
                  case u:
                  case l:
                  case y:
                  case p:
                  case o:
                    return ge;
                  default:
                    return ue;
                }
            }
          case r:
            return ue;
        }
      }
    }
    var m = s, w = c, _ = u, P = o, T = t, M = l, j = n, $ = y, I = p, k = r, R = a, D = i, B = f, W = !1;
    function K(C) {
      return W || (W = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), E(C) || O(C) === s;
    }
    function E(C) {
      return O(C) === c;
    }
    function N(C) {
      return O(C) === u;
    }
    function L(C) {
      return O(C) === o;
    }
    function z(C) {
      return typeof C == "object" && C !== null && C.$$typeof === t;
    }
    function V(C) {
      return O(C) === l;
    }
    function Y(C) {
      return O(C) === n;
    }
    function ee(C) {
      return O(C) === y;
    }
    function ne(C) {
      return O(C) === p;
    }
    function X(C) {
      return O(C) === r;
    }
    function F(C) {
      return O(C) === a;
    }
    function G(C) {
      return O(C) === i;
    }
    function Q(C) {
      return O(C) === f;
    }
    pe.AsyncMode = m, pe.ConcurrentMode = w, pe.ContextConsumer = _, pe.ContextProvider = P, pe.Element = T, pe.ForwardRef = M, pe.Fragment = j, pe.Lazy = $, pe.Memo = I, pe.Portal = k, pe.Profiler = R, pe.StrictMode = D, pe.Suspense = B, pe.isAsyncMode = K, pe.isConcurrentMode = E, pe.isContextConsumer = N, pe.isContextProvider = L, pe.isElement = z, pe.isForwardRef = V, pe.isFragment = Y, pe.isLazy = ee, pe.isMemo = ne, pe.isPortal = X, pe.isProfiler = F, pe.isStrictMode = G, pe.isSuspense = Q, pe.isValidElementType = b, pe.typeOf = O;
  }()), pe;
}
var ob;
function MO() {
  return ob || (ob = 1, process.env.NODE_ENV === "production" ? ca.exports = CI() : ca.exports = II()), ca.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Il, ub;
function NI() {
  if (ub) return Il;
  ub = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var o = {}, u = 0; u < 10; u++)
        o["_" + String.fromCharCode(u)] = u;
      var s = Object.getOwnPropertyNames(o).map(function(l) {
        return o[l];
      });
      if (s.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        c[l] = l;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Il = i() ? Object.assign : function(a, o) {
    for (var u, s = n(a), c, l = 1; l < arguments.length; l++) {
      u = Object(arguments[l]);
      for (var f in u)
        t.call(u, f) && (s[f] = u[f]);
      if (e) {
        c = e(u);
        for (var d = 0; d < c.length; d++)
          r.call(u, c[d]) && (s[c[d]] = u[c[d]]);
      }
    }
    return s;
  }, Il;
}
var Nl, sb;
function $p() {
  if (sb) return Nl;
  sb = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Nl = e, Nl;
}
var kl, cb;
function CO() {
  return cb || (cb = 1, kl = Function.call.bind(Object.prototype.hasOwnProperty)), kl;
}
var Rl, lb;
function kI() {
  if (lb) return Rl;
  lb = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ $p(), r = {}, n = /* @__PURE__ */ CO();
    e = function(a) {
      var o = "Warning: " + a;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function i(a, o, u, s, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in a)
        if (n(a, l)) {
          var f;
          try {
            if (typeof a[l] != "function") {
              var d = Error(
                (s || "React class") + ": " + u + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = a[l](o, l, s, u, null, t);
          } catch (y) {
            f = y;
          }
          if (f && !(f instanceof Error) && e(
            (s || "React class") + ": type specification of " + u + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in r)) {
            r[f.message] = !0;
            var p = c ? c() : "";
            e(
              "Failed " + u + " type: " + f.message + (p ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, Rl = i, Rl;
}
var Dl, fb;
function RI() {
  if (fb) return Dl;
  fb = 1;
  var e = MO(), t = NI(), r = /* @__PURE__ */ $p(), n = /* @__PURE__ */ CO(), i = /* @__PURE__ */ kI(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(u) {
    var s = "Warning: " + u;
    typeof console < "u" && console.error(s);
    try {
      throw new Error(s);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Dl = function(u, s) {
    var c = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function f(E) {
      var N = E && (c && E[c] || E[l]);
      if (typeof N == "function")
        return N;
    }
    var d = "<<anonymous>>", p = {
      array: x("array"),
      bigint: x("bigint"),
      bool: x("boolean"),
      func: x("function"),
      number: x("number"),
      object: x("object"),
      string: x("string"),
      symbol: x("symbol"),
      any: g(),
      arrayOf: b,
      element: O(),
      elementType: m(),
      instanceOf: w,
      node: M(),
      objectOf: P,
      oneOf: _,
      oneOfType: T,
      shape: $,
      exact: I
    };
    function y(E, N) {
      return E === N ? E !== 0 || 1 / E === 1 / N : E !== E && N !== N;
    }
    function v(E, N) {
      this.message = E, this.data = N && typeof N == "object" ? N : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function h(E) {
      if (process.env.NODE_ENV !== "production")
        var N = {}, L = 0;
      function z(Y, ee, ne, X, F, G, Q) {
        if (X = X || d, G = G || ne, Q !== r) {
          if (s) {
            var C = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw C.name = "Invariant Violation", C;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ue = X + ":" + ne;
            !N[ue] && // Avoid spamming the console because they are often not actionable except for lib authors
            L < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + G + "` prop on `" + X + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), N[ue] = !0, L++);
          }
        }
        return ee[ne] == null ? Y ? ee[ne] === null ? new v("The " + F + " `" + G + "` is marked as required " + ("in `" + X + "`, but its value is `null`.")) : new v("The " + F + " `" + G + "` is marked as required in " + ("`" + X + "`, but its value is `undefined`.")) : null : E(ee, ne, X, F, G);
      }
      var V = z.bind(null, !1);
      return V.isRequired = z.bind(null, !0), V;
    }
    function x(E) {
      function N(L, z, V, Y, ee, ne) {
        var X = L[z], F = D(X);
        if (F !== E) {
          var G = B(X);
          return new v(
            "Invalid " + Y + " `" + ee + "` of type " + ("`" + G + "` supplied to `" + V + "`, expected ") + ("`" + E + "`."),
            { expectedType: E }
          );
        }
        return null;
      }
      return h(N);
    }
    function g() {
      return h(o);
    }
    function b(E) {
      function N(L, z, V, Y, ee) {
        if (typeof E != "function")
          return new v("Property `" + ee + "` of component `" + V + "` has invalid PropType notation inside arrayOf.");
        var ne = L[z];
        if (!Array.isArray(ne)) {
          var X = D(ne);
          return new v("Invalid " + Y + " `" + ee + "` of type " + ("`" + X + "` supplied to `" + V + "`, expected an array."));
        }
        for (var F = 0; F < ne.length; F++) {
          var G = E(ne, F, V, Y, ee + "[" + F + "]", r);
          if (G instanceof Error)
            return G;
        }
        return null;
      }
      return h(N);
    }
    function O() {
      function E(N, L, z, V, Y) {
        var ee = N[L];
        if (!u(ee)) {
          var ne = D(ee);
          return new v("Invalid " + V + " `" + Y + "` of type " + ("`" + ne + "` supplied to `" + z + "`, expected a single ReactElement."));
        }
        return null;
      }
      return h(E);
    }
    function m() {
      function E(N, L, z, V, Y) {
        var ee = N[L];
        if (!e.isValidElementType(ee)) {
          var ne = D(ee);
          return new v("Invalid " + V + " `" + Y + "` of type " + ("`" + ne + "` supplied to `" + z + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return h(E);
    }
    function w(E) {
      function N(L, z, V, Y, ee) {
        if (!(L[z] instanceof E)) {
          var ne = E.name || d, X = K(L[z]);
          return new v("Invalid " + Y + " `" + ee + "` of type " + ("`" + X + "` supplied to `" + V + "`, expected ") + ("instance of `" + ne + "`."));
        }
        return null;
      }
      return h(N);
    }
    function _(E) {
      if (!Array.isArray(E))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), o;
      function N(L, z, V, Y, ee) {
        for (var ne = L[z], X = 0; X < E.length; X++)
          if (y(ne, E[X]))
            return null;
        var F = JSON.stringify(E, function(Q, C) {
          var ue = B(C);
          return ue === "symbol" ? String(C) : C;
        });
        return new v("Invalid " + Y + " `" + ee + "` of value `" + String(ne) + "` " + ("supplied to `" + V + "`, expected one of " + F + "."));
      }
      return h(N);
    }
    function P(E) {
      function N(L, z, V, Y, ee) {
        if (typeof E != "function")
          return new v("Property `" + ee + "` of component `" + V + "` has invalid PropType notation inside objectOf.");
        var ne = L[z], X = D(ne);
        if (X !== "object")
          return new v("Invalid " + Y + " `" + ee + "` of type " + ("`" + X + "` supplied to `" + V + "`, expected an object."));
        for (var F in ne)
          if (n(ne, F)) {
            var G = E(ne, F, V, Y, ee + "." + F, r);
            if (G instanceof Error)
              return G;
          }
        return null;
      }
      return h(N);
    }
    function T(E) {
      if (!Array.isArray(E))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var N = 0; N < E.length; N++) {
        var L = E[N];
        if (typeof L != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + W(L) + " at index " + N + "."
          ), o;
      }
      function z(V, Y, ee, ne, X) {
        for (var F = [], G = 0; G < E.length; G++) {
          var Q = E[G], C = Q(V, Y, ee, ne, X, r);
          if (C == null)
            return null;
          C.data && n(C.data, "expectedType") && F.push(C.data.expectedType);
        }
        var ue = F.length > 0 ? ", expected one of type [" + F.join(", ") + "]" : "";
        return new v("Invalid " + ne + " `" + X + "` supplied to " + ("`" + ee + "`" + ue + "."));
      }
      return h(z);
    }
    function M() {
      function E(N, L, z, V, Y) {
        return k(N[L]) ? null : new v("Invalid " + V + " `" + Y + "` supplied to " + ("`" + z + "`, expected a ReactNode."));
      }
      return h(E);
    }
    function j(E, N, L, z, V) {
      return new v(
        (E || "React class") + ": " + N + " type `" + L + "." + z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + V + "`."
      );
    }
    function $(E) {
      function N(L, z, V, Y, ee) {
        var ne = L[z], X = D(ne);
        if (X !== "object")
          return new v("Invalid " + Y + " `" + ee + "` of type `" + X + "` " + ("supplied to `" + V + "`, expected `object`."));
        for (var F in E) {
          var G = E[F];
          if (typeof G != "function")
            return j(V, Y, ee, F, B(G));
          var Q = G(ne, F, V, Y, ee + "." + F, r);
          if (Q)
            return Q;
        }
        return null;
      }
      return h(N);
    }
    function I(E) {
      function N(L, z, V, Y, ee) {
        var ne = L[z], X = D(ne);
        if (X !== "object")
          return new v("Invalid " + Y + " `" + ee + "` of type `" + X + "` " + ("supplied to `" + V + "`, expected `object`."));
        var F = t({}, L[z], E);
        for (var G in F) {
          var Q = E[G];
          if (n(E, G) && typeof Q != "function")
            return j(V, Y, ee, G, B(Q));
          if (!Q)
            return new v(
              "Invalid " + Y + " `" + ee + "` key `" + G + "` supplied to `" + V + "`.\nBad object: " + JSON.stringify(L[z], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(E), null, "  ")
            );
          var C = Q(ne, G, V, Y, ee + "." + G, r);
          if (C)
            return C;
        }
        return null;
      }
      return h(N);
    }
    function k(E) {
      switch (typeof E) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !E;
        case "object":
          if (Array.isArray(E))
            return E.every(k);
          if (E === null || u(E))
            return !0;
          var N = f(E);
          if (N) {
            var L = N.call(E), z;
            if (N !== E.entries) {
              for (; !(z = L.next()).done; )
                if (!k(z.value))
                  return !1;
            } else
              for (; !(z = L.next()).done; ) {
                var V = z.value;
                if (V && !k(V[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function R(E, N) {
      return E === "symbol" ? !0 : N ? N["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && N instanceof Symbol : !1;
    }
    function D(E) {
      var N = typeof E;
      return Array.isArray(E) ? "array" : E instanceof RegExp ? "object" : R(N, E) ? "symbol" : N;
    }
    function B(E) {
      if (typeof E > "u" || E === null)
        return "" + E;
      var N = D(E);
      if (N === "object") {
        if (E instanceof Date)
          return "date";
        if (E instanceof RegExp)
          return "regexp";
      }
      return N;
    }
    function W(E) {
      var N = B(E);
      switch (N) {
        case "array":
        case "object":
          return "an " + N;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + N;
        default:
          return N;
      }
    }
    function K(E) {
      return !E.constructor || !E.constructor.name ? d : E.constructor.name;
    }
    return p.checkPropTypes = i, p.resetWarningCache = i.resetWarningCache, p.PropTypes = p, p;
  }, Dl;
}
var Ll, db;
function DI() {
  if (db) return Ll;
  db = 1;
  var e = /* @__PURE__ */ $p();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, Ll = function() {
    function n(o, u, s, c, l, f) {
      if (f !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    n.isRequired = n;
    function i() {
      return n;
    }
    var a = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: i,
      element: n,
      elementType: n,
      instanceOf: i,
      node: n,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, Ll;
}
var pb;
function LI() {
  if (pb) return sa.exports;
  if (pb = 1, process.env.NODE_ENV !== "production") {
    var e = MO(), t = !0;
    sa.exports = /* @__PURE__ */ RI()(e.isElement, t);
  } else
    sa.exports = /* @__PURE__ */ DI()();
  return sa.exports;
}
var qI = /* @__PURE__ */ LI();
const he = /* @__PURE__ */ ye(qI);
var BI = Object.getOwnPropertyNames, FI = Object.getOwnPropertySymbols, zI = Object.prototype.hasOwnProperty;
function hb(e, t) {
  return function(n, i, a) {
    return e(n, i, a) && t(n, i, a);
  };
}
function la(e) {
  return function(r, n, i) {
    if (!r || !n || typeof r != "object" || typeof n != "object")
      return e(r, n, i);
    var a = i.cache, o = a.get(r), u = a.get(n);
    if (o && u)
      return o === n && u === r;
    a.set(r, n), a.set(n, r);
    var s = e(r, n, i);
    return a.delete(r), a.delete(n), s;
  };
}
function vb(e) {
  return BI(e).concat(FI(e));
}
var WI = Object.hasOwn || function(e, t) {
  return zI.call(e, t);
};
function kr(e, t) {
  return e === t || !e && !t && e !== e && t !== t;
}
var UI = "__v", KI = "__o", HI = "_owner", yb = Object.getOwnPropertyDescriptor, mb = Object.keys;
function GI(e, t, r) {
  var n = e.length;
  if (t.length !== n)
    return !1;
  for (; n-- > 0; )
    if (!r.equals(e[n], t[n], n, n, e, t, r))
      return !1;
  return !0;
}
function VI(e, t) {
  return kr(e.getTime(), t.getTime());
}
function YI(e, t) {
  return e.name === t.name && e.message === t.message && e.cause === t.cause && e.stack === t.stack;
}
function XI(e, t) {
  return e === t;
}
function gb(e, t, r) {
  var n = e.size;
  if (n !== t.size)
    return !1;
  if (!n)
    return !0;
  for (var i = new Array(n), a = e.entries(), o, u, s = 0; (o = a.next()) && !o.done; ) {
    for (var c = t.entries(), l = !1, f = 0; (u = c.next()) && !u.done; ) {
      if (i[f]) {
        f++;
        continue;
      }
      var d = o.value, p = u.value;
      if (r.equals(d[0], p[0], s, f, e, t, r) && r.equals(d[1], p[1], d[0], p[0], e, t, r)) {
        l = i[f] = !0;
        break;
      }
      f++;
    }
    if (!l)
      return !1;
    s++;
  }
  return !0;
}
var ZI = kr;
function JI(e, t, r) {
  var n = mb(e), i = n.length;
  if (mb(t).length !== i)
    return !1;
  for (; i-- > 0; )
    if (!IO(e, t, r, n[i]))
      return !1;
  return !0;
}
function Hn(e, t, r) {
  var n = vb(e), i = n.length;
  if (vb(t).length !== i)
    return !1;
  for (var a, o, u; i-- > 0; )
    if (a = n[i], !IO(e, t, r, a) || (o = yb(e, a), u = yb(t, a), (o || u) && (!o || !u || o.configurable !== u.configurable || o.enumerable !== u.enumerable || o.writable !== u.writable)))
      return !1;
  return !0;
}
function QI(e, t) {
  return kr(e.valueOf(), t.valueOf());
}
function eN(e, t) {
  return e.source === t.source && e.flags === t.flags;
}
function bb(e, t, r) {
  var n = e.size;
  if (n !== t.size)
    return !1;
  if (!n)
    return !0;
  for (var i = new Array(n), a = e.values(), o, u; (o = a.next()) && !o.done; ) {
    for (var s = t.values(), c = !1, l = 0; (u = s.next()) && !u.done; ) {
      if (!i[l] && r.equals(o.value, u.value, o.value, u.value, e, t, r)) {
        c = i[l] = !0;
        break;
      }
      l++;
    }
    if (!c)
      return !1;
  }
  return !0;
}
function tN(e, t) {
  var r = e.length;
  if (t.length !== r)
    return !1;
  for (; r-- > 0; )
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function rN(e, t) {
  return e.hostname === t.hostname && e.pathname === t.pathname && e.protocol === t.protocol && e.port === t.port && e.hash === t.hash && e.username === t.username && e.password === t.password;
}
function IO(e, t, r, n) {
  return (n === HI || n === KI || n === UI) && (e.$$typeof || t.$$typeof) ? !0 : WI(t, n) && r.equals(e[n], t[n], n, n, e, t, r);
}
var nN = "[object Arguments]", iN = "[object Boolean]", aN = "[object Date]", oN = "[object Error]", uN = "[object Map]", sN = "[object Number]", cN = "[object Object]", lN = "[object RegExp]", fN = "[object Set]", dN = "[object String]", pN = "[object URL]", hN = Array.isArray, xb = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, wb = Object.assign, vN = Object.prototype.toString.call.bind(Object.prototype.toString);
function yN(e) {
  var t = e.areArraysEqual, r = e.areDatesEqual, n = e.areErrorsEqual, i = e.areFunctionsEqual, a = e.areMapsEqual, o = e.areNumbersEqual, u = e.areObjectsEqual, s = e.arePrimitiveWrappersEqual, c = e.areRegExpsEqual, l = e.areSetsEqual, f = e.areTypedArraysEqual, d = e.areUrlsEqual;
  return function(y, v, h) {
    if (y === v)
      return !0;
    if (y == null || v == null)
      return !1;
    var x = typeof y;
    if (x !== typeof v)
      return !1;
    if (x !== "object")
      return x === "number" ? o(y, v, h) : x === "function" ? i(y, v, h) : !1;
    var g = y.constructor;
    if (g !== v.constructor)
      return !1;
    if (g === Object)
      return u(y, v, h);
    if (hN(y))
      return t(y, v, h);
    if (xb != null && xb(y))
      return f(y, v, h);
    if (g === Date)
      return r(y, v, h);
    if (g === RegExp)
      return c(y, v, h);
    if (g === Map)
      return a(y, v, h);
    if (g === Set)
      return l(y, v, h);
    var b = vN(y);
    return b === aN ? r(y, v, h) : b === lN ? c(y, v, h) : b === uN ? a(y, v, h) : b === fN ? l(y, v, h) : b === cN ? typeof y.then != "function" && typeof v.then != "function" && u(y, v, h) : b === pN ? d(y, v, h) : b === oN ? n(y, v, h) : b === nN ? u(y, v, h) : b === iN || b === sN || b === dN ? s(y, v, h) : !1;
  };
}
function mN(e) {
  var t = e.circular, r = e.createCustomConfig, n = e.strict, i = {
    areArraysEqual: n ? Hn : GI,
    areDatesEqual: VI,
    areErrorsEqual: YI,
    areFunctionsEqual: XI,
    areMapsEqual: n ? hb(gb, Hn) : gb,
    areNumbersEqual: ZI,
    areObjectsEqual: n ? Hn : JI,
    arePrimitiveWrappersEqual: QI,
    areRegExpsEqual: eN,
    areSetsEqual: n ? hb(bb, Hn) : bb,
    areTypedArraysEqual: n ? Hn : tN,
    areUrlsEqual: rN
  };
  if (r && (i = wb({}, i, r(i))), t) {
    var a = la(i.areArraysEqual), o = la(i.areMapsEqual), u = la(i.areObjectsEqual), s = la(i.areSetsEqual);
    i = wb({}, i, {
      areArraysEqual: a,
      areMapsEqual: o,
      areObjectsEqual: u,
      areSetsEqual: s
    });
  }
  return i;
}
function gN(e) {
  return function(t, r, n, i, a, o, u) {
    return e(t, r, u);
  };
}
function bN(e) {
  var t = e.circular, r = e.comparator, n = e.createState, i = e.equals, a = e.strict;
  if (n)
    return function(s, c) {
      var l = n(), f = l.cache, d = f === void 0 ? t ? /* @__PURE__ */ new WeakMap() : void 0 : f, p = l.meta;
      return r(s, c, {
        cache: d,
        equals: i,
        meta: p,
        strict: a
      });
    };
  if (t)
    return function(s, c) {
      return r(s, c, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: i,
        meta: void 0,
        strict: a
      });
    };
  var o = {
    cache: void 0,
    equals: i,
    meta: void 0,
    strict: a
  };
  return function(s, c) {
    return r(s, c, o);
  };
}
var xN = lr();
lr({ strict: !0 });
lr({ circular: !0 });
lr({
  circular: !0,
  strict: !0
});
lr({
  createInternalComparator: function() {
    return kr;
  }
});
lr({
  strict: !0,
  createInternalComparator: function() {
    return kr;
  }
});
lr({
  circular: !0,
  createInternalComparator: function() {
    return kr;
  }
});
lr({
  circular: !0,
  createInternalComparator: function() {
    return kr;
  },
  strict: !0
});
function lr(e) {
  e === void 0 && (e = {});
  var t = e.circular, r = t === void 0 ? !1 : t, n = e.createInternalComparator, i = e.createState, a = e.strict, o = a === void 0 ? !1 : a, u = mN(e), s = yN(u), c = n ? n(s) : gN(s);
  return bN({ circular: r, comparator: s, createState: i, equals: c, strict: o });
}
function wN(e) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
}
function Ob(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = -1, n = function i(a) {
    r < 0 && (r = a), a - r > t ? (e(a), r = -1) : wN(i);
  };
  requestAnimationFrame(n);
}
function Jf(e) {
  "@babel/helpers - typeof";
  return Jf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Jf(e);
}
function ON(e) {
  return PN(e) || SN(e) || AN(e) || _N();
}
function _N() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function AN(e, t) {
  if (e) {
    if (typeof e == "string") return _b(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return _b(e, t);
  }
}
function _b(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function SN(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function PN(e) {
  if (Array.isArray(e)) return e;
}
function EN() {
  var e = {}, t = function() {
    return null;
  }, r = !1, n = function i(a) {
    if (!r) {
      if (Array.isArray(a)) {
        if (!a.length)
          return;
        var o = a, u = ON(o), s = u[0], c = u.slice(1);
        if (typeof s == "number") {
          Ob(i.bind(null, c), s);
          return;
        }
        i(s), Ob(i.bind(null, c));
        return;
      }
      Jf(a) === "object" && (e = a, t(e)), typeof a == "function" && a();
    }
  };
  return {
    stop: function() {
      r = !0;
    },
    start: function(a) {
      r = !1, n(a);
    },
    subscribe: function(a) {
      return t = a, function() {
        t = function() {
          return null;
        };
      };
    }
  };
}
function ji(e) {
  "@babel/helpers - typeof";
  return ji = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ji(e);
}
function Ab(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Sb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ab(Object(r), !0).forEach(function(n) {
      NO(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ab(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function NO(e, t, r) {
  return t = jN(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function jN(e) {
  var t = TN(e, "string");
  return ji(t) === "symbol" ? t : String(t);
}
function TN(e, t) {
  if (ji(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ji(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var $N = function(t, r) {
  return [Object.keys(t), Object.keys(r)].reduce(function(n, i) {
    return n.filter(function(a) {
      return i.includes(a);
    });
  });
}, MN = function(t) {
  return t;
}, CN = function(t) {
  return t.replace(/([A-Z])/g, function(r) {
    return "-".concat(r.toLowerCase());
  });
}, ei = function(t, r) {
  return Object.keys(r).reduce(function(n, i) {
    return Sb(Sb({}, n), {}, NO({}, i, t(i, r[i])));
  }, {});
}, Pb = function(t, r, n) {
  return t.map(function(i) {
    return "".concat(CN(i), " ").concat(r, "ms ").concat(n);
  }).join(",");
}, IN = process.env.NODE_ENV !== "production", Wa = function(t, r, n, i, a, o, u, s) {
  if (IN && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
    if (r === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var c = [n, i, a, o, u, s], l = 0;
      console.warn(r.replace(/%s/g, function() {
        return c[l++];
      }));
    }
};
function NN(e, t) {
  return DN(e) || RN(e, t) || kO(e, t) || kN();
}
function kN() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function RN(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], s = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(s = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function DN(e) {
  if (Array.isArray(e)) return e;
}
function LN(e) {
  return FN(e) || BN(e) || kO(e) || qN();
}
function qN() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kO(e, t) {
  if (e) {
    if (typeof e == "string") return Qf(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Qf(e, t);
  }
}
function BN(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function FN(e) {
  if (Array.isArray(e)) return Qf(e);
}
function Qf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var Ua = 1e-4, RO = function(t, r) {
  return [0, 3 * t, 3 * r - 6 * t, 3 * t - 3 * r + 1];
}, DO = function(t, r) {
  return t.map(function(n, i) {
    return n * Math.pow(r, i);
  }).reduce(function(n, i) {
    return n + i;
  });
}, Eb = function(t, r) {
  return function(n) {
    var i = RO(t, r);
    return DO(i, n);
  };
}, zN = function(t, r) {
  return function(n) {
    var i = RO(t, r), a = [].concat(LN(i.map(function(o, u) {
      return o * u;
    }).slice(1)), [0]);
    return DO(a, n);
  };
}, jb = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var i = r[0], a = r[1], o = r[2], u = r[3];
  if (r.length === 1)
    switch (r[0]) {
      case "linear":
        i = 0, a = 0, o = 1, u = 1;
        break;
      case "ease":
        i = 0.25, a = 0.1, o = 0.25, u = 1;
        break;
      case "ease-in":
        i = 0.42, a = 0, o = 1, u = 1;
        break;
      case "ease-out":
        i = 0.42, a = 0, o = 0.58, u = 1;
        break;
      case "ease-in-out":
        i = 0, a = 0, o = 0.58, u = 1;
        break;
      default: {
        var s = r[0].split("(");
        if (s[0] === "cubic-bezier" && s[1].split(")")[0].split(",").length === 4) {
          var c = s[1].split(")")[0].split(",").map(function(h) {
            return parseFloat(h);
          }), l = NN(c, 4);
          i = l[0], a = l[1], o = l[2], u = l[3];
        } else
          Wa(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", r);
      }
    }
  Wa([i, o, a, u].every(function(h) {
    return typeof h == "number" && h >= 0 && h <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", r);
  var f = Eb(i, o), d = Eb(a, u), p = zN(i, o), y = function(x) {
    return x > 1 ? 1 : x < 0 ? 0 : x;
  }, v = function(x) {
    for (var g = x > 1 ? 1 : x, b = g, O = 0; O < 8; ++O) {
      var m = f(b) - g, w = p(b);
      if (Math.abs(m - g) < Ua || w < Ua)
        return d(b);
      b = y(b - m / w);
    }
    return d(b);
  };
  return v.isStepper = !1, v;
}, WN = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.stiff, n = r === void 0 ? 100 : r, i = t.damping, a = i === void 0 ? 8 : i, o = t.dt, u = o === void 0 ? 17 : o, s = function(l, f, d) {
    var p = -(l - f) * n, y = d * a, v = d + (p - y) * u / 1e3, h = d * u / 1e3 + l;
    return Math.abs(h - f) < Ua && Math.abs(v) < Ua ? [f, 0] : [h, v];
  };
  return s.isStepper = !0, s.dt = u, s;
}, UN = function() {
  for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  var i = r[0];
  if (typeof i == "string")
    switch (i) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return jb(i);
      case "spring":
        return WN();
      default:
        if (i.split("(")[0] === "cubic-bezier")
          return jb(i);
        Wa(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", r);
    }
  return typeof i == "function" ? i : (Wa(!1, "[configEasing]: first argument type should be function or string, instead received %s", r), null);
};
function Ti(e) {
  "@babel/helpers - typeof";
  return Ti = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ti(e);
}
function Tb(e) {
  return GN(e) || HN(e) || LO(e) || KN();
}
function KN() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function HN(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function GN(e) {
  if (Array.isArray(e)) return td(e);
}
function $b(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function qe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $b(Object(r), !0).forEach(function(n) {
      ed(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : $b(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ed(e, t, r) {
  return t = VN(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function VN(e) {
  var t = YN(e, "string");
  return Ti(t) === "symbol" ? t : String(t);
}
function YN(e, t) {
  if (Ti(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ti(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function XN(e, t) {
  return QN(e) || JN(e, t) || LO(e, t) || ZN();
}
function ZN() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function LO(e, t) {
  if (e) {
    if (typeof e == "string") return td(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return td(e, t);
  }
}
function td(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function JN(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], s = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(s = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function QN(e) {
  if (Array.isArray(e)) return e;
}
var Ka = function(t, r, n) {
  return t + (r - t) * n;
}, rd = function(t) {
  var r = t.from, n = t.to;
  return r !== n;
}, ek = function e(t, r, n) {
  var i = ei(function(a, o) {
    if (rd(o)) {
      var u = t(o.from, o.to, o.velocity), s = XN(u, 2), c = s[0], l = s[1];
      return qe(qe({}, o), {}, {
        from: c,
        velocity: l
      });
    }
    return o;
  }, r);
  return n < 1 ? ei(function(a, o) {
    return rd(o) ? qe(qe({}, o), {}, {
      velocity: Ka(o.velocity, i[a].velocity, n),
      from: Ka(o.from, i[a].from, n)
    }) : o;
  }, r) : e(t, i, n - 1);
};
const tk = function(e, t, r, n, i) {
  var a = $N(e, t), o = a.reduce(function(h, x) {
    return qe(qe({}, h), {}, ed({}, x, [e[x], t[x]]));
  }, {}), u = a.reduce(function(h, x) {
    return qe(qe({}, h), {}, ed({}, x, {
      from: e[x],
      velocity: 0,
      to: t[x]
    }));
  }, {}), s = -1, c, l, f = function() {
    return null;
  }, d = function() {
    return ei(function(x, g) {
      return g.from;
    }, u);
  }, p = function() {
    return !Object.values(u).filter(rd).length;
  }, y = function(x) {
    c || (c = x);
    var g = x - c, b = g / r.dt;
    u = ek(r, u, b), i(qe(qe(qe({}, e), t), d())), c = x, p() || (s = requestAnimationFrame(f));
  }, v = function(x) {
    l || (l = x);
    var g = (x - l) / n, b = ei(function(m, w) {
      return Ka.apply(void 0, Tb(w).concat([r(g)]));
    }, o);
    if (i(qe(qe(qe({}, e), t), b)), g < 1)
      s = requestAnimationFrame(f);
    else {
      var O = ei(function(m, w) {
        return Ka.apply(void 0, Tb(w).concat([r(1)]));
      }, o);
      i(qe(qe(qe({}, e), t), O));
    }
  };
  return f = r.isStepper ? y : v, function() {
    return requestAnimationFrame(f), function() {
      cancelAnimationFrame(s);
    };
  };
};
function un(e) {
  "@babel/helpers - typeof";
  return un = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, un(e);
}
var rk = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function nk(e, t) {
  if (e == null) return {};
  var r = ik(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function ik(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), i, a;
  for (a = 0; a < n.length; a++)
    i = n[a], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
  return r;
}
function ql(e) {
  return sk(e) || uk(e) || ok(e) || ak();
}
function ak() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ok(e, t) {
  if (e) {
    if (typeof e == "string") return nd(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return nd(e, t);
  }
}
function uk(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function sk(e) {
  if (Array.isArray(e)) return nd(e);
}
function nd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function Mb(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function vt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Mb(Object(r), !0).forEach(function(n) {
      Xn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Mb(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Xn(e, t, r) {
  return t = qO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function ck(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function lk(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, qO(n.key), n);
  }
}
function fk(e, t, r) {
  return t && lk(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function qO(e) {
  var t = dk(e, "string");
  return un(t) === "symbol" ? t : String(t);
}
function dk(e, t) {
  if (un(e) !== "object" || e === null) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (un(n) !== "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function pk(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && id(e, t);
}
function id(e, t) {
  return id = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, id(e, t);
}
function hk(e) {
  var t = vk();
  return function() {
    var n = Ha(e), i;
    if (t) {
      var a = Ha(this).constructor;
      i = Reflect.construct(n, arguments, a);
    } else
      i = n.apply(this, arguments);
    return ad(this, i);
  };
}
function ad(e, t) {
  if (t && (un(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return od(e);
}
function od(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function vk() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Ha(e) {
  return Ha = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ha(e);
}
var pt = /* @__PURE__ */ function(e) {
  pk(r, e);
  var t = hk(r);
  function r(n, i) {
    var a;
    ck(this, r), a = t.call(this, n, i);
    var o = a.props, u = o.isActive, s = o.attributeName, c = o.from, l = o.to, f = o.steps, d = o.children, p = o.duration;
    if (a.handleStyleChange = a.handleStyleChange.bind(od(a)), a.changeStyle = a.changeStyle.bind(od(a)), !u || p <= 0)
      return a.state = {
        style: {}
      }, typeof d == "function" && (a.state = {
        style: l
      }), ad(a);
    if (f && f.length)
      a.state = {
        style: f[0].style
      };
    else if (c) {
      if (typeof d == "function")
        return a.state = {
          style: c
        }, ad(a);
      a.state = {
        style: s ? Xn({}, s, c) : c
      };
    } else
      a.state = {
        style: {}
      };
    return a;
  }
  return fk(r, [{
    key: "componentDidMount",
    value: function() {
      var i = this.props, a = i.isActive, o = i.canBegin;
      this.mounted = !0, !(!a || !o) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      var a = this.props, o = a.isActive, u = a.canBegin, s = a.attributeName, c = a.shouldReAnimate, l = a.to, f = a.from, d = this.state.style;
      if (u) {
        if (!o) {
          var p = {
            style: s ? Xn({}, s, l) : l
          };
          this.state && d && (s && d[s] !== l || !s && d !== l) && this.setState(p);
          return;
        }
        if (!(xN(i.to, l) && i.canBegin && i.isActive)) {
          var y = !i.canBegin || !i.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var v = y || c ? f : i.to;
          if (this.state && d) {
            var h = {
              style: s ? Xn({}, s, v) : v
            };
            (s && d[s] !== v || !s && d !== v) && this.setState(h);
          }
          this.runAnimation(vt(vt({}, this.props), {}, {
            from: v,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var i = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), i && i();
    }
  }, {
    key: "handleStyleChange",
    value: function(i) {
      this.changeStyle(i);
    }
  }, {
    key: "changeStyle",
    value: function(i) {
      this.mounted && this.setState({
        style: i
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(i) {
      var a = this, o = i.from, u = i.to, s = i.duration, c = i.easing, l = i.begin, f = i.onAnimationEnd, d = i.onAnimationStart, p = tk(o, u, UN(c), s, this.changeStyle), y = function() {
        a.stopJSAnimation = p();
      };
      this.manager.start([d, l, y, s, f]);
    }
  }, {
    key: "runStepAnimation",
    value: function(i) {
      var a = this, o = i.steps, u = i.begin, s = i.onAnimationStart, c = o[0], l = c.style, f = c.duration, d = f === void 0 ? 0 : f, p = function(v, h, x) {
        if (x === 0)
          return v;
        var g = h.duration, b = h.easing, O = b === void 0 ? "ease" : b, m = h.style, w = h.properties, _ = h.onAnimationEnd, P = x > 0 ? o[x - 1] : h, T = w || Object.keys(m);
        if (typeof O == "function" || O === "spring")
          return [].concat(ql(v), [a.runJSAnimation.bind(a, {
            from: P.style,
            to: m,
            duration: g,
            easing: O
          }), g]);
        var M = Pb(T, g, O), j = vt(vt(vt({}, P.style), m), {}, {
          transition: M
        });
        return [].concat(ql(v), [j, g, _]).filter(MN);
      };
      return this.manager.start([s].concat(ql(o.reduce(p, [l, Math.max(d, u)])), [i.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(i) {
      this.manager || (this.manager = EN());
      var a = i.begin, o = i.duration, u = i.attributeName, s = i.to, c = i.easing, l = i.onAnimationStart, f = i.onAnimationEnd, d = i.steps, p = i.children, y = this.manager;
      if (this.unSubscribe = y.subscribe(this.handleStyleChange), typeof c == "function" || typeof p == "function" || c === "spring") {
        this.runJSAnimation(i);
        return;
      }
      if (d.length > 1) {
        this.runStepAnimation(i);
        return;
      }
      var v = u ? Xn({}, u, s) : s, h = Pb(Object.keys(v), o, c);
      y.start([l, a, vt(vt({}, v), {}, {
        transition: h
      }), o, f]);
    }
  }, {
    key: "render",
    value: function() {
      var i = this.props, a = i.children;
      i.begin;
      var o = i.duration;
      i.attributeName, i.easing;
      var u = i.isActive;
      i.steps, i.from, i.to, i.canBegin, i.onAnimationEnd, i.shouldReAnimate, i.onAnimationReStart;
      var s = nk(i, rk), c = _r.count(a), l = this.state.style;
      if (typeof a == "function")
        return a(l);
      if (!u || c === 0 || o <= 0)
        return a;
      var f = function(p) {
        var y = p.props, v = y.style, h = v === void 0 ? {} : v, x = y.className, g = /* @__PURE__ */ Ce(p, vt(vt({}, s), {}, {
          style: vt(vt({}, h), l),
          className: x
        }));
        return g;
      };
      return c === 1 ? f(_r.only(a)) : /* @__PURE__ */ S.createElement("div", null, _r.map(a, function(d) {
        return f(d);
      }));
    }
  }]), r;
}(tt);
pt.displayName = "Animate";
pt.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
pt.propTypes = {
  from: he.oneOfType([he.object, he.string]),
  to: he.oneOfType([he.object, he.string]),
  attributeName: he.string,
  // animation duration
  duration: he.number,
  begin: he.number,
  easing: he.oneOfType([he.string, he.func]),
  steps: he.arrayOf(he.shape({
    duration: he.number.isRequired,
    style: he.object.isRequired,
    easing: he.oneOfType([he.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), he.func]),
    // transition css properties(dash case), optional
    properties: he.arrayOf("string"),
    onAnimationEnd: he.func
  })),
  children: he.oneOfType([he.node, he.func]),
  isActive: he.bool,
  canBegin: he.bool,
  onAnimationEnd: he.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: he.bool,
  onAnimationStart: he.func,
  onAnimationReStart: he.func
};
function $i(e) {
  "@babel/helpers - typeof";
  return $i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $i(e);
}
function Ga() {
  return Ga = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ga.apply(this, arguments);
}
function yk(e, t) {
  return xk(e) || bk(e, t) || gk(e, t) || mk();
}
function mk() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function gk(e, t) {
  if (e) {
    if (typeof e == "string") return Cb(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Cb(e, t);
  }
}
function Cb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function bk(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], s = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(s = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function xk(e) {
  if (Array.isArray(e)) return e;
}
function Ib(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Nb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ib(Object(r), !0).forEach(function(n) {
      wk(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ib(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function wk(e, t, r) {
  return t = Ok(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Ok(e) {
  var t = _k(e, "string");
  return $i(t) == "symbol" ? t : t + "";
}
function _k(e, t) {
  if ($i(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if ($i(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var kb = function(t, r, n, i, a) {
  var o = Math.min(Math.abs(n) / 2, Math.abs(i) / 2), u = i >= 0 ? 1 : -1, s = n >= 0 ? 1 : -1, c = i >= 0 && n >= 0 || i < 0 && n < 0 ? 1 : 0, l;
  if (o > 0 && a instanceof Array) {
    for (var f = [0, 0, 0, 0], d = 0, p = 4; d < p; d++)
      f[d] = a[d] > o ? o : a[d];
    l = "M".concat(t, ",").concat(r + u * f[0]), f[0] > 0 && (l += "A ".concat(f[0], ",").concat(f[0], ",0,0,").concat(c, ",").concat(t + s * f[0], ",").concat(r)), l += "L ".concat(t + n - s * f[1], ",").concat(r), f[1] > 0 && (l += "A ".concat(f[1], ",").concat(f[1], ",0,0,").concat(c, `,
        `).concat(t + n, ",").concat(r + u * f[1])), l += "L ".concat(t + n, ",").concat(r + i - u * f[2]), f[2] > 0 && (l += "A ".concat(f[2], ",").concat(f[2], ",0,0,").concat(c, `,
        `).concat(t + n - s * f[2], ",").concat(r + i)), l += "L ".concat(t + s * f[3], ",").concat(r + i), f[3] > 0 && (l += "A ".concat(f[3], ",").concat(f[3], ",0,0,").concat(c, `,
        `).concat(t, ",").concat(r + i - u * f[3])), l += "Z";
  } else if (o > 0 && a === +a && a > 0) {
    var y = Math.min(o, a);
    l = "M ".concat(t, ",").concat(r + u * y, `
            A `).concat(y, ",").concat(y, ",0,0,").concat(c, ",").concat(t + s * y, ",").concat(r, `
            L `).concat(t + n - s * y, ",").concat(r, `
            A `).concat(y, ",").concat(y, ",0,0,").concat(c, ",").concat(t + n, ",").concat(r + u * y, `
            L `).concat(t + n, ",").concat(r + i - u * y, `
            A `).concat(y, ",").concat(y, ",0,0,").concat(c, ",").concat(t + n - s * y, ",").concat(r + i, `
            L `).concat(t + s * y, ",").concat(r + i, `
            A `).concat(y, ",").concat(y, ",0,0,").concat(c, ",").concat(t, ",").concat(r + i - u * y, " Z");
  } else
    l = "M ".concat(t, ",").concat(r, " h ").concat(n, " v ").concat(i, " h ").concat(-n, " Z");
  return l;
}, Ak = function(t, r) {
  if (!t || !r)
    return !1;
  var n = t.x, i = t.y, a = r.x, o = r.y, u = r.width, s = r.height;
  if (Math.abs(u) > 0 && Math.abs(s) > 0) {
    var c = Math.min(a, a + u), l = Math.max(a, a + u), f = Math.min(o, o + s), d = Math.max(o, o + s);
    return n >= c && n <= l && i >= f && i <= d;
  }
  return !1;
}, Sk = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Mp = function(t) {
  var r = Nb(Nb({}, Sk), t), n = ha(), i = Pr(-1), a = yk(i, 2), o = a[0], u = a[1];
  bo(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var O = n.current.getTotalLength();
        O && u(O);
      } catch {
      }
  }, []);
  var s = r.x, c = r.y, l = r.width, f = r.height, d = r.radius, p = r.className, y = r.animationEasing, v = r.animationDuration, h = r.animationBegin, x = r.isAnimationActive, g = r.isUpdateAnimationActive;
  if (s !== +s || c !== +c || l !== +l || f !== +f || l === 0 || f === 0)
    return null;
  var b = ae("recharts-rectangle", p);
  return g ? /* @__PURE__ */ S.createElement(pt, {
    canBegin: o > 0,
    from: {
      width: l,
      height: f,
      x: s,
      y: c
    },
    to: {
      width: l,
      height: f,
      x: s,
      y: c
    },
    duration: v,
    animationEasing: y,
    isActive: g
  }, function(O) {
    var m = O.width, w = O.height, _ = O.x, P = O.y;
    return /* @__PURE__ */ S.createElement(pt, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: h,
      duration: v,
      isActive: x,
      easing: y
    }, /* @__PURE__ */ S.createElement("path", Ga({}, J(r, !0), {
      className: b,
      d: kb(_, P, m, w, d),
      ref: n
    })));
  }) : /* @__PURE__ */ S.createElement("path", Ga({}, J(r, !0), {
    className: b,
    d: kb(s, c, l, f, d)
  }));
}, Pk = ["points", "className", "baseLinePoints", "connectNulls"];
function Wr() {
  return Wr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Wr.apply(this, arguments);
}
function Ek(e, t) {
  if (e == null) return {};
  var r = jk(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function jk(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Rb(e) {
  return Ck(e) || Mk(e) || $k(e) || Tk();
}
function Tk() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function $k(e, t) {
  if (e) {
    if (typeof e == "string") return ud(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ud(e, t);
  }
}
function Mk(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Ck(e) {
  if (Array.isArray(e)) return ud(e);
}
function ud(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var Db = function(t) {
  return t && t.x === +t.x && t.y === +t.y;
}, Ik = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], r = [[]];
  return t.forEach(function(n) {
    Db(n) ? r[r.length - 1].push(n) : r[r.length - 1].length > 0 && r.push([]);
  }), Db(t[0]) && r[r.length - 1].push(t[0]), r[r.length - 1].length <= 0 && (r = r.slice(0, -1)), r;
}, ti = function(t, r) {
  var n = Ik(t);
  r && (n = [n.reduce(function(a, o) {
    return [].concat(Rb(a), Rb(o));
  }, [])]);
  var i = n.map(function(a) {
    return a.reduce(function(o, u, s) {
      return "".concat(o).concat(s === 0 ? "M" : "L").concat(u.x, ",").concat(u.y);
    }, "");
  }).join("");
  return n.length === 1 ? "".concat(i, "Z") : i;
}, Nk = function(t, r, n) {
  var i = ti(t, n);
  return "".concat(i.slice(-1) === "Z" ? i.slice(0, -1) : i, "L").concat(ti(r.reverse(), n).slice(1));
}, kk = function(t) {
  var r = t.points, n = t.className, i = t.baseLinePoints, a = t.connectNulls, o = Ek(t, Pk);
  if (!r || !r.length)
    return null;
  var u = ae("recharts-polygon", n);
  if (i && i.length) {
    var s = o.stroke && o.stroke !== "none", c = Nk(r, i, a);
    return /* @__PURE__ */ S.createElement("g", {
      className: u
    }, /* @__PURE__ */ S.createElement("path", Wr({}, J(o, !0), {
      fill: c.slice(-1) === "Z" ? o.fill : "none",
      stroke: "none",
      d: c
    })), s ? /* @__PURE__ */ S.createElement("path", Wr({}, J(o, !0), {
      fill: "none",
      d: ti(r, a)
    })) : null, s ? /* @__PURE__ */ S.createElement("path", Wr({}, J(o, !0), {
      fill: "none",
      d: ti(i, a)
    })) : null);
  }
  var l = ti(r, a);
  return /* @__PURE__ */ S.createElement("path", Wr({}, J(o, !0), {
    fill: l.slice(-1) === "Z" ? o.fill : "none",
    className: u,
    d: l
  }));
};
function sd() {
  return sd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, sd.apply(this, arguments);
}
var Hi = function(t) {
  var r = t.cx, n = t.cy, i = t.r, a = t.className, o = ae("recharts-dot", a);
  return r === +r && n === +n && i === +i ? /* @__PURE__ */ ft.createElement("circle", sd({}, J(t, !1), ya(t), {
    className: o,
    cx: r,
    cy: n,
    r: i
  })) : null;
};
function Mi(e) {
  "@babel/helpers - typeof";
  return Mi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mi(e);
}
var Rk = ["x", "y", "top", "left", "width", "height", "className"];
function cd() {
  return cd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, cd.apply(this, arguments);
}
function Lb(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Dk(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Lb(Object(r), !0).forEach(function(n) {
      Lk(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Lb(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Lk(e, t, r) {
  return t = qk(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function qk(e) {
  var t = Bk(e, "string");
  return Mi(t) == "symbol" ? t : t + "";
}
function Bk(e, t) {
  if (Mi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Mi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Fk(e, t) {
  if (e == null) return {};
  var r = zk(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function zk(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var Wk = function(t, r, n, i, a, o) {
  return "M".concat(t, ",").concat(a, "v").concat(i, "M").concat(o, ",").concat(r, "h").concat(n);
}, Uk = function(t) {
  var r = t.x, n = r === void 0 ? 0 : r, i = t.y, a = i === void 0 ? 0 : i, o = t.top, u = o === void 0 ? 0 : o, s = t.left, c = s === void 0 ? 0 : s, l = t.width, f = l === void 0 ? 0 : l, d = t.height, p = d === void 0 ? 0 : d, y = t.className, v = Fk(t, Rk), h = Dk({
    x: n,
    y: a,
    top: u,
    left: c,
    width: f,
    height: p
  }, v);
  return !U(n) || !U(a) || !U(f) || !U(p) || !U(u) || !U(c) ? null : /* @__PURE__ */ S.createElement("path", cd({}, J(h, !0), {
    className: ae("recharts-cross", y),
    d: Wk(n, a, f, p, u, c)
  }));
}, Bl, qb;
function Kk() {
  if (qb) return Bl;
  qb = 1;
  var e = qo(), t = Jw(), r = Tt();
  function n(i, a) {
    return i && i.length ? e(i, r(a, 2), t) : void 0;
  }
  return Bl = n, Bl;
}
var Hk = Kk();
const Gk = /* @__PURE__ */ ye(Hk);
var Fl, Bb;
function Vk() {
  if (Bb) return Fl;
  Bb = 1;
  var e = qo(), t = Tt(), r = Qw();
  function n(i, a) {
    return i && i.length ? e(i, t(a, 2), r) : void 0;
  }
  return Fl = n, Fl;
}
var Yk = Vk();
const Xk = /* @__PURE__ */ ye(Yk);
var Zk = ["cx", "cy", "angle", "ticks", "axisLine"], Jk = ["ticks", "tick", "angle", "tickFormatter", "stroke"];
function sn(e) {
  "@babel/helpers - typeof";
  return sn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, sn(e);
}
function ri() {
  return ri = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ri.apply(this, arguments);
}
function Fb(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function pr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Fb(Object(r), !0).forEach(function(n) {
      Wo(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Fb(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function zb(e, t) {
  if (e == null) return {};
  var r = Qk(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Qk(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function eR(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Wb(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, FO(n.key), n);
  }
}
function tR(e, t, r) {
  return t && Wb(e.prototype, t), r && Wb(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function rR(e, t, r) {
  return t = Va(t), nR(e, BO() ? Reflect.construct(t, r || [], Va(e).constructor) : t.apply(e, r));
}
function nR(e, t) {
  if (t && (sn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return iR(e);
}
function iR(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function BO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (BO = function() {
    return !!e;
  })();
}
function Va(e) {
  return Va = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Va(e);
}
function aR(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && ld(e, t);
}
function ld(e, t) {
  return ld = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, ld(e, t);
}
function Wo(e, t, r) {
  return t = FO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function FO(e) {
  var t = oR(e, "string");
  return sn(t) == "symbol" ? t : t + "";
}
function oR(e, t) {
  if (sn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (sn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Uo = /* @__PURE__ */ function(e) {
  function t() {
    return eR(this, t), rR(this, t, arguments);
  }
  return aR(t, e), tR(t, [{
    key: "getTickValueCoord",
    value: (
      /**
       * Calculate the coordinate of tick
       * @param  {Number} coordinate The radius of tick
       * @return {Object} (x, y)
       */
      function(n) {
        var i = n.coordinate, a = this.props, o = a.angle, u = a.cx, s = a.cy;
        return we(u, s, i, o);
      }
    )
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props.orientation, i;
      switch (n) {
        case "left":
          i = "end";
          break;
        case "right":
          i = "start";
          break;
        default:
          i = "middle";
          break;
      }
      return i;
    }
  }, {
    key: "getViewBox",
    value: function() {
      var n = this.props, i = n.cx, a = n.cy, o = n.angle, u = n.ticks, s = Gk(u, function(l) {
        return l.coordinate || 0;
      }), c = Xk(u, function(l) {
        return l.coordinate || 0;
      });
      return {
        cx: i,
        cy: a,
        startAngle: o,
        endAngle: o,
        innerRadius: c.coordinate || 0,
        outerRadius: s.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, i = n.cx, a = n.cy, o = n.angle, u = n.ticks, s = n.axisLine, c = zb(n, Zk), l = u.reduce(function(y, v) {
        return [Math.min(y[0], v.coordinate), Math.max(y[1], v.coordinate)];
      }, [1 / 0, -1 / 0]), f = we(i, a, l[0], o), d = we(i, a, l[1], o), p = pr(pr(pr({}, J(c, !1)), {}, {
        fill: "none"
      }, J(s, !1)), {}, {
        x1: f.x,
        y1: f.y,
        x2: d.x,
        y2: d.y
      });
      return /* @__PURE__ */ S.createElement("line", ri({
        className: "recharts-polar-radius-axis-line"
      }, p));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, i = this.props, a = i.ticks, o = i.tick, u = i.angle, s = i.tickFormatter, c = i.stroke, l = zb(i, Jk), f = this.getTickTextAnchor(), d = J(l, !1), p = J(o, !1), y = a.map(function(v, h) {
        var x = n.getTickValueCoord(v), g = pr(pr(pr(pr({
          textAnchor: f,
          transform: "rotate(".concat(90 - u, ", ").concat(x.x, ", ").concat(x.y, ")")
        }, d), {}, {
          stroke: "none",
          fill: c
        }, p), {}, {
          index: h
        }, x), {}, {
          payload: v
        });
        return /* @__PURE__ */ S.createElement(oe, ri({
          className: ae("recharts-polar-radius-axis-tick", EO(o)),
          key: "tick-".concat(v.coordinate)
        }, nr(n.props, v, h)), t.renderTickItem(o, g, s ? s(v.value, h) : v.value));
      });
      return /* @__PURE__ */ S.createElement(oe, {
        className: "recharts-polar-radius-axis-ticks"
      }, y);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, i = n.ticks, a = n.axisLine, o = n.tick;
      return !i || !i.length ? null : /* @__PURE__ */ S.createElement(oe, {
        className: ae("recharts-polar-radius-axis", this.props.className)
      }, a && this.renderAxisLine(), o && this.renderTicks(), Re.renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, i, a) {
      var o;
      return /* @__PURE__ */ S.isValidElement(n) ? o = /* @__PURE__ */ S.cloneElement(n, i) : re(n) ? o = n(i) : o = /* @__PURE__ */ S.createElement(jr, ri({}, i, {
        className: "recharts-polar-radius-axis-tick-value"
      }), a), o;
    }
  }]);
}(tt);
Wo(Uo, "displayName", "PolarRadiusAxis");
Wo(Uo, "axisType", "radiusAxis");
Wo(Uo, "defaultProps", {
  type: "number",
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: "right",
  stroke: "#ccc",
  axisLine: !0,
  tick: !0,
  tickCount: 5,
  allowDataOverflow: !1,
  scale: "auto",
  allowDuplicatedCategory: !0
});
function cn(e) {
  "@babel/helpers - typeof";
  return cn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, cn(e);
}
function mr() {
  return mr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, mr.apply(this, arguments);
}
function Ub(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function hr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ub(Object(r), !0).forEach(function(n) {
      Ko(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ub(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function uR(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Kb(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, WO(n.key), n);
  }
}
function sR(e, t, r) {
  return t && Kb(e.prototype, t), r && Kb(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function cR(e, t, r) {
  return t = Ya(t), lR(e, zO() ? Reflect.construct(t, r || [], Ya(e).constructor) : t.apply(e, r));
}
function lR(e, t) {
  if (t && (cn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return fR(e);
}
function fR(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function zO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (zO = function() {
    return !!e;
  })();
}
function Ya(e) {
  return Ya = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Ya(e);
}
function dR(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && fd(e, t);
}
function fd(e, t) {
  return fd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, fd(e, t);
}
function Ko(e, t, r) {
  return t = WO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function WO(e) {
  var t = pR(e, "string");
  return cn(t) == "symbol" ? t : t + "";
}
function pR(e, t) {
  if (cn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (cn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var hR = Math.PI / 180, Hb = 1e-5, Ho = /* @__PURE__ */ function(e) {
  function t() {
    return uR(this, t), cR(this, t, arguments);
  }
  return dR(t, e), sR(t, [{
    key: "getTickLineCoord",
    value: (
      /**
       * Calculate the coordinate of line endpoint
       * @param  {Object} data The Data if ticks
       * @return {Object} (x0, y0): The start point of text,
       *                  (x1, y1): The end point close to text,
       *                  (x2, y2): The end point close to axis
       */
      function(n) {
        var i = this.props, a = i.cx, o = i.cy, u = i.radius, s = i.orientation, c = i.tickSize, l = c || 8, f = we(a, o, u, n.coordinate), d = we(a, o, u + (s === "inner" ? -1 : 1) * l, n.coordinate);
        return {
          x1: f.x,
          y1: f.y,
          x2: d.x,
          y2: d.y
        };
      }
    )
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */
  }, {
    key: "getTickTextAnchor",
    value: function(n) {
      var i = this.props.orientation, a = Math.cos(-n.coordinate * hR), o;
      return a > Hb ? o = i === "outer" ? "start" : "end" : a < -Hb ? o = i === "outer" ? "end" : "start" : o = "middle", o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, i = n.cx, a = n.cy, o = n.radius, u = n.axisLine, s = n.axisLineType, c = hr(hr({}, J(this.props, !1)), {}, {
        fill: "none"
      }, J(u, !1));
      if (s === "circle")
        return /* @__PURE__ */ S.createElement(Hi, mr({
          className: "recharts-polar-angle-axis-line"
        }, c, {
          cx: i,
          cy: a,
          r: o
        }));
      var l = this.props.ticks, f = l.map(function(d) {
        return we(i, a, o, d.coordinate);
      });
      return /* @__PURE__ */ S.createElement(kk, mr({
        className: "recharts-polar-angle-axis-line"
      }, c, {
        points: f
      }));
    }
  }, {
    key: "renderTicks",
    value: function() {
      var n = this, i = this.props, a = i.ticks, o = i.tick, u = i.tickLine, s = i.tickFormatter, c = i.stroke, l = J(this.props, !1), f = J(o, !1), d = hr(hr({}, l), {}, {
        fill: "none"
      }, J(u, !1)), p = a.map(function(y, v) {
        var h = n.getTickLineCoord(y), x = n.getTickTextAnchor(y), g = hr(hr(hr({
          textAnchor: x
        }, l), {}, {
          stroke: "none",
          fill: c
        }, f), {}, {
          index: v,
          payload: y,
          x: h.x2,
          y: h.y2
        });
        return /* @__PURE__ */ S.createElement(oe, mr({
          className: ae("recharts-polar-angle-axis-tick", EO(o)),
          key: "tick-".concat(y.coordinate)
        }, nr(n.props, y, v)), u && /* @__PURE__ */ S.createElement("line", mr({
          className: "recharts-polar-angle-axis-tick-line"
        }, d, h)), o && t.renderTickItem(o, g, s ? s(y.value, v) : y.value));
      });
      return /* @__PURE__ */ S.createElement(oe, {
        className: "recharts-polar-angle-axis-ticks"
      }, p);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, i = n.ticks, a = n.radius, o = n.axisLine;
      return a <= 0 || !i || !i.length ? null : /* @__PURE__ */ S.createElement(oe, {
        className: ae("recharts-polar-angle-axis", this.props.className)
      }, o && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function(n, i, a) {
      var o;
      return /* @__PURE__ */ S.isValidElement(n) ? o = /* @__PURE__ */ S.cloneElement(n, i) : re(n) ? o = n(i) : o = /* @__PURE__ */ S.createElement(jr, mr({}, i, {
        className: "recharts-polar-angle-axis-tick-value"
      }), a), o;
    }
  }]);
}(tt);
Ko(Ho, "displayName", "PolarAngleAxis");
Ko(Ho, "axisType", "angleAxis");
Ko(Ho, "defaultProps", {
  type: "category",
  angleAxisId: 0,
  scale: "auto",
  cx: 0,
  cy: 0,
  orientation: "outer",
  axisLine: !0,
  tickLine: !0,
  tickSize: 8,
  tick: !0,
  hide: !1,
  allowDuplicatedCategory: !0
});
var zl, Gb;
function vR() {
  if (Gb) return zl;
  Gb = 1;
  var e = Zx(), t = e(Object.getPrototypeOf, Object);
  return zl = t, zl;
}
var Wl, Vb;
function yR() {
  if (Vb) return Wl;
  Vb = 1;
  var e = Wt(), t = vR(), r = Ut(), n = "[object Object]", i = Function.prototype, a = Object.prototype, o = i.toString, u = a.hasOwnProperty, s = o.call(Object);
  function c(l) {
    if (!r(l) || e(l) != n)
      return !1;
    var f = t(l);
    if (f === null)
      return !0;
    var d = u.call(f, "constructor") && f.constructor;
    return typeof d == "function" && d instanceof d && o.call(d) == s;
  }
  return Wl = c, Wl;
}
var mR = yR();
const gR = /* @__PURE__ */ ye(mR);
var Ul, Yb;
function bR() {
  if (Yb) return Ul;
  Yb = 1;
  var e = Wt(), t = Ut(), r = "[object Boolean]";
  function n(i) {
    return i === !0 || i === !1 || t(i) && e(i) == r;
  }
  return Ul = n, Ul;
}
var xR = bR();
const wR = /* @__PURE__ */ ye(xR);
function Ci(e) {
  "@babel/helpers - typeof";
  return Ci = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ci(e);
}
function Xa() {
  return Xa = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Xa.apply(this, arguments);
}
function OR(e, t) {
  return PR(e) || SR(e, t) || AR(e, t) || _R();
}
function _R() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function AR(e, t) {
  if (e) {
    if (typeof e == "string") return Xb(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Xb(e, t);
  }
}
function Xb(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function SR(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], s = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(s = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function PR(e) {
  if (Array.isArray(e)) return e;
}
function Zb(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Jb(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Zb(Object(r), !0).forEach(function(n) {
      ER(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Zb(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ER(e, t, r) {
  return t = jR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function jR(e) {
  var t = TR(e, "string");
  return Ci(t) == "symbol" ? t : t + "";
}
function TR(e, t) {
  if (Ci(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ci(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Qb = function(t, r, n, i, a) {
  var o = n - i, u;
  return u = "M ".concat(t, ",").concat(r), u += "L ".concat(t + n, ",").concat(r), u += "L ".concat(t + n - o / 2, ",").concat(r + a), u += "L ".concat(t + n - o / 2 - i, ",").concat(r + a), u += "L ".concat(t, ",").concat(r, " Z"), u;
}, $R = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, MR = function(t) {
  var r = Jb(Jb({}, $R), t), n = ha(), i = Pr(-1), a = OR(i, 2), o = a[0], u = a[1];
  bo(function() {
    if (n.current && n.current.getTotalLength)
      try {
        var b = n.current.getTotalLength();
        b && u(b);
      } catch {
      }
  }, []);
  var s = r.x, c = r.y, l = r.upperWidth, f = r.lowerWidth, d = r.height, p = r.className, y = r.animationEasing, v = r.animationDuration, h = r.animationBegin, x = r.isUpdateAnimationActive;
  if (s !== +s || c !== +c || l !== +l || f !== +f || d !== +d || l === 0 && f === 0 || d === 0)
    return null;
  var g = ae("recharts-trapezoid", p);
  return x ? /* @__PURE__ */ S.createElement(pt, {
    canBegin: o > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: d,
      x: s,
      y: c
    },
    to: {
      upperWidth: l,
      lowerWidth: f,
      height: d,
      x: s,
      y: c
    },
    duration: v,
    animationEasing: y,
    isActive: x
  }, function(b) {
    var O = b.upperWidth, m = b.lowerWidth, w = b.height, _ = b.x, P = b.y;
    return /* @__PURE__ */ S.createElement(pt, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: h,
      duration: v,
      easing: y
    }, /* @__PURE__ */ S.createElement("path", Xa({}, J(r, !0), {
      className: g,
      d: Qb(_, P, O, m, w),
      ref: n
    })));
  }) : /* @__PURE__ */ S.createElement("g", null, /* @__PURE__ */ S.createElement("path", Xa({}, J(r, !0), {
    className: g,
    d: Qb(s, c, l, f, d)
  })));
}, CR = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function Ii(e) {
  "@babel/helpers - typeof";
  return Ii = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ii(e);
}
function IR(e, t) {
  if (e == null) return {};
  var r = NR(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function NR(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function e0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Za(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? e0(Object(r), !0).forEach(function(n) {
      kR(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : e0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function kR(e, t, r) {
  return t = RR(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function RR(e) {
  var t = DR(e, "string");
  return Ii(t) == "symbol" ? t : t + "";
}
function DR(e, t) {
  if (Ii(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ii(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function LR(e, t) {
  return Za(Za({}, t), e);
}
function qR(e, t) {
  return e === "symbols";
}
function t0(e) {
  var t = e.shapeType, r = e.elementProps;
  switch (t) {
    case "rectangle":
      return /* @__PURE__ */ S.createElement(Mp, r);
    case "trapezoid":
      return /* @__PURE__ */ S.createElement(MR, r);
    case "sector":
      return /* @__PURE__ */ S.createElement($O, r);
    case "symbols":
      if (qR(t))
        return /* @__PURE__ */ S.createElement(To, r);
      break;
    default:
      return null;
  }
}
function BR(e) {
  return /* @__PURE__ */ bt(e) ? e.props : e;
}
function Ja(e) {
  var t = e.option, r = e.shapeType, n = e.propTransformer, i = n === void 0 ? LR : n, a = e.activeClassName, o = a === void 0 ? "recharts-active-shape" : a, u = e.isActive, s = IR(e, CR), c;
  if (/* @__PURE__ */ bt(t))
    c = /* @__PURE__ */ Ce(t, Za(Za({}, s), BR(t)));
  else if (re(t))
    c = t(s);
  else if (gR(t) && !wR(t)) {
    var l = i(t, s);
    c = /* @__PURE__ */ S.createElement(t0, {
      shapeType: r,
      elementProps: l
    });
  } else {
    var f = s;
    c = /* @__PURE__ */ S.createElement(t0, {
      shapeType: r,
      elementProps: f
    });
  }
  return u ? /* @__PURE__ */ S.createElement(oe, {
    className: o
  }, c) : c;
}
function Go(e, t) {
  return t != null && "trapezoids" in e.props;
}
function Vo(e, t) {
  return t != null && "sectors" in e.props;
}
function Ni(e, t) {
  return t != null && "points" in e.props;
}
function FR(e, t) {
  var r, n, i = e.x === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.x) || e.x === t.x, a = e.y === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.y) || e.y === t.y;
  return i && a;
}
function zR(e, t) {
  var r = e.endAngle === t.endAngle, n = e.startAngle === t.startAngle;
  return r && n;
}
function WR(e, t) {
  var r = e.x === t.x, n = e.y === t.y, i = e.z === t.z;
  return r && n && i;
}
function UR(e, t) {
  var r;
  return Go(e, t) ? r = FR : Vo(e, t) ? r = zR : Ni(e, t) && (r = WR), r;
}
function KR(e, t) {
  var r;
  return Go(e, t) ? r = "trapezoids" : Vo(e, t) ? r = "sectors" : Ni(e, t) && (r = "points"), r;
}
function HR(e, t) {
  if (Go(e, t)) {
    var r;
    return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  if (Vo(e, t)) {
    var n;
    return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
  }
  return Ni(e, t) ? t.payload : {};
}
function GR(e) {
  var t = e.activeTooltipItem, r = e.graphicalItem, n = e.itemData, i = KR(r, t), a = HR(r, t), o = n.filter(function(s, c) {
    var l = ir(a, s), f = r.props[i].filter(function(y) {
      var v = UR(r, t);
      return v(y, t);
    }), d = r.props[i].indexOf(f[f.length - 1]), p = c === d;
    return l && p;
  }), u = n.indexOf(o[o.length - 1]);
  return u;
}
var pa;
function ln(e) {
  "@babel/helpers - typeof";
  return ln = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ln(e);
}
function Ur() {
  return Ur = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ur.apply(this, arguments);
}
function r0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function be(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? r0(Object(r), !0).forEach(function(n) {
      st(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : r0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function VR(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function n0(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, KO(n.key), n);
  }
}
function YR(e, t, r) {
  return t && n0(e.prototype, t), r && n0(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function XR(e, t, r) {
  return t = Qa(t), ZR(e, UO() ? Reflect.construct(t, r || [], Qa(e).constructor) : t.apply(e, r));
}
function ZR(e, t) {
  if (t && (ln(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return JR(e);
}
function JR(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function UO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (UO = function() {
    return !!e;
  })();
}
function Qa(e) {
  return Qa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Qa(e);
}
function QR(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && dd(e, t);
}
function dd(e, t) {
  return dd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, dd(e, t);
}
function st(e, t, r) {
  return t = KO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function KO(e) {
  var t = e2(e, "string");
  return ln(t) == "symbol" ? t : t + "";
}
function e2(e, t) {
  if (ln(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ln(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var $t = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return VR(this, t), n = XR(this, t, [r]), st(n, "pieRef", null), st(n, "sectorRefs", []), st(n, "id", ur("recharts-pie-")), st(n, "handleAnimationEnd", function() {
      var i = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), re(i) && i();
    }), st(n, "handleAnimationStart", function() {
      var i = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), re(i) && i();
    }), n.state = {
      isAnimationFinished: !r.isAnimationActive,
      prevIsAnimationActive: r.isAnimationActive,
      prevAnimationId: r.animationId,
      sectorToFocus: 0
    }, n;
  }
  return QR(t, e), YR(t, [{
    key: "isActiveIndex",
    value: function(n) {
      var i = this.props.activeIndex;
      return Array.isArray(i) ? i.indexOf(n) !== -1 : n === i;
    }
  }, {
    key: "hasActiveIndex",
    value: function() {
      var n = this.props.activeIndex;
      return Array.isArray(n) ? n.length !== 0 : n || n === 0;
    }
  }, {
    key: "renderLabels",
    value: function(n) {
      var i = this.props.isAnimationActive;
      if (i && !this.state.isAnimationFinished)
        return null;
      var a = this.props, o = a.label, u = a.labelLine, s = a.dataKey, c = a.valueKey, l = J(this.props, !1), f = J(o, !1), d = J(u, !1), p = o && o.offsetRadius || 20, y = n.map(function(v, h) {
        var x = (v.startAngle + v.endAngle) / 2, g = we(v.cx, v.cy, v.outerRadius + p, x), b = be(be(be(be({}, l), v), {}, {
          stroke: "none"
        }, f), {}, {
          index: h,
          textAnchor: t.getTextAnchor(g.x, v.cx)
        }, g), O = be(be(be(be({}, l), v), {}, {
          fill: "none",
          stroke: v.fill
        }, d), {}, {
          index: h,
          points: [we(v.cx, v.cy, v.outerRadius, x), g]
        }), m = s;
        return te(s) && te(c) ? m = "value" : te(s) && (m = c), // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ S.createElement(oe, {
          key: "label-".concat(v.startAngle, "-").concat(v.endAngle, "-").concat(v.midAngle, "-").concat(h)
        }, u && t.renderLabelLineItem(u, O, "line"), t.renderLabelItem(o, b, _e(v, m)));
      });
      return /* @__PURE__ */ S.createElement(oe, {
        className: "recharts-pie-labels"
      }, y);
    }
  }, {
    key: "renderSectorsStatically",
    value: function(n) {
      var i = this, a = this.props, o = a.activeShape, u = a.blendStroke, s = a.inactiveShape;
      return n.map(function(c, l) {
        if ((c == null ? void 0 : c.startAngle) === 0 && (c == null ? void 0 : c.endAngle) === 0 && n.length !== 1) return null;
        var f = i.isActiveIndex(l), d = s && i.hasActiveIndex() ? s : null, p = f ? o : d, y = be(be({}, c), {}, {
          stroke: u ? c.fill : c.stroke,
          tabIndex: -1
        });
        return /* @__PURE__ */ S.createElement(oe, Ur({
          ref: function(h) {
            h && !i.sectorRefs.includes(h) && i.sectorRefs.push(h);
          },
          tabIndex: -1,
          className: "recharts-pie-sector"
        }, nr(i.props, c, l), {
          // eslint-disable-next-line react/no-array-index-key
          key: "sector-".concat(c == null ? void 0 : c.startAngle, "-").concat(c == null ? void 0 : c.endAngle, "-").concat(c.midAngle, "-").concat(l)
        }), /* @__PURE__ */ S.createElement(Ja, Ur({
          option: p,
          isActive: f,
          shapeType: "sector"
        }, y)));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function() {
      var n = this, i = this.props, a = i.sectors, o = i.isAnimationActive, u = i.animationBegin, s = i.animationDuration, c = i.animationEasing, l = i.animationId, f = this.state, d = f.prevSectors, p = f.prevIsAnimationActive;
      return /* @__PURE__ */ S.createElement(pt, {
        begin: u,
        duration: s,
        isActive: o,
        easing: c,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(l, "-").concat(p),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function(y) {
        var v = y.t, h = [], x = a && a[0], g = x.startAngle;
        return a.forEach(function(b, O) {
          var m = d && d[O], w = O > 0 ? et(b, "paddingAngle", 0) : 0;
          if (m) {
            var _ = Pe(m.endAngle - m.startAngle, b.endAngle - b.startAngle), P = be(be({}, b), {}, {
              startAngle: g + w,
              endAngle: g + _(v) + w
            });
            h.push(P), g = P.endAngle;
          } else {
            var T = b.endAngle, M = b.startAngle, j = Pe(0, T - M), $ = j(v), I = be(be({}, b), {}, {
              startAngle: g + w,
              endAngle: g + $ + w
            });
            h.push(I), g = I.endAngle;
          }
        }), /* @__PURE__ */ S.createElement(oe, null, n.renderSectorsStatically(h));
      });
    }
  }, {
    key: "attachKeyboardHandlers",
    value: function(n) {
      var i = this;
      n.onkeydown = function(a) {
        if (!a.altKey)
          switch (a.key) {
            case "ArrowLeft": {
              var o = ++i.state.sectorToFocus % i.sectorRefs.length;
              i.sectorRefs[o].focus(), i.setState({
                sectorToFocus: o
              });
              break;
            }
            case "ArrowRight": {
              var u = --i.state.sectorToFocus < 0 ? i.sectorRefs.length - 1 : i.state.sectorToFocus % i.sectorRefs.length;
              i.sectorRefs[u].focus(), i.setState({
                sectorToFocus: u
              });
              break;
            }
            case "Escape": {
              i.sectorRefs[i.state.sectorToFocus].blur(), i.setState({
                sectorToFocus: 0
              });
              break;
            }
          }
      };
    }
  }, {
    key: "renderSectors",
    value: function() {
      var n = this.props, i = n.sectors, a = n.isAnimationActive, o = this.state.prevSectors;
      return a && i && i.length && (!o || !ir(o, i)) ? this.renderSectorsWithAnimation() : this.renderSectorsStatically(i);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.pieRef && this.attachKeyboardHandlers(this.pieRef);
    }
  }, {
    key: "render",
    value: function() {
      var n = this, i = this.props, a = i.hide, o = i.sectors, u = i.className, s = i.label, c = i.cx, l = i.cy, f = i.innerRadius, d = i.outerRadius, p = i.isAnimationActive, y = this.state.isAnimationFinished;
      if (a || !o || !o.length || !U(c) || !U(l) || !U(f) || !U(d))
        return null;
      var v = ae("recharts-pie", u);
      return /* @__PURE__ */ S.createElement(oe, {
        tabIndex: this.props.rootTabIndex,
        className: v,
        ref: function(x) {
          n.pieRef = x;
        }
      }, this.renderSectors(), s && this.renderLabels(o), Re.renderCallByParent(this.props, null, !1), (!p || y) && wt.renderCallByParent(this.props, o, !1));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, i) {
      return i.prevIsAnimationActive !== n.isAnimationActive ? {
        prevIsAnimationActive: n.isAnimationActive,
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: [],
        isAnimationFinished: !0
      } : n.isAnimationActive && n.animationId !== i.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curSectors: n.sectors,
        prevSectors: i.curSectors,
        isAnimationFinished: !0
      } : n.sectors !== i.curSectors ? {
        curSectors: n.sectors,
        isAnimationFinished: !0
      } : null;
    }
  }, {
    key: "getTextAnchor",
    value: function(n, i) {
      return n > i ? "start" : n < i ? "end" : "middle";
    }
  }, {
    key: "renderLabelLineItem",
    value: function(n, i, a) {
      if (/* @__PURE__ */ S.isValidElement(n))
        return /* @__PURE__ */ S.cloneElement(n, i);
      if (re(n))
        return n(i);
      var o = ae("recharts-pie-label-line", typeof n != "boolean" ? n.className : "");
      return /* @__PURE__ */ S.createElement(rr, Ur({}, i, {
        key: a,
        type: "linear",
        className: o
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function(n, i, a) {
      if (/* @__PURE__ */ S.isValidElement(n))
        return /* @__PURE__ */ S.cloneElement(n, i);
      var o = a;
      if (re(n) && (o = n(i), /* @__PURE__ */ S.isValidElement(o)))
        return o;
      var u = ae("recharts-pie-label-text", typeof n != "boolean" && !re(n) ? n.className : "");
      return /* @__PURE__ */ S.createElement(jr, Ur({}, i, {
        alignmentBaseline: "middle",
        className: u
      }), o);
    }
  }]);
}(tt);
pa = $t;
st($t, "displayName", "Pie");
st($t, "defaultProps", {
  stroke: "#fff",
  fill: "#808080",
  legendType: "rect",
  cx: "50%",
  cy: "50%",
  startAngle: 0,
  endAngle: 360,
  innerRadius: 0,
  outerRadius: "80%",
  paddingAngle: 0,
  labelLine: !0,
  hide: !1,
  minAngle: 0,
  isAnimationActive: !Kt.isSsr,
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: "ease",
  nameKey: "name",
  blendStroke: !1,
  rootTabIndex: 0
});
st($t, "parseDeltaAngle", function(e, t) {
  var r = We(t - e), n = Math.min(Math.abs(t - e), 360);
  return r * n;
});
st($t, "getRealPieData", function(e) {
  var t = e.data, r = e.children, n = J(e, !1), i = He(r, Mn);
  return t && t.length ? t.map(function(a, o) {
    return be(be(be({
      payload: a
    }, n), a), i && i[o] && i[o].props);
  }) : i && i.length ? i.map(function(a) {
    return be(be({}, n), a.props);
  }) : [];
});
st($t, "parseCoordinateOfPie", function(e, t) {
  var r = t.top, n = t.left, i = t.width, a = t.height, o = PO(i, a), u = n + Ue(e.cx, i, i / 2), s = r + Ue(e.cy, a, a / 2), c = Ue(e.innerRadius, o, 0), l = Ue(e.outerRadius, o, o * 0.8), f = e.maxRadius || Math.sqrt(i * i + a * a) / 2;
  return {
    cx: u,
    cy: s,
    innerRadius: c,
    outerRadius: l,
    maxRadius: f
  };
});
st($t, "getComposedData", function(e) {
  var t = e.item, r = e.offset, n = t.type.defaultProps !== void 0 ? be(be({}, t.type.defaultProps), t.props) : t.props, i = pa.getRealPieData(n);
  if (!i || !i.length)
    return null;
  var a = n.cornerRadius, o = n.startAngle, u = n.endAngle, s = n.paddingAngle, c = n.dataKey, l = n.nameKey, f = n.valueKey, d = n.tooltipType, p = Math.abs(n.minAngle), y = pa.parseCoordinateOfPie(n, r), v = pa.parseDeltaAngle(o, u), h = Math.abs(v), x = c;
  te(c) && te(f) ? (xt(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), x = "value") : te(c) && (xt(!1, `Use "dataKey" to specify the value of pie,
      the props "valueKey" will be deprecated in 1.1.0`), x = f);
  var g = i.filter(function(P) {
    return _e(P, x, 0) !== 0;
  }).length, b = (h >= 360 ? g : g - 1) * s, O = h - g * p - b, m = i.reduce(function(P, T) {
    var M = _e(T, x, 0);
    return P + (U(M) ? M : 0);
  }, 0), w;
  if (m > 0) {
    var _;
    w = i.map(function(P, T) {
      var M = _e(P, x, 0), j = _e(P, l, T), $ = (U(M) ? M : 0) / m, I;
      T ? I = _.endAngle + We(v) * s * (M !== 0 ? 1 : 0) : I = o;
      var k = I + We(v) * ((M !== 0 ? p : 0) + $ * O), R = (I + k) / 2, D = (y.innerRadius + y.outerRadius) / 2, B = [{
        name: j,
        value: M,
        payload: P,
        dataKey: x,
        type: d
      }], W = we(y.cx, y.cy, D, R);
      return _ = be(be(be({
        percent: $,
        cornerRadius: a,
        name: j,
        tooltipPayload: B,
        midAngle: R,
        middleRadius: D,
        tooltipPosition: W
      }, P), y), {}, {
        value: _e(P, x),
        startAngle: I,
        endAngle: k,
        payload: P,
        paddingAngle: We(v) * s
      }), _;
    });
  }
  return be(be({}, y), {}, {
    sectors: w,
    data: i
  });
});
var Kl, i0;
function t2() {
  if (i0) return Kl;
  i0 = 1;
  var e = Math.ceil, t = Math.max;
  function r(n, i, a, o) {
    for (var u = -1, s = t(e((i - n) / (a || 1)), 0), c = Array(s); s--; )
      c[o ? s : ++u] = n, n += a;
    return c;
  }
  return Kl = r, Kl;
}
var Hl, a0;
function HO() {
  if (a0) return Hl;
  a0 = 1;
  var e = pw(), t = 1 / 0, r = 17976931348623157e292;
  function n(i) {
    if (!i)
      return i === 0 ? i : 0;
    if (i = e(i), i === t || i === -t) {
      var a = i < 0 ? -1 : 1;
      return a * r;
    }
    return i === i ? i : 0;
  }
  return Hl = n, Hl;
}
var Gl, o0;
function r2() {
  if (o0) return Gl;
  o0 = 1;
  var e = t2(), t = Co(), r = HO();
  function n(i) {
    return function(a, o, u) {
      return u && typeof u != "number" && t(a, o, u) && (o = u = void 0), a = r(a), o === void 0 ? (o = a, a = 0) : o = r(o), u = u === void 0 ? a < o ? 1 : -1 : r(u), e(a, o, u, i);
    };
  }
  return Gl = n, Gl;
}
var Vl, u0;
function n2() {
  if (u0) return Vl;
  u0 = 1;
  var e = r2(), t = e();
  return Vl = t, Vl;
}
var i2 = n2();
const eo = /* @__PURE__ */ ye(i2);
function ki(e) {
  "@babel/helpers - typeof";
  return ki = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ki(e);
}
function s0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function c0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? s0(Object(r), !0).forEach(function(n) {
      GO(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : s0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function GO(e, t, r) {
  return t = a2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function a2(e) {
  var t = o2(e, "string");
  return ki(t) == "symbol" ? t : t + "";
}
function o2(e, t) {
  if (ki(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (ki(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var u2 = ["Webkit", "Moz", "O", "ms"], s2 = function(t, r) {
  var n = t.replace(/(\w)/, function(a) {
    return a.toUpperCase();
  }), i = u2.reduce(function(a, o) {
    return c0(c0({}, a), {}, GO({}, o + n, r));
  }, {});
  return i[t] = r, i;
};
function fn(e) {
  "@babel/helpers - typeof";
  return fn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fn(e);
}
function to() {
  return to = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, to.apply(this, arguments);
}
function l0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Yl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? l0(Object(r), !0).forEach(function(n) {
      Ze(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function c2(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function f0(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, YO(n.key), n);
  }
}
function l2(e, t, r) {
  return t && f0(e.prototype, t), r && f0(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function f2(e, t, r) {
  return t = ro(t), d2(e, VO() ? Reflect.construct(t, r || [], ro(e).constructor) : t.apply(e, r));
}
function d2(e, t) {
  if (t && (fn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return p2(e);
}
function p2(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function VO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (VO = function() {
    return !!e;
  })();
}
function ro(e) {
  return ro = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ro(e);
}
function h2(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && pd(e, t);
}
function pd(e, t) {
  return pd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, pd(e, t);
}
function Ze(e, t, r) {
  return t = YO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function YO(e) {
  var t = v2(e, "string");
  return fn(t) == "symbol" ? t : t + "";
}
function v2(e, t) {
  if (fn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (fn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var y2 = function(t) {
  var r = t.data, n = t.startIndex, i = t.endIndex, a = t.x, o = t.width, u = t.travellerWidth;
  if (!r || !r.length)
    return {};
  var s = r.length, c = Jn().domain(eo(0, s)).range([a, a + o - u]), l = c.domain().map(function(f) {
    return c(f);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: c(n),
    endX: c(i),
    scale: c,
    scaleValues: l
  };
}, d0 = function(t) {
  return t.changedTouches && !!t.changedTouches.length;
}, dn = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return c2(this, t), n = f2(this, t, [r]), Ze(n, "handleDrag", function(i) {
      n.leaveTimer && (clearTimeout(n.leaveTimer), n.leaveTimer = null), n.state.isTravellerMoving ? n.handleTravellerMove(i) : n.state.isSlideMoving && n.handleSlideDrag(i);
    }), Ze(n, "handleTouchMove", function(i) {
      i.changedTouches != null && i.changedTouches.length > 0 && n.handleDrag(i.changedTouches[0]);
    }), Ze(n, "handleDragEnd", function() {
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var i = n.props, a = i.endIndex, o = i.onDragEnd, u = i.startIndex;
        o == null || o({
          endIndex: a,
          startIndex: u
        });
      }), n.detachDragEndListener();
    }), Ze(n, "handleLeaveWrapper", function() {
      (n.state.isTravellerMoving || n.state.isSlideMoving) && (n.leaveTimer = window.setTimeout(n.handleDragEnd, n.props.leaveTimeOut));
    }), Ze(n, "handleEnterSlideOrTraveller", function() {
      n.setState({
        isTextActive: !0
      });
    }), Ze(n, "handleLeaveSlideOrTraveller", function() {
      n.setState({
        isTextActive: !1
      });
    }), Ze(n, "handleSlideDragStart", function(i) {
      var a = d0(i) ? i.changedTouches[0] : i;
      n.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: a.pageX
      }), n.attachDragEndListener();
    }), n.travellerDragStartHandlers = {
      startX: n.handleTravellerDragStart.bind(n, "startX"),
      endX: n.handleTravellerDragStart.bind(n, "endX")
    }, n.state = {}, n;
  }
  return h2(t, e), l2(t, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(n) {
      var i = n.startX, a = n.endX, o = this.state.scaleValues, u = this.props, s = u.gap, c = u.data, l = c.length - 1, f = Math.min(i, a), d = Math.max(i, a), p = t.getIndexInRange(o, f), y = t.getIndexInRange(o, d);
      return {
        startIndex: p - p % s,
        endIndex: y === l ? l : y - y % s
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(n) {
      var i = this.props, a = i.data, o = i.tickFormatter, u = i.dataKey, s = _e(a[n], u, n);
      return re(o) ? o(s, n) : s;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(n) {
      var i = this.state, a = i.slideMoveStartX, o = i.startX, u = i.endX, s = this.props, c = s.x, l = s.width, f = s.travellerWidth, d = s.startIndex, p = s.endIndex, y = s.onChange, v = n.pageX - a;
      v > 0 ? v = Math.min(v, c + l - f - u, c + l - f - o) : v < 0 && (v = Math.max(v, c - o, c - u));
      var h = this.getIndex({
        startX: o + v,
        endX: u + v
      });
      (h.startIndex !== d || h.endIndex !== p) && y && y(h), this.setState({
        startX: o + v,
        endX: u + v,
        slideMoveStartX: n.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(n, i) {
      var a = d0(i) ? i.changedTouches[0] : i;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: n,
        brushMoveStartX: a.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(n) {
      var i = this.state, a = i.brushMoveStartX, o = i.movingTravellerId, u = i.endX, s = i.startX, c = this.state[o], l = this.props, f = l.x, d = l.width, p = l.travellerWidth, y = l.onChange, v = l.gap, h = l.data, x = {
        startX: this.state.startX,
        endX: this.state.endX
      }, g = n.pageX - a;
      g > 0 ? g = Math.min(g, f + d - p - c) : g < 0 && (g = Math.max(g, f - c)), x[o] = c + g;
      var b = this.getIndex(x), O = b.startIndex, m = b.endIndex, w = function() {
        var P = h.length - 1;
        return o === "startX" && (u > s ? O % v === 0 : m % v === 0) || u < s && m === P || o === "endX" && (u > s ? m % v === 0 : O % v === 0) || u > s && m === P;
      };
      this.setState(Ze(Ze({}, o, c + g), "brushMoveStartX", n.pageX), function() {
        y && w() && y(b);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(n, i) {
      var a = this, o = this.state, u = o.scaleValues, s = o.startX, c = o.endX, l = this.state[i], f = u.indexOf(l);
      if (f !== -1) {
        var d = f + n;
        if (!(d === -1 || d >= u.length)) {
          var p = u[d];
          i === "startX" && p >= c || i === "endX" && p <= s || this.setState(Ze({}, i, p), function() {
            a.props.onChange(a.getIndex({
              startX: a.state.startX,
              endX: a.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this.props, i = n.x, a = n.y, o = n.width, u = n.height, s = n.fill, c = n.stroke;
      return /* @__PURE__ */ S.createElement("rect", {
        stroke: c,
        fill: s,
        x: i,
        y: a,
        width: o,
        height: u
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var n = this.props, i = n.x, a = n.y, o = n.width, u = n.height, s = n.data, c = n.children, l = n.padding, f = _r.only(c);
      return f ? /* @__PURE__ */ S.cloneElement(f, {
        x: i,
        y: a,
        width: o,
        height: u,
        margin: l,
        compact: !0,
        data: s
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(n, i) {
      var a, o, u = this, s = this.props, c = s.y, l = s.travellerWidth, f = s.height, d = s.traveller, p = s.ariaLabel, y = s.data, v = s.startIndex, h = s.endIndex, x = Math.max(n, this.props.x), g = Yl(Yl({}, J(this.props, !1)), {}, {
        x,
        y: c,
        width: l,
        height: f
      }), b = p || "Min value: ".concat((a = y[v]) === null || a === void 0 ? void 0 : a.name, ", Max value: ").concat((o = y[h]) === null || o === void 0 ? void 0 : o.name);
      return /* @__PURE__ */ S.createElement(oe, {
        tabIndex: 0,
        role: "slider",
        "aria-label": b,
        "aria-valuenow": n,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[i],
        onTouchStart: this.travellerDragStartHandlers[i],
        onKeyDown: function(m) {
          ["ArrowLeft", "ArrowRight"].includes(m.key) && (m.preventDefault(), m.stopPropagation(), u.handleTravellerMoveKeyboard(m.key === "ArrowRight" ? 1 : -1, i));
        },
        onFocus: function() {
          u.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          u.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, t.renderTraveller(d, g));
    }
  }, {
    key: "renderSlide",
    value: function(n, i) {
      var a = this.props, o = a.y, u = a.height, s = a.stroke, c = a.travellerWidth, l = Math.min(n, i) + c, f = Math.max(Math.abs(i - n) - c, 0);
      return /* @__PURE__ */ S.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: s,
        fillOpacity: 0.2,
        x: l,
        y: o,
        width: f,
        height: u
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var n = this.props, i = n.startIndex, a = n.endIndex, o = n.y, u = n.height, s = n.travellerWidth, c = n.stroke, l = this.state, f = l.startX, d = l.endX, p = 5, y = {
        pointerEvents: "none",
        fill: c
      };
      return /* @__PURE__ */ S.createElement(oe, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ S.createElement(jr, to({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(f, d) - p,
        y: o + u / 2
      }, y), this.getTextOfTick(i)), /* @__PURE__ */ S.createElement(jr, to({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(f, d) + s + p,
        y: o + u / 2
      }, y), this.getTextOfTick(a)));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, i = n.data, a = n.className, o = n.children, u = n.x, s = n.y, c = n.width, l = n.height, f = n.alwaysShowText, d = this.state, p = d.startX, y = d.endX, v = d.isTextActive, h = d.isSlideMoving, x = d.isTravellerMoving, g = d.isTravellerFocused;
      if (!i || !i.length || !U(u) || !U(s) || !U(c) || !U(l) || c <= 0 || l <= 0)
        return null;
      var b = ae("recharts-brush", a), O = S.Children.count(o) === 1, m = s2("userSelect", "none");
      return /* @__PURE__ */ S.createElement(oe, {
        className: b,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: m
      }, this.renderBackground(), O && this.renderPanorama(), this.renderSlide(p, y), this.renderTravellerLayer(p, "startX"), this.renderTravellerLayer(y, "endX"), (v || h || x || g || f) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(n) {
      var i = n.x, a = n.y, o = n.width, u = n.height, s = n.stroke, c = Math.floor(a + u / 2) - 1;
      return /* @__PURE__ */ S.createElement(S.Fragment, null, /* @__PURE__ */ S.createElement("rect", {
        x: i,
        y: a,
        width: o,
        height: u,
        fill: s,
        stroke: "none"
      }), /* @__PURE__ */ S.createElement("line", {
        x1: i + 1,
        y1: c,
        x2: i + o - 1,
        y2: c,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ S.createElement("line", {
        x1: i + 1,
        y1: c + 2,
        x2: i + o - 1,
        y2: c + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(n, i) {
      var a;
      return /* @__PURE__ */ S.isValidElement(n) ? a = /* @__PURE__ */ S.cloneElement(n, i) : re(n) ? a = n(i) : a = t.renderDefaultTraveller(i), a;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(n, i) {
      var a = n.data, o = n.width, u = n.x, s = n.travellerWidth, c = n.updateId, l = n.startIndex, f = n.endIndex;
      if (a !== i.prevData || c !== i.prevUpdateId)
        return Yl({
          prevData: a,
          prevTravellerWidth: s,
          prevUpdateId: c,
          prevX: u,
          prevWidth: o
        }, a && a.length ? y2({
          data: a,
          width: o,
          x: u,
          travellerWidth: s,
          startIndex: l,
          endIndex: f
        }) : {
          scale: null,
          scaleValues: null
        });
      if (i.scale && (o !== i.prevWidth || u !== i.prevX || s !== i.prevTravellerWidth)) {
        i.scale.range([u, u + o - s]);
        var d = i.scale.domain().map(function(p) {
          return i.scale(p);
        });
        return {
          prevData: a,
          prevTravellerWidth: s,
          prevUpdateId: c,
          prevX: u,
          prevWidth: o,
          startX: i.scale(n.startIndex),
          endX: i.scale(n.endIndex),
          scaleValues: d
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(n, i) {
      for (var a = n.length, o = 0, u = a - 1; u - o > 1; ) {
        var s = Math.floor((o + u) / 2);
        n[s] > i ? u = s : o = s;
      }
      return i >= n[u] ? u : o;
    }
  }]);
}(tt);
Ze(dn, "displayName", "Brush");
Ze(dn, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var Xl, p0;
function m2() {
  if (p0) return Xl;
  p0 = 1;
  var e = tp();
  function t(r, n) {
    var i;
    return e(r, function(a, o, u) {
      return i = n(a, o, u), !i;
    }), !!i;
  }
  return Xl = t, Xl;
}
var Zl, h0;
function g2() {
  if (h0) return Zl;
  h0 = 1;
  var e = Ux(), t = Tt(), r = m2(), n = Ye(), i = Co();
  function a(o, u, s) {
    var c = n(o) ? e : r;
    return s && i(o, u, s) && (u = void 0), c(o, t(u, 3));
  }
  return Zl = a, Zl;
}
var b2 = g2();
const x2 = /* @__PURE__ */ ye(b2);
var Pt = function(t, r) {
  var n = t.alwaysShow, i = t.ifOverflow;
  return n && (i = "extendDomain"), i === r;
}, Jl, v0;
function w2() {
  if (v0) return Jl;
  v0 = 1;
  var e = sw();
  function t(r, n, i) {
    n == "__proto__" && e ? e(r, n, {
      configurable: !0,
      enumerable: !0,
      value: i,
      writable: !0
    }) : r[n] = i;
  }
  return Jl = t, Jl;
}
var Ql, y0;
function O2() {
  if (y0) return Ql;
  y0 = 1;
  var e = w2(), t = ow(), r = Tt();
  function n(i, a) {
    var o = {};
    return a = r(a, 3), t(i, function(u, s, c) {
      e(o, s, a(u, s, c));
    }), o;
  }
  return Ql = n, Ql;
}
var _2 = O2();
const A2 = /* @__PURE__ */ ye(_2);
var ef, m0;
function S2() {
  if (m0) return ef;
  m0 = 1;
  function e(t, r) {
    for (var n = -1, i = t == null ? 0 : t.length; ++n < i; )
      if (!r(t[n], n, t))
        return !1;
    return !0;
  }
  return ef = e, ef;
}
var tf, g0;
function P2() {
  if (g0) return tf;
  g0 = 1;
  var e = tp();
  function t(r, n) {
    var i = !0;
    return e(r, function(a, o, u) {
      return i = !!n(a, o, u), i;
    }), i;
  }
  return tf = t, tf;
}
var rf, b0;
function E2() {
  if (b0) return rf;
  b0 = 1;
  var e = S2(), t = P2(), r = Tt(), n = Ye(), i = Co();
  function a(o, u, s) {
    var c = n(o) ? e : t;
    return s && i(o, u, s) && (u = void 0), c(o, r(u, 3));
  }
  return rf = a, rf;
}
var j2 = E2();
const XO = /* @__PURE__ */ ye(j2);
var T2 = ["x", "y"];
function pn(e) {
  "@babel/helpers - typeof";
  return pn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, pn(e);
}
function hd() {
  return hd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, hd.apply(this, arguments);
}
function x0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Gn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? x0(Object(r), !0).forEach(function(n) {
      $2(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : x0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function $2(e, t, r) {
  return t = M2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function M2(e) {
  var t = C2(e, "string");
  return pn(t) == "symbol" ? t : t + "";
}
function C2(e, t) {
  if (pn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (pn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function I2(e, t) {
  if (e == null) return {};
  var r = N2(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function N2(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function k2(e, t) {
  var r = e.x, n = e.y, i = I2(e, T2), a = "".concat(r), o = parseInt(a, 10), u = "".concat(n), s = parseInt(u, 10), c = "".concat(t.height || i.height), l = parseInt(c, 10), f = "".concat(t.width || i.width), d = parseInt(f, 10);
  return Gn(Gn(Gn(Gn(Gn({}, t), i), o ? {
    x: o
  } : {}), s ? {
    y: s
  } : {}), {}, {
    height: l,
    width: d,
    name: t.name,
    radius: t.radius
  });
}
function w0(e) {
  return /* @__PURE__ */ S.createElement(Ja, hd({
    shapeType: "rectangle",
    propTransformer: k2,
    activeClassName: "recharts-active-bar"
  }, e));
}
var R2 = function(t) {
  var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(n, i) {
    if (typeof t == "number") return t;
    var a = U(n) || eA(n);
    return a ? t(n, i) : (a || (process.env.NODE_ENV !== "production" ? Ve(!1, "minPointSize callback function received a value with type of ".concat(pn(n), ". Currently only numbers or null/undefined are supported.")) : Ve()), r);
  };
}, D2 = ["value", "background"], ZO;
function hn(e) {
  "@babel/helpers - typeof";
  return hn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, hn(e);
}
function L2(e, t) {
  if (e == null) return {};
  var r = q2(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function q2(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function no() {
  return no = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, no.apply(this, arguments);
}
function O0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function je(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? O0(Object(r), !0).forEach(function(n) {
      Jt(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : O0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function B2(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function _0(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, QO(n.key), n);
  }
}
function F2(e, t, r) {
  return t && _0(e.prototype, t), r && _0(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function z2(e, t, r) {
  return t = io(t), W2(e, JO() ? Reflect.construct(t, r || [], io(e).constructor) : t.apply(e, r));
}
function W2(e, t) {
  if (t && (hn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return U2(e);
}
function U2(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function JO() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (JO = function() {
    return !!e;
  })();
}
function io(e) {
  return io = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, io(e);
}
function K2(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && vd(e, t);
}
function vd(e, t) {
  return vd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, vd(e, t);
}
function Jt(e, t, r) {
  return t = QO(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function QO(e) {
  var t = H2(e, "string");
  return hn(t) == "symbol" ? t : t + "";
}
function H2(e, t) {
  if (hn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (hn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var ar = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    B2(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = z2(this, t, [].concat(i)), Jt(r, "state", {
      isAnimationFinished: !1
    }), Jt(r, "id", ur("recharts-bar-")), Jt(r, "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), o && o();
    }), Jt(r, "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), o && o();
    }), r;
  }
  return K2(t, e), F2(t, [{
    key: "renderRectanglesStatically",
    value: function(n) {
      var i = this, a = this.props, o = a.shape, u = a.dataKey, s = a.activeIndex, c = a.activeBar, l = J(this.props, !1);
      return n && n.map(function(f, d) {
        var p = d === s, y = p ? c : o, v = je(je(je({}, l), f), {}, {
          isActive: p,
          option: y,
          index: d,
          dataKey: u,
          onAnimationStart: i.handleAnimationStart,
          onAnimationEnd: i.handleAnimationEnd
        });
        return /* @__PURE__ */ S.createElement(oe, no({
          className: "recharts-bar-rectangle"
        }, nr(i.props, f, d), {
          // https://github.com/recharts/recharts/issues/5415
          // eslint-disable-next-line react/no-array-index-key
          key: "rectangle-".concat(f == null ? void 0 : f.x, "-").concat(f == null ? void 0 : f.y, "-").concat(f == null ? void 0 : f.value, "-").concat(d)
        }), /* @__PURE__ */ S.createElement(w0, v));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var n = this, i = this.props, a = i.data, o = i.layout, u = i.isAnimationActive, s = i.animationBegin, c = i.animationDuration, l = i.animationEasing, f = i.animationId, d = this.state.prevData;
      return /* @__PURE__ */ S.createElement(pt, {
        begin: s,
        duration: c,
        isActive: u,
        easing: l,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(f),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(p) {
        var y = p.t, v = a.map(function(h, x) {
          var g = d && d[x];
          if (g) {
            var b = Pe(g.x, h.x), O = Pe(g.y, h.y), m = Pe(g.width, h.width), w = Pe(g.height, h.height);
            return je(je({}, h), {}, {
              x: b(y),
              y: O(y),
              width: m(y),
              height: w(y)
            });
          }
          if (o === "horizontal") {
            var _ = Pe(0, h.height), P = _(y);
            return je(je({}, h), {}, {
              y: h.y + h.height - P,
              height: P
            });
          }
          var T = Pe(0, h.width), M = T(y);
          return je(je({}, h), {}, {
            width: M
          });
        });
        return /* @__PURE__ */ S.createElement(oe, null, n.renderRectanglesStatically(v));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var n = this.props, i = n.data, a = n.isAnimationActive, o = this.state.prevData;
      return a && i && i.length && (!o || !ir(o, i)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(i);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var n = this, i = this.props, a = i.data, o = i.dataKey, u = i.activeIndex, s = J(this.props.background, !1);
      return a.map(function(c, l) {
        c.value;
        var f = c.background, d = L2(c, D2);
        if (!f)
          return null;
        var p = je(je(je(je(je({}, d), {}, {
          fill: "#eee"
        }, f), s), nr(n.props, c, l)), {}, {
          onAnimationStart: n.handleAnimationStart,
          onAnimationEnd: n.handleAnimationEnd,
          dataKey: o,
          index: l,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ S.createElement(w0, no({
          key: "background-bar-".concat(l),
          option: n.props.background,
          isActive: l === u
        }, p));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(n, i) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var a = this.props, o = a.data, u = a.xAxis, s = a.yAxis, c = a.layout, l = a.children, f = He(l, kn);
      if (!f)
        return null;
      var d = c === "vertical" ? o[0].height / 2 : o[0].width / 2, p = function(h, x) {
        var g = Array.isArray(h.value) ? h.value[1] : h.value;
        return {
          x: h.x,
          y: h.y,
          value: g,
          errorVal: _e(h, x)
        };
      }, y = {
        clipPath: n ? "url(#clipPath-".concat(i, ")") : null
      };
      return /* @__PURE__ */ S.createElement(oe, y, f.map(function(v) {
        return /* @__PURE__ */ S.cloneElement(v, {
          key: "error-bar-".concat(i, "-").concat(v.props.dataKey),
          data: o,
          xAxis: u,
          yAxis: s,
          layout: c,
          offset: d,
          dataPointFormatter: p
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, i = n.hide, a = n.data, o = n.className, u = n.xAxis, s = n.yAxis, c = n.left, l = n.top, f = n.width, d = n.height, p = n.isAnimationActive, y = n.background, v = n.id;
      if (i || !a || !a.length)
        return null;
      var h = this.state.isAnimationFinished, x = ae("recharts-bar", o), g = u && u.allowDataOverflow, b = s && s.allowDataOverflow, O = g || b, m = te(v) ? this.id : v;
      return /* @__PURE__ */ S.createElement(oe, {
        className: x
      }, g || b ? /* @__PURE__ */ S.createElement("defs", null, /* @__PURE__ */ S.createElement("clipPath", {
        id: "clipPath-".concat(m)
      }, /* @__PURE__ */ S.createElement("rect", {
        x: g ? c : c - f / 2,
        y: b ? l : l - d / 2,
        width: g ? f : f * 2,
        height: b ? d : d * 2
      }))) : null, /* @__PURE__ */ S.createElement(oe, {
        className: "recharts-bar-rectangles",
        clipPath: O ? "url(#clipPath-".concat(m, ")") : null
      }, y ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(O, m), (!p || h) && wt.renderCallByParent(this.props, a));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, i) {
      return n.animationId !== i.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curData: n.data,
        prevData: i.curData
      } : n.data !== i.curData ? {
        curData: n.data
      } : null;
    }
  }]);
}(tt);
ZO = ar;
Jt(ar, "displayName", "Bar");
Jt(ar, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !Kt.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
Jt(ar, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.barPosition, i = e.bandSize, a = e.xAxis, o = e.yAxis, u = e.xAxisTicks, s = e.yAxisTicks, c = e.stackedData, l = e.dataStartIndex, f = e.displayedData, d = e.offset, p = yC(n, r);
  if (!p)
    return null;
  var y = t.layout, v = r.type.defaultProps, h = v !== void 0 ? je(je({}, v), r.props) : r.props, x = h.dataKey, g = h.children, b = h.minPointSize, O = y === "horizontal" ? o : a, m = c ? O.scale.domain() : null, w = _C({
    numericAxis: O
  }), _ = He(g, Mn), P = f.map(function(T, M) {
    var j, $, I, k, R, D;
    c ? j = mC(c[l + M], m) : (j = _e(T, x), Array.isArray(j) || (j = [w, j]));
    var B = R2(b, ZO.defaultProps.minPointSize)(j[1], M);
    if (y === "horizontal") {
      var W, K = [o.scale(j[0]), o.scale(j[1])], E = K[0], N = K[1];
      $ = Fg({
        axis: a,
        ticks: u,
        bandSize: i,
        offset: p.offset,
        entry: T,
        index: M
      }), I = (W = N ?? E) !== null && W !== void 0 ? W : void 0, k = p.size;
      var L = E - N;
      if (R = Number.isNaN(L) ? 0 : L, D = {
        x: $,
        y: o.y,
        width: k,
        height: o.height
      }, Math.abs(B) > 0 && Math.abs(R) < Math.abs(B)) {
        var z = We(R || B) * (Math.abs(B) - Math.abs(R));
        I -= z, R += z;
      }
    } else {
      var V = [a.scale(j[0]), a.scale(j[1])], Y = V[0], ee = V[1];
      if ($ = Y, I = Fg({
        axis: o,
        ticks: s,
        bandSize: i,
        offset: p.offset,
        entry: T,
        index: M
      }), k = ee - Y, R = p.size, D = {
        x: a.x,
        y: I,
        width: a.width,
        height: R
      }, Math.abs(B) > 0 && Math.abs(k) < Math.abs(B)) {
        var ne = We(k || B) * (Math.abs(B) - Math.abs(k));
        k += ne;
      }
    }
    return je(je(je({}, T), {}, {
      x: $,
      y: I,
      width: k,
      height: R,
      value: c ? j : j[1],
      payload: T,
      background: D
    }, _ && _[M] && _[M].props), {}, {
      tooltipPayload: [AO(r, T)],
      tooltipPosition: {
        x: $ + k / 2,
        y: I + R / 2
      }
    });
  });
  return je({
    data: P,
    layout: y
  }, d);
});
function Ri(e) {
  "@babel/helpers - typeof";
  return Ri = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ri(e);
}
function G2(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function A0(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, e_(n.key), n);
  }
}
function V2(e, t, r) {
  return t && A0(e.prototype, t), r && A0(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function S0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function yt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? S0(Object(r), !0).forEach(function(n) {
      Yo(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : S0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Yo(e, t, r) {
  return t = e_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function e_(e) {
  var t = Y2(e, "string");
  return Ri(t) == "symbol" ? t : t + "";
}
function Y2(e, t) {
  if (Ri(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Ri(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var X2 = function(t, r, n, i, a) {
  var o = t.width, u = t.height, s = t.layout, c = t.children, l = Object.keys(r), f = {
    left: n.left,
    leftMirror: n.left,
    right: o - n.right,
    rightMirror: o - n.right,
    top: n.top,
    topMirror: n.top,
    bottom: u - n.bottom,
    bottomMirror: u - n.bottom
  }, d = !!Je(c, ar);
  return l.reduce(function(p, y) {
    var v = r[y], h = v.orientation, x = v.domain, g = v.padding, b = g === void 0 ? {} : g, O = v.mirror, m = v.reversed, w = "".concat(h).concat(O ? "Mirror" : ""), _, P, T, M, j;
    if (v.type === "number" && (v.padding === "gap" || v.padding === "no-gap")) {
      var $ = x[1] - x[0], I = 1 / 0, k = v.categoricalDomain.sort(iA);
      if (k.forEach(function(V, Y) {
        Y > 0 && (I = Math.min((V || 0) - (k[Y - 1] || 0), I));
      }), Number.isFinite(I)) {
        var R = I / $, D = v.layout === "vertical" ? n.height : n.width;
        if (v.padding === "gap" && (_ = R * D / 2), v.padding === "no-gap") {
          var B = Ue(t.barCategoryGap, R * D), W = R * D / 2;
          _ = W - B - (W - B) / D * B;
        }
      }
    }
    i === "xAxis" ? P = [n.left + (b.left || 0) + (_ || 0), n.left + n.width - (b.right || 0) - (_ || 0)] : i === "yAxis" ? P = s === "horizontal" ? [n.top + n.height - (b.bottom || 0), n.top + (b.top || 0)] : [n.top + (b.top || 0) + (_ || 0), n.top + n.height - (b.bottom || 0) - (_ || 0)] : P = v.range, m && (P = [P[1], P[0]]);
    var K = xO(v, a, d), E = K.scale, N = K.realScaleType;
    E.domain(x).range(P), wO(E);
    var L = OO(E, yt(yt({}, v), {}, {
      realScaleType: N
    }));
    i === "xAxis" ? (j = h === "top" && !O || h === "bottom" && O, T = n.left, M = f[w] - j * v.height) : i === "yAxis" && (j = h === "left" && !O || h === "right" && O, T = f[w] - j * v.width, M = n.top);
    var z = yt(yt(yt({}, v), L), {}, {
      realScaleType: N,
      x: T,
      y: M,
      scale: E,
      width: i === "xAxis" ? n.width : v.width,
      height: i === "yAxis" ? n.height : v.height
    });
    return z.bandSize = Ba(z, L), !v.hide && i === "xAxis" ? f[w] += (j ? -1 : 1) * z.height : v.hide || (f[w] += (j ? -1 : 1) * z.width), yt(yt({}, p), {}, Yo({}, y, z));
  }, {});
}, t_ = function(t, r) {
  var n = t.x, i = t.y, a = r.x, o = r.y;
  return {
    x: Math.min(n, a),
    y: Math.min(i, o),
    width: Math.abs(a - n),
    height: Math.abs(o - i)
  };
}, Z2 = function(t) {
  var r = t.x1, n = t.y1, i = t.x2, a = t.y2;
  return t_({
    x: r,
    y: n
  }, {
    x: i,
    y: a
  });
}, r_ = /* @__PURE__ */ function() {
  function e(t) {
    G2(this, e), this.scale = t;
  }
  return V2(e, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(r) {
      var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = n.bandAware, a = n.position;
      if (r !== void 0) {
        if (a)
          switch (a) {
            case "start":
              return this.scale(r);
            case "middle": {
              var o = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(r) + o;
            }
            case "end": {
              var u = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(r) + u;
            }
            default:
              return this.scale(r);
          }
        if (i) {
          var s = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(r) + s;
        }
        return this.scale(r);
      }
    }
  }, {
    key: "isInRange",
    value: function(r) {
      var n = this.range(), i = n[0], a = n[n.length - 1];
      return i <= a ? r >= i && r <= a : r >= a && r <= i;
    }
  }], [{
    key: "create",
    value: function(r) {
      return new e(r);
    }
  }]);
}();
Yo(r_, "EPS", 1e-4);
var Cp = function(t) {
  var r = Object.keys(t).reduce(function(n, i) {
    return yt(yt({}, n), {}, Yo({}, i, r_.create(t[i])));
  }, {});
  return yt(yt({}, r), {}, {
    apply: function(i) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = a.bandAware, u = a.position;
      return A2(i, function(s, c) {
        return r[c].apply(s, {
          bandAware: o,
          position: u
        });
      });
    },
    isInRange: function(i) {
      return XO(i, function(a, o) {
        return r[o].isInRange(a);
      });
    }
  });
};
function J2(e) {
  return (e % 180 + 180) % 180;
}
var Q2 = function(t) {
  var r = t.width, n = t.height, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, a = J2(i), o = a * Math.PI / 180, u = Math.atan(n / r), s = o > u && o < Math.PI - u ? n / Math.sin(o) : r / Math.cos(o);
  return Math.abs(s);
}, nf, P0;
function eD() {
  if (P0) return nf;
  P0 = 1;
  var e = Tt(), t = Fi(), r = $o();
  function n(i) {
    return function(a, o, u) {
      var s = Object(a);
      if (!t(a)) {
        var c = e(o, 3);
        a = r(a), o = function(f) {
          return c(s[f], f, s);
        };
      }
      var l = i(a, o, u);
      return l > -1 ? s[c ? a[l] : l] : void 0;
    };
  }
  return nf = n, nf;
}
var af, E0;
function tD() {
  if (E0) return af;
  E0 = 1;
  var e = HO();
  function t(r) {
    var n = e(r), i = n % 1;
    return n === n ? i ? n - i : n : 0;
  }
  return af = t, af;
}
var of, j0;
function rD() {
  if (j0) return of;
  j0 = 1;
  var e = tw(), t = Tt(), r = tD(), n = Math.max;
  function i(a, o, u) {
    var s = a == null ? 0 : a.length;
    if (!s)
      return -1;
    var c = u == null ? 0 : r(u);
    return c < 0 && (c = n(s + c, 0)), e(a, t(o, 3), c);
  }
  return of = i, of;
}
var uf, T0;
function nD() {
  if (T0) return uf;
  T0 = 1;
  var e = eD(), t = rD(), r = e(t);
  return uf = r, uf;
}
var iD = nD();
const aD = /* @__PURE__ */ ye(iD);
var oD = yx();
const uD = /* @__PURE__ */ ye(oD);
var sD = uD(function(e) {
  return {
    x: e.left,
    y: e.top,
    width: e.width,
    height: e.height
  };
}, function(e) {
  return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
});
function ao(e) {
  "@babel/helpers - typeof";
  return ao = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ao(e);
}
var Ip = /* @__PURE__ */ Mr(void 0), Np = /* @__PURE__ */ Mr(void 0), n_ = /* @__PURE__ */ Mr(void 0), i_ = /* @__PURE__ */ Mr({}), a_ = /* @__PURE__ */ Mr(void 0), o_ = /* @__PURE__ */ Mr(0), u_ = /* @__PURE__ */ Mr(0), $0 = function(t) {
  var r = t.state, n = r.xAxisMap, i = r.yAxisMap, a = r.offset, o = t.clipPathId, u = t.children, s = t.width, c = t.height, l = sD(a);
  return /* @__PURE__ */ S.createElement(Ip.Provider, {
    value: n
  }, /* @__PURE__ */ S.createElement(Np.Provider, {
    value: i
  }, /* @__PURE__ */ S.createElement(i_.Provider, {
    value: a
  }, /* @__PURE__ */ S.createElement(n_.Provider, {
    value: l
  }, /* @__PURE__ */ S.createElement(a_.Provider, {
    value: o
  }, /* @__PURE__ */ S.createElement(o_.Provider, {
    value: c
  }, /* @__PURE__ */ S.createElement(u_.Provider, {
    value: s
  }, u)))))));
}, cD = function() {
  return zt(a_);
};
function s_(e) {
  var t = Object.keys(e);
  return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
}
var c_ = function(t) {
  var r = zt(Ip);
  r == null && (process.env.NODE_ENV !== "production" ? Ve(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Ve());
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? Ve(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(ao(t), "]. ").concat(s_(r))) : Ve()), n;
}, lD = function() {
  var t = zt(Ip);
  return Xt(t);
}, fD = function() {
  var t = zt(Np), r = aD(t, function(n) {
    return XO(n.domain, Number.isFinite);
  });
  return r || Xt(t);
}, l_ = function(t) {
  var r = zt(Np);
  r == null && (process.env.NODE_ENV !== "production" ? Ve(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Ve());
  var n = r[t];
  return n == null && (process.env.NODE_ENV !== "production" ? Ve(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(ao(t), "]. ").concat(s_(r))) : Ve()), n;
}, dD = function() {
  var t = zt(n_);
  return t;
}, pD = function() {
  return zt(i_);
}, kp = function() {
  return zt(u_);
}, Rp = function() {
  return zt(o_);
};
function vn(e) {
  "@babel/helpers - typeof";
  return vn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vn(e);
}
function hD(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function vD(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, d_(n.key), n);
  }
}
function yD(e, t, r) {
  return t && vD(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function mD(e, t, r) {
  return t = oo(t), gD(e, f_() ? Reflect.construct(t, r || [], oo(e).constructor) : t.apply(e, r));
}
function gD(e, t) {
  if (t && (vn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return bD(e);
}
function bD(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function f_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (f_ = function() {
    return !!e;
  })();
}
function oo(e) {
  return oo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, oo(e);
}
function xD(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && yd(e, t);
}
function yd(e, t) {
  return yd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, yd(e, t);
}
function M0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function C0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? M0(Object(r), !0).forEach(function(n) {
      Dp(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : M0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Dp(e, t, r) {
  return t = d_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function d_(e) {
  var t = wD(e, "string");
  return vn(t) == "symbol" ? t : t + "";
}
function wD(e, t) {
  if (vn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (vn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function OD(e, t) {
  return PD(e) || SD(e, t) || AD(e, t) || _D();
}
function _D() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function AD(e, t) {
  if (e) {
    if (typeof e == "string") return I0(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return I0(e, t);
  }
}
function I0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function SD(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], s = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(s = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function PD(e) {
  if (Array.isArray(e)) return e;
}
function md() {
  return md = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, md.apply(this, arguments);
}
var ED = function(t, r) {
  var n;
  return /* @__PURE__ */ S.isValidElement(t) ? n = /* @__PURE__ */ S.cloneElement(t, r) : re(t) ? n = t(r) : n = /* @__PURE__ */ S.createElement("line", md({}, r, {
    className: "recharts-reference-line-line"
  })), n;
}, jD = function(t, r, n, i, a, o, u, s, c) {
  var l = a.x, f = a.y, d = a.width, p = a.height;
  if (n) {
    var y = c.y, v = t.y.apply(y, {
      position: o
    });
    if (Pt(c, "discard") && !t.y.isInRange(v))
      return null;
    var h = [{
      x: l + d,
      y: v
    }, {
      x: l,
      y: v
    }];
    return s === "left" ? h.reverse() : h;
  }
  if (r) {
    var x = c.x, g = t.x.apply(x, {
      position: o
    });
    if (Pt(c, "discard") && !t.x.isInRange(g))
      return null;
    var b = [{
      x: g,
      y: f + p
    }, {
      x: g,
      y: f
    }];
    return u === "top" ? b.reverse() : b;
  }
  if (i) {
    var O = c.segment, m = O.map(function(w) {
      return t.apply(w, {
        position: o
      });
    });
    return Pt(c, "discard") && x2(m, function(w) {
      return !t.isInRange(w);
    }) ? null : m;
  }
  return null;
};
function TD(e) {
  var t = e.x, r = e.y, n = e.segment, i = e.xAxisId, a = e.yAxisId, o = e.shape, u = e.className, s = e.alwaysShow, c = cD(), l = c_(i), f = l_(a), d = dD();
  if (!c || !d)
    return null;
  xt(s === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var p = Cp({
    x: l.scale,
    y: f.scale
  }), y = Ie(t), v = Ie(r), h = n && n.length === 2, x = jD(p, y, v, h, d, e.position, l.orientation, f.orientation, e);
  if (!x)
    return null;
  var g = OD(x, 2), b = g[0], O = b.x, m = b.y, w = g[1], _ = w.x, P = w.y, T = Pt(e, "hidden") ? "url(#".concat(c, ")") : void 0, M = C0(C0({
    clipPath: T
  }, J(e, !0)), {}, {
    x1: O,
    y1: m,
    x2: _,
    y2: P
  });
  return /* @__PURE__ */ S.createElement(oe, {
    className: ae("recharts-reference-line", u)
  }, ED(o, M), Re.renderCallByParent(e, Z2({
    x1: O,
    y1: m,
    x2: _,
    y2: P
  })));
}
var Lp = /* @__PURE__ */ function(e) {
  function t() {
    return hD(this, t), mD(this, t, arguments);
  }
  return xD(t, e), yD(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ S.createElement(TD, this.props);
    }
  }]);
}(S.Component);
Dp(Lp, "displayName", "ReferenceLine");
Dp(Lp, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function gd() {
  return gd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, gd.apply(this, arguments);
}
function yn(e) {
  "@babel/helpers - typeof";
  return yn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, yn(e);
}
function N0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function k0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? N0(Object(r), !0).forEach(function(n) {
      Xo(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : N0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function $D(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function MD(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, h_(n.key), n);
  }
}
function CD(e, t, r) {
  return t && MD(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ID(e, t, r) {
  return t = uo(t), ND(e, p_() ? Reflect.construct(t, r || [], uo(e).constructor) : t.apply(e, r));
}
function ND(e, t) {
  if (t && (yn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return kD(e);
}
function kD(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function p_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (p_ = function() {
    return !!e;
  })();
}
function uo(e) {
  return uo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, uo(e);
}
function RD(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && bd(e, t);
}
function bd(e, t) {
  return bd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, bd(e, t);
}
function Xo(e, t, r) {
  return t = h_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function h_(e) {
  var t = DD(e, "string");
  return yn(t) == "symbol" ? t : t + "";
}
function DD(e, t) {
  if (yn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (yn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var LD = function(t) {
  var r = t.x, n = t.y, i = t.xAxis, a = t.yAxis, o = Cp({
    x: i.scale,
    y: a.scale
  }), u = o.apply({
    x: r,
    y: n
  }, {
    bandAware: !0
  });
  return Pt(t, "discard") && !o.isInRange(u) ? null : u;
}, Zo = /* @__PURE__ */ function(e) {
  function t() {
    return $D(this, t), ID(this, t, arguments);
  }
  return RD(t, e), CD(t, [{
    key: "render",
    value: function() {
      var n = this.props, i = n.x, a = n.y, o = n.r, u = n.alwaysShow, s = n.clipPathId, c = Ie(i), l = Ie(a);
      if (xt(u === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !c || !l)
        return null;
      var f = LD(this.props);
      if (!f)
        return null;
      var d = f.x, p = f.y, y = this.props, v = y.shape, h = y.className, x = Pt(this.props, "hidden") ? "url(#".concat(s, ")") : void 0, g = k0(k0({
        clipPath: x
      }, J(this.props, !0)), {}, {
        cx: d,
        cy: p
      });
      return /* @__PURE__ */ S.createElement(oe, {
        className: ae("recharts-reference-dot", h)
      }, t.renderDot(v, g), Re.renderCallByParent(this.props, {
        x: d - o,
        y: p - o,
        width: 2 * o,
        height: 2 * o
      }));
    }
  }]);
}(S.Component);
Xo(Zo, "displayName", "ReferenceDot");
Xo(Zo, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
Xo(Zo, "renderDot", function(e, t) {
  var r;
  return /* @__PURE__ */ S.isValidElement(e) ? r = /* @__PURE__ */ S.cloneElement(e, t) : re(e) ? r = e(t) : r = /* @__PURE__ */ S.createElement(Hi, gd({}, t, {
    cx: t.cx,
    cy: t.cy,
    className: "recharts-reference-dot-dot"
  })), r;
});
function xd() {
  return xd = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, xd.apply(this, arguments);
}
function mn(e) {
  "@babel/helpers - typeof";
  return mn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, mn(e);
}
function R0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function D0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? R0(Object(r), !0).forEach(function(n) {
      Jo(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : R0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function qD(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function BD(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, y_(n.key), n);
  }
}
function FD(e, t, r) {
  return t && BD(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function zD(e, t, r) {
  return t = so(t), WD(e, v_() ? Reflect.construct(t, r || [], so(e).constructor) : t.apply(e, r));
}
function WD(e, t) {
  if (t && (mn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return UD(e);
}
function UD(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function v_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (v_ = function() {
    return !!e;
  })();
}
function so(e) {
  return so = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, so(e);
}
function KD(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && wd(e, t);
}
function wd(e, t) {
  return wd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, wd(e, t);
}
function Jo(e, t, r) {
  return t = y_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function y_(e) {
  var t = HD(e, "string");
  return mn(t) == "symbol" ? t : t + "";
}
function HD(e, t) {
  if (mn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (mn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var GD = function(t, r, n, i, a) {
  var o = a.x1, u = a.x2, s = a.y1, c = a.y2, l = a.xAxis, f = a.yAxis;
  if (!l || !f) return null;
  var d = Cp({
    x: l.scale,
    y: f.scale
  }), p = {
    x: t ? d.x.apply(o, {
      position: "start"
    }) : d.x.rangeMin,
    y: n ? d.y.apply(s, {
      position: "start"
    }) : d.y.rangeMin
  }, y = {
    x: r ? d.x.apply(u, {
      position: "end"
    }) : d.x.rangeMax,
    y: i ? d.y.apply(c, {
      position: "end"
    }) : d.y.rangeMax
  };
  return Pt(a, "discard") && (!d.isInRange(p) || !d.isInRange(y)) ? null : t_(p, y);
}, Qo = /* @__PURE__ */ function(e) {
  function t() {
    return qD(this, t), zD(this, t, arguments);
  }
  return KD(t, e), FD(t, [{
    key: "render",
    value: function() {
      var n = this.props, i = n.x1, a = n.x2, o = n.y1, u = n.y2, s = n.className, c = n.alwaysShow, l = n.clipPathId;
      xt(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var f = Ie(i), d = Ie(a), p = Ie(o), y = Ie(u), v = this.props.shape;
      if (!f && !d && !p && !y && !v)
        return null;
      var h = GD(f, d, p, y, this.props);
      if (!h && !v)
        return null;
      var x = Pt(this.props, "hidden") ? "url(#".concat(l, ")") : void 0;
      return /* @__PURE__ */ S.createElement(oe, {
        className: ae("recharts-reference-area", s)
      }, t.renderRect(v, D0(D0({
        clipPath: x
      }, J(this.props, !0)), h)), Re.renderCallByParent(this.props, h));
    }
  }]);
}(S.Component);
Jo(Qo, "displayName", "ReferenceArea");
Jo(Qo, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
Jo(Qo, "renderRect", function(e, t) {
  var r;
  return /* @__PURE__ */ S.isValidElement(e) ? r = /* @__PURE__ */ S.cloneElement(e, t) : re(e) ? r = e(t) : r = /* @__PURE__ */ S.createElement(Mp, xd({}, t, {
    className: "recharts-reference-area-rect"
  })), r;
});
function m_(e, t, r) {
  if (t < 1)
    return [];
  if (t === 1 && r === void 0)
    return e;
  for (var n = [], i = 0; i < e.length; i += t)
    n.push(e[i]);
  return n;
}
function VD(e, t, r) {
  var n = {
    width: e.width + t.width,
    height: e.height + t.height
  };
  return Q2(n, r);
}
function YD(e, t, r) {
  var n = r === "width", i = e.x, a = e.y, o = e.width, u = e.height;
  return t === 1 ? {
    start: n ? i : a,
    end: n ? i + o : a + u
  } : {
    start: n ? i + o : a + u,
    end: n ? i : a
  };
}
function co(e, t, r, n, i) {
  if (e * t < e * n || e * t > e * i)
    return !1;
  var a = r();
  return e * (t - e * a / 2 - n) >= 0 && e * (t + e * a / 2 - i) <= 0;
}
function XD(e, t) {
  return m_(e, t + 1);
}
function ZD(e, t, r, n, i) {
  for (var a = (n || []).slice(), o = t.start, u = t.end, s = 0, c = 1, l = o, f = function() {
    var y = n == null ? void 0 : n[s];
    if (y === void 0)
      return {
        v: m_(n, c)
      };
    var v = s, h, x = function() {
      return h === void 0 && (h = r(y, v)), h;
    }, g = y.coordinate, b = s === 0 || co(e, g, x, l, u);
    b || (s = 0, l = o, c += 1), b && (l = g + e * (x() / 2 + i), s += c);
  }, d; c <= a.length; )
    if (d = f(), d) return d.v;
  return [];
}
function Di(e) {
  "@babel/helpers - typeof";
  return Di = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Di(e);
}
function L0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Be(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? L0(Object(r), !0).forEach(function(n) {
      JD(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : L0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function JD(e, t, r) {
  return t = QD(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function QD(e) {
  var t = eL(e, "string");
  return Di(t) == "symbol" ? t : t + "";
}
function eL(e, t) {
  if (Di(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Di(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function tL(e, t, r, n, i) {
  for (var a = (n || []).slice(), o = a.length, u = t.start, s = t.end, c = function(d) {
    var p = a[d], y, v = function() {
      return y === void 0 && (y = r(p, d)), y;
    };
    if (d === o - 1) {
      var h = e * (p.coordinate + e * v() / 2 - s);
      a[d] = p = Be(Be({}, p), {}, {
        tickCoord: h > 0 ? p.coordinate - h * e : p.coordinate
      });
    } else
      a[d] = p = Be(Be({}, p), {}, {
        tickCoord: p.coordinate
      });
    var x = co(e, p.tickCoord, v, u, s);
    x && (s = p.tickCoord - e * (v() / 2 + i), a[d] = Be(Be({}, p), {}, {
      isShow: !0
    }));
  }, l = o - 1; l >= 0; l--)
    c(l);
  return a;
}
function rL(e, t, r, n, i, a) {
  var o = (n || []).slice(), u = o.length, s = t.start, c = t.end;
  if (a) {
    var l = n[u - 1], f = r(l, u - 1), d = e * (l.coordinate + e * f / 2 - c);
    o[u - 1] = l = Be(Be({}, l), {}, {
      tickCoord: d > 0 ? l.coordinate - d * e : l.coordinate
    });
    var p = co(e, l.tickCoord, function() {
      return f;
    }, s, c);
    p && (c = l.tickCoord - e * (f / 2 + i), o[u - 1] = Be(Be({}, l), {}, {
      isShow: !0
    }));
  }
  for (var y = a ? u - 1 : u, v = function(g) {
    var b = o[g], O, m = function() {
      return O === void 0 && (O = r(b, g)), O;
    };
    if (g === 0) {
      var w = e * (b.coordinate - e * m() / 2 - s);
      o[g] = b = Be(Be({}, b), {}, {
        tickCoord: w < 0 ? b.coordinate - w * e : b.coordinate
      });
    } else
      o[g] = b = Be(Be({}, b), {}, {
        tickCoord: b.coordinate
      });
    var _ = co(e, b.tickCoord, m, s, c);
    _ && (s = b.tickCoord + e * (m() / 2 + i), o[g] = Be(Be({}, b), {}, {
      isShow: !0
    }));
  }, h = 0; h < y; h++)
    v(h);
  return o;
}
function qp(e, t, r) {
  var n = e.tick, i = e.ticks, a = e.viewBox, o = e.minTickGap, u = e.orientation, s = e.interval, c = e.tickFormatter, l = e.unit, f = e.angle;
  if (!i || !i.length || !n)
    return [];
  if (U(s) || Kt.isSsr)
    return XD(i, typeof s == "number" && U(s) ? s : 0);
  var d = [], p = u === "top" || u === "bottom" ? "width" : "height", y = l && p === "width" ? Zn(l, {
    fontSize: t,
    letterSpacing: r
  }) : {
    width: 0,
    height: 0
  }, v = function(b, O) {
    var m = re(c) ? c(b.value, O) : b.value;
    return p === "width" ? VD(Zn(m, {
      fontSize: t,
      letterSpacing: r
    }), y, f) : Zn(m, {
      fontSize: t,
      letterSpacing: r
    })[p];
  }, h = i.length >= 2 ? We(i[1].coordinate - i[0].coordinate) : 1, x = YD(a, h, p);
  return s === "equidistantPreserveStart" ? ZD(h, x, v, i, o) : (s === "preserveStart" || s === "preserveStartEnd" ? d = rL(h, x, v, i, o, s === "preserveStartEnd") : d = tL(h, x, v, i, o), d.filter(function(g) {
    return g.isShow;
  }));
}
var nL = ["viewBox"], iL = ["viewBox"], aL = ["ticks"];
function gn(e) {
  "@babel/helpers - typeof";
  return gn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, gn(e);
}
function Kr() {
  return Kr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Kr.apply(this, arguments);
}
function q0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $e(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? q0(Object(r), !0).forEach(function(n) {
      Bp(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : q0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function sf(e, t) {
  if (e == null) return {};
  var r = oL(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function oL(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function uL(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function B0(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, b_(n.key), n);
  }
}
function sL(e, t, r) {
  return t && B0(e.prototype, t), r && B0(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function cL(e, t, r) {
  return t = lo(t), lL(e, g_() ? Reflect.construct(t, r || [], lo(e).constructor) : t.apply(e, r));
}
function lL(e, t) {
  if (t && (gn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return fL(e);
}
function fL(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function g_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (g_ = function() {
    return !!e;
  })();
}
function lo(e) {
  return lo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, lo(e);
}
function dL(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Od(e, t);
}
function Od(e, t) {
  return Od = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Od(e, t);
}
function Bp(e, t, r) {
  return t = b_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function b_(e) {
  var t = pL(e, "string");
  return gn(t) == "symbol" ? t : t + "";
}
function pL(e, t) {
  if (gn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (gn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Rn = /* @__PURE__ */ function(e) {
  function t(r) {
    var n;
    return uL(this, t), n = cL(this, t, [r]), n.state = {
      fontSize: "",
      letterSpacing: ""
    }, n;
  }
  return dL(t, e), sL(t, [{
    key: "shouldComponentUpdate",
    value: function(n, i) {
      var a = n.viewBox, o = sf(n, nL), u = this.props, s = u.viewBox, c = sf(u, iL);
      return !Gr(a, s) || !Gr(o, c) || !Gr(i, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var n = this.layerReference;
      if (n) {
        var i = n.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        i && this.setState({
          fontSize: window.getComputedStyle(i).fontSize,
          letterSpacing: window.getComputedStyle(i).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(n) {
      var i = this.props, a = i.x, o = i.y, u = i.width, s = i.height, c = i.orientation, l = i.tickSize, f = i.mirror, d = i.tickMargin, p, y, v, h, x, g, b = f ? -1 : 1, O = n.tickSize || l, m = U(n.tickCoord) ? n.tickCoord : n.coordinate;
      switch (c) {
        case "top":
          p = y = n.coordinate, h = o + +!f * s, v = h - b * O, g = v - b * d, x = m;
          break;
        case "left":
          v = h = n.coordinate, y = a + +!f * u, p = y - b * O, x = p - b * d, g = m;
          break;
        case "right":
          v = h = n.coordinate, y = a + +f * u, p = y + b * O, x = p + b * d, g = m;
          break;
        default:
          p = y = n.coordinate, h = o + +f * s, v = h + b * O, g = v + b * d, x = m;
          break;
      }
      return {
        line: {
          x1: p,
          y1: v,
          x2: y,
          y2: h
        },
        tick: {
          x,
          y: g
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var n = this.props, i = n.orientation, a = n.mirror, o;
      switch (i) {
        case "left":
          o = a ? "start" : "end";
          break;
        case "right":
          o = a ? "end" : "start";
          break;
        default:
          o = "middle";
          break;
      }
      return o;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var n = this.props, i = n.orientation, a = n.mirror, o = "end";
      switch (i) {
        case "left":
        case "right":
          o = "middle";
          break;
        case "top":
          o = a ? "start" : "end";
          break;
        default:
          o = a ? "end" : "start";
          break;
      }
      return o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var n = this.props, i = n.x, a = n.y, o = n.width, u = n.height, s = n.orientation, c = n.mirror, l = n.axisLine, f = $e($e($e({}, J(this.props, !1)), J(l, !1)), {}, {
        fill: "none"
      });
      if (s === "top" || s === "bottom") {
        var d = +(s === "top" && !c || s === "bottom" && c);
        f = $e($e({}, f), {}, {
          x1: i,
          y1: a + d * u,
          x2: i + o,
          y2: a + d * u
        });
      } else {
        var p = +(s === "left" && !c || s === "right" && c);
        f = $e($e({}, f), {}, {
          x1: i + p * o,
          y1: a,
          x2: i + p * o,
          y2: a + u
        });
      }
      return /* @__PURE__ */ S.createElement("line", Kr({}, f, {
        className: ae("recharts-cartesian-axis-line", et(l, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(n, i, a) {
        var o = this, u = this.props, s = u.tickLine, c = u.stroke, l = u.tick, f = u.tickFormatter, d = u.unit, p = qp($e($e({}, this.props), {}, {
          ticks: n
        }), i, a), y = this.getTickTextAnchor(), v = this.getTickVerticalAnchor(), h = J(this.props, !1), x = J(l, !1), g = $e($e({}, h), {}, {
          fill: "none"
        }, J(s, !1)), b = p.map(function(O, m) {
          var w = o.getTickLineCoord(O), _ = w.line, P = w.tick, T = $e($e($e($e({
            textAnchor: y,
            verticalAnchor: v
          }, h), {}, {
            stroke: "none",
            fill: c
          }, x), P), {}, {
            index: m,
            payload: O,
            visibleTicksCount: p.length,
            tickFormatter: f
          });
          return /* @__PURE__ */ S.createElement(oe, Kr({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(O.value, "-").concat(O.coordinate, "-").concat(O.tickCoord)
          }, nr(o.props, O, m)), s && /* @__PURE__ */ S.createElement("line", Kr({}, g, _, {
            className: ae("recharts-cartesian-axis-tick-line", et(s, "className"))
          })), l && t.renderTickItem(l, T, "".concat(re(f) ? f(O.value, m) : O.value).concat(d || "")));
        });
        return /* @__PURE__ */ S.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, b);
      }
    )
  }, {
    key: "render",
    value: function() {
      var n = this, i = this.props, a = i.axisLine, o = i.width, u = i.height, s = i.ticksGenerator, c = i.className, l = i.hide;
      if (l)
        return null;
      var f = this.props, d = f.ticks, p = sf(f, aL), y = d;
      return re(s) && (y = d && d.length > 0 ? s(this.props) : s(p)), o <= 0 || u <= 0 || !y || !y.length ? null : /* @__PURE__ */ S.createElement(oe, {
        className: ae("recharts-cartesian-axis", c),
        ref: function(h) {
          n.layerReference = h;
        }
      }, a && this.renderAxisLine(), this.renderTicks(y, this.state.fontSize, this.state.letterSpacing), Re.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(n, i, a) {
      var o, u = ae(i.className, "recharts-cartesian-axis-tick-value");
      return /* @__PURE__ */ S.isValidElement(n) ? o = /* @__PURE__ */ S.cloneElement(n, $e($e({}, i), {}, {
        className: u
      })) : re(n) ? o = n($e($e({}, i), {}, {
        className: u
      })) : o = /* @__PURE__ */ S.createElement(jr, Kr({}, i, {
        className: "recharts-cartesian-axis-tick-value"
      }), a), o;
    }
  }]);
}(lx);
Bp(Rn, "displayName", "CartesianAxis");
Bp(Rn, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var hL = ["x1", "y1", "x2", "y2", "key"], vL = ["offset"];
function $r(e) {
  "@babel/helpers - typeof";
  return $r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, $r(e);
}
function F0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Fe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? F0(Object(r), !0).forEach(function(n) {
      yL(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : F0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function yL(e, t, r) {
  return t = mL(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function mL(e) {
  var t = gL(e, "string");
  return $r(t) == "symbol" ? t : t + "";
}
function gL(e, t) {
  if ($r(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if ($r(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function wr() {
  return wr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, wr.apply(this, arguments);
}
function z0(e, t) {
  if (e == null) return {};
  var r = bL(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function bL(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
var xL = function(t) {
  var r = t.fill;
  if (!r || r === "none")
    return null;
  var n = t.fillOpacity, i = t.x, a = t.y, o = t.width, u = t.height, s = t.ry;
  return /* @__PURE__ */ S.createElement("rect", {
    x: i,
    y: a,
    ry: s,
    width: o,
    height: u,
    stroke: "none",
    fill: r,
    fillOpacity: n,
    className: "recharts-cartesian-grid-bg"
  });
};
function x_(e, t) {
  var r;
  if (/* @__PURE__ */ S.isValidElement(e))
    r = /* @__PURE__ */ S.cloneElement(e, t);
  else if (re(e))
    r = e(t);
  else {
    var n = t.x1, i = t.y1, a = t.x2, o = t.y2, u = t.key, s = z0(t, hL), c = J(s, !1);
    c.offset;
    var l = z0(c, vL);
    r = /* @__PURE__ */ S.createElement("line", wr({}, l, {
      x1: n,
      y1: i,
      x2: a,
      y2: o,
      fill: "none",
      key: u
    }));
  }
  return r;
}
function wL(e) {
  var t = e.x, r = e.width, n = e.horizontal, i = n === void 0 ? !0 : n, a = e.horizontalPoints;
  if (!i || !a || !a.length)
    return null;
  var o = a.map(function(u, s) {
    var c = Fe(Fe({}, e), {}, {
      x1: t,
      y1: u,
      x2: t + r,
      y2: u,
      key: "line-".concat(s),
      index: s
    });
    return x_(i, c);
  });
  return /* @__PURE__ */ S.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, o);
}
function OL(e) {
  var t = e.y, r = e.height, n = e.vertical, i = n === void 0 ? !0 : n, a = e.verticalPoints;
  if (!i || !a || !a.length)
    return null;
  var o = a.map(function(u, s) {
    var c = Fe(Fe({}, e), {}, {
      x1: u,
      y1: t,
      x2: u,
      y2: t + r,
      key: "line-".concat(s),
      index: s
    });
    return x_(i, c);
  });
  return /* @__PURE__ */ S.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, o);
}
function _L(e) {
  var t = e.horizontalFill, r = e.fillOpacity, n = e.x, i = e.y, a = e.width, o = e.height, u = e.horizontalPoints, s = e.horizontal, c = s === void 0 ? !0 : s;
  if (!c || !t || !t.length)
    return null;
  var l = u.map(function(d) {
    return Math.round(d + i - i);
  }).sort(function(d, p) {
    return d - p;
  });
  i !== l[0] && l.unshift(0);
  var f = l.map(function(d, p) {
    var y = !l[p + 1], v = y ? i + o - d : l[p + 1] - d;
    if (v <= 0)
      return null;
    var h = p % t.length;
    return /* @__PURE__ */ S.createElement("rect", {
      key: "react-".concat(p),
      y: d,
      x: n,
      height: v,
      width: a,
      stroke: "none",
      fill: t[h],
      fillOpacity: r,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ S.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, f);
}
function AL(e) {
  var t = e.vertical, r = t === void 0 ? !0 : t, n = e.verticalFill, i = e.fillOpacity, a = e.x, o = e.y, u = e.width, s = e.height, c = e.verticalPoints;
  if (!r || !n || !n.length)
    return null;
  var l = c.map(function(d) {
    return Math.round(d + a - a);
  }).sort(function(d, p) {
    return d - p;
  });
  a !== l[0] && l.unshift(0);
  var f = l.map(function(d, p) {
    var y = !l[p + 1], v = y ? a + u - d : l[p + 1] - d;
    if (v <= 0)
      return null;
    var h = p % n.length;
    return /* @__PURE__ */ S.createElement("rect", {
      key: "react-".concat(p),
      x: d,
      y: o,
      width: v,
      height: s,
      stroke: "none",
      fill: n[h],
      fillOpacity: i,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ S.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, f);
}
var SL = function(t, r) {
  var n = t.xAxis, i = t.width, a = t.height, o = t.offset;
  return bO(qp(Fe(Fe(Fe({}, Rn.defaultProps), n), {}, {
    ticks: Rt(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: i,
      height: a
    }
  })), o.left, o.left + o.width, r);
}, PL = function(t, r) {
  var n = t.yAxis, i = t.width, a = t.height, o = t.offset;
  return bO(qp(Fe(Fe(Fe({}, Rn.defaultProps), n), {}, {
    ticks: Rt(n, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: i,
      height: a
    }
  })), o.top, o.top + o.height, r);
}, Br = {
  horizontal: !0,
  vertical: !0,
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function w_(e) {
  var t, r, n, i, a, o, u = kp(), s = Rp(), c = pD(), l = Fe(Fe({}, e), {}, {
    stroke: (t = e.stroke) !== null && t !== void 0 ? t : Br.stroke,
    fill: (r = e.fill) !== null && r !== void 0 ? r : Br.fill,
    horizontal: (n = e.horizontal) !== null && n !== void 0 ? n : Br.horizontal,
    horizontalFill: (i = e.horizontalFill) !== null && i !== void 0 ? i : Br.horizontalFill,
    vertical: (a = e.vertical) !== null && a !== void 0 ? a : Br.vertical,
    verticalFill: (o = e.verticalFill) !== null && o !== void 0 ? o : Br.verticalFill,
    x: U(e.x) ? e.x : c.left,
    y: U(e.y) ? e.y : c.top,
    width: U(e.width) ? e.width : c.width,
    height: U(e.height) ? e.height : c.height
  }), f = l.x, d = l.y, p = l.width, y = l.height, v = l.syncWithTicks, h = l.horizontalValues, x = l.verticalValues, g = lD(), b = fD();
  if (!U(p) || p <= 0 || !U(y) || y <= 0 || !U(f) || f !== +f || !U(d) || d !== +d)
    return null;
  var O = l.verticalCoordinatesGenerator || SL, m = l.horizontalCoordinatesGenerator || PL, w = l.horizontalPoints, _ = l.verticalPoints;
  if ((!w || !w.length) && re(m)) {
    var P = h && h.length, T = m({
      yAxis: b ? Fe(Fe({}, b), {}, {
        ticks: P ? h : b.ticks
      }) : void 0,
      width: u,
      height: s,
      offset: c
    }, P ? !0 : v);
    xt(Array.isArray(T), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat($r(T), "]")), Array.isArray(T) && (w = T);
  }
  if ((!_ || !_.length) && re(O)) {
    var M = x && x.length, j = O({
      xAxis: g ? Fe(Fe({}, g), {}, {
        ticks: M ? x : g.ticks
      }) : void 0,
      width: u,
      height: s,
      offset: c
    }, M ? !0 : v);
    xt(Array.isArray(j), "verticalCoordinatesGenerator should return Array but instead it returned [".concat($r(j), "]")), Array.isArray(j) && (_ = j);
  }
  return /* @__PURE__ */ S.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ S.createElement(xL, {
    fill: l.fill,
    fillOpacity: l.fillOpacity,
    x: l.x,
    y: l.y,
    width: l.width,
    height: l.height,
    ry: l.ry
  }), /* @__PURE__ */ S.createElement(wL, wr({}, l, {
    offset: c,
    horizontalPoints: w,
    xAxis: g,
    yAxis: b
  })), /* @__PURE__ */ S.createElement(OL, wr({}, l, {
    offset: c,
    verticalPoints: _,
    xAxis: g,
    yAxis: b
  })), /* @__PURE__ */ S.createElement(_L, wr({}, l, {
    horizontalPoints: w
  })), /* @__PURE__ */ S.createElement(AL, wr({}, l, {
    verticalPoints: _
  })));
}
w_.displayName = "CartesianGrid";
var EL = ["type", "layout", "connectNulls", "ref"], jL = ["key"];
function bn(e) {
  "@babel/helpers - typeof";
  return bn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, bn(e);
}
function W0(e, t) {
  if (e == null) return {};
  var r = TL(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function TL(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function ni() {
  return ni = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ni.apply(this, arguments);
}
function U0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Xe(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? U0(Object(r), !0).forEach(function(n) {
      mt(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : U0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Fr(e) {
  return IL(e) || CL(e) || ML(e) || $L();
}
function $L() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ML(e, t) {
  if (e) {
    if (typeof e == "string") return _d(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return _d(e, t);
  }
}
function CL(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function IL(e) {
  if (Array.isArray(e)) return _d(e);
}
function _d(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function NL(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function K0(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, __(n.key), n);
  }
}
function kL(e, t, r) {
  return t && K0(e.prototype, t), r && K0(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function RL(e, t, r) {
  return t = fo(t), DL(e, O_() ? Reflect.construct(t, r || [], fo(e).constructor) : t.apply(e, r));
}
function DL(e, t) {
  if (t && (bn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return LL(e);
}
function LL(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function O_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (O_ = function() {
    return !!e;
  })();
}
function fo(e) {
  return fo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, fo(e);
}
function qL(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ad(e, t);
}
function Ad(e, t) {
  return Ad = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Ad(e, t);
}
function mt(e, t, r) {
  return t = __(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function __(e) {
  var t = BL(e, "string");
  return bn(t) == "symbol" ? t : t + "";
}
function BL(e, t) {
  if (bn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (bn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Gi = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    NL(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = RL(this, t, [].concat(i)), mt(r, "state", {
      isAnimationFinished: !0,
      totalLength: 0
    }), mt(r, "generateSimpleStrokeDasharray", function(o, u) {
      return "".concat(u, "px ").concat(o - u, "px");
    }), mt(r, "getStrokeDasharray", function(o, u, s) {
      var c = s.reduce(function(x, g) {
        return x + g;
      });
      if (!c)
        return r.generateSimpleStrokeDasharray(u, o);
      for (var l = Math.floor(o / c), f = o % c, d = u - o, p = [], y = 0, v = 0; y < s.length; v += s[y], ++y)
        if (v + s[y] > f) {
          p = [].concat(Fr(s.slice(0, y)), [f - v]);
          break;
        }
      var h = p.length % 2 === 0 ? [0, d] : [d];
      return [].concat(Fr(t.repeat(s, l)), Fr(p), h).map(function(x) {
        return "".concat(x, "px");
      }).join(", ");
    }), mt(r, "id", ur("recharts-line-")), mt(r, "pathRef", function(o) {
      r.mainCurve = o;
    }), mt(r, "handleAnimationEnd", function() {
      r.setState({
        isAnimationFinished: !0
      }), r.props.onAnimationEnd && r.props.onAnimationEnd();
    }), mt(r, "handleAnimationStart", function() {
      r.setState({
        isAnimationFinished: !1
      }), r.props.onAnimationStart && r.props.onAnimationStart();
    }), r;
  }
  return qL(t, e), kL(t, [{
    key: "componentDidMount",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      if (this.props.isAnimationActive) {
        var n = this.getTotalLength();
        n !== this.state.totalLength && this.setState({
          totalLength: n
        });
      }
    }
  }, {
    key: "getTotalLength",
    value: function() {
      var n = this.mainCurve;
      try {
        return n && n.getTotalLength && n.getTotalLength() || 0;
      } catch {
        return 0;
      }
    }
  }, {
    key: "renderErrorBar",
    value: function(n, i) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var a = this.props, o = a.points, u = a.xAxis, s = a.yAxis, c = a.layout, l = a.children, f = He(l, kn);
      if (!f)
        return null;
      var d = function(v, h) {
        return {
          x: v.x,
          y: v.y,
          value: v.value,
          errorVal: _e(v.payload, h)
        };
      }, p = {
        clipPath: n ? "url(#clipPath-".concat(i, ")") : null
      };
      return /* @__PURE__ */ S.createElement(oe, p, f.map(function(y) {
        return /* @__PURE__ */ S.cloneElement(y, {
          key: "bar-".concat(y.props.dataKey),
          data: o,
          xAxis: u,
          yAxis: s,
          layout: c,
          dataPointFormatter: d
        });
      }));
    }
  }, {
    key: "renderDots",
    value: function(n, i, a) {
      var o = this.props.isAnimationActive;
      if (o && !this.state.isAnimationFinished)
        return null;
      var u = this.props, s = u.dot, c = u.points, l = u.dataKey, f = J(this.props, !1), d = J(s, !0), p = c.map(function(v, h) {
        var x = Xe(Xe(Xe({
          key: "dot-".concat(h),
          r: 3
        }, f), d), {}, {
          index: h,
          cx: v.x,
          cy: v.y,
          value: v.value,
          dataKey: l,
          payload: v.payload,
          points: c
        });
        return t.renderDotItem(s, x);
      }), y = {
        clipPath: n ? "url(#clipPath-".concat(i ? "" : "dots-").concat(a, ")") : null
      };
      return /* @__PURE__ */ S.createElement(oe, ni({
        className: "recharts-line-dots",
        key: "dots"
      }, y), p);
    }
  }, {
    key: "renderCurveStatically",
    value: function(n, i, a, o) {
      var u = this.props, s = u.type, c = u.layout, l = u.connectNulls;
      u.ref;
      var f = W0(u, EL), d = Xe(Xe(Xe({}, J(f, !0)), {}, {
        fill: "none",
        className: "recharts-line-curve",
        clipPath: i ? "url(#clipPath-".concat(a, ")") : null,
        points: n
      }, o), {}, {
        type: s,
        layout: c,
        connectNulls: l
      });
      return /* @__PURE__ */ S.createElement(rr, ni({}, d, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function(n, i) {
      var a = this, o = this.props, u = o.points, s = o.strokeDasharray, c = o.isAnimationActive, l = o.animationBegin, f = o.animationDuration, d = o.animationEasing, p = o.animationId, y = o.animateNewValues, v = o.width, h = o.height, x = this.state, g = x.prevPoints, b = x.totalLength;
      return /* @__PURE__ */ S.createElement(pt, {
        begin: l,
        duration: f,
        isActive: c,
        easing: d,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(p),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(O) {
        var m = O.t;
        if (g) {
          var w = g.length / u.length, _ = u.map(function($, I) {
            var k = Math.floor(I * w);
            if (g[k]) {
              var R = g[k], D = Pe(R.x, $.x), B = Pe(R.y, $.y);
              return Xe(Xe({}, $), {}, {
                x: D(m),
                y: B(m)
              });
            }
            if (y) {
              var W = Pe(v * 2, $.x), K = Pe(h / 2, $.y);
              return Xe(Xe({}, $), {}, {
                x: W(m),
                y: K(m)
              });
            }
            return Xe(Xe({}, $), {}, {
              x: $.x,
              y: $.y
            });
          });
          return a.renderCurveStatically(_, n, i);
        }
        var P = Pe(0, b), T = P(m), M;
        if (s) {
          var j = "".concat(s).split(/[,\s]+/gim).map(function($) {
            return parseFloat($);
          });
          M = a.getStrokeDasharray(T, b, j);
        } else
          M = a.generateSimpleStrokeDasharray(b, T);
        return a.renderCurveStatically(u, n, i, {
          strokeDasharray: M
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function(n, i) {
      var a = this.props, o = a.points, u = a.isAnimationActive, s = this.state, c = s.prevPoints, l = s.totalLength;
      return u && o && o.length && (!c && l > 0 || !ir(c, o)) ? this.renderCurveWithAnimation(n, i) : this.renderCurveStatically(o, n, i);
    }
  }, {
    key: "render",
    value: function() {
      var n, i = this.props, a = i.hide, o = i.dot, u = i.points, s = i.className, c = i.xAxis, l = i.yAxis, f = i.top, d = i.left, p = i.width, y = i.height, v = i.isAnimationActive, h = i.id;
      if (a || !u || !u.length)
        return null;
      var x = this.state.isAnimationFinished, g = u.length === 1, b = ae("recharts-line", s), O = c && c.allowDataOverflow, m = l && l.allowDataOverflow, w = O || m, _ = te(h) ? this.id : h, P = (n = J(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, T = P.r, M = T === void 0 ? 3 : T, j = P.strokeWidth, $ = j === void 0 ? 2 : j, I = wx(o) ? o : {}, k = I.clipDot, R = k === void 0 ? !0 : k, D = M * 2 + $;
      return /* @__PURE__ */ S.createElement(oe, {
        className: b
      }, O || m ? /* @__PURE__ */ S.createElement("defs", null, /* @__PURE__ */ S.createElement("clipPath", {
        id: "clipPath-".concat(_)
      }, /* @__PURE__ */ S.createElement("rect", {
        x: O ? d : d - p / 2,
        y: m ? f : f - y / 2,
        width: O ? p : p * 2,
        height: m ? y : y * 2
      })), !R && /* @__PURE__ */ S.createElement("clipPath", {
        id: "clipPath-dots-".concat(_)
      }, /* @__PURE__ */ S.createElement("rect", {
        x: d - D / 2,
        y: f - D / 2,
        width: p + D,
        height: y + D
      }))) : null, !g && this.renderCurve(w, _), this.renderErrorBar(w, _), (g || o) && this.renderDots(w, R, _), (!v || x) && wt.renderCallByParent(this.props, u));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, i) {
      return n.animationId !== i.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: i.curPoints
      } : n.points !== i.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }, {
    key: "repeat",
    value: function(n, i) {
      for (var a = n.length % 2 !== 0 ? [].concat(Fr(n), [0]) : n, o = [], u = 0; u < i; ++u)
        o = [].concat(Fr(o), Fr(a));
      return o;
    }
  }, {
    key: "renderDotItem",
    value: function(n, i) {
      var a;
      if (/* @__PURE__ */ S.isValidElement(n))
        a = /* @__PURE__ */ S.cloneElement(n, i);
      else if (re(n))
        a = n(i);
      else {
        var o = i.key, u = W0(i, jL), s = ae("recharts-line-dot", typeof n != "boolean" ? n.className : "");
        a = /* @__PURE__ */ S.createElement(Hi, ni({
          key: o
        }, u, {
          className: s
        }));
      }
      return a;
    }
  }]);
}(tt);
mt(Gi, "displayName", "Line");
mt(Gi, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: !1,
  activeDot: !0,
  dot: !0,
  legendType: "line",
  stroke: "#3182bd",
  strokeWidth: 1,
  fill: "#fff",
  points: [],
  isAnimationActive: !Kt.isSsr,
  animateNewValues: !0,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease",
  hide: !1,
  label: !1
});
mt(Gi, "getComposedData", function(e) {
  var t = e.props, r = e.xAxis, n = e.yAxis, i = e.xAxisTicks, a = e.yAxisTicks, o = e.dataKey, u = e.bandSize, s = e.displayedData, c = e.offset, l = t.layout, f = s.map(function(d, p) {
    var y = _e(d, o);
    return l === "horizontal" ? {
      x: on({
        axis: r,
        ticks: i,
        bandSize: u,
        entry: d,
        index: p
      }),
      y: te(y) ? null : n.scale(y),
      value: y,
      payload: d
    } : {
      x: te(y) ? null : r.scale(y),
      y: on({
        axis: n,
        ticks: a,
        bandSize: u,
        entry: d,
        index: p
      }),
      value: y,
      payload: d
    };
  });
  return Xe({
    points: f,
    layout: l
  }, c);
});
var FL = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], zL = ["key"], A_;
function xn(e) {
  "@babel/helpers - typeof";
  return xn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, xn(e);
}
function S_(e, t) {
  if (e == null) return {};
  var r = WL(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function WL(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function Or() {
  return Or = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Or.apply(this, arguments);
}
function H0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Vt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? H0(Object(r), !0).forEach(function(n) {
      At(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : H0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function UL(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function G0(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, E_(n.key), n);
  }
}
function KL(e, t, r) {
  return t && G0(e.prototype, t), r && G0(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function HL(e, t, r) {
  return t = po(t), GL(e, P_() ? Reflect.construct(t, r || [], po(e).constructor) : t.apply(e, r));
}
function GL(e, t) {
  if (t && (xn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return VL(e);
}
function VL(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function P_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (P_ = function() {
    return !!e;
  })();
}
function po(e) {
  return po = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, po(e);
}
function YL(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Sd(e, t);
}
function Sd(e, t) {
  return Sd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Sd(e, t);
}
function At(e, t, r) {
  return t = E_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function E_(e) {
  var t = XL(e, "string");
  return xn(t) == "symbol" ? t : t + "";
}
function XL(e, t) {
  if (xn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (xn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var Rr = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    UL(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = HL(this, t, [].concat(i)), At(r, "state", {
      isAnimationFinished: !0
    }), At(r, "id", ur("recharts-area-")), At(r, "handleAnimationEnd", function() {
      var o = r.props.onAnimationEnd;
      r.setState({
        isAnimationFinished: !0
      }), re(o) && o();
    }), At(r, "handleAnimationStart", function() {
      var o = r.props.onAnimationStart;
      r.setState({
        isAnimationFinished: !1
      }), re(o) && o();
    }), r;
  }
  return YL(t, e), KL(t, [{
    key: "renderDots",
    value: function(n, i, a) {
      var o = this.props.isAnimationActive, u = this.state.isAnimationFinished;
      if (o && !u)
        return null;
      var s = this.props, c = s.dot, l = s.points, f = s.dataKey, d = J(this.props, !1), p = J(c, !0), y = l.map(function(h, x) {
        var g = Vt(Vt(Vt({
          key: "dot-".concat(x),
          r: 3
        }, d), p), {}, {
          index: x,
          cx: h.x,
          cy: h.y,
          dataKey: f,
          value: h.value,
          payload: h.payload,
          points: l
        });
        return t.renderDotItem(c, g);
      }), v = {
        clipPath: n ? "url(#clipPath-".concat(i ? "" : "dots-").concat(a, ")") : null
      };
      return /* @__PURE__ */ S.createElement(oe, Or({
        className: "recharts-area-dots"
      }, v), y);
    }
  }, {
    key: "renderHorizontalRect",
    value: function(n) {
      var i = this.props, a = i.baseLine, o = i.points, u = i.strokeWidth, s = o[0].x, c = o[o.length - 1].x, l = n * Math.abs(s - c), f = Zt(o.map(function(d) {
        return d.y || 0;
      }));
      return U(a) && typeof a == "number" ? f = Math.max(a, f) : a && Array.isArray(a) && a.length && (f = Math.max(Zt(a.map(function(d) {
        return d.y || 0;
      })), f)), U(f) ? /* @__PURE__ */ S.createElement("rect", {
        x: s < c ? s : s - l,
        y: 0,
        width: l,
        height: Math.floor(f + (u ? parseInt("".concat(u), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(n) {
      var i = this.props, a = i.baseLine, o = i.points, u = i.strokeWidth, s = o[0].y, c = o[o.length - 1].y, l = n * Math.abs(s - c), f = Zt(o.map(function(d) {
        return d.x || 0;
      }));
      return U(a) && typeof a == "number" ? f = Math.max(a, f) : a && Array.isArray(a) && a.length && (f = Math.max(Zt(a.map(function(d) {
        return d.x || 0;
      })), f)), U(f) ? /* @__PURE__ */ S.createElement("rect", {
        x: 0,
        y: s < c ? s : s - l,
        width: f + (u ? parseInt("".concat(u), 10) : 1),
        height: Math.floor(l)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(n) {
      var i = this.props.layout;
      return i === "vertical" ? this.renderVerticalRect(n) : this.renderHorizontalRect(n);
    }
  }, {
    key: "renderAreaStatically",
    value: function(n, i, a, o) {
      var u = this.props, s = u.layout, c = u.type, l = u.stroke, f = u.connectNulls, d = u.isRange;
      u.ref;
      var p = S_(u, FL);
      return /* @__PURE__ */ S.createElement(oe, {
        clipPath: a ? "url(#clipPath-".concat(o, ")") : null
      }, /* @__PURE__ */ S.createElement(rr, Or({}, J(p, !0), {
        points: n,
        connectNulls: f,
        type: c,
        baseLine: i,
        layout: s,
        stroke: "none",
        className: "recharts-area-area"
      })), l !== "none" && /* @__PURE__ */ S.createElement(rr, Or({}, J(this.props, !1), {
        className: "recharts-area-curve",
        layout: s,
        type: c,
        connectNulls: f,
        fill: "none",
        points: n
      })), l !== "none" && d && /* @__PURE__ */ S.createElement(rr, Or({}, J(this.props, !1), {
        className: "recharts-area-curve",
        layout: s,
        type: c,
        connectNulls: f,
        fill: "none",
        points: i
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(n, i) {
      var a = this, o = this.props, u = o.points, s = o.baseLine, c = o.isAnimationActive, l = o.animationBegin, f = o.animationDuration, d = o.animationEasing, p = o.animationId, y = this.state, v = y.prevPoints, h = y.prevBaseLine;
      return /* @__PURE__ */ S.createElement(pt, {
        begin: l,
        duration: f,
        isActive: c,
        easing: d,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(p),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(x) {
        var g = x.t;
        if (v) {
          var b = v.length / u.length, O = u.map(function(P, T) {
            var M = Math.floor(T * b);
            if (v[M]) {
              var j = v[M], $ = Pe(j.x, P.x), I = Pe(j.y, P.y);
              return Vt(Vt({}, P), {}, {
                x: $(g),
                y: I(g)
              });
            }
            return P;
          }), m;
          if (U(s) && typeof s == "number") {
            var w = Pe(h, s);
            m = w(g);
          } else if (te(s) || Tn(s)) {
            var _ = Pe(h, 0);
            m = _(g);
          } else
            m = s.map(function(P, T) {
              var M = Math.floor(T * b);
              if (h[M]) {
                var j = h[M], $ = Pe(j.x, P.x), I = Pe(j.y, P.y);
                return Vt(Vt({}, P), {}, {
                  x: $(g),
                  y: I(g)
                });
              }
              return P;
            });
          return a.renderAreaStatically(O, m, n, i);
        }
        return /* @__PURE__ */ S.createElement(oe, null, /* @__PURE__ */ S.createElement("defs", null, /* @__PURE__ */ S.createElement("clipPath", {
          id: "animationClipPath-".concat(i)
        }, a.renderClipRect(g))), /* @__PURE__ */ S.createElement(oe, {
          clipPath: "url(#animationClipPath-".concat(i, ")")
        }, a.renderAreaStatically(u, s, n, i)));
      });
    }
  }, {
    key: "renderArea",
    value: function(n, i) {
      var a = this.props, o = a.points, u = a.baseLine, s = a.isAnimationActive, c = this.state, l = c.prevPoints, f = c.prevBaseLine, d = c.totalLength;
      return s && o && o.length && (!l && d > 0 || !ir(l, o) || !ir(f, u)) ? this.renderAreaWithAnimation(n, i) : this.renderAreaStatically(o, u, n, i);
    }
  }, {
    key: "render",
    value: function() {
      var n, i = this.props, a = i.hide, o = i.dot, u = i.points, s = i.className, c = i.top, l = i.left, f = i.xAxis, d = i.yAxis, p = i.width, y = i.height, v = i.isAnimationActive, h = i.id;
      if (a || !u || !u.length)
        return null;
      var x = this.state.isAnimationFinished, g = u.length === 1, b = ae("recharts-area", s), O = f && f.allowDataOverflow, m = d && d.allowDataOverflow, w = O || m, _ = te(h) ? this.id : h, P = (n = J(o, !1)) !== null && n !== void 0 ? n : {
        r: 3,
        strokeWidth: 2
      }, T = P.r, M = T === void 0 ? 3 : T, j = P.strokeWidth, $ = j === void 0 ? 2 : j, I = wx(o) ? o : {}, k = I.clipDot, R = k === void 0 ? !0 : k, D = M * 2 + $;
      return /* @__PURE__ */ S.createElement(oe, {
        className: b
      }, O || m ? /* @__PURE__ */ S.createElement("defs", null, /* @__PURE__ */ S.createElement("clipPath", {
        id: "clipPath-".concat(_)
      }, /* @__PURE__ */ S.createElement("rect", {
        x: O ? l : l - p / 2,
        y: m ? c : c - y / 2,
        width: O ? p : p * 2,
        height: m ? y : y * 2
      })), !R && /* @__PURE__ */ S.createElement("clipPath", {
        id: "clipPath-dots-".concat(_)
      }, /* @__PURE__ */ S.createElement("rect", {
        x: l - D / 2,
        y: c - D / 2,
        width: p + D,
        height: y + D
      }))) : null, g ? null : this.renderArea(w, _), (o || g) && this.renderDots(w, R, _), (!v || x) && wt.renderCallByParent(this.props, u));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, i) {
      return n.animationId !== i.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        curBaseLine: n.baseLine,
        prevPoints: i.curPoints,
        prevBaseLine: i.curBaseLine
      } : n.points !== i.curPoints || n.baseLine !== i.curBaseLine ? {
        curPoints: n.points,
        curBaseLine: n.baseLine
      } : null;
    }
  }]);
}(tt);
A_ = Rr;
At(Rr, "displayName", "Area");
At(Rr, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  // points of area
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !Kt.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
At(Rr, "getBaseValue", function(e, t, r, n) {
  var i = e.layout, a = e.baseValue, o = t.props.baseValue, u = o ?? a;
  if (U(u) && typeof u == "number")
    return u;
  var s = i === "horizontal" ? n : r, c = s.scale.domain();
  if (s.type === "number") {
    var l = Math.max(c[0], c[1]), f = Math.min(c[0], c[1]);
    return u === "dataMin" ? f : u === "dataMax" || l < 0 ? l : Math.max(Math.min(c[0], c[1]), 0);
  }
  return u === "dataMin" ? c[0] : u === "dataMax" ? c[1] : c[0];
});
At(Rr, "getComposedData", function(e) {
  var t = e.props, r = e.item, n = e.xAxis, i = e.yAxis, a = e.xAxisTicks, o = e.yAxisTicks, u = e.bandSize, s = e.dataKey, c = e.stackedData, l = e.dataStartIndex, f = e.displayedData, d = e.offset, p = t.layout, y = c && c.length, v = A_.getBaseValue(t, r, n, i), h = p === "horizontal", x = !1, g = f.map(function(O, m) {
    var w;
    y ? w = c[l + m] : (w = _e(O, s), Array.isArray(w) ? x = !0 : w = [v, w]);
    var _ = w[1] == null || y && _e(O, s) == null;
    return h ? {
      x: on({
        axis: n,
        ticks: a,
        bandSize: u,
        entry: O,
        index: m
      }),
      y: _ ? null : i.scale(w[1]),
      value: w,
      payload: O
    } : {
      x: _ ? null : n.scale(w[1]),
      y: on({
        axis: i,
        ticks: o,
        bandSize: u,
        entry: O,
        index: m
      }),
      value: w,
      payload: O
    };
  }), b;
  return y || x ? b = g.map(function(O) {
    var m = Array.isArray(O.value) ? O.value[0] : null;
    return h ? {
      x: O.x,
      y: m != null && O.y != null ? i.scale(m) : null
    } : {
      x: m != null ? n.scale(m) : null,
      y: O.y
    };
  }) : b = h ? i.scale(v) : n.scale(v), Vt({
    points: g,
    baseLine: b,
    layout: p,
    isRange: x
  }, d);
});
At(Rr, "renderDotItem", function(e, t) {
  var r;
  if (/* @__PURE__ */ S.isValidElement(e))
    r = /* @__PURE__ */ S.cloneElement(e, t);
  else if (re(e))
    r = e(t);
  else {
    var n = ae("recharts-area-dot", typeof e != "boolean" ? e.className : ""), i = t.key, a = S_(t, zL);
    r = /* @__PURE__ */ S.createElement(Hi, Or({}, a, {
      key: i,
      className: n
    }));
  }
  return r;
});
function wn(e) {
  "@babel/helpers - typeof";
  return wn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, wn(e);
}
function ZL(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function JL(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, $_(n.key), n);
  }
}
function QL(e, t, r) {
  return t && JL(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function eq(e, t, r) {
  return t = ho(t), tq(e, j_() ? Reflect.construct(t, r || [], ho(e).constructor) : t.apply(e, r));
}
function tq(e, t) {
  if (t && (wn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return rq(e);
}
function rq(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function j_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (j_ = function() {
    return !!e;
  })();
}
function ho(e) {
  return ho = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, ho(e);
}
function nq(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Pd(e, t);
}
function Pd(e, t) {
  return Pd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Pd(e, t);
}
function T_(e, t, r) {
  return t = $_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function $_(e) {
  var t = iq(e, "string");
  return wn(t) == "symbol" ? t : t + "";
}
function iq(e, t) {
  if (wn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (wn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var eu = /* @__PURE__ */ function(e) {
  function t() {
    return ZL(this, t), eq(this, t, arguments);
  }
  return nq(t, e), QL(t, [{
    key: "render",
    value: function() {
      return null;
    }
  }]);
}(ft.Component);
T_(eu, "displayName", "ZAxis");
T_(eu, "defaultProps", {
  zAxisId: 0,
  range: [64, 64],
  scale: "auto",
  type: "number"
});
var aq = ["option", "isActive"];
function ii() {
  return ii = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ii.apply(this, arguments);
}
function oq(e, t) {
  if (e == null) return {};
  var r = uq(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function uq(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function sq(e) {
  var t = e.option, r = e.isActive, n = oq(e, aq);
  return typeof t == "string" ? /* @__PURE__ */ ft.createElement(Ja, ii({
    option: /* @__PURE__ */ ft.createElement(To, ii({
      type: t
    }, n)),
    isActive: r,
    shapeType: "symbols"
  }, n)) : /* @__PURE__ */ ft.createElement(Ja, ii({
    option: t,
    isActive: r,
    shapeType: "symbols"
  }, n));
}
function On(e) {
  "@babel/helpers - typeof";
  return On = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, On(e);
}
function ai() {
  return ai = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ai.apply(this, arguments);
}
function V0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function ot(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? V0(Object(r), !0).forEach(function(n) {
      Qt(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : V0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function cq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Y0(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, C_(n.key), n);
  }
}
function lq(e, t, r) {
  return t && Y0(e.prototype, t), r && Y0(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function fq(e, t, r) {
  return t = vo(t), dq(e, M_() ? Reflect.construct(t, r || [], vo(e).constructor) : t.apply(e, r));
}
function dq(e, t) {
  if (t && (On(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return pq(e);
}
function pq(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function M_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (M_ = function() {
    return !!e;
  })();
}
function vo(e) {
  return vo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, vo(e);
}
function hq(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ed(e, t);
}
function Ed(e, t) {
  return Ed = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Ed(e, t);
}
function Qt(e, t, r) {
  return t = C_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function C_(e) {
  var t = vq(e, "string");
  return On(t) == "symbol" ? t : t + "";
}
function vq(e, t) {
  if (On(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (On(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var tu = /* @__PURE__ */ function(e) {
  function t() {
    var r;
    cq(this, t);
    for (var n = arguments.length, i = new Array(n), a = 0; a < n; a++)
      i[a] = arguments[a];
    return r = fq(this, t, [].concat(i)), Qt(r, "state", {
      isAnimationFinished: !1
    }), Qt(r, "handleAnimationEnd", function() {
      r.setState({
        isAnimationFinished: !0
      });
    }), Qt(r, "handleAnimationStart", function() {
      r.setState({
        isAnimationFinished: !1
      });
    }), Qt(r, "id", ur("recharts-scatter-")), r;
  }
  return hq(t, e), lq(t, [{
    key: "renderSymbolsStatically",
    value: function(n) {
      var i = this, a = this.props, o = a.shape, u = a.activeShape, s = a.activeIndex, c = J(this.props, !1);
      return n.map(function(l, f) {
        var d = s === f, p = d ? u : o, y = ot(ot({}, c), l);
        return /* @__PURE__ */ S.createElement(oe, ai({
          className: "recharts-scatter-symbol",
          key: "symbol-".concat(l == null ? void 0 : l.cx, "-").concat(l == null ? void 0 : l.cy, "-").concat(l == null ? void 0 : l.size, "-").concat(f)
        }, nr(i.props, l, f), {
          role: "img"
        }), /* @__PURE__ */ S.createElement(sq, ai({
          option: p,
          isActive: d,
          key: "symbol-".concat(f)
        }, y)));
      });
    }
  }, {
    key: "renderSymbolsWithAnimation",
    value: function() {
      var n = this, i = this.props, a = i.points, o = i.isAnimationActive, u = i.animationBegin, s = i.animationDuration, c = i.animationEasing, l = i.animationId, f = this.state.prevPoints;
      return /* @__PURE__ */ S.createElement(pt, {
        begin: u,
        duration: s,
        isActive: o,
        easing: c,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(l),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(d) {
        var p = d.t, y = a.map(function(v, h) {
          var x = f && f[h];
          if (x) {
            var g = Pe(x.cx, v.cx), b = Pe(x.cy, v.cy), O = Pe(x.size, v.size);
            return ot(ot({}, v), {}, {
              cx: g(p),
              cy: b(p),
              size: O(p)
            });
          }
          var m = Pe(0, v.size);
          return ot(ot({}, v), {}, {
            size: m(p)
          });
        });
        return /* @__PURE__ */ S.createElement(oe, null, n.renderSymbolsStatically(y));
      });
    }
  }, {
    key: "renderSymbols",
    value: function() {
      var n = this.props, i = n.points, a = n.isAnimationActive, o = this.state.prevPoints;
      return a && i && i.length && (!o || !ir(o, i)) ? this.renderSymbolsWithAnimation() : this.renderSymbolsStatically(i);
    }
  }, {
    key: "renderErrorBar",
    value: function() {
      var n = this.props.isAnimationActive;
      if (n && !this.state.isAnimationFinished)
        return null;
      var i = this.props, a = i.points, o = i.xAxis, u = i.yAxis, s = i.children, c = He(s, kn);
      return c ? c.map(function(l, f) {
        var d = l.props, p = d.direction, y = d.dataKey;
        return /* @__PURE__ */ S.cloneElement(l, {
          key: "".concat(p, "-").concat(y, "-").concat(a[f]),
          data: a,
          xAxis: o,
          yAxis: u,
          layout: p === "x" ? "vertical" : "horizontal",
          dataPointFormatter: function(h, x) {
            return {
              x: h.cx,
              y: h.cy,
              value: p === "x" ? +h.node.x : +h.node.y,
              errorVal: _e(h, x)
            };
          }
        });
      }) : null;
    }
  }, {
    key: "renderLine",
    value: function() {
      var n = this.props, i = n.points, a = n.line, o = n.lineType, u = n.lineJointType, s = J(this.props, !1), c = J(a, !1), l, f;
      if (o === "joint")
        l = i.map(function(b) {
          return {
            x: b.cx,
            y: b.cy
          };
        });
      else if (o === "fitting") {
        var d = nA(i), p = d.xmin, y = d.xmax, v = d.a, h = d.b, x = function(O) {
          return v * O + h;
        };
        l = [{
          x: p,
          y: x(p)
        }, {
          x: y,
          y: x(y)
        }];
      }
      var g = ot(ot(ot({}, s), {}, {
        fill: "none",
        stroke: s && s.fill
      }, c), {}, {
        points: l
      });
      return /* @__PURE__ */ S.isValidElement(a) ? f = /* @__PURE__ */ S.cloneElement(a, g) : re(a) ? f = a(g) : f = /* @__PURE__ */ S.createElement(rr, ai({}, g, {
        type: u
      })), /* @__PURE__ */ S.createElement(oe, {
        className: "recharts-scatter-line",
        key: "recharts-scatter-line"
      }, f);
    }
  }, {
    key: "render",
    value: function() {
      var n = this.props, i = n.hide, a = n.points, o = n.line, u = n.className, s = n.xAxis, c = n.yAxis, l = n.left, f = n.top, d = n.width, p = n.height, y = n.id, v = n.isAnimationActive;
      if (i || !a || !a.length)
        return null;
      var h = this.state.isAnimationFinished, x = ae("recharts-scatter", u), g = s && s.allowDataOverflow, b = c && c.allowDataOverflow, O = g || b, m = te(y) ? this.id : y;
      return /* @__PURE__ */ S.createElement(oe, {
        className: x,
        clipPath: O ? "url(#clipPath-".concat(m, ")") : null
      }, g || b ? /* @__PURE__ */ S.createElement("defs", null, /* @__PURE__ */ S.createElement("clipPath", {
        id: "clipPath-".concat(m)
      }, /* @__PURE__ */ S.createElement("rect", {
        x: g ? l : l - d / 2,
        y: b ? f : f - p / 2,
        width: g ? d : d * 2,
        height: b ? p : p * 2
      }))) : null, o && this.renderLine(), this.renderErrorBar(), /* @__PURE__ */ S.createElement(oe, {
        key: "recharts-scatter-symbols"
      }, this.renderSymbols()), (!v || h) && wt.renderCallByParent(this.props, a));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, i) {
      return n.animationId !== i.prevAnimationId ? {
        prevAnimationId: n.animationId,
        curPoints: n.points,
        prevPoints: i.curPoints
      } : n.points !== i.curPoints ? {
        curPoints: n.points
      } : null;
    }
  }]);
}(tt);
Qt(tu, "displayName", "Scatter");
Qt(tu, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  zAxisId: 0,
  legendType: "circle",
  lineType: "joint",
  lineJointType: "linear",
  data: [],
  shape: "circle",
  hide: !1,
  isAnimationActive: !Kt.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "linear"
});
Qt(tu, "getComposedData", function(e) {
  var t = e.xAxis, r = e.yAxis, n = e.zAxis, i = e.item, a = e.displayedData, o = e.xAxisTicks, u = e.yAxisTicks, s = e.offset, c = i.props.tooltipType, l = He(i.props.children, Mn), f = te(t.dataKey) ? i.props.dataKey : t.dataKey, d = te(r.dataKey) ? i.props.dataKey : r.dataKey, p = n && n.dataKey, y = n ? n.range : eu.defaultProps.range, v = y && y[0], h = t.scale.bandwidth ? t.scale.bandwidth() : 0, x = r.scale.bandwidth ? r.scale.bandwidth() : 0, g = a.map(function(b, O) {
    var m = _e(b, f), w = _e(b, d), _ = !te(p) && _e(b, p) || "-", P = [{
      name: te(t.dataKey) ? i.props.name : t.name || t.dataKey,
      unit: t.unit || "",
      value: m,
      payload: b,
      dataKey: f,
      type: c
    }, {
      name: te(r.dataKey) ? i.props.name : r.name || r.dataKey,
      unit: r.unit || "",
      value: w,
      payload: b,
      dataKey: d,
      type: c
    }];
    _ !== "-" && P.push({
      name: n.name || n.dataKey,
      unit: n.unit || "",
      value: _,
      payload: b,
      dataKey: p,
      type: c
    });
    var T = on({
      axis: t,
      ticks: o,
      bandSize: h,
      entry: b,
      index: O,
      dataKey: f
    }), M = on({
      axis: r,
      ticks: u,
      bandSize: x,
      entry: b,
      index: O,
      dataKey: d
    }), j = _ !== "-" ? n.scale(_) : v, $ = Math.sqrt(Math.max(j, 0) / Math.PI);
    return ot(ot({}, b), {}, {
      cx: T,
      cy: M,
      x: T - $,
      y: M - $,
      xAxis: t,
      yAxis: r,
      zAxis: n,
      width: 2 * $,
      height: 2 * $,
      size: j,
      node: {
        x: m,
        y: w,
        z: _
      },
      tooltipPayload: P,
      tooltipPosition: {
        x: T,
        y: M
      },
      payload: b
    }, l && l[O] && l[O].props);
  });
  return ot({
    points: g
  }, s);
});
function _n(e) {
  "@babel/helpers - typeof";
  return _n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, _n(e);
}
function yq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function mq(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, k_(n.key), n);
  }
}
function gq(e, t, r) {
  return t && mq(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function bq(e, t, r) {
  return t = yo(t), xq(e, I_() ? Reflect.construct(t, r || [], yo(e).constructor) : t.apply(e, r));
}
function xq(e, t) {
  if (t && (_n(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return wq(e);
}
function wq(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function I_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (I_ = function() {
    return !!e;
  })();
}
function yo(e) {
  return yo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, yo(e);
}
function Oq(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && jd(e, t);
}
function jd(e, t) {
  return jd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, jd(e, t);
}
function N_(e, t, r) {
  return t = k_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function k_(e) {
  var t = _q(e, "string");
  return _n(t) == "symbol" ? t : t + "";
}
function _q(e, t) {
  if (_n(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (_n(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Td() {
  return Td = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Td.apply(this, arguments);
}
function Aq(e) {
  var t = e.xAxisId, r = kp(), n = Rp(), i = c_(t);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ ft.createElement(Rn, Td({}, i, {
      className: ae("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: n
      },
      ticksGenerator: function(o) {
        return Rt(o, !0);
      }
    }))
  );
}
var ru = /* @__PURE__ */ function(e) {
  function t() {
    return yq(this, t), bq(this, t, arguments);
  }
  return Oq(t, e), gq(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ ft.createElement(Aq, this.props);
    }
  }]);
}(ft.Component);
N_(ru, "displayName", "XAxis");
N_(ru, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function An(e) {
  "@babel/helpers - typeof";
  return An = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, An(e);
}
function Sq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Pq(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, L_(n.key), n);
  }
}
function Eq(e, t, r) {
  return t && Pq(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function jq(e, t, r) {
  return t = mo(t), Tq(e, R_() ? Reflect.construct(t, r || [], mo(e).constructor) : t.apply(e, r));
}
function Tq(e, t) {
  if (t && (An(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return $q(e);
}
function $q(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function R_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (R_ = function() {
    return !!e;
  })();
}
function mo(e) {
  return mo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, mo(e);
}
function Mq(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && $d(e, t);
}
function $d(e, t) {
  return $d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, $d(e, t);
}
function D_(e, t, r) {
  return t = L_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function L_(e) {
  var t = Cq(e, "string");
  return An(t) == "symbol" ? t : t + "";
}
function Cq(e, t) {
  if (An(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (An(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function Md() {
  return Md = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Md.apply(this, arguments);
}
var Iq = function(t) {
  var r = t.yAxisId, n = kp(), i = Rp(), a = l_(r);
  return a == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ ft.createElement(Rn, Md({}, a, {
      className: ae("recharts-".concat(a.axisType, " ").concat(a.axisType), a.className),
      viewBox: {
        x: 0,
        y: 0,
        width: n,
        height: i
      },
      ticksGenerator: function(u) {
        return Rt(u, !0);
      }
    }))
  );
}, nu = /* @__PURE__ */ function(e) {
  function t() {
    return Sq(this, t), jq(this, t, arguments);
  }
  return Mq(t, e), Eq(t, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ ft.createElement(Iq, this.props);
    }
  }]);
}(ft.Component);
D_(nu, "displayName", "YAxis");
D_(nu, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function X0(e) {
  return Dq(e) || Rq(e) || kq(e) || Nq();
}
function Nq() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function kq(e, t) {
  if (e) {
    if (typeof e == "string") return Cd(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Cd(e, t);
  }
}
function Rq(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Dq(e) {
  if (Array.isArray(e)) return Cd(e);
}
function Cd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var Id = function(t, r, n, i, a) {
  var o = He(t, Lp), u = He(t, Zo), s = [].concat(X0(o), X0(u)), c = He(t, Qo), l = "".concat(i, "Id"), f = i[0], d = r;
  if (s.length && (d = s.reduce(function(v, h) {
    if (h.props[l] === n && Pt(h.props, "extendDomain") && U(h.props[f])) {
      var x = h.props[f];
      return [Math.min(v[0], x), Math.max(v[1], x)];
    }
    return v;
  }, d)), c.length) {
    var p = "".concat(f, "1"), y = "".concat(f, "2");
    d = c.reduce(function(v, h) {
      if (h.props[l] === n && Pt(h.props, "extendDomain") && U(h.props[p]) && U(h.props[y])) {
        var x = h.props[p], g = h.props[y];
        return [Math.min(v[0], x, g), Math.max(v[1], x, g)];
      }
      return v;
    }, d);
  }
  return a && a.length && (d = a.reduce(function(v, h) {
    return U(h) ? [Math.min(v[0], h), Math.max(v[1], h)] : v;
  }, d)), d;
}, cf = { exports: {} }, Z0;
function Lq() {
  return Z0 || (Z0 = 1, function(e) {
    var t = Object.prototype.hasOwnProperty, r = "~";
    function n() {
    }
    Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
    function i(s, c, l) {
      this.fn = s, this.context = c, this.once = l || !1;
    }
    function a(s, c, l, f, d) {
      if (typeof l != "function")
        throw new TypeError("The listener must be a function");
      var p = new i(l, f || s, d), y = r ? r + c : c;
      return s._events[y] ? s._events[y].fn ? s._events[y] = [s._events[y], p] : s._events[y].push(p) : (s._events[y] = p, s._eventsCount++), s;
    }
    function o(s, c) {
      --s._eventsCount === 0 ? s._events = new n() : delete s._events[c];
    }
    function u() {
      this._events = new n(), this._eventsCount = 0;
    }
    u.prototype.eventNames = function() {
      var c = [], l, f;
      if (this._eventsCount === 0) return c;
      for (f in l = this._events)
        t.call(l, f) && c.push(r ? f.slice(1) : f);
      return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(l)) : c;
    }, u.prototype.listeners = function(c) {
      var l = r ? r + c : c, f = this._events[l];
      if (!f) return [];
      if (f.fn) return [f.fn];
      for (var d = 0, p = f.length, y = new Array(p); d < p; d++)
        y[d] = f[d].fn;
      return y;
    }, u.prototype.listenerCount = function(c) {
      var l = r ? r + c : c, f = this._events[l];
      return f ? f.fn ? 1 : f.length : 0;
    }, u.prototype.emit = function(c, l, f, d, p, y) {
      var v = r ? r + c : c;
      if (!this._events[v]) return !1;
      var h = this._events[v], x = arguments.length, g, b;
      if (h.fn) {
        switch (h.once && this.removeListener(c, h.fn, void 0, !0), x) {
          case 1:
            return h.fn.call(h.context), !0;
          case 2:
            return h.fn.call(h.context, l), !0;
          case 3:
            return h.fn.call(h.context, l, f), !0;
          case 4:
            return h.fn.call(h.context, l, f, d), !0;
          case 5:
            return h.fn.call(h.context, l, f, d, p), !0;
          case 6:
            return h.fn.call(h.context, l, f, d, p, y), !0;
        }
        for (b = 1, g = new Array(x - 1); b < x; b++)
          g[b - 1] = arguments[b];
        h.fn.apply(h.context, g);
      } else {
        var O = h.length, m;
        for (b = 0; b < O; b++)
          switch (h[b].once && this.removeListener(c, h[b].fn, void 0, !0), x) {
            case 1:
              h[b].fn.call(h[b].context);
              break;
            case 2:
              h[b].fn.call(h[b].context, l);
              break;
            case 3:
              h[b].fn.call(h[b].context, l, f);
              break;
            case 4:
              h[b].fn.call(h[b].context, l, f, d);
              break;
            default:
              if (!g) for (m = 1, g = new Array(x - 1); m < x; m++)
                g[m - 1] = arguments[m];
              h[b].fn.apply(h[b].context, g);
          }
      }
      return !0;
    }, u.prototype.on = function(c, l, f) {
      return a(this, c, l, f, !1);
    }, u.prototype.once = function(c, l, f) {
      return a(this, c, l, f, !0);
    }, u.prototype.removeListener = function(c, l, f, d) {
      var p = r ? r + c : c;
      if (!this._events[p]) return this;
      if (!l)
        return o(this, p), this;
      var y = this._events[p];
      if (y.fn)
        y.fn === l && (!d || y.once) && (!f || y.context === f) && o(this, p);
      else {
        for (var v = 0, h = [], x = y.length; v < x; v++)
          (y[v].fn !== l || d && !y[v].once || f && y[v].context !== f) && h.push(y[v]);
        h.length ? this._events[p] = h.length === 1 ? h[0] : h : o(this, p);
      }
      return this;
    }, u.prototype.removeAllListeners = function(c) {
      var l;
      return c ? (l = r ? r + c : c, this._events[l] && o(this, l)) : (this._events = new n(), this._eventsCount = 0), this;
    }, u.prototype.off = u.prototype.removeListener, u.prototype.addListener = u.prototype.on, u.prefixed = r, u.EventEmitter = u, e.exports = u;
  }(cf)), cf.exports;
}
var qq = Lq();
const Bq = /* @__PURE__ */ ye(qq);
var lf = new Bq(), ff = "recharts.syncMouseEvents";
function Li(e) {
  "@babel/helpers - typeof";
  return Li = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Li(e);
}
function Fq(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function zq(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, q_(n.key), n);
  }
}
function Wq(e, t, r) {
  return t && zq(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function df(e, t, r) {
  return t = q_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function q_(e) {
  var t = Uq(e, "string");
  return Li(t) == "symbol" ? t : t + "";
}
function Uq(e, t) {
  if (Li(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Li(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Kq = /* @__PURE__ */ function() {
  function e() {
    Fq(this, e), df(this, "activeIndex", 0), df(this, "coordinateList", []), df(this, "layout", "horizontal");
  }
  return Wq(e, [{
    key: "setDetails",
    value: function(r) {
      var n, i = r.coordinateList, a = i === void 0 ? null : i, o = r.container, u = o === void 0 ? null : o, s = r.layout, c = s === void 0 ? null : s, l = r.offset, f = l === void 0 ? null : l, d = r.mouseHandlerCallback, p = d === void 0 ? null : d;
      this.coordinateList = (n = a ?? this.coordinateList) !== null && n !== void 0 ? n : [], this.container = u ?? this.container, this.layout = c ?? this.layout, this.offset = f ?? this.offset, this.mouseHandlerCallback = p ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(r) {
      if (this.coordinateList.length !== 0)
        switch (r.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(r) {
      this.activeIndex = r;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var r, n;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var i = this.container.getBoundingClientRect(), a = i.x, o = i.y, u = i.height, s = this.coordinateList[this.activeIndex].coordinate, c = ((r = window) === null || r === void 0 ? void 0 : r.scrollX) || 0, l = ((n = window) === null || n === void 0 ? void 0 : n.scrollY) || 0, f = a + s + c, d = o + this.offset.top + u / 2 + l;
        this.mouseHandlerCallback({
          pageX: f,
          pageY: d
        });
      }
    }
  }]);
}();
function Hq(e, t, r) {
  if (r === "number" && t === !0 && Array.isArray(e)) {
    var n = e == null ? void 0 : e[0], i = e == null ? void 0 : e[1];
    if (n && i && U(n) && U(i))
      return !0;
  }
  return !1;
}
function Gq(e, t, r, n) {
  var i = n / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: e === "horizontal" ? t.x - i : r.left + 0.5,
    y: e === "horizontal" ? r.top + 0.5 : t.y - i,
    width: e === "horizontal" ? n : r.width - 1,
    height: e === "horizontal" ? r.height - 1 : n
  };
}
function B_(e) {
  var t = e.cx, r = e.cy, n = e.radius, i = e.startAngle, a = e.endAngle, o = we(t, r, n, i), u = we(t, r, n, a);
  return {
    points: [o, u],
    cx: t,
    cy: r,
    radius: n,
    startAngle: i,
    endAngle: a
  };
}
function Vq(e, t, r) {
  var n, i, a, o;
  if (e === "horizontal")
    n = t.x, a = n, i = r.top, o = r.top + r.height;
  else if (e === "vertical")
    i = t.y, o = i, n = r.left, a = r.left + r.width;
  else if (t.cx != null && t.cy != null)
    if (e === "centric") {
      var u = t.cx, s = t.cy, c = t.innerRadius, l = t.outerRadius, f = t.angle, d = we(u, s, c, f), p = we(u, s, l, f);
      n = d.x, i = d.y, a = p.x, o = p.y;
    } else
      return B_(t);
  return [{
    x: n,
    y: i
  }, {
    x: a,
    y: o
  }];
}
function qi(e) {
  "@babel/helpers - typeof";
  return qi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qi(e);
}
function J0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function fa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? J0(Object(r), !0).forEach(function(n) {
      Yq(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : J0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Yq(e, t, r) {
  return t = Xq(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Xq(e) {
  var t = Zq(e, "string");
  return qi(t) == "symbol" ? t : t + "";
}
function Zq(e, t) {
  if (qi(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (qi(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Jq(e) {
  var t, r, n = e.element, i = e.tooltipEventType, a = e.isActive, o = e.activeCoordinate, u = e.activePayload, s = e.offset, c = e.activeTooltipIndex, l = e.tooltipAxisBandSize, f = e.layout, d = e.chartName, p = (t = n.props.cursor) !== null && t !== void 0 ? t : (r = n.type.defaultProps) === null || r === void 0 ? void 0 : r.cursor;
  if (!n || !p || !a || !o || d !== "ScatterChart" && i !== "axis")
    return null;
  var y, v = rr;
  if (d === "ScatterChart")
    y = o, v = Uk;
  else if (d === "BarChart")
    y = Gq(f, o, s, l), v = Mp;
  else if (f === "radial") {
    var h = B_(o), x = h.cx, g = h.cy, b = h.radius, O = h.startAngle, m = h.endAngle;
    y = {
      cx: x,
      cy: g,
      startAngle: O,
      endAngle: m,
      innerRadius: b,
      outerRadius: b
    }, v = $O;
  } else
    y = {
      points: Vq(f, o, s)
    }, v = rr;
  var w = fa(fa(fa(fa({
    stroke: "#ccc",
    pointerEvents: "none"
  }, s), y), J(p, !1)), {}, {
    payload: u,
    payloadIndex: c,
    className: ae("recharts-tooltip-cursor", p.className)
  });
  return /* @__PURE__ */ bt(p) ? /* @__PURE__ */ Ce(p, w) : /* @__PURE__ */ cx(v, w);
}
var Qq = ["item"], eB = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function Sn(e) {
  "@babel/helpers - typeof";
  return Sn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Sn(e);
}
function Hr() {
  return Hr = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Hr.apply(this, arguments);
}
function Q0(e, t) {
  return nB(e) || rB(e, t) || z_(e, t) || tB();
}
function tB() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rB(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n, i, a, o, u = [], s = !0, c = !1;
    try {
      if (a = (r = r.call(e)).next, t !== 0) for (; !(s = (n = a.call(r)).done) && (u.push(n.value), u.length !== t); s = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!s && r.return != null && (o = r.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return u;
  }
}
function nB(e) {
  if (Array.isArray(e)) return e;
}
function ex(e, t) {
  if (e == null) return {};
  var r = iB(e, t), n, i;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (i = 0; i < a.length; i++)
      n = a[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function iB(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      if (t.indexOf(n) >= 0) continue;
      r[n] = e[n];
    }
  return r;
}
function aB(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function oB(e, t) {
  for (var r = 0; r < t.length; r++) {
    var n = t[r];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, W_(n.key), n);
  }
}
function uB(e, t, r) {
  return t && oB(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function sB(e, t, r) {
  return t = go(t), cB(e, F_() ? Reflect.construct(t, r || [], go(e).constructor) : t.apply(e, r));
}
function cB(e, t) {
  if (t && (Sn(t) === "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return lB(e);
}
function lB(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function F_() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (F_ = function() {
    return !!e;
  })();
}
function go(e) {
  return go = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, go(e);
}
function fB(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Nd(e, t);
}
function Nd(e, t) {
  return Nd = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
    return n.__proto__ = i, n;
  }, Nd(e, t);
}
function Pn(e) {
  return hB(e) || pB(e) || z_(e) || dB();
}
function dB() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function z_(e, t) {
  if (e) {
    if (typeof e == "string") return kd(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return kd(e, t);
  }
}
function pB(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function hB(e) {
  if (Array.isArray(e)) return kd(e);
}
function kd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function tx(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function q(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? tx(Object(r), !0).forEach(function(n) {
      ie(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : tx(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ie(e, t, r) {
  return t = W_(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function W_(e) {
  var t = vB(e, "string");
  return Sn(t) == "symbol" ? t : t + "";
}
function vB(e, t) {
  if (Sn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (Sn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var yB = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, mB = {
  width: "100%",
  height: "100%"
}, U_ = {
  x: 0,
  y: 0
};
function da(e) {
  return e;
}
var gB = function(t, r) {
  return r === "horizontal" ? t.x : r === "vertical" ? t.y : r === "centric" ? t.angle : t.radius;
}, bB = function(t, r, n, i) {
  var a = r.find(function(l) {
    return l && l.index === n;
  });
  if (a) {
    if (t === "horizontal")
      return {
        x: a.coordinate,
        y: i.y
      };
    if (t === "vertical")
      return {
        x: i.x,
        y: a.coordinate
      };
    if (t === "centric") {
      var o = a.coordinate, u = i.radius;
      return q(q(q({}, i), we(i.cx, i.cy, u, o)), {}, {
        angle: o,
        radius: u
      });
    }
    var s = a.coordinate, c = i.angle;
    return q(q(q({}, i), we(i.cx, i.cy, s, c)), {}, {
      angle: c,
      radius: s
    });
  }
  return U_;
}, iu = function(t, r) {
  var n = r.graphicalItems, i = r.dataStartIndex, a = r.dataEndIndex, o = (n ?? []).reduce(function(u, s) {
    var c = s.props.data;
    return c && c.length ? [].concat(Pn(u), Pn(c)) : u;
  }, []);
  return o.length > 0 ? o : t && t.length && U(i) && U(a) ? t.slice(i, a + 1) : [];
};
function K_(e) {
  return e === "number" ? [0, "auto"] : void 0;
}
var Rd = function(t, r, n, i) {
  var a = t.graphicalItems, o = t.tooltipAxis, u = iu(r, t);
  return n < 0 || !a || !a.length || n >= u.length ? null : a.reduce(function(s, c) {
    var l, f = (l = c.props.data) !== null && l !== void 0 ? l : r;
    f && t.dataStartIndex + t.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    t.dataEndIndex - t.dataStartIndex >= n && (f = f.slice(t.dataStartIndex, t.dataEndIndex + 1));
    var d;
    if (o.dataKey && !o.allowDuplicatedCategory) {
      var p = f === void 0 ? u : f;
      d = va(p, o.dataKey, i);
    } else
      d = f && f[n] || u[n];
    return d ? [].concat(Pn(s), [AO(c, d)]) : s;
  }, []);
}, rx = function(t, r, n, i) {
  var a = i || {
    x: t.chartX,
    y: t.chartY
  }, o = gB(a, n), u = t.orderedTooltipTicks, s = t.tooltipAxis, c = t.tooltipTicks, l = lC(o, u, c, s);
  if (l >= 0 && c) {
    var f = c[l] && c[l].value, d = Rd(t, r, l, f), p = bB(n, u, l, a);
    return {
      activeTooltipIndex: l,
      activeLabel: f,
      activePayload: d,
      activeCoordinate: p
    };
  }
  return null;
}, xB = function(t, r) {
  var n = r.axes, i = r.graphicalItems, a = r.axisType, o = r.axisIdKey, u = r.stackGroups, s = r.dataStartIndex, c = r.dataEndIndex, l = t.layout, f = t.children, d = t.stackOffset, p = gO(l, a);
  return n.reduce(function(y, v) {
    var h, x = v.type.defaultProps !== void 0 ? q(q({}, v.type.defaultProps), v.props) : v.props, g = x.type, b = x.dataKey, O = x.allowDataOverflow, m = x.allowDuplicatedCategory, w = x.scale, _ = x.ticks, P = x.includeHidden, T = x[o];
    if (y[T])
      return y;
    var M = iu(t.data, {
      graphicalItems: i.filter(function(L) {
        var z, V = o in L.props ? L.props[o] : (z = L.type.defaultProps) === null || z === void 0 ? void 0 : z[o];
        return V === T;
      }),
      dataStartIndex: s,
      dataEndIndex: c
    }), j = M.length, $, I, k;
    Hq(x.domain, O, g) && ($ = Gf(x.domain, null, O), p && (g === "number" || w !== "auto") && (k = Qn(M, b, "category")));
    var R = K_(g);
    if (!$ || $.length === 0) {
      var D, B = (D = x.domain) !== null && D !== void 0 ? D : R;
      if (b) {
        if ($ = Qn(M, b, g), g === "category" && p) {
          var W = rA($);
          m && W ? (I = $, $ = eo(0, j)) : m || ($ = Ug(B, $, v).reduce(function(L, z) {
            return L.indexOf(z) >= 0 ? L : [].concat(Pn(L), [z]);
          }, []));
        } else if (g === "category")
          m ? $ = $.filter(function(L) {
            return L !== "" && !te(L);
          }) : $ = Ug(B, $, v).reduce(function(L, z) {
            return L.indexOf(z) >= 0 || z === "" || te(z) ? L : [].concat(Pn(L), [z]);
          }, []);
        else if (g === "number") {
          var K = vC(M, i.filter(function(L) {
            var z, V, Y = o in L.props ? L.props[o] : (z = L.type.defaultProps) === null || z === void 0 ? void 0 : z[o], ee = "hide" in L.props ? L.props.hide : (V = L.type.defaultProps) === null || V === void 0 ? void 0 : V.hide;
            return Y === T && (P || !ee);
          }), b, a, l);
          K && ($ = K);
        }
        p && (g === "number" || w !== "auto") && (k = Qn(M, b, "category"));
      } else p ? $ = eo(0, j) : u && u[T] && u[T].hasStack && g === "number" ? $ = d === "expand" ? [0, 1] : _O(u[T].stackGroups, s, c) : $ = mO(M, i.filter(function(L) {
        var z = o in L.props ? L.props[o] : L.type.defaultProps[o], V = "hide" in L.props ? L.props.hide : L.type.defaultProps.hide;
        return z === T && (P || !V);
      }), g, l, !0);
      if (g === "number")
        $ = Id(f, $, T, a, _), B && ($ = Gf(B, $, O));
      else if (g === "category" && B) {
        var E = B, N = $.every(function(L) {
          return E.indexOf(L) >= 0;
        });
        N && ($ = E);
      }
    }
    return q(q({}, y), {}, ie({}, T, q(q({}, x), {}, {
      axisType: a,
      domain: $,
      categoricalDomain: k,
      duplicateDomain: I,
      originalDomain: (h = x.domain) !== null && h !== void 0 ? h : R,
      isCategorical: p,
      layout: l
    })));
  }, {});
}, wB = function(t, r) {
  var n = r.graphicalItems, i = r.Axis, a = r.axisType, o = r.axisIdKey, u = r.stackGroups, s = r.dataStartIndex, c = r.dataEndIndex, l = t.layout, f = t.children, d = iu(t.data, {
    graphicalItems: n,
    dataStartIndex: s,
    dataEndIndex: c
  }), p = d.length, y = gO(l, a), v = -1;
  return n.reduce(function(h, x) {
    var g = x.type.defaultProps !== void 0 ? q(q({}, x.type.defaultProps), x.props) : x.props, b = g[o], O = K_("number");
    if (!h[b]) {
      v++;
      var m;
      return y ? m = eo(0, p) : u && u[b] && u[b].hasStack ? (m = _O(u[b].stackGroups, s, c), m = Id(f, m, b, a)) : (m = Gf(O, mO(d, n.filter(function(w) {
        var _, P, T = o in w.props ? w.props[o] : (_ = w.type.defaultProps) === null || _ === void 0 ? void 0 : _[o], M = "hide" in w.props ? w.props.hide : (P = w.type.defaultProps) === null || P === void 0 ? void 0 : P.hide;
        return T === b && !M;
      }), "number", l), i.defaultProps.allowDataOverflow), m = Id(f, m, b, a)), q(q({}, h), {}, ie({}, b, q(q({
        axisType: a
      }, i.defaultProps), {}, {
        hide: !0,
        orientation: et(yB, "".concat(a, ".").concat(v % 2), null),
        domain: m,
        originalDomain: O,
        isCategorical: y,
        layout: l
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return h;
  }, {});
}, OB = function(t, r) {
  var n = r.axisType, i = n === void 0 ? "xAxis" : n, a = r.AxisComp, o = r.graphicalItems, u = r.stackGroups, s = r.dataStartIndex, c = r.dataEndIndex, l = t.children, f = "".concat(i, "Id"), d = He(l, a), p = {};
  return d && d.length ? p = xB(t, {
    axes: d,
    graphicalItems: o,
    axisType: i,
    axisIdKey: f,
    stackGroups: u,
    dataStartIndex: s,
    dataEndIndex: c
  }) : o && o.length && (p = wB(t, {
    Axis: a,
    graphicalItems: o,
    axisType: i,
    axisIdKey: f,
    stackGroups: u,
    dataStartIndex: s,
    dataEndIndex: c
  })), p;
}, _B = function(t) {
  var r = Xt(t), n = Rt(r, !1, !0);
  return {
    tooltipTicks: n,
    orderedTooltipTicks: rp(n, function(i) {
      return i.coordinate;
    }),
    tooltipAxis: r,
    tooltipAxisBandSize: Ba(r, n)
  };
}, nx = function(t) {
  var r = t.children, n = t.defaultShowTooltip, i = Je(r, dn), a = 0, o = 0;
  return t.data && t.data.length !== 0 && (o = t.data.length - 1), i && i.props && (i.props.startIndex >= 0 && (a = i.props.startIndex), i.props.endIndex >= 0 && (o = i.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: a,
    dataEndIndex: o,
    activeTooltipIndex: -1,
    isTooltipActive: !!n
  };
}, AB = function(t) {
  return !t || !t.length ? !1 : t.some(function(r) {
    var n = Dt(r && r.type);
    return n && n.indexOf("Bar") >= 0;
  });
}, ix = function(t) {
  return t === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : t === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : t === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, SB = function(t, r) {
  var n = t.props, i = t.graphicalItems, a = t.xAxisMap, o = a === void 0 ? {} : a, u = t.yAxisMap, s = u === void 0 ? {} : u, c = n.width, l = n.height, f = n.children, d = n.margin || {}, p = Je(f, dn), y = Je(f, er), v = Object.keys(s).reduce(function(m, w) {
    var _ = s[w], P = _.orientation;
    return !_.mirror && !_.hide ? q(q({}, m), {}, ie({}, P, m[P] + _.width)) : m;
  }, {
    left: d.left || 0,
    right: d.right || 0
  }), h = Object.keys(o).reduce(function(m, w) {
    var _ = o[w], P = _.orientation;
    return !_.mirror && !_.hide ? q(q({}, m), {}, ie({}, P, et(m, "".concat(P)) + _.height)) : m;
  }, {
    top: d.top || 0,
    bottom: d.bottom || 0
  }), x = q(q({}, h), v), g = x.bottom;
  p && (x.bottom += p.props.height || dn.defaultProps.height), y && r && (x = pC(x, i, n, r));
  var b = c - x.left - x.right, O = l - x.top - x.bottom;
  return q(q({
    brushBottom: g
  }, x), {}, {
    // never return negative values for height and width
    width: Math.max(b, 0),
    height: Math.max(O, 0)
  });
}, PB = function(t, r) {
  if (r === "xAxis")
    return t[r].width;
  if (r === "yAxis")
    return t[r].height;
}, H_ = function(t) {
  var r = t.chartName, n = t.GraphicalChild, i = t.defaultTooltipEventType, a = i === void 0 ? "axis" : i, o = t.validateTooltipEventTypes, u = o === void 0 ? ["axis"] : o, s = t.axisComponents, c = t.legendContent, l = t.formatAxisMap, f = t.defaultProps, d = function(x, g) {
    var b = g.graphicalItems, O = g.stackGroups, m = g.offset, w = g.updateId, _ = g.dataStartIndex, P = g.dataEndIndex, T = x.barSize, M = x.layout, j = x.barGap, $ = x.barCategoryGap, I = x.maxBarSize, k = ix(M), R = k.numericAxisName, D = k.cateAxisName, B = AB(b), W = [];
    return b.forEach(function(K, E) {
      var N = iu(x.data, {
        graphicalItems: [K],
        dataStartIndex: _,
        dataEndIndex: P
      }), L = K.type.defaultProps !== void 0 ? q(q({}, K.type.defaultProps), K.props) : K.props, z = L.dataKey, V = L.maxBarSize, Y = L["".concat(R, "Id")], ee = L["".concat(D, "Id")], ne = {}, X = s.reduce(function(fr, Mt) {
        var au, ou, uu = g["".concat(Mt.axisType, "Map")], Fp = L["".concat(Mt.axisType, "Id")];
        uu && uu[Fp] || Mt.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? Ve(!1, "Specifying a(n) ".concat(Mt.axisType, "Id requires a corresponding ").concat(
          Mt.axisType,
          "Id on the targeted graphical component "
        ).concat((au = K == null || (ou = K.type) === null || ou === void 0 ? void 0 : ou.displayName) !== null && au !== void 0 ? au : "")) : Ve());
        var zp = uu[Fp];
        return q(q({}, fr), {}, ie(ie({}, Mt.axisType, zp), "".concat(Mt.axisType, "Ticks"), Rt(zp)));
      }, ne), F = X[D], G = X["".concat(D, "Ticks")], Q = O && O[Y] && O[Y].hasStack && AC(K, O[Y].stackGroups), C = Dt(K.type).indexOf("Bar") >= 0, ue = Ba(F, G), H = [], ge = B && fC({
        barSize: T,
        stackGroups: O,
        totalSize: PB(X, D)
      });
      if (C) {
        var Ae, Le, Gt = te(V) ? I : V, Dr = (Ae = (Le = Ba(F, G, !0)) !== null && Le !== void 0 ? Le : Gt) !== null && Ae !== void 0 ? Ae : 0;
        H = dC({
          barGap: j,
          barCategoryGap: $,
          bandSize: Dr !== ue ? Dr : ue,
          sizeList: ge[ee],
          maxBarSize: Gt
        }), Dr !== ue && (H = H.map(function(fr) {
          return q(q({}, fr), {}, {
            position: q(q({}, fr.position), {}, {
              offset: fr.position.offset - Dr / 2
            })
          });
        }));
      }
      var Vi = K && K.type && K.type.getComposedData;
      Vi && W.push({
        props: q(q({}, Vi(q(q({}, X), {}, {
          displayedData: N,
          props: x,
          dataKey: z,
          item: K,
          bandSize: ue,
          barPosition: H,
          offset: m,
          stackedData: Q,
          layout: M,
          dataStartIndex: _,
          dataEndIndex: P
        }))), {}, ie(ie(ie({
          key: K.key || "item-".concat(E)
        }, R, X[R]), D, X[D]), "animationId", w)),
        childIndex: vA(K, x.children),
        item: K
      });
    }), W;
  }, p = function(x, g) {
    var b = x.props, O = x.dataStartIndex, m = x.dataEndIndex, w = x.updateId;
    if (!av({
      props: b
    }))
      return null;
    var _ = b.children, P = b.layout, T = b.stackOffset, M = b.data, j = b.reverseStackOrder, $ = ix(P), I = $.numericAxisName, k = $.cateAxisName, R = He(_, n), D = OC(M, R, "".concat(I, "Id"), "".concat(k, "Id"), T, j), B = s.reduce(function(L, z) {
      var V = "".concat(z.axisType, "Map");
      return q(q({}, L), {}, ie({}, V, OB(b, q(q({}, z), {}, {
        graphicalItems: R,
        stackGroups: z.axisType === I && D,
        dataStartIndex: O,
        dataEndIndex: m
      }))));
    }, {}), W = SB(q(q({}, B), {}, {
      props: b,
      graphicalItems: R
    }), g == null ? void 0 : g.legendBBox);
    Object.keys(B).forEach(function(L) {
      B[L] = l(b, B[L], W, L.replace("Map", ""), r);
    });
    var K = B["".concat(k, "Map")], E = _B(K), N = d(b, q(q({}, B), {}, {
      dataStartIndex: O,
      dataEndIndex: m,
      updateId: w,
      graphicalItems: R,
      stackGroups: D,
      offset: W
    }));
    return q(q({
      formattedGraphicalItems: N,
      graphicalItems: R,
      offset: W,
      stackGroups: D
    }, E), B);
  }, y = /* @__PURE__ */ function(h) {
    function x(g) {
      var b, O, m;
      return aB(this, x), m = sB(this, x, [g]), ie(m, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), ie(m, "accessibilityManager", new Kq()), ie(m, "handleLegendBBoxUpdate", function(w) {
        if (w) {
          var _ = m.state, P = _.dataStartIndex, T = _.dataEndIndex, M = _.updateId;
          m.setState(q({
            legendBBox: w
          }, p({
            props: m.props,
            dataStartIndex: P,
            dataEndIndex: T,
            updateId: M
          }, q(q({}, m.state), {}, {
            legendBBox: w
          }))));
        }
      }), ie(m, "handleReceiveSyncEvent", function(w, _, P) {
        if (m.props.syncId === w) {
          if (P === m.eventEmitterSymbol && typeof m.props.syncMethod != "function")
            return;
          m.applySyncEvent(_);
        }
      }), ie(m, "handleBrushChange", function(w) {
        var _ = w.startIndex, P = w.endIndex;
        if (_ !== m.state.dataStartIndex || P !== m.state.dataEndIndex) {
          var T = m.state.updateId;
          m.setState(function() {
            return q({
              dataStartIndex: _,
              dataEndIndex: P
            }, p({
              props: m.props,
              dataStartIndex: _,
              dataEndIndex: P,
              updateId: T
            }, m.state));
          }), m.triggerSyncEvent({
            dataStartIndex: _,
            dataEndIndex: P
          });
        }
      }), ie(m, "handleMouseEnter", function(w) {
        var _ = m.getMouseInfo(w);
        if (_) {
          var P = q(q({}, _), {}, {
            isTooltipActive: !0
          });
          m.setState(P), m.triggerSyncEvent(P);
          var T = m.props.onMouseEnter;
          re(T) && T(P, w);
        }
      }), ie(m, "triggeredAfterMouseMove", function(w) {
        var _ = m.getMouseInfo(w), P = _ ? q(q({}, _), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        m.setState(P), m.triggerSyncEvent(P);
        var T = m.props.onMouseMove;
        re(T) && T(P, w);
      }), ie(m, "handleItemMouseEnter", function(w) {
        m.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: w,
            activePayload: w.tooltipPayload,
            activeCoordinate: w.tooltipPosition || {
              x: w.cx,
              y: w.cy
            }
          };
        });
      }), ie(m, "handleItemMouseLeave", function() {
        m.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), ie(m, "handleMouseMove", function(w) {
        w.persist(), m.throttleTriggeredAfterMouseMove(w);
      }), ie(m, "handleMouseLeave", function(w) {
        m.throttleTriggeredAfterMouseMove.cancel();
        var _ = {
          isTooltipActive: !1
        };
        m.setState(_), m.triggerSyncEvent(_);
        var P = m.props.onMouseLeave;
        re(P) && P(_, w);
      }), ie(m, "handleOuterEvent", function(w) {
        var _ = hA(w), P = et(m.props, "".concat(_));
        if (_ && re(P)) {
          var T, M;
          /.*touch.*/i.test(_) ? M = m.getMouseInfo(w.changedTouches[0]) : M = m.getMouseInfo(w), P((T = M) !== null && T !== void 0 ? T : {}, w);
        }
      }), ie(m, "handleClick", function(w) {
        var _ = m.getMouseInfo(w);
        if (_) {
          var P = q(q({}, _), {}, {
            isTooltipActive: !0
          });
          m.setState(P), m.triggerSyncEvent(P);
          var T = m.props.onClick;
          re(T) && T(P, w);
        }
      }), ie(m, "handleMouseDown", function(w) {
        var _ = m.props.onMouseDown;
        if (re(_)) {
          var P = m.getMouseInfo(w);
          _(P, w);
        }
      }), ie(m, "handleMouseUp", function(w) {
        var _ = m.props.onMouseUp;
        if (re(_)) {
          var P = m.getMouseInfo(w);
          _(P, w);
        }
      }), ie(m, "handleTouchMove", function(w) {
        w.changedTouches != null && w.changedTouches.length > 0 && m.throttleTriggeredAfterMouseMove(w.changedTouches[0]);
      }), ie(m, "handleTouchStart", function(w) {
        w.changedTouches != null && w.changedTouches.length > 0 && m.handleMouseDown(w.changedTouches[0]);
      }), ie(m, "handleTouchEnd", function(w) {
        w.changedTouches != null && w.changedTouches.length > 0 && m.handleMouseUp(w.changedTouches[0]);
      }), ie(m, "handleDoubleClick", function(w) {
        var _ = m.props.onDoubleClick;
        if (re(_)) {
          var P = m.getMouseInfo(w);
          _(P, w);
        }
      }), ie(m, "handleContextMenu", function(w) {
        var _ = m.props.onContextMenu;
        if (re(_)) {
          var P = m.getMouseInfo(w);
          _(P, w);
        }
      }), ie(m, "triggerSyncEvent", function(w) {
        m.props.syncId !== void 0 && lf.emit(ff, m.props.syncId, w, m.eventEmitterSymbol);
      }), ie(m, "applySyncEvent", function(w) {
        var _ = m.props, P = _.layout, T = _.syncMethod, M = m.state.updateId, j = w.dataStartIndex, $ = w.dataEndIndex;
        if (w.dataStartIndex !== void 0 || w.dataEndIndex !== void 0)
          m.setState(q({
            dataStartIndex: j,
            dataEndIndex: $
          }, p({
            props: m.props,
            dataStartIndex: j,
            dataEndIndex: $,
            updateId: M
          }, m.state)));
        else if (w.activeTooltipIndex !== void 0) {
          var I = w.chartX, k = w.chartY, R = w.activeTooltipIndex, D = m.state, B = D.offset, W = D.tooltipTicks;
          if (!B)
            return;
          if (typeof T == "function")
            R = T(W, w);
          else if (T === "value") {
            R = -1;
            for (var K = 0; K < W.length; K++)
              if (W[K].value === w.activeLabel) {
                R = K;
                break;
              }
          }
          var E = q(q({}, B), {}, {
            x: B.left,
            y: B.top
          }), N = Math.min(I, E.x + E.width), L = Math.min(k, E.y + E.height), z = W[R] && W[R].value, V = Rd(m.state, m.props.data, R), Y = W[R] ? {
            x: P === "horizontal" ? W[R].coordinate : N,
            y: P === "horizontal" ? L : W[R].coordinate
          } : U_;
          m.setState(q(q({}, w), {}, {
            activeLabel: z,
            activeCoordinate: Y,
            activePayload: V,
            activeTooltipIndex: R
          }));
        } else
          m.setState(w);
      }), ie(m, "renderCursor", function(w) {
        var _, P = m.state, T = P.isTooltipActive, M = P.activeCoordinate, j = P.activePayload, $ = P.offset, I = P.activeTooltipIndex, k = P.tooltipAxisBandSize, R = m.getTooltipEventType(), D = (_ = w.props.active) !== null && _ !== void 0 ? _ : T, B = m.props.layout, W = w.key || "_recharts-cursor";
        return /* @__PURE__ */ S.createElement(Jq, {
          key: W,
          activeCoordinate: M,
          activePayload: j,
          activeTooltipIndex: I,
          chartName: r,
          element: w,
          isActive: D,
          layout: B,
          offset: $,
          tooltipAxisBandSize: k,
          tooltipEventType: R
        });
      }), ie(m, "renderPolarAxis", function(w, _, P) {
        var T = et(w, "type.axisType"), M = et(m.state, "".concat(T, "Map")), j = w.type.defaultProps, $ = j !== void 0 ? q(q({}, j), w.props) : w.props, I = M && M[$["".concat(T, "Id")]];
        return /* @__PURE__ */ Ce(w, q(q({}, I), {}, {
          className: ae(T, I.className),
          key: w.key || "".concat(_, "-").concat(P),
          ticks: Rt(I, !0)
        }));
      }), ie(m, "renderPolarGrid", function(w) {
        var _ = w.props, P = _.radialLines, T = _.polarAngles, M = _.polarRadius, j = m.state, $ = j.radiusAxisMap, I = j.angleAxisMap, k = Xt($), R = Xt(I), D = R.cx, B = R.cy, W = R.innerRadius, K = R.outerRadius;
        return /* @__PURE__ */ Ce(w, {
          polarAngles: Array.isArray(T) ? T : Rt(R, !0).map(function(E) {
            return E.coordinate;
          }),
          polarRadius: Array.isArray(M) ? M : Rt(k, !0).map(function(E) {
            return E.coordinate;
          }),
          cx: D,
          cy: B,
          innerRadius: W,
          outerRadius: K,
          key: w.key || "polar-grid",
          radialLines: P
        });
      }), ie(m, "renderLegend", function() {
        var w = m.state.formattedGraphicalItems, _ = m.props, P = _.children, T = _.width, M = _.height, j = m.props.margin || {}, $ = T - (j.left || 0) - (j.right || 0), I = vO({
          children: P,
          formattedGraphicalItems: w,
          legendWidth: $,
          legendContent: c
        });
        if (!I)
          return null;
        var k = I.item, R = ex(I, Qq);
        return /* @__PURE__ */ Ce(k, q(q({}, R), {}, {
          chartWidth: T,
          chartHeight: M,
          margin: j,
          onBBoxUpdate: m.handleLegendBBoxUpdate
        }));
      }), ie(m, "renderTooltip", function() {
        var w, _ = m.props, P = _.children, T = _.accessibilityLayer, M = Je(P, ut);
        if (!M)
          return null;
        var j = m.state, $ = j.isTooltipActive, I = j.activeCoordinate, k = j.activePayload, R = j.activeLabel, D = j.offset, B = (w = M.props.active) !== null && w !== void 0 ? w : $;
        return /* @__PURE__ */ Ce(M, {
          viewBox: q(q({}, D), {}, {
            x: D.left,
            y: D.top
          }),
          active: B,
          label: R,
          payload: B ? k : [],
          coordinate: I,
          accessibilityLayer: T
        });
      }), ie(m, "renderBrush", function(w) {
        var _ = m.props, P = _.margin, T = _.data, M = m.state, j = M.offset, $ = M.dataStartIndex, I = M.dataEndIndex, k = M.updateId;
        return /* @__PURE__ */ Ce(w, {
          key: w.key || "_recharts-brush",
          onChange: aa(m.handleBrushChange, w.props.onChange),
          data: T,
          x: U(w.props.x) ? w.props.x : j.left,
          y: U(w.props.y) ? w.props.y : j.top + j.height + j.brushBottom - (P.bottom || 0),
          width: U(w.props.width) ? w.props.width : j.width,
          startIndex: $,
          endIndex: I,
          updateId: "brush-".concat(k)
        });
      }), ie(m, "renderReferenceElement", function(w, _, P) {
        if (!w)
          return null;
        var T = m, M = T.clipPathId, j = m.state, $ = j.xAxisMap, I = j.yAxisMap, k = j.offset, R = w.type.defaultProps || {}, D = w.props, B = D.xAxisId, W = B === void 0 ? R.xAxisId : B, K = D.yAxisId, E = K === void 0 ? R.yAxisId : K;
        return /* @__PURE__ */ Ce(w, {
          key: w.key || "".concat(_, "-").concat(P),
          xAxis: $[W],
          yAxis: I[E],
          viewBox: {
            x: k.left,
            y: k.top,
            width: k.width,
            height: k.height
          },
          clipPathId: M
        });
      }), ie(m, "renderActivePoints", function(w) {
        var _ = w.item, P = w.activePoint, T = w.basePoint, M = w.childIndex, j = w.isRange, $ = [], I = _.props.key, k = _.item.type.defaultProps !== void 0 ? q(q({}, _.item.type.defaultProps), _.item.props) : _.item.props, R = k.activeDot, D = k.dataKey, B = q(q({
          index: M,
          dataKey: D,
          cx: P.x,
          cy: P.y,
          r: 4,
          fill: Tp(_.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: P.payload,
          value: P.value
        }, J(R, !1)), ya(R));
        return $.push(x.renderActiveDot(R, B, "".concat(I, "-activePoint-").concat(M))), T ? $.push(x.renderActiveDot(R, q(q({}, B), {}, {
          cx: T.x,
          cy: T.y
        }), "".concat(I, "-basePoint-").concat(M))) : j && $.push(null), $;
      }), ie(m, "renderGraphicChild", function(w, _, P) {
        var T = m.filterFormatItem(w, _, P);
        if (!T)
          return null;
        var M = m.getTooltipEventType(), j = m.state, $ = j.isTooltipActive, I = j.tooltipAxis, k = j.activeTooltipIndex, R = j.activeLabel, D = m.props.children, B = Je(D, ut), W = T.props, K = W.points, E = W.isRange, N = W.baseLine, L = T.item.type.defaultProps !== void 0 ? q(q({}, T.item.type.defaultProps), T.item.props) : T.item.props, z = L.activeDot, V = L.hide, Y = L.activeBar, ee = L.activeShape, ne = !!(!V && $ && B && (z || Y || ee)), X = {};
        M !== "axis" && B && B.props.trigger === "click" ? X = {
          onClick: aa(m.handleItemMouseEnter, w.props.onClick)
        } : M !== "axis" && (X = {
          onMouseLeave: aa(m.handleItemMouseLeave, w.props.onMouseLeave),
          onMouseEnter: aa(m.handleItemMouseEnter, w.props.onMouseEnter)
        });
        var F = /* @__PURE__ */ Ce(w, q(q({}, T.props), X));
        function G(Mt) {
          return typeof I.dataKey == "function" ? I.dataKey(Mt.payload) : null;
        }
        if (ne)
          if (k >= 0) {
            var Q, C;
            if (I.dataKey && !I.allowDuplicatedCategory) {
              var ue = typeof I.dataKey == "function" ? G : "payload.".concat(I.dataKey.toString());
              Q = va(K, ue, R), C = E && N && va(N, ue, R);
            } else
              Q = K == null ? void 0 : K[k], C = E && N && N[k];
            if (ee || Y) {
              var H = w.props.activeIndex !== void 0 ? w.props.activeIndex : k;
              return [/* @__PURE__ */ Ce(w, q(q(q({}, T.props), X), {}, {
                activeIndex: H
              })), null, null];
            }
            if (!te(Q))
              return [F].concat(Pn(m.renderActivePoints({
                item: T,
                activePoint: Q,
                basePoint: C,
                childIndex: k,
                isRange: E
              })));
          } else {
            var ge, Ae = (ge = m.getItemByXY(m.state.activeCoordinate)) !== null && ge !== void 0 ? ge : {
              graphicalItem: F
            }, Le = Ae.graphicalItem, Gt = Le.item, Dr = Gt === void 0 ? w : Gt, Vi = Le.childIndex, fr = q(q(q({}, T.props), X), {}, {
              activeIndex: Vi
            });
            return [/* @__PURE__ */ Ce(Dr, fr), null, null];
          }
        return E ? [F, null, null] : [F, null];
      }), ie(m, "renderCustomized", function(w, _, P) {
        return /* @__PURE__ */ Ce(w, q(q({
          key: "recharts-customized-".concat(P)
        }, m.props), m.state));
      }), ie(m, "renderMap", {
        CartesianGrid: {
          handler: da,
          once: !0
        },
        ReferenceArea: {
          handler: m.renderReferenceElement
        },
        ReferenceLine: {
          handler: da
        },
        ReferenceDot: {
          handler: m.renderReferenceElement
        },
        XAxis: {
          handler: da
        },
        YAxis: {
          handler: da
        },
        Brush: {
          handler: m.renderBrush,
          once: !0
        },
        Bar: {
          handler: m.renderGraphicChild
        },
        Line: {
          handler: m.renderGraphicChild
        },
        Area: {
          handler: m.renderGraphicChild
        },
        Radar: {
          handler: m.renderGraphicChild
        },
        RadialBar: {
          handler: m.renderGraphicChild
        },
        Scatter: {
          handler: m.renderGraphicChild
        },
        Pie: {
          handler: m.renderGraphicChild
        },
        Funnel: {
          handler: m.renderGraphicChild
        },
        Tooltip: {
          handler: m.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: m.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: m.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: m.renderPolarAxis
        },
        Customized: {
          handler: m.renderCustomized
        }
      }), m.clipPathId = "".concat((b = g.id) !== null && b !== void 0 ? b : ur("recharts"), "-clip"), m.throttleTriggeredAfterMouseMove = hw(m.triggeredAfterMouseMove, (O = g.throttleDelay) !== null && O !== void 0 ? O : 1e3 / 60), m.state = {}, m;
    }
    return fB(x, h), uB(x, [{
      key: "componentDidMount",
      value: function() {
        var b, O;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (b = this.props.margin.left) !== null && b !== void 0 ? b : 0,
            top: (O = this.props.margin.top) !== null && O !== void 0 ? O : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var b = this.props, O = b.children, m = b.data, w = b.height, _ = b.layout, P = Je(O, ut);
        if (P) {
          var T = P.props.defaultIndex;
          if (!(typeof T != "number" || T < 0 || T > this.state.tooltipTicks.length - 1)) {
            var M = this.state.tooltipTicks[T] && this.state.tooltipTicks[T].value, j = Rd(this.state, m, T, M), $ = this.state.tooltipTicks[T].coordinate, I = (this.state.offset.top + w) / 2, k = _ === "horizontal", R = k ? {
              x: $,
              y: I
            } : {
              y: $,
              x: I
            }, D = this.state.formattedGraphicalItems.find(function(W) {
              var K = W.item;
              return K.type.name === "Scatter";
            });
            D && (R = q(q({}, R), D.props.points[T].tooltipPosition), j = D.props.points[T].tooltipPayload);
            var B = {
              activeTooltipIndex: T,
              isTooltipActive: !0,
              activeLabel: M,
              activePayload: j,
              activeCoordinate: R
            };
            this.setState(B), this.renderCursor(P), this.accessibilityManager.setIndex(T);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(b, O) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== O.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== b.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== b.margin) {
          var m, w;
          this.accessibilityManager.setDetails({
            offset: {
              left: (m = this.props.margin.left) !== null && m !== void 0 ? m : 0,
              top: (w = this.props.margin.top) !== null && w !== void 0 ? w : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(b) {
        vf([Je(b.children, ut)], [Je(this.props.children, ut)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var b = Je(this.props.children, ut);
        if (b && typeof b.props.shared == "boolean") {
          var O = b.props.shared ? "axis" : "item";
          return u.indexOf(O) >= 0 ? O : a;
        }
        return a;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(b) {
        if (!this.container)
          return null;
        var O = this.container, m = O.getBoundingClientRect(), w = rj(m), _ = {
          chartX: Math.round(b.pageX - w.left),
          chartY: Math.round(b.pageY - w.top)
        }, P = m.width / O.offsetWidth || 1, T = this.inRange(_.chartX, _.chartY, P);
        if (!T)
          return null;
        var M = this.state, j = M.xAxisMap, $ = M.yAxisMap, I = this.getTooltipEventType(), k = rx(this.state, this.props.data, this.props.layout, T);
        if (I !== "axis" && j && $) {
          var R = Xt(j).scale, D = Xt($).scale, B = R && R.invert ? R.invert(_.chartX) : null, W = D && D.invert ? D.invert(_.chartY) : null;
          return q(q({}, _), {}, {
            xValue: B,
            yValue: W
          }, k);
        }
        return k ? q(q({}, _), k) : null;
      }
    }, {
      key: "inRange",
      value: function(b, O) {
        var m = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, w = this.props.layout, _ = b / m, P = O / m;
        if (w === "horizontal" || w === "vertical") {
          var T = this.state.offset, M = _ >= T.left && _ <= T.left + T.width && P >= T.top && P <= T.top + T.height;
          return M ? {
            x: _,
            y: P
          } : null;
        }
        var j = this.state, $ = j.angleAxisMap, I = j.radiusAxisMap;
        if ($ && I) {
          var k = Xt($);
          return Gg({
            x: _,
            y: P
          }, k);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var b = this.props.children, O = this.getTooltipEventType(), m = Je(b, ut), w = {};
        m && O === "axis" && (m.props.trigger === "click" ? w = {
          onClick: this.handleClick
        } : w = {
          onMouseEnter: this.handleMouseEnter,
          onDoubleClick: this.handleDoubleClick,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd,
          onContextMenu: this.handleContextMenu
        });
        var _ = ya(this.props, this.handleOuterEvent);
        return q(q({}, _), w);
      }
    }, {
      key: "addListener",
      value: function() {
        lf.on(ff, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        lf.removeListener(ff, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(b, O, m) {
        for (var w = this.state.formattedGraphicalItems, _ = 0, P = w.length; _ < P; _++) {
          var T = w[_];
          if (T.item === b || T.props.key === b.key || O === Dt(T.item.type) && m === T.childIndex)
            return T;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var b = this.clipPathId, O = this.state.offset, m = O.left, w = O.top, _ = O.height, P = O.width;
        return /* @__PURE__ */ S.createElement("defs", null, /* @__PURE__ */ S.createElement("clipPath", {
          id: b
        }, /* @__PURE__ */ S.createElement("rect", {
          x: m,
          y: w,
          height: _,
          width: P
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var b = this.state.xAxisMap;
        return b ? Object.entries(b).reduce(function(O, m) {
          var w = Q0(m, 2), _ = w[0], P = w[1];
          return q(q({}, O), {}, ie({}, _, P.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var b = this.state.yAxisMap;
        return b ? Object.entries(b).reduce(function(O, m) {
          var w = Q0(m, 2), _ = w[0], P = w[1];
          return q(q({}, O), {}, ie({}, _, P.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(b) {
        var O;
        return (O = this.state.xAxisMap) === null || O === void 0 || (O = O[b]) === null || O === void 0 ? void 0 : O.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(b) {
        var O;
        return (O = this.state.yAxisMap) === null || O === void 0 || (O = O[b]) === null || O === void 0 ? void 0 : O.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(b) {
        var O = this.state, m = O.formattedGraphicalItems, w = O.activeItem;
        if (m && m.length)
          for (var _ = 0, P = m.length; _ < P; _++) {
            var T = m[_], M = T.props, j = T.item, $ = j.type.defaultProps !== void 0 ? q(q({}, j.type.defaultProps), j.props) : j.props, I = Dt(j.type);
            if (I === "Bar") {
              var k = (M.data || []).find(function(W) {
                return Ak(b, W);
              });
              if (k)
                return {
                  graphicalItem: T,
                  payload: k
                };
            } else if (I === "RadialBar") {
              var R = (M.data || []).find(function(W) {
                return Gg(b, W);
              });
              if (R)
                return {
                  graphicalItem: T,
                  payload: R
                };
            } else if (Go(T, w) || Vo(T, w) || Ni(T, w)) {
              var D = GR({
                graphicalItem: T,
                activeTooltipItem: w,
                itemData: $.data
              }), B = $.activeIndex === void 0 ? D : $.activeIndex;
              return {
                graphicalItem: q(q({}, T), {}, {
                  childIndex: B
                }),
                payload: Ni(T, w) ? $.data[D] : T.props.data[D]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var b = this;
        if (!av(this))
          return null;
        var O = this.props, m = O.children, w = O.className, _ = O.width, P = O.height, T = O.style, M = O.compact, j = O.title, $ = O.desc, I = ex(O, eB), k = J(I, !1);
        if (M)
          return /* @__PURE__ */ S.createElement($0, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ S.createElement(mf, Hr({}, k, {
            width: _,
            height: P,
            title: j,
            desc: $
          }), this.renderClipPath(), uv(m, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var R, D;
          k.tabIndex = (R = this.props.tabIndex) !== null && R !== void 0 ? R : 0, k.role = (D = this.props.role) !== null && D !== void 0 ? D : "application", k.onKeyDown = function(W) {
            b.accessibilityManager.keyboardEvent(W);
          }, k.onFocus = function() {
            b.accessibilityManager.focus();
          };
        }
        var B = this.parseEventsOfWrapper();
        return /* @__PURE__ */ S.createElement($0, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ S.createElement("div", Hr({
          className: ae("recharts-wrapper", w),
          style: q({
            position: "relative",
            cursor: "default",
            width: _,
            height: P
          }, T)
        }, B, {
          ref: function(K) {
            b.container = K;
          }
        }), /* @__PURE__ */ S.createElement(mf, Hr({}, k, {
          width: _,
          height: P,
          title: j,
          desc: $,
          style: mB
        }), this.renderClipPath(), uv(m, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  }(lx);
  ie(y, "displayName", r), ie(y, "defaultProps", q({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, f)), ie(y, "getDerivedStateFromProps", function(h, x) {
    var g = h.dataKey, b = h.data, O = h.children, m = h.width, w = h.height, _ = h.layout, P = h.stackOffset, T = h.margin, M = x.dataStartIndex, j = x.dataEndIndex;
    if (x.updateId === void 0) {
      var $ = nx(h);
      return q(q(q({}, $), {}, {
        updateId: 0
      }, p(q(q({
        props: h
      }, $), {}, {
        updateId: 0
      }), x)), {}, {
        prevDataKey: g,
        prevData: b,
        prevWidth: m,
        prevHeight: w,
        prevLayout: _,
        prevStackOffset: P,
        prevMargin: T,
        prevChildren: O
      });
    }
    if (g !== x.prevDataKey || b !== x.prevData || m !== x.prevWidth || w !== x.prevHeight || _ !== x.prevLayout || P !== x.prevStackOffset || !Gr(T, x.prevMargin)) {
      var I = nx(h), k = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: x.chartX,
        chartY: x.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: x.isTooltipActive
      }, R = q(q({}, rx(x, b, _)), {}, {
        updateId: x.updateId + 1
      }), D = q(q(q({}, I), k), R);
      return q(q(q({}, D), p(q({
        props: h
      }, D), x)), {}, {
        prevDataKey: g,
        prevData: b,
        prevWidth: m,
        prevHeight: w,
        prevLayout: _,
        prevStackOffset: P,
        prevMargin: T,
        prevChildren: O
      });
    }
    if (!vf(O, x.prevChildren)) {
      var B, W, K, E, N = Je(O, dn), L = N && (B = (W = N.props) === null || W === void 0 ? void 0 : W.startIndex) !== null && B !== void 0 ? B : M, z = N && (K = (E = N.props) === null || E === void 0 ? void 0 : E.endIndex) !== null && K !== void 0 ? K : j, V = L !== M || z !== j, Y = !te(b), ee = Y && !V ? x.updateId : x.updateId + 1;
      return q(q({
        updateId: ee
      }, p(q(q({
        props: h
      }, x), {}, {
        updateId: ee,
        dataStartIndex: L,
        dataEndIndex: z
      }), x)), {}, {
        prevChildren: O,
        dataStartIndex: L,
        dataEndIndex: z
      });
    }
    return null;
  }), ie(y, "renderActiveDot", function(h, x, g) {
    var b;
    return /* @__PURE__ */ bt(h) ? b = /* @__PURE__ */ Ce(h, x) : re(h) ? b = h(x) : b = /* @__PURE__ */ S.createElement(Hi, x), /* @__PURE__ */ S.createElement(oe, {
      className: "recharts-active-dot",
      key: g
    }, b);
  });
  var v = /* @__PURE__ */ ux(function(x, g) {
    return /* @__PURE__ */ S.createElement(y, Hr({}, x, {
      ref: g
    }));
  });
  return v.displayName = y.displayName, v;
}, G_ = H_({
  chartName: "PieChart",
  GraphicalChild: $t,
  validateTooltipEventTypes: ["item"],
  defaultTooltipEventType: "item",
  legendContent: "children",
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: Ho
  }, {
    axisType: "radiusAxis",
    AxisComp: Uo
  }],
  formatAxisMap: NC,
  defaultProps: {
    layout: "centric",
    startAngle: 0,
    endAngle: 360,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
}), EB = H_({
  chartName: "ComposedChart",
  GraphicalChild: [Gi, Rr, ar, tu],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: ru
  }, {
    axisType: "yAxis",
    AxisComp: nu
  }, {
    axisType: "zAxis",
    AxisComp: eu
  }],
  formatAxisMap: X2
});
const jB = [
  { value: "all", label: "Todos os meses" },
  { value: "1", label: "Janeiro" },
  { value: "2", label: "Fevereiro" },
  { value: "3", label: "Março" },
  { value: "4", label: "Abril" },
  { value: "5", label: "Maio" },
  { value: "6", label: "Junho" },
  { value: "7", label: "Julho" },
  { value: "8", label: "Agosto" },
  { value: "9", label: "Setembro" },
  { value: "10", label: "Outubro" },
  { value: "11", label: "Novembro" },
  { value: "12", label: "Dezembro" }
], TB = {
  1: "Jan",
  2: "Fev",
  3: "Mar",
  4: "Abr",
  5: "Mai",
  6: "Jun",
  7: "Jul",
  8: "Ago",
  9: "Set",
  10: "Out",
  11: "Nov",
  12: "Dez"
};
function ZB({
  data: e,
  selectedPeriod: t,
  selectedMonth: r,
  onPeriodChange: n,
  onMonthChange: i,
  showFilters: a = !0
}) {
  const [o, u] = Pr(
    t || "2024"
  ), [s, c] = Pr(
    r || "all"
  ), l = t || o, f = r || s, d = (g) => {
    n ? n(g) : u(g);
  }, p = (g) => {
    i ? i(g) : c(g);
  }, y = e.filter((g) => g.year === l), h = (f === "all" ? y : y.filter((g) => g.month === TB[f])).map((g) => {
    const b = g.receitas - g.despesas, O = g.receitas > 0 ? b / g.receitas * 100 : 0;
    return {
      ...g,
      lucro: b,
      margemLucro: Number(O.toFixed(1))
    };
  }), x = (g, b) => {
    if (b === "margemLucro")
      return [`${g}%`, "Margem de Lucro"];
    if (b === "Lucro") {
      const O = Number(g) < 0;
      return [`R$ ${g}`, O ? "Prejuízo" : "Lucro"];
    }
    return [`R$ ${g}`, b];
  };
  return /* @__PURE__ */ A.jsxs("div", { children: [
    /* @__PURE__ */ A.jsxs("div", { className: "flex items-center justify-between mb-6", children: [
      /* @__PURE__ */ A.jsx("h3", { className: "text-lg font-semibold text-gray-900", children: "Evolução Mensal" }),
      a && /* @__PURE__ */ A.jsxs("div", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ A.jsxs("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ A.jsx(J_, { className: "w-4 h-4 text-gray-500" }),
          /* @__PURE__ */ A.jsxs(
            "select",
            {
              value: l,
              onChange: (g) => d(g.target.value),
              className: "text-sm border border-gray-300 rounded-md px-3 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500",
              children: [
                /* @__PURE__ */ A.jsx("option", { value: "2024", children: "2024" }),
                /* @__PURE__ */ A.jsx("option", { value: "2023", children: "2023" }),
                /* @__PURE__ */ A.jsx("option", { value: "2022", children: "2022" })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ A.jsx(
          "select",
          {
            value: f,
            onChange: (g) => p(g.target.value),
            className: "text-sm border border-gray-300 rounded-md px-3 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500",
            children: jB.map((g) => /* @__PURE__ */ A.jsx("option", { value: g.value, children: g.label }, g.value))
          }
        )
      ] })
    ] }),
    h.length > 0 ? /* @__PURE__ */ A.jsx(ip, { width: "100%", height: 300, children: /* @__PURE__ */ A.jsxs(EB, { data: h, children: [
      /* @__PURE__ */ A.jsx(w_, { strokeDasharray: "3 3" }),
      /* @__PURE__ */ A.jsx(ru, { dataKey: "month" }),
      /* @__PURE__ */ A.jsx(nu, {}),
      /* @__PURE__ */ A.jsx(ut, { formatter: x }),
      /* @__PURE__ */ A.jsx(ar, { dataKey: "receitas", fill: "#22c55e", name: "Receitas" }),
      /* @__PURE__ */ A.jsx(ar, { dataKey: "despesas", fill: "#eab308", name: "Despesas" }),
      /* @__PURE__ */ A.jsx(
        Gi,
        {
          type: "monotone",
          dataKey: "lucro",
          stroke: "#3b82f6",
          strokeWidth: 3,
          dot: (g) => {
            const { cx: b, cy: O, payload: m } = g, w = ((m == null ? void 0 : m.lucro) ?? 0) < 0;
            return /* @__PURE__ */ A.jsx(
              "circle",
              {
                cx: b,
                cy: O,
                r: 4,
                fill: w ? "#ef4444" : "#3b82f6",
                stroke: w ? "#dc2626" : "#2563eb",
                strokeWidth: 2
              }
            );
          },
          connectNulls: !1,
          name: "Lucro"
        }
      )
    ] }) }) : /* @__PURE__ */ A.jsx("div", { className: "flex items-center justify-center h-64 text-gray-500", children: /* @__PURE__ */ A.jsx("p", { children: "Nenhum dado disponível para o período selecionado" }) }),
    /* @__PURE__ */ A.jsx("div", { className: "mt-4 pt-4 border-t border-gray-200", children: /* @__PURE__ */ A.jsxs("div", { className: "grid grid-cols-2 gap-4", children: [
      /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("p", { className: "text-sm text-gray-600", children: "Receita Total" }),
        /* @__PURE__ */ A.jsxs("p", { className: "text-lg font-semibold text-gray-900", children: [
          "R$ ",
          h.reduce((g, b) => g + b.receitas, 0).toLocaleString("pt-BR")
        ] })
      ] }),
      /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("p", { className: "text-sm text-gray-600", children: "Lucro Total" }),
        /* @__PURE__ */ A.jsxs("p", { className: `text-lg font-semibold ${h.reduce((g, b) => g + b.lucro, 0) >= 0 ? "text-green-600" : "text-red-600"}`, children: [
          "R$ ",
          h.reduce((g, b) => g + b.lucro, 0).toLocaleString("pt-BR")
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ A.jsxs("div", { className: "mt-4 flex items-center justify-center gap-6", children: [
      /* @__PURE__ */ A.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ A.jsx(
          "div",
          {
            className: "w-3 h-3 rounded-full",
            style: { backgroundColor: "#22c55e" }
          }
        ),
        /* @__PURE__ */ A.jsx("span", { className: "text-sm text-gray-600", children: "Receitas" })
      ] }),
      /* @__PURE__ */ A.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ A.jsx(
          "div",
          {
            className: "w-3 h-3 rounded-full",
            style: { backgroundColor: "#eab308" }
          }
        ),
        /* @__PURE__ */ A.jsx("span", { className: "text-sm text-gray-600", children: "Despesas" })
      ] }),
      /* @__PURE__ */ A.jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ A.jsx(
          "div",
          {
            className: "w-3 h-3 rounded-full",
            style: { backgroundColor: "#3b82f6" }
          }
        ),
        /* @__PURE__ */ A.jsx("span", { className: "text-sm text-gray-600", children: "Lucro" }),
        /* @__PURE__ */ A.jsx(
          "div",
          {
            className: "w-3 h-3 rounded-full ml-2",
            style: { backgroundColor: "#ef4444" }
          }
        ),
        /* @__PURE__ */ A.jsx("span", { className: "text-sm text-gray-600", children: "Prejuízo" })
      ] })
    ] })
  ] });
}
const ax = Math.PI / 180, $B = ({
  cx: e,
  cy: t,
  midAngle: r,
  innerRadius: n,
  outerRadius: i,
  percent: a
}) => {
  const o = n + (i - n) * 0.5, u = e + o * Math.cos(-r * ax), s = t + o * Math.sin(-r * ax);
  return a < 0.05 ? null : /* @__PURE__ */ A.jsx(
    "text",
    {
      x: u,
      y: s,
      fill: "white",
      textAnchor: u > e ? "start" : "end",
      dominantBaseline: "central",
      fontSize: 12,
      fontWeight: "bold",
      children: `${(a * 100).toFixed(0)}%`
    }
  );
}, MB = ({
  active: e,
  payload: t
}) => {
  if (e && t && t.length) {
    const r = t[0];
    return /* @__PURE__ */ A.jsxs("div", { className: "bg-white p-3 border border-gray-300 rounded-lg shadow-lg", children: [
      /* @__PURE__ */ A.jsx("p", { className: "font-medium text-gray-900", children: r.name }),
      /* @__PURE__ */ A.jsxs("p", { className: "text-sm text-gray-600", children: [
        "R$ ",
        r.value.toLocaleString()
      ] }),
      /* @__PURE__ */ A.jsxs("p", { className: "text-sm text-gray-600", children: [
        (r.value / t[0].payload.total * 100).toFixed(1),
        "%"
      ] })
    ] });
  }
  return null;
};
function JB({
  data: e,
  title: t = "Fontes de Receita",
  showLegend: r = !0,
  totalLabel: n = "Receita Total",
  emptyStateMessage: i = "Nenhum dado de receita disponível"
}) {
  const a = e.reduce((u, s) => u + s.value, 0), o = e.map((u) => ({ ...u, total: a }));
  return /* @__PURE__ */ A.jsxs("div", { children: [
    /* @__PURE__ */ A.jsx("h3", { className: "text-lg font-semibold text-gray-900 mb-6", children: t }),
    e.length > 0 ? /* @__PURE__ */ A.jsx("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ A.jsx(ip, { width: "100%", height: 300, children: /* @__PURE__ */ A.jsxs(G_, { children: [
      /* @__PURE__ */ A.jsx(
        $t,
        {
          data: o,
          cx: "50%",
          cy: "50%",
          labelLine: !1,
          label: $B,
          outerRadius: 80,
          fill: "#8884d8",
          dataKey: "value",
          children: o.map((u, s) => /* @__PURE__ */ A.jsx(Mn, { fill: u.color }, `cell-${s}`))
        }
      ),
      /* @__PURE__ */ A.jsx(ut, { content: /* @__PURE__ */ A.jsx(MB, {}) }),
      r && /* @__PURE__ */ A.jsx(
        er,
        {
          verticalAlign: "bottom",
          height: 36,
          formatter: (u, s) => {
            var c;
            return /* @__PURE__ */ A.jsxs("span", { style: { color: s.color || "#000" }, children: [
              u,
              " - R$ ",
              (((c = s.payload) == null ? void 0 : c.value) || 0).toLocaleString()
            ] });
          }
        }
      )
    ] }) }) }) : /* @__PURE__ */ A.jsx("div", { className: "flex items-center justify-center h-64 text-gray-500", children: /* @__PURE__ */ A.jsx("p", { children: i }) }),
    /* @__PURE__ */ A.jsx("div", { className: "mt-4 pt-4 border-t border-gray-200", children: /* @__PURE__ */ A.jsxs("div", { className: "grid grid-cols-2 gap-4", children: [
      /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("p", { className: "text-sm text-gray-600", children: n }),
        /* @__PURE__ */ A.jsxs("p", { className: "text-lg font-semibold text-gray-900", children: [
          "R$ ",
          a.toLocaleString("pt-BR")
        ] })
      ] }),
      /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("p", { className: "text-sm text-gray-600", children: "Maior Fonte" }),
        /* @__PURE__ */ A.jsx("p", { className: "text-lg font-semibold text-gray-900", children: e.length > 0 ? e.reduce(
          (u, s) => s.value > u.value ? s : u
        ).name : "-" })
      ] })
    ] }) })
  ] });
}
const ox = Math.PI / 180, CB = ({
  cx: e,
  cy: t,
  midAngle: r,
  innerRadius: n,
  outerRadius: i,
  percent: a
}) => {
  const o = n + (i - n) * 0.5, u = e + o * Math.cos(-r * ox), s = t + o * Math.sin(-r * ox);
  return a < 0.05 ? null : /* @__PURE__ */ A.jsx(
    "text",
    {
      x: u,
      y: s,
      fill: "white",
      textAnchor: u > e ? "start" : "end",
      dominantBaseline: "central",
      fontSize: 12,
      fontWeight: "bold",
      children: `${(a * 100).toFixed(0)}%`
    }
  );
}, IB = ({
  active: e,
  payload: t
}) => {
  if (e && t && t.length) {
    const r = t[0];
    return /* @__PURE__ */ A.jsxs("div", { className: "bg-white p-3 border border-gray-300 rounded-lg shadow-lg", children: [
      /* @__PURE__ */ A.jsx("p", { className: "font-medium text-gray-900", children: r.name }),
      /* @__PURE__ */ A.jsxs("p", { className: "text-sm text-gray-600", children: [
        "R$ ",
        r.value.toLocaleString()
      ] }),
      /* @__PURE__ */ A.jsxs("p", { className: "text-sm text-gray-600", children: [
        (r.value / t[0].payload.total * 100).toFixed(1),
        "%"
      ] })
    ] });
  }
  return null;
};
function QB({
  data: e,
  title: t = "Fontes de Despesa",
  showLegend: r = !0,
  totalLabel: n = "Despesa Total",
  emptyStateMessage: i = "Nenhum dado de despesa disponível",
  largestLabel: a = "Maior Despesa"
}) {
  const o = e.reduce((s, c) => s + c.value, 0), u = e.map((s) => ({ ...s, total: o }));
  return /* @__PURE__ */ A.jsxs("div", { children: [
    /* @__PURE__ */ A.jsx("h3", { className: "text-lg font-semibold text-gray-900 mb-6", children: t }),
    e.length > 0 ? /* @__PURE__ */ A.jsx("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ A.jsx(ip, { width: "100%", height: 300, children: /* @__PURE__ */ A.jsxs(G_, { children: [
      /* @__PURE__ */ A.jsx(
        $t,
        {
          data: u,
          cx: "50%",
          cy: "50%",
          labelLine: !1,
          label: CB,
          outerRadius: 80,
          fill: "#8884d8",
          dataKey: "value",
          children: u.map((s, c) => /* @__PURE__ */ A.jsx(Mn, { fill: s.color }, `cell-${c}`))
        }
      ),
      /* @__PURE__ */ A.jsx(ut, { content: /* @__PURE__ */ A.jsx(IB, {}) }),
      r && /* @__PURE__ */ A.jsx(
        er,
        {
          verticalAlign: "bottom",
          height: 36,
          formatter: (s, c) => {
            var l;
            return /* @__PURE__ */ A.jsxs("span", { style: { color: c.color || "#000" }, children: [
              s,
              " - R$ ",
              (((l = c.payload) == null ? void 0 : l.value) || 0).toLocaleString()
            ] });
          }
        }
      )
    ] }) }) }) : /* @__PURE__ */ A.jsx("div", { className: "flex items-center justify-center h-64 text-gray-500", children: /* @__PURE__ */ A.jsx("p", { children: i }) }),
    /* @__PURE__ */ A.jsx("div", { className: "mt-4 pt-4 border-t border-gray-200", children: /* @__PURE__ */ A.jsxs("div", { className: "grid grid-cols-2 gap-4", children: [
      /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("p", { className: "text-sm text-gray-600", children: n }),
        /* @__PURE__ */ A.jsxs("p", { className: "text-lg font-semibold text-gray-900", children: [
          "R$ ",
          o.toLocaleString("pt-BR")
        ] })
      ] }),
      /* @__PURE__ */ A.jsxs("div", { children: [
        /* @__PURE__ */ A.jsx("p", { className: "text-sm text-gray-600", children: a }),
        /* @__PURE__ */ A.jsx("p", { className: "text-lg font-semibold text-gray-900", children: e.length > 0 ? e.reduce(
          (s, c) => c.value > s.value ? c : s
        ).name : "-" })
      ] })
    ] }) })
  ] });
}
function eF({
  icon: e,
  title: t,
  description: r,
  type: n = "insight",
  className: i
}) {
  const o = {
    alert: {
      container: "bg-yellow-50 border-yellow-200",
      icon: "text-yellow-600",
      title: "text-yellow-800",
      description: "text-yellow-700"
    },
    insight: {
      container: "bg-blue-50 border-blue-200",
      icon: "text-blue-600",
      title: "text-blue-800",
      description: "text-blue-700"
    },
    success: {
      container: "bg-green-50 border-green-200",
      icon: "text-green-600",
      title: "text-green-800",
      description: "text-green-700"
    }
  }[n];
  return /* @__PURE__ */ A.jsx("div", { className: se("p-3 border rounded-lg", o.container, i), children: /* @__PURE__ */ A.jsxs("div", { className: "flex items-start gap-3", children: [
    /* @__PURE__ */ A.jsx(e, { className: se("w-4 h-4 mt-0.5 flex-shrink-0", o.icon) }),
    /* @__PURE__ */ A.jsxs("div", { className: "flex-1", children: [
      /* @__PURE__ */ A.jsx("p", { className: se("text-sm font-medium", o.title), children: t }),
      /* @__PURE__ */ A.jsx("p", { className: se("text-xs mt-1", o.description), children: r })
    ] })
  ] }) });
}
function NB({
  content: e,
  children: t,
  position: r = "top",
  className: n = ""
}) {
  const [i, a] = Pr(!1), o = () => {
    switch (r) {
      case "top":
        return "bottom-full left-1/2 -translate-x-1/2 mb-2";
      case "bottom":
        return "top-full left-1/2 -translate-x-1/2 mt-2";
      case "left":
        return "right-full top-1/2 -translate-y-1/2 mr-2";
      case "right":
        return "left-full top-1/2 -translate-y-1/2 ml-2";
      default:
        return "bottom-full left-1/2 -translate-x-1/2 mb-2";
    }
  }, u = () => {
    switch (r) {
      case "top":
        return "top-full left-1/2 -translate-x-1/2 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-900";
      case "bottom":
        return "bottom-full left-1/2 -translate-x-1/2 border-l-4 border-r-4 border-b-4 border-l-transparent border-r-transparent border-b-gray-900";
      case "left":
        return "left-full top-1/2 -translate-y-1/2 border-t-4 border-b-4 border-l-4 border-t-transparent border-b-transparent border-l-gray-900";
      case "right":
        return "right-full top-1/2 -translate-y-1/2 border-t-4 border-b-4 border-r-4 border-t-transparent border-b-transparent border-r-gray-900";
      default:
        return "top-full left-1/2 -translate-x-1/2 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-gray-900";
    }
  };
  return /* @__PURE__ */ A.jsxs(
    "span",
    {
      className: se("relative inline-flex items-center gap-1 group", n),
      onMouseEnter: () => a(!0),
      onMouseLeave: () => a(!1),
      children: [
        /* @__PURE__ */ A.jsx("span", { className: "text-gray-800 group-hover:text-black transition-colors", children: t }),
        /* @__PURE__ */ A.jsxs("span", { className: "relative inline-block", children: [
          /* @__PURE__ */ A.jsx("span", { className: "w-4 h-4 text-gray-400 hover:text-gray-600 cursor-pointer transition-colors", children: /* @__PURE__ */ A.jsx(Q_, { className: "w-4 h-4" }) }),
          i && /* @__PURE__ */ A.jsxs("div", { className: se("absolute z-50", o()), children: [
            /* @__PURE__ */ A.jsx("div", { className: "bg-gray-900 text-white text-sm rounded-lg px-3 py-2 max-w-sm whitespace-normal shadow-xl border border-gray-700", children: e }),
            /* @__PURE__ */ A.jsx("div", { className: se("absolute w-0 h-0", u()) })
          ] })
        ] })
      ]
    }
  );
}
function tF({
  term: e,
  definition: t,
  children: r,
  position: n = "top"
}) {
  return /* @__PURE__ */ A.jsx(NB, { content: t, position: n, children: r || e });
}
function rF({
  loading: e = !1,
  className: t = "",
  children: r = "Sugerir com IA",
  usageInfo: n,
  showUsageTooltip: i = !1,
  disabled: a,
  ...o
}) {
  const u = n && !n.canUse, s = a || u || e, c = () => u ? `Limite atingido (${n == null ? void 0 : n.currentUsage}/${n == null ? void 0 : n.limit})` : n && i ? `${r} (${n.remainingUsage} restantes)` : r, l = () => u ? e1 : t1;
  return /* @__PURE__ */ A.jsxs("div", { className: `relative group ${u ? "cursor-not-allowed" : ""}`, children: [
    /* @__PURE__ */ A.jsx(
      s1,
      {
        type: "button",
        variant: u ? "outline" : "secondary",
        size: "sm",
        icon: l(),
        loading: e,
        disabled: s,
        className: `ml-2 ${t} ${u ? "opacity-60 cursor-not-allowed" : ""}`,
        ...o,
        children: c()
      }
    ),
    n && (i || u) && /* @__PURE__ */ A.jsxs("div", { className: "absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-10 whitespace-nowrap", children: [
      u ? `Limite mensal de ${n.limit} sugestões atingido. Reset: próximo mês.` : `${n.remainingUsage} de ${n.limit} sugestões disponíveis este mês`,
      /* @__PURE__ */ A.jsx("div", { className: "absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-900" })
    ] })
  ] });
}
const lt = {
  colors: {
    // Brand colors
    brand: {
      primary: "#2563eb",
      // blue-600
      primaryHover: "#1d4ed8",
      // blue-700
      primaryLight: "#dbeafe",
      // blue-100
      secondary: "#64748b",
      // slate-500
      accent: "#3b82f6"
      // blue-500
    },
    // Semantic colors
    semantic: {
      success: "#22c55e",
      // green-500
      successHover: "#16a34a",
      // green-600
      successLight: "#dcfce7",
      // green-100
      warning: "#f59e0b",
      // amber-500
      warningHover: "#d97706",
      // amber-600
      warningLight: "#fef3c7",
      // amber-100
      error: "#ef4444",
      // red-500
      errorHover: "#dc2626",
      // red-600
      errorLight: "#fee2e2",
      // red-100
      info: "#06b6d4",
      // cyan-500
      infoHover: "#0891b2",
      // cyan-600
      infoLight: "#cffafe"
      // cyan-100
    },
    // Neutral scale
    neutral: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827"
    },
    // Surface colors
    surface: {
      background: "#ffffff",
      backgroundSecondary: "#f9fafb",
      backgroundAccent: "#f3f4f6",
      card: "#ffffff",
      cardHover: "#f9fafb"
    },
    // Border colors
    border: {
      default: "#e5e7eb",
      // neutral-200
      light: "#f3f4f6",
      // neutral-100
      medium: "#d1d5db",
      // neutral-300
      strong: "#9ca3af",
      // neutral-400
      focus: "#3b82f6"
      // brand-accent
    }
  },
  spacing: {
    0: "0",
    1: "0.25rem",
    // 4px
    2: "0.5rem",
    // 8px
    3: "0.75rem",
    // 12px
    4: "1rem",
    // 16px
    5: "1.25rem",
    // 20px
    6: "1.5rem",
    // 24px
    8: "2rem",
    // 32px
    10: "2.5rem",
    // 40px
    12: "3rem",
    // 48px
    16: "4rem",
    // 64px
    20: "5rem",
    // 80px
    24: "6rem"
    // 96px
  },
  borderRadius: {
    none: "0",
    sm: "0.125rem",
    // 2px
    md: "0.375rem",
    // 6px
    lg: "0.5rem",
    // 8px
    xl: "0.75rem",
    // 12px
    "2xl": "1rem",
    // 16px
    full: "9999px"
  },
  typography: {
    fontFamily: {
      sans: [
        "Inter",
        "system-ui",
        "-apple-system",
        "BlinkMacSystemFont",
        "sans-serif"
      ],
      mono: [
        "ui-monospace",
        "SFMono-Regular",
        "Monaco",
        "Consolas",
        "monospace"
      ]
    },
    fontSize: {
      xs: "0.75rem",
      // 12px
      sm: "0.875rem",
      // 14px
      base: "1rem",
      // 16px
      lg: "1.125rem",
      // 18px
      xl: "1.25rem",
      // 20px
      "2xl": "1.5rem",
      // 24px
      "3xl": "1.875rem",
      // 30px
      "4xl": "2.25rem"
      // 36px
    },
    fontWeight: {
      normal: "400",
      medium: "500",
      semibold: "600",
      bold: "700"
    },
    lineHeight: {
      tight: "1.25",
      normal: "1.5",
      relaxed: "1.625"
    }
  },
  shadows: {
    none: "none",
    sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
    lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
    xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
  },
  transitions: {
    duration: {
      fast: "150ms",
      normal: "200ms",
      slow: "300ms"
    },
    easing: {
      linear: "linear",
      easeIn: "cubic-bezier(0.4, 0, 1, 1)",
      easeOut: "cubic-bezier(0, 0, 0.2, 1)",
      easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)"
    }
  }
}, kB = () => {
  const e = {};
  return Object.entries(lt.colors).forEach(([t, r]) => {
    Object.entries(r).forEach(([n, i]) => {
      e[`--fs-color-${t}-${n}`] = i;
    });
  }), Object.entries(lt.spacing).forEach(([t, r]) => {
    e[`--fs-spacing-${t}`] = r;
  }), Object.entries(lt.borderRadius).forEach(([t, r]) => {
    e[`--fs-radius-${t}`] = r;
  }), Object.entries(lt.shadows).forEach(([t, r]) => {
    e[`--fs-shadow-${t}`] = r;
  }), e;
};
function at(e) {
  const t = e.split(".");
  let r = lt.colors;
  for (const n of t)
    if (r && typeof r == "object" && n in r)
      r = r[n];
    else
      return console.warn(`Color token not found: ${e}`), "#000000";
  return typeof r == "string" ? r : "#000000";
}
function nF(e) {
  return lt.spacing[e] || "0";
}
function iF(e) {
  return lt.typography.fontSize[e] || lt.typography.fontSize.base;
}
function aF(e) {
  return lt.borderRadius[e] || lt.borderRadius.md;
}
function oF(e) {
  return lt.shadows[e] || lt.shadows.sm;
}
function uF(e) {
  const t = kB();
  Object.entries(t).forEach(([r, n]) => {
    e.style.setProperty(r, n);
  });
}
const sF = {
  primary: {
    background: at("brand.primary"),
    hover: at("brand.primaryHover"),
    light: at("brand.primaryLight"),
    text: "#ffffff"
  },
  success: {
    background: at("semantic.success"),
    hover: at("semantic.successHover"),
    light: at("semantic.successLight"),
    text: "#ffffff"
  },
  warning: {
    background: at("semantic.warning"),
    hover: at("semantic.warningHover"),
    light: at("semantic.warningLight"),
    text: "#ffffff"
  },
  error: {
    background: at("semantic.error"),
    hover: at("semantic.errorHover"),
    light: at("semantic.errorLight"),
    text: "#ffffff"
  }
}, RB = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px"
};
function cF(e) {
  return `@media (min-width: ${RB[e]})`;
}
export {
  rF as AISuggestionButton,
  tF as BusinessTerm,
  s1 as Button,
  px as Card,
  zB as Divider,
  QB as ExpenseSourcesChart,
  BB as FeatureCard,
  XB as FinancialCompass,
  WB as Input,
  eF as InsightItem,
  KB as Modal,
  ZB as MonthlyEvolutionChart,
  VB as Navbar,
  JB as RevenueSourcesChart,
  HB as Select,
  YB as Sidebar,
  UB as Spinner,
  FB as StatsCard,
  GB as Textarea,
  NB as Tooltip,
  uF as applyTokensToElement,
  RB as breakpoints,
  se as cn,
  sF as colorSchemes,
  kB as generateCSSVars,
  aF as getBorderRadius,
  at as getColor,
  iF as getFontSize,
  oF as getShadow,
  nF as getSpacing,
  cF as mediaQuery,
  lt as tokens
};
